function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirece84"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirece84"] = parcelRequire;
}
parcelRequire.register("dGtP5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9f6654d3acf53af5$export$2e2bcd8739ae039; });
function $9f6654d3acf53af5$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRequire.register("lsgQ0", function(module, exports) {
"use strict";

});

parcelRequire.register("aHKG5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $k48zG = parcelRequire("k48zG");

var $70r74 = parcelRequire("70r74");

var $gLz18 = parcelRequire("gLz18");

var $gUDaf = parcelRequire("gUDaf");
var $7cb220c5f5f31e8c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $gLz18.RawSha256();
        if (secret) {
            this.outer = new $gLz18.RawSha256();
            var inner = $7cb220c5f5f31e8c$var$bufferFromSecret(secret);
            var outer = new Uint8Array($70r74.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $70r74.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $gUDaf.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $gUDaf.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            return (0, $k48zG.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $7cb220c5f5f31e8c$var$Sha256;
function $7cb220c5f5f31e8c$var$bufferFromSecret(secret) {
    var input = (0, $gUDaf.convertToBuffer)(secret);
    if (input.byteLength > $70r74.BLOCK_SIZE) {
        var bufferHash = new $gLz18.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($70r74.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRequire.register("k48zG", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $e9bad51634de5928$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $e9bad51634de5928$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $e9bad51634de5928$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $e9bad51634de5928$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $e9bad51634de5928$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $e9bad51634de5928$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $e9bad51634de5928$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $e9bad51634de5928$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spread", function () { return $e9bad51634de5928$export$afc72e2116322959; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e9bad51634de5928$var$extendStatics = function(d, b) {
    $e9bad51634de5928$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e9bad51634de5928$var$extendStatics(d, b);
};
function $e9bad51634de5928$export$a8ba968b8961cb8a(d, b) {
    $e9bad51634de5928$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e9bad51634de5928$export$18ce0697a983be9b = function() {
    $e9bad51634de5928$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9bad51634de5928$export$18ce0697a983be9b.apply(this, arguments);
};
function $e9bad51634de5928$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e9bad51634de5928$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e9bad51634de5928$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e9bad51634de5928$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e9bad51634de5928$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e9bad51634de5928$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e9bad51634de5928$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e9bad51634de5928$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e9bad51634de5928$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e9bad51634de5928$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e9bad51634de5928$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e9bad51634de5928$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e9bad51634de5928$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e9bad51634de5928$export$10c90e4f7922046c(v) {
    return this instanceof $e9bad51634de5928$export$10c90e4f7922046c ? (this.v = v, this) : new $e9bad51634de5928$export$10c90e4f7922046c(v);
}
function $e9bad51634de5928$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e9bad51634de5928$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e9bad51634de5928$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e9bad51634de5928$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e9bad51634de5928$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e9bad51634de5928$export$19a8beecd37a4c45 === "function" ? $e9bad51634de5928$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e9bad51634de5928$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e9bad51634de5928$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e9bad51634de5928$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e9bad51634de5928$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e9bad51634de5928$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("70r74", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRequire.register("gLz18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $70r74 = parcelRequire("70r74");
/**
 * @internal
 */ var $c34c32da55f3f000$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($70r74.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $70r74.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $70r74.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $70r74.BLOCK_SIZE >= $70r74.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $70r74.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $70r74.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($70r74.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($70r74.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($70r74.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $70r74.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($70r74.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $c34c32da55f3f000$var$RawSha256;

});

parcelRequire.register("gUDaf", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $h0OZe = parcelRequire("h0OZe");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $h0OZe.convertToBuffer;
    }
});

var $3YkQf = parcelRequire("3YkQf");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $3YkQf.isEmptyData;
    }
});

var $ugHxs = parcelRequire("ugHxs");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $ugHxs.numToUint8;
    }
});

var $5I75H = parcelRequire("5I75H");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $5I75H.uint32ArrayFrom;
    }
});

});
parcelRequire.register("h0OZe", function(module, exports) {

var $5Ue0n = parcelRequire("5Ue0n");
var $c629fca18e0bb0e5$require$Buffer = $5Ue0n.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $j6KOb = parcelRequire("j6KOb");
// Quick polyfill
var $c629fca18e0bb0e5$var$fromUtf8 = typeof $c629fca18e0bb0e5$require$Buffer !== "undefined" && $c629fca18e0bb0e5$require$Buffer.from ? function(input) {
    return $c629fca18e0bb0e5$require$Buffer.from(input, "utf8");
} : $j6KOb.fromUtf8;
function $c629fca18e0bb0e5$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $c629fca18e0bb0e5$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $c629fca18e0bb0e5$var$convertToBuffer;

});
parcelRequire.register("5Ue0n", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $44cd0bd3a1192d9a$export$a143d493d941bafc; }, function (v) { return $44cd0bd3a1192d9a$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $44cd0bd3a1192d9a$export$f99ded8fe4b79145; }, function (v) { return $44cd0bd3a1192d9a$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $44cd0bd3a1192d9a$export$a143d493d941bafc;
var $44cd0bd3a1192d9a$export$e4cf37d7f6fb9e0a;
var $44cd0bd3a1192d9a$export$f99ded8fe4b79145;
var $44cd0bd3a1192d9a$export$599f31c3813fae4d;
"use strict";

var $2IpUO = parcelRequire("2IpUO");

var $7CwwS = parcelRequire("7CwwS");
const $44cd0bd3a1192d9a$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$44cd0bd3a1192d9a$export$a143d493d941bafc = $44cd0bd3a1192d9a$var$Buffer;
$44cd0bd3a1192d9a$export$e4cf37d7f6fb9e0a = $44cd0bd3a1192d9a$var$SlowBuffer;
$44cd0bd3a1192d9a$export$f99ded8fe4b79145 = 50;
const $44cd0bd3a1192d9a$var$K_MAX_LENGTH = 0x7fffffff;
$44cd0bd3a1192d9a$export$599f31c3813fae4d = $44cd0bd3a1192d9a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $44cd0bd3a1192d9a$var$Buffer.TYPED_ARRAY_SUPPORT = $44cd0bd3a1192d9a$var$typedArraySupport();
if (!$44cd0bd3a1192d9a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $44cd0bd3a1192d9a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($44cd0bd3a1192d9a$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($44cd0bd3a1192d9a$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $44cd0bd3a1192d9a$var$createBuffer(length) {
    if (length > $44cd0bd3a1192d9a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $44cd0bd3a1192d9a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $44cd0bd3a1192d9a$var$allocUnsafe(arg);
    }
    return $44cd0bd3a1192d9a$var$from(arg, encodingOrOffset, length);
}
$44cd0bd3a1192d9a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $44cd0bd3a1192d9a$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $44cd0bd3a1192d9a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $44cd0bd3a1192d9a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($44cd0bd3a1192d9a$var$isInstance(value, ArrayBuffer) || value && $44cd0bd3a1192d9a$var$isInstance(value.buffer, ArrayBuffer)) return $44cd0bd3a1192d9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($44cd0bd3a1192d9a$var$isInstance(value, SharedArrayBuffer) || value && $44cd0bd3a1192d9a$var$isInstance(value.buffer, SharedArrayBuffer))) return $44cd0bd3a1192d9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $44cd0bd3a1192d9a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $44cd0bd3a1192d9a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $44cd0bd3a1192d9a$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $44cd0bd3a1192d9a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $44cd0bd3a1192d9a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($44cd0bd3a1192d9a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($44cd0bd3a1192d9a$var$Buffer, Uint8Array);
function $44cd0bd3a1192d9a$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $44cd0bd3a1192d9a$var$alloc(size, fill, encoding) {
    $44cd0bd3a1192d9a$var$assertSize(size);
    if (size <= 0) return $44cd0bd3a1192d9a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $44cd0bd3a1192d9a$var$createBuffer(size).fill(fill, encoding) : $44cd0bd3a1192d9a$var$createBuffer(size).fill(fill);
    return $44cd0bd3a1192d9a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $44cd0bd3a1192d9a$var$Buffer.alloc = function(size, fill, encoding) {
    return $44cd0bd3a1192d9a$var$alloc(size, fill, encoding);
};
function $44cd0bd3a1192d9a$var$allocUnsafe(size) {
    $44cd0bd3a1192d9a$var$assertSize(size);
    return $44cd0bd3a1192d9a$var$createBuffer(size < 0 ? 0 : $44cd0bd3a1192d9a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $44cd0bd3a1192d9a$var$Buffer.allocUnsafe = function(size) {
    return $44cd0bd3a1192d9a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $44cd0bd3a1192d9a$var$Buffer.allocUnsafeSlow = function(size) {
    return $44cd0bd3a1192d9a$var$allocUnsafe(size);
};
function $44cd0bd3a1192d9a$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$44cd0bd3a1192d9a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $44cd0bd3a1192d9a$var$byteLength(string, encoding) | 0;
    let buf = $44cd0bd3a1192d9a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $44cd0bd3a1192d9a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $44cd0bd3a1192d9a$var$checked(array.length) | 0;
    const buf = $44cd0bd3a1192d9a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $44cd0bd3a1192d9a$var$fromArrayView(arrayView) {
    if ($44cd0bd3a1192d9a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $44cd0bd3a1192d9a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $44cd0bd3a1192d9a$var$fromArrayLike(arrayView);
}
function $44cd0bd3a1192d9a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return buf;
}
function $44cd0bd3a1192d9a$var$fromObject(obj) {
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(obj)) {
        const len = $44cd0bd3a1192d9a$var$checked(obj.length) | 0;
        const buf = $44cd0bd3a1192d9a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $44cd0bd3a1192d9a$var$numberIsNaN(obj.length)) return $44cd0bd3a1192d9a$var$createBuffer(0);
        return $44cd0bd3a1192d9a$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $44cd0bd3a1192d9a$var$fromArrayLike(obj.data);
}
function $44cd0bd3a1192d9a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $44cd0bd3a1192d9a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $44cd0bd3a1192d9a$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $44cd0bd3a1192d9a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $44cd0bd3a1192d9a$var$Buffer.alloc(+length);
}
$44cd0bd3a1192d9a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $44cd0bd3a1192d9a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$44cd0bd3a1192d9a$var$Buffer.compare = function compare(a, b) {
    if ($44cd0bd3a1192d9a$var$isInstance(a, Uint8Array)) a = $44cd0bd3a1192d9a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($44cd0bd3a1192d9a$var$isInstance(b, Uint8Array)) b = $44cd0bd3a1192d9a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(a) || !$44cd0bd3a1192d9a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$44cd0bd3a1192d9a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$44cd0bd3a1192d9a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $44cd0bd3a1192d9a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $44cd0bd3a1192d9a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($44cd0bd3a1192d9a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) buf = $44cd0bd3a1192d9a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $44cd0bd3a1192d9a$var$byteLength(string, encoding) {
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $44cd0bd3a1192d9a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $44cd0bd3a1192d9a$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $44cd0bd3a1192d9a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $44cd0bd3a1192d9a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$44cd0bd3a1192d9a$var$Buffer.byteLength = $44cd0bd3a1192d9a$var$byteLength;
function $44cd0bd3a1192d9a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $44cd0bd3a1192d9a$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $44cd0bd3a1192d9a$var$utf8Slice(this, start, end);
        case "ascii":
            return $44cd0bd3a1192d9a$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $44cd0bd3a1192d9a$var$latin1Slice(this, start, end);
        case "base64":
            return $44cd0bd3a1192d9a$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $44cd0bd3a1192d9a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$44cd0bd3a1192d9a$var$Buffer.prototype._isBuffer = true;
function $44cd0bd3a1192d9a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$44cd0bd3a1192d9a$var$swap(this, i, i + 1);
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $44cd0bd3a1192d9a$var$swap(this, i, i + 3);
        $44cd0bd3a1192d9a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $44cd0bd3a1192d9a$var$swap(this, i, i + 7);
        $44cd0bd3a1192d9a$var$swap(this, i + 1, i + 6);
        $44cd0bd3a1192d9a$var$swap(this, i + 2, i + 5);
        $44cd0bd3a1192d9a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $44cd0bd3a1192d9a$var$utf8Slice(this, 0, length);
    return $44cd0bd3a1192d9a$var$slowToString.apply(this, arguments);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toLocaleString = $44cd0bd3a1192d9a$var$Buffer.prototype.toString;
$44cd0bd3a1192d9a$var$Buffer.prototype.equals = function equals(b) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $44cd0bd3a1192d9a$var$Buffer.compare(this, b) === 0;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $44cd0bd3a1192d9a$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($44cd0bd3a1192d9a$var$customInspectSymbol) $44cd0bd3a1192d9a$var$Buffer.prototype[$44cd0bd3a1192d9a$var$customInspectSymbol] = $44cd0bd3a1192d9a$var$Buffer.prototype.inspect;
$44cd0bd3a1192d9a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($44cd0bd3a1192d9a$var$isInstance(target, Uint8Array)) target = $44cd0bd3a1192d9a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $44cd0bd3a1192d9a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($44cd0bd3a1192d9a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $44cd0bd3a1192d9a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $44cd0bd3a1192d9a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $44cd0bd3a1192d9a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $44cd0bd3a1192d9a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $44cd0bd3a1192d9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $44cd0bd3a1192d9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $44cd0bd3a1192d9a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($44cd0bd3a1192d9a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $44cd0bd3a1192d9a$var$utf8Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$asciiWrite(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$asciiToBytes(string), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$base64Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$base64ToBytes(string), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$ucs2Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$44cd0bd3a1192d9a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $44cd0bd3a1192d9a$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $44cd0bd3a1192d9a$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $44cd0bd3a1192d9a$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $44cd0bd3a1192d9a$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $44cd0bd3a1192d9a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $44cd0bd3a1192d9a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $2IpUO.fromByteArray(buf);
    else return $2IpUO.fromByteArray(buf.slice(start, end));
}
function $44cd0bd3a1192d9a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $44cd0bd3a1192d9a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $44cd0bd3a1192d9a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $44cd0bd3a1192d9a$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $44cd0bd3a1192d9a$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $44cd0bd3a1192d9a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $44cd0bd3a1192d9a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $44cd0bd3a1192d9a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $44cd0bd3a1192d9a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$44cd0bd3a1192d9a$var$Buffer.prototype.readUintLE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUintBE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint8 = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint16LE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint16BE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint32LE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint32BE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigUInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigUInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, true, 23, 4);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, false, 23, 4);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, true, 52, 8);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, false, 52, 8);
};
function $44cd0bd3a1192d9a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUintLE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUintBE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint8 = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint16LE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint16BE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint32LE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint32BE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $44cd0bd3a1192d9a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $44cd0bd3a1192d9a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigUInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigUInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $44cd0bd3a1192d9a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeFloat(this, value, offset, true, noAssert);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeFloat(this, value, offset, false, noAssert);
};
function $44cd0bd3a1192d9a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeDouble(this, value, offset, true, noAssert);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$44cd0bd3a1192d9a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$44cd0bd3a1192d9a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$44cd0bd3a1192d9a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $44cd0bd3a1192d9a$var$Buffer.isBuffer(val) ? val : $44cd0bd3a1192d9a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $44cd0bd3a1192d9a$var$errors = {};
function $44cd0bd3a1192d9a$var$E(sym, getMessage, Base) {
    $44cd0bd3a1192d9a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$44cd0bd3a1192d9a$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$44cd0bd3a1192d9a$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$44cd0bd3a1192d9a$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $44cd0bd3a1192d9a$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $44cd0bd3a1192d9a$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $44cd0bd3a1192d9a$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $44cd0bd3a1192d9a$var$checkBounds(buf, offset, byteLength) {
    $44cd0bd3a1192d9a$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $44cd0bd3a1192d9a$var$checkBounds(buf, offset, byteLength);
}
function $44cd0bd3a1192d9a$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $44cd0bd3a1192d9a$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $44cd0bd3a1192d9a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $44cd0bd3a1192d9a$var$validateNumber(value, type);
        throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $44cd0bd3a1192d9a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $44cd0bd3a1192d9a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $44cd0bd3a1192d9a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($44cd0bd3a1192d9a$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $44cd0bd3a1192d9a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $44cd0bd3a1192d9a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $44cd0bd3a1192d9a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $44cd0bd3a1192d9a$var$base64ToBytes(str) {
    return $2IpUO.toByteArray($44cd0bd3a1192d9a$var$base64clean(str));
}
function $44cd0bd3a1192d9a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $44cd0bd3a1192d9a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $44cd0bd3a1192d9a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $44cd0bd3a1192d9a$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $44cd0bd3a1192d9a$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $44cd0bd3a1192d9a$var$BufferBigIntNotDefined : fn;
}
function $44cd0bd3a1192d9a$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("2IpUO", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $1fa3cb0d676f4b02$export$d622b2ad8d90c771; }, function (v) { return $1fa3cb0d676f4b02$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $1fa3cb0d676f4b02$export$6100ba28696e12de; }, function (v) { return $1fa3cb0d676f4b02$export$6100ba28696e12de = v; });
var $1fa3cb0d676f4b02$export$a48f0734ac7c2329;
var $1fa3cb0d676f4b02$export$d622b2ad8d90c771;
var $1fa3cb0d676f4b02$export$6100ba28696e12de;
"use strict";
$1fa3cb0d676f4b02$export$a48f0734ac7c2329 = $1fa3cb0d676f4b02$var$byteLength;
$1fa3cb0d676f4b02$export$d622b2ad8d90c771 = $1fa3cb0d676f4b02$var$toByteArray;
$1fa3cb0d676f4b02$export$6100ba28696e12de = $1fa3cb0d676f4b02$var$fromByteArray;
var $1fa3cb0d676f4b02$var$lookup = [];
var $1fa3cb0d676f4b02$var$revLookup = [];
var $1fa3cb0d676f4b02$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $1fa3cb0d676f4b02$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $1fa3cb0d676f4b02$var$i = 0, $1fa3cb0d676f4b02$var$len = $1fa3cb0d676f4b02$var$code.length; $1fa3cb0d676f4b02$var$i < $1fa3cb0d676f4b02$var$len; ++$1fa3cb0d676f4b02$var$i){
    $1fa3cb0d676f4b02$var$lookup[$1fa3cb0d676f4b02$var$i] = $1fa3cb0d676f4b02$var$code[$1fa3cb0d676f4b02$var$i];
    $1fa3cb0d676f4b02$var$revLookup[$1fa3cb0d676f4b02$var$code.charCodeAt($1fa3cb0d676f4b02$var$i)] = $1fa3cb0d676f4b02$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$1fa3cb0d676f4b02$var$revLookup["-".charCodeAt(0)] = 62;
$1fa3cb0d676f4b02$var$revLookup["_".charCodeAt(0)] = 63;
function $1fa3cb0d676f4b02$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $1fa3cb0d676f4b02$var$byteLength(b64) {
    var lens = $1fa3cb0d676f4b02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1fa3cb0d676f4b02$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1fa3cb0d676f4b02$var$toByteArray(b64) {
    var tmp;
    var lens = $1fa3cb0d676f4b02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $1fa3cb0d676f4b02$var$Arr($1fa3cb0d676f4b02$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 18 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 2 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 10 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $1fa3cb0d676f4b02$var$tripletToBase64(num) {
    return $1fa3cb0d676f4b02$var$lookup[num >> 18 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num >> 12 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num >> 6 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num & 0x3F];
}
function $1fa3cb0d676f4b02$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($1fa3cb0d676f4b02$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $1fa3cb0d676f4b02$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($1fa3cb0d676f4b02$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($1fa3cb0d676f4b02$var$lookup[tmp >> 2] + $1fa3cb0d676f4b02$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($1fa3cb0d676f4b02$var$lookup[tmp >> 10] + $1fa3cb0d676f4b02$var$lookup[tmp >> 4 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("7CwwS", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $58c550a140bdb182$export$aafa59e2e03f2942; }, function (v) { return $58c550a140bdb182$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $58c550a140bdb182$export$68d8715fc104d294; }, function (v) { return $58c550a140bdb182$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $58c550a140bdb182$export$aafa59e2e03f2942;
var $58c550a140bdb182$export$68d8715fc104d294;
$58c550a140bdb182$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$58c550a140bdb182$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("j6KOb", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $de92e3025c34e24a$export$c7c5cef950a4d2fc; });

var $jaEDQ = parcelRequire("jaEDQ");

var $kILff = parcelRequire("kILff");
const $de92e3025c34e24a$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $kILff.fromUtf8)(input) : (0, $jaEDQ.fromUtf8)(input);
const $de92e3025c34e24a$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $kILff.toUtf8)(input) : (0, $jaEDQ.toUtf8)(input);

});
parcelRequire.register("jaEDQ", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $df4e7a1ac3631402$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $df4e7a1ac3631402$export$b4b216764bb846eb; });
const $df4e7a1ac3631402$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $df4e7a1ac3631402$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRequire.register("kILff", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $f15c908b35252ada$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $f15c908b35252ada$export$b4b216764bb846eb; });
function $f15c908b35252ada$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $f15c908b35252ada$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRequire.register("3YkQf", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $2e47246e55742ef1$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $2e47246e55742ef1$var$isEmptyData;

});

parcelRequire.register("ugHxs", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $05afc1f95da02ff9$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $05afc1f95da02ff9$var$numToUint8;

});

parcelRequire.register("5I75H", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $42868fecf0e0bda4$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $42868fecf0e0bda4$var$uint32ArrayFrom;

});



parcelRequire.register("cX4QS", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRequire.register("kVoG6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $f3bc460dd001e37f$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$f3bc460dd001e37f$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($f3bc460dd001e37f$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $f3bc460dd001e37f$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRequire.register("3o3ca", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $27761783faa591c8$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $27761783faa591c8$var$map($27761783faa591c8$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($27761783faa591c8$var$stringifyPrimitive(k)) + eq;
        if ($27761783faa591c8$var$isArray(obj[k])) return $27761783faa591c8$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($27761783faa591c8$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($27761783faa591c8$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($27761783faa591c8$var$stringifyPrimitive(name)) + eq + encodeURIComponent($27761783faa591c8$var$stringifyPrimitive(obj));
};
var $27761783faa591c8$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $27761783faa591c8$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $27761783faa591c8$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});

var $c46317026d1b626f$exports = {};

$c46317026d1b626f$exports = new URL((parcelRequire("d8rS2")).resolve("kjfFn"), import.meta.url).toString();


var $8c1f3845b573e132$exports = {};
!function(n) {
    "use strict";
    function t(n, t, e) {
        return e.a = n, e.f = t, e;
    }
    function F2(n) {
        return t(2, n, function(t) {
            return function(e) {
                return n(t, e);
            };
        });
    }
    function F3(n) {
        return t(3, n, function(t) {
            return function(e) {
                return function(r) {
                    return n(t, e, r);
                };
            };
        });
    }
    function F4(n) {
        return t(4, n, function(t) {
            return function(e) {
                return function(r) {
                    return function(u) {
                        return n(t, e, r, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return t(5, n, function(t) {
            return function(e) {
                return function(r) {
                    return function(u) {
                        return function(a) {
                            return n(t, e, r, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return t(6, n, function(t) {
            return function(e) {
                return function(r) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(t, e, r, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return t(7, n, function(t) {
            return function(e) {
                return function(r) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(t, e, r, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, t, e) {
        return 2 === n.a ? n.f(t, e) : n(t)(e);
    }
    function A3(n, t, e, r) {
        return 3 === n.a ? n.f(t, e, r) : n(t)(e)(r);
    }
    function A4(n, t, e, r, u) {
        return 4 === n.a ? n.f(t, e, r, u) : n(t)(e)(r)(u);
    }
    function A5(n, t, e, r, u, a) {
        return 5 === n.a ? n.f(t, e, r, u, a) : n(t)(e)(r)(u)(a);
    }
    function A6(n, t, e, r, u, a, i) {
        return 6 === n.a ? n.f(t, e, r, u, a, i) : n(t)(e)(r)(u)(a)(i);
    }
    function A7(n, t, e, r, u, a, i, o) {
        return 7 === n.a ? n.f(t, e, r, u, a, i, o) : n(t)(e)(r)(u)(a)(i)(o);
    }
    function e(n, t) {
        for(var e, u = [], a = r(n, t, 0, u); a && (e = u.pop()); a = r(e.a, e.b, 0, u));
        return a;
    }
    function r(n, t, e, u) {
        if (n === t) return !0;
        if ("object" != typeof n || null === n || null === t) return "function" == typeof n && x(5), !1;
        if (e > 100) return u.push(i(n, t)), !0;
        for(var a in 0 > n.$ && (n = fe(n), t = fe(t)), n)if (!r(n[a], t[a], e + 1, u)) return !1;
        return !0;
    }
    function u(n, t, e) {
        if ("object" != typeof n) return n === t ? 0 : t > n ? -1 : 1;
        if (void 0 === n.$) return (e = u(n.a, t.a)) || (e = u(n.b, t.b)) ? e : u(n.c, t.c);
        for(; n.b && t.b && !(e = u(n.a, t.a)); n = n.b, t = t.b);
        return e || (n.b ? 1 : t.b ? -1 : 0);
    }
    var a = F2(function(n, t) {
        var e = u(n, t);
        return 0 > e ? oe : e ? ie : ae;
    });
    function i(n, t) {
        return {
            a: n,
            b: t
        };
    }
    function o(n, t, e) {
        return {
            a: n,
            b: t,
            c: e
        };
    }
    function c(n, t) {
        var e = {};
        for(var r in n)e[r] = n[r];
        for(var r in t)e[r] = t[r];
        return e;
    }
    function s(n, t) {
        if ("string" == typeof n) return n + t;
        if (!n.b) return t;
        var e = l(n.a, t);
        n = n.b;
        for(var r = e; n.b; n = n.b)r = r.b = l(n.a, t);
        return e;
    }
    var f = {
        $: 0
    };
    function l(n, t) {
        return {
            $: 1,
            a: n,
            b: t
        };
    }
    var d = F2(l);
    function b(n) {
        for(var t = f, e = n.length; e--;)t = l(n[e], t);
        return t;
    }
    function h(n) {
        for(var t = []; n.b; n = n.b)t.push(n.a);
        return t;
    }
    var v = F3(function(n, t, e) {
        for(var r = []; t.b && e.b; t = t.b, e = e.b)r.push(A2(n, t.a, e.a));
        return b(r);
    }), m = F2(function(n, t) {
        return b(h(t).sort(function(t, e) {
            return u(n(t), n(e));
        }));
    }), p = F3(function(n, t, e) {
        for(var r = Array(n), u = 0; n > u; u++)r[u] = e(t + u);
        return r;
    }), g = F2(function(n, t) {
        for(var e = Array(n), r = 0; n > r && t.b; r++)e[r] = t.a, t = t.b;
        return e.length = r, i(e, t);
    }), $ = F2(function(n, t) {
        return t[n];
    }), w = F3(function(n, t, e) {
        for(var r = e.length, u = 0; r > u; u++)t = A2(n, e[u], t);
        return t;
    }), y = F3(function(n, t, e) {
        for(var r = e.length - 1; r >= 0; r--)t = A2(n, e[r], t);
        return t;
    }), C = F2(function(n, t) {
        for(var e = t.length, r = Array(e), u = 0; e > u; u++)r[u] = n(t[u]);
        return r;
    }), k = F3(function(n, t, e) {
        for(var r = e.length, u = Array(r), a = 0; r > a; a++)u[a] = A2(n, t + a, e[a]);
        return u;
    });
    function x(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var z = F2(function(n, t) {
        return n + t;
    }), M = F2(Math.pow), S = F2(function(n, t) {
        var e = t % n;
        return 0 === n ? x(11) : e > 0 && 0 > n || 0 > e && n > 0 ? e + n : e;
    }), H = Math.ceil, T = Math.floor, A = Math.round, L = Math.log, V = F2(function(n, t) {
        return n + t;
    }), E = F3(function(n, t, e) {
        for(var r = e.length, u = 0; r > u;){
            var a = e[u], i = e.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += e[u], u++), t = A2(n, a, t);
        }
        return t;
    }), Z = F2(function(n, t) {
        return t.split(n);
    }), P = F2(function(n, t) {
        return t.join(n);
    }), _ = F3(function(n, t, e) {
        return e.slice(n, t);
    }), j = F2(function(n, t) {
        for(var e = t.length; e--;){
            var r = t[e], u = t.charCodeAt(e);
            if (56320 > u || u > 57343 || (r = t[--e] + r), !n(r)) return !1;
        }
        return !0;
    }), N = F2(function(n, t) {
        return t.indexOf(n) > -1;
    }), O = F2(function(n, t) {
        return 0 === t.indexOf(n);
    }), I = F2(function(n, t) {
        var e = n.length;
        if (1 > e) return f;
        for(var r = 0, u = []; (r = t.indexOf(n, r)) > -1;)u.push(r), r += e;
        return b(u);
    });
    function q(n) {
        return n + "";
    }
    function D(n) {
        return {
            $: 2,
            b: n
        };
    }
    var F = D(function(n) {
        return "number" != typeof n ? on("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? we(n) : !isFinite(n) || n % 1 ? on("an INT", n) : we(n);
    }), X = D(function(n) {
        return "boolean" == typeof n ? we(n) : on("a BOOL", n);
    }), G = D(function(n) {
        return "number" == typeof n ? we(n) : on("a FLOAT", n);
    }), R = D(function(n) {
        return we(n);
    }), U = D(function(n) {
        return "string" == typeof n ? we(n) : n instanceof String ? we(n + "") : on("a STRING", n);
    }), Y = F2(function(n, t) {
        return {
            $: 6,
            d: n,
            b: t
        };
    });
    function W(n, t) {
        return {
            $: 9,
            f: n,
            g: t
        };
    }
    var B = F2(function(n, t) {
        return {
            $: 10,
            b: t,
            h: n
        };
    }), J = F2(function(n, t) {
        return W(n, [
            t
        ]);
    }), K = F3(function(n, t, e) {
        return W(n, [
            t,
            e
        ]);
    }), Q = F4(function(n, t, e, r) {
        return W(n, [
            t,
            e,
            r
        ]);
    }), nn = F2(function(n, t) {
        try {
            return en(n, JSON.parse(t));
        } catch (n) {
            return me(A2(pe, "This is not valid JSON! " + n.message, t));
        }
    }), tn = F2(function(n, t) {
        return en(n, t);
    });
    function en(n, t) {
        switch(n.$){
            case 2:
                return n.b(t);
            case 5:
                return null === t ? we(n.c) : on("null", t);
            case 3:
                return un(t) ? rn(n.b, t, b) : on("a LIST", t);
            case 4:
                return un(t) ? rn(n.b, t, an) : on("an ARRAY", t);
            case 6:
                var e = n.d;
                if ("object" != typeof t || null === t || !(e in t)) return on("an OBJECT with a field named `" + e + "`", t);
                var r = en(n.b, t[e]);
                return hr(r) ? r : me(A2(ge, e, r.a));
            case 7:
                var u = n.e;
                return un(t) ? t.length > u ? (r = en(n.b, t[u]), hr(r) ? r : me(A2($e, u, r.a))) : on("a LONGER array. Need index " + u + " but only see " + t.length + " entries", t) : on("an ARRAY", t);
            case 8:
                if ("object" != typeof t || null === t || un(t)) return on("an OBJECT", t);
                var a = f;
                for(var o in t)if (t.hasOwnProperty(o)) {
                    if (r = en(n.b, t[o]), !hr(r)) return me(A2(ge, o, r.a));
                    a = l(i(o, r.a), a);
                }
                return we(qe(a));
            case 9:
                for(var c = n.f, s = n.g, d = 0; s.length > d; d++){
                    if (r = en(s[d], t), !hr(r)) return r;
                    c = c(r.a);
                }
                return we(c);
            case 10:
                return r = en(n.b, t), hr(r) ? en(n.h(r.a), t) : r;
            case 11:
                for(var h = f, v = n.g; v.b; v = v.b){
                    if (r = en(v.a, t), hr(r)) return r;
                    h = l(r.a, h);
                }
                return me(ye(qe(h)));
            case 1:
                return me(A2(pe, n.a, t));
            case 0:
                return we(n.a);
        }
    }
    function rn(n, t, e) {
        for(var r = t.length, u = Array(r), a = 0; r > a; a++){
            var i = en(n, t[a]);
            if (!hr(i)) return me(A2($e, a, i.a));
            u[a] = i.a;
        }
        return we(e(u));
    }
    function un(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function an(n) {
        return A2(br, n.length, function(t) {
            return n[t];
        });
    }
    function on(n, t) {
        return me(A2(pe, "Expecting " + n, t));
    }
    function cn(n, t) {
        if (n === t) return !0;
        if (n.$ !== t.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === t.a;
            case 2:
                return n.b === t.b;
            case 5:
                return n.c === t.c;
            case 3:
            case 4:
            case 8:
                return cn(n.b, t.b);
            case 6:
                return n.d === t.d && cn(n.b, t.b);
            case 7:
                return n.e === t.e && cn(n.b, t.b);
            case 9:
                return n.f === t.f && sn(n.g, t.g);
            case 10:
                return n.h === t.h && cn(n.b, t.b);
            case 11:
                return sn(n.g, t.g);
        }
    }
    function sn(n, t) {
        var e = n.length;
        if (e !== t.length) return !1;
        for(var r = 0; e > r; r++)if (!cn(n[r], t[r])) return !1;
        return !0;
    }
    var fn = F2(function(n, t) {
        return JSON.stringify(t, null, n) + "";
    });
    function ln(n) {
        return n;
    }
    var dn = F3(function(n, t, e) {
        return e[n] = t, e;
    });
    function bn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function hn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var vn = F2(function(n, t) {
        return {
            $: 3,
            b: n,
            d: t
        };
    }), mn = F2(function(n, t) {
        return {
            $: 4,
            b: n,
            d: t
        };
    }), pn = 0;
    function gn(n) {
        var t = {
            $: 0,
            e: pn++,
            f: n,
            g: null,
            h: []
        };
        return xn(t), t;
    }
    function $n(n) {
        return hn(function(t) {
            t(bn(gn(n)));
        });
    }
    function wn(n, t) {
        n.h.push(t), xn(n);
    }
    var yn = F2(function(n, t) {
        return hn(function(e) {
            wn(n, t), e(bn(0));
        });
    }), Cn = !1, kn = [];
    function xn(n) {
        if (kn.push(n), !Cn) {
            for(Cn = !0; n = kn.shift();)zn(n);
            Cn = !1;
        }
    }
    function zn(n) {
        for(; n.f;){
            var t = n.f.$;
            if (0 === t || 1 === t) {
                for(; n.g && n.g.$ !== t;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === t) return void (n.f.c = n.f.b(function(t) {
                    n.f = t, xn(n);
                }));
                if (5 === t) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === t ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Mn(n) {
        return hn(function(t) {
            var e = setTimeout(function() {
                t(bn(0));
            }, n);
            return function() {
                clearTimeout(e);
            };
        });
    }
    var Sn = {};
    function Hn(n, t, e, r, u) {
        return {
            b: n,
            c: t,
            d: e,
            e: r,
            f: u
        };
    }
    function Tn(n, t) {
        var e = {
            g: t,
            h: void 0
        }, r = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(vn, o, {
                $: 5,
                b: function(t) {
                    var o = t.a;
                    return 0 === t.$ ? A3(u, e, o, n) : a && i ? A4(r, e, o.i, o.j, n) : A3(r, e, a ? o.i : o.j, n);
                }
            });
        }
        return e.h = gn(A2(vn, o, n.b));
    }
    var An = F2(function(n, t) {
        return hn(function(e) {
            n.g(t), e(bn(0));
        });
    }), Ln = F2(function(n, t) {
        return A2(yn, n.h, {
            $: 0,
            a: t
        });
    });
    function Vn(n) {
        return function(t) {
            return {
                $: 1,
                k: n,
                l: t
            };
        };
    }
    function En(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Zn = F2(function(n, t) {
        return {
            $: 3,
            n: n,
            o: t
        };
    }), Pn = [], _n = !1;
    function jn(n, t, e) {
        if (Pn.push({
            p: n,
            q: t,
            r: e
        }), !_n) {
            _n = !0;
            for(var r; r = Pn.shift();)Nn(r.p, r.q, r.r);
            _n = !1;
        }
    }
    function Nn(n, t, e) {
        var r = {};
        for(var u in On(!0, t, r, null), On(!1, e, r, null), n)wn(n[u], {
            $: "fx",
            a: r[u] || {
                i: f,
                j: f
            }
        });
    }
    function On(n, t, e, r) {
        switch(t.$){
            case 1:
                var u = t.k, a = function(n, t, e, r) {
                    function u(n) {
                        for(var t = e; t; t = t.t)n = t.s(n);
                        return n;
                    }
                    return A2(n ? Sn[t].e : Sn[t].f, u, r);
                }(n, u, r, t.l);
                return void (e[u] = function(n, t, e) {
                    return e = e || {
                        i: f,
                        j: f
                    }, n ? e.i = l(t, e.i) : e.j = l(t, e.j), e;
                }(n, a, e[u]));
            case 2:
                for(var i = t.m; i.b; i = i.b)On(n, i.a, e, r);
                return;
            case 3:
                return void On(n, t.o, e, {
                    s: t.n,
                    t: r
                });
        }
    }
    function In(n) {
        Sn[n] && x(3);
    }
    function qn(n, t) {
        return In(n), Sn[n] = {
            e: Dn,
            u: t,
            a: Fn
        }, Vn(n);
    }
    var Dn = F2(function(n, t) {
        return t;
    });
    function Fn(n) {
        var t = [], e = Sn[n].u, r = Mn(0);
        return Sn[n].b = r, Sn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = t, i = e(u.a), o = 0; a.length > o; o++)a[o](i);
            return r;
        }), {
            subscribe: function(n) {
                t.push(n);
            },
            unsubscribe: function(n) {
                var e = (t = t.slice()).indexOf(n);
                0 > e || t.splice(e, 1);
            }
        };
    }
    function Xn(n, t) {
        return In(n), Sn[n] = {
            f: Rn,
            u: t,
            a: Un
        }, Vn(n);
    }
    var Gn, Rn = F2(function(n, t) {
        return function(e) {
            return n(t(e));
        };
    });
    function Un(n, t) {
        var e = f, r = Sn[n].u, u = bn(null);
        return Sn[n].b = u, Sn[n].c = F3(function(n, t) {
            return e = t, u;
        }), {
            send: function(n) {
                var u = A2(tn, r, n);
                hr(u) || x(4);
                for(var a = u.a, i = e; i.b; i = i.b)t(i.a(a));
            }
        };
    }
    var Yn = "undefined" != typeof document ? document : {};
    function Wn(n, t) {
        n.appendChild(t);
    }
    function Bn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Jn = F2(function(n, t) {
        return F2(function(e, r) {
            for(var u = [], a = 0; r.b; r = r.b){
                var i = r.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: t,
                d: bt(e),
                e: u,
                f: n,
                b: a
            };
        });
    }), Kn = Jn(void 0);
    F2(function(n, t) {
        return F2(function(e, r) {
            for(var u = [], a = 0; r.b; r = r.b){
                var i = r.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: t,
                d: bt(e),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var Qn = F2(function(n, t) {
        return {
            $: 4,
            j: n,
            k: t,
            b: 1 + (t.b || 0)
        };
    }), nt = F2(function(n, t) {
        return {
            $: "a0",
            n: n,
            o: t
        };
    }), tt = F2(function(n, t) {
        return {
            $: "a1",
            n: n,
            o: t
        };
    }), et = F2(function(n, t) {
        return {
            $: "a2",
            n: n,
            o: t
        };
    }), rt = F2(function(n, t) {
        return {
            $: "a3",
            n: n,
            o: t
        };
    }), ut = /^script$/i, at = /^(on|formAction$)/i, it = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, ot = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function ct(n) {
        return ot.test(n) ? "" : n;
    }
    var st, ft = F2(function(n, t) {
        return "a0" === t.$ ? A2(nt, t.n, function(n, t) {
            var e = gr(t);
            return {
                $: t.$,
                a: e ? A3(mr, 3 > e ? lt : dt, pr(n), t.a) : A2(vr, n, t.a)
            };
        }(n, t.o)) : t;
    }), lt = F2(function(n, t) {
        return i(n(t.a), t.b);
    }), dt = F2(function(n, t) {
        return {
            cD: n(t.cD),
            bl: t.bl,
            bg: t.bg
        };
    });
    function bt(n) {
        for(var t = {}; n.b; n = n.b){
            var e = n.a, r = e.$, u = e.n, a = e.o;
            if ("a2" !== r) {
                var i = t[r] || (t[r] = {});
                "a3" === r && "class" === u ? ht(i, u, a) : i[u] = a;
            } else "className" === u ? ht(t, u, a) : t[u] = a;
        }
        return t;
    }
    function ht(n, t, e) {
        var r = n[t];
        n[t] = r ? r + " " + e : e;
    }
    function vt(n, t) {
        var e = n.$;
        if (5 === e) return vt(n.k || (n.k = n.m()), t);
        if (0 === e) return Yn.createTextNode(n.a);
        if (4 === e) {
            for(var r = n.k, u = n.j; 4 === r.$;)"object" != typeof u ? u = [
                u,
                r.j
            ] : u.push(r.j), r = r.k;
            var a = {
                j: u,
                p: t
            };
            return (i = vt(r, a)).elm_event_node_ref = a, i;
        }
        if (3 === e) return mt(i = n.h(n.g), t, n.d), i;
        var i = n.f ? Yn.createElementNS(n.f, n.c) : Yn.createElement(n.c);
        Gn && "a" == n.c && i.addEventListener("click", Gn(i)), mt(i, t, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)Wn(i, vt(1 === e ? o[c] : o[c].b, t));
        return i;
    }
    function mt(n, t, e) {
        for(var r in e){
            var u = e[r];
            "a1" === r ? pt(n, u) : "a0" === r ? wt(n, t, u) : "a3" === r ? gt(n, u) : "a4" === r ? $t(n, u) : ("value" !== r && "checked" !== r || n[r] !== u) && (n[r] = u);
        }
    }
    function pt(n, t) {
        var e = n.style;
        for(var r in t)e[r] = t[r];
    }
    function gt(n, t) {
        for(var e in t){
            var r = t[e];
            void 0 !== r ? n.setAttribute(e, r) : n.removeAttribute(e);
        }
    }
    function $t(n, t) {
        for(var e in t){
            var r = t[e], u = r.f, a = r.o;
            void 0 !== a ? n.setAttributeNS(u, e, a) : n.removeAttributeNS(u, e);
        }
    }
    function wt(n, t, e) {
        var r = n.elmFs || (n.elmFs = {});
        for(var u in e){
            var a = e[u], i = r[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = yt(t, a), n.addEventListener(u, i, st && {
                    passive: 2 > gr(a)
                }), r[u] = i;
            } else n.removeEventListener(u, i), r[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                st = !0;
            }
        }));
    } catch (n) {}
    function yt(n, t) {
        function e(t) {
            var r = e.q, u = en(r.a, t);
            if (hr(u)) {
                for(var a, i = gr(r), o = u.a, c = i ? 3 > i ? o.a : o.cD : o, s = 1 == i ? o.b : 3 == i && o.bl, f = (s && t.stopPropagation(), (2 == i ? o.b : 3 == i && o.bg) && t.preventDefault(), n); a = f.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var l = a.length; l--;)c = a[l](c);
                    f = f.p;
                }
                f(c, s);
            }
        }
        return e.q = t, e;
    }
    function Ct(n, t) {
        return n.$ == t.$ && cn(n.a, t.a);
    }
    function kt(n, t, e, r) {
        var u = {
            $: t,
            r: e,
            s: r,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function xt(n, t, e, r) {
        if (n !== t) {
            var u = n.$, a = t.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void kt(e, 0, r, t);
                t = function(n) {
                    for(var t = n.e, e = t.length, r = Array(e), u = 0; e > u; u++)r[u] = t[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: r,
                        f: n.f,
                        b: n.b
                    };
                }(t), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = t.l, c = i.length, s = c === o.length; s && c--;)s = i[c] === o[c];
                    if (s) return void (t.k = n.k);
                    t.k = t.m();
                    var f = [];
                    return xt(n.k, t.k, f, 0), void (f.length > 0 && kt(e, 1, r, f));
                case 4:
                    for(var l = n.j, d = t.j, b = !1, h = n.k; 4 === h.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        h.j
                    ] : l.push(h.j), h = h.k;
                    for(var v = t.k; 4 === v.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        v.j
                    ] : d.push(v.j), v = v.k;
                    return b && l.length !== d.length ? void kt(e, 0, r, t) : ((b ? function(n, t) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== t[e]) return !1;
                        return !0;
                    }(l, d) : l === d) || kt(e, 2, r, d), void xt(h, v, e, r + 1));
                case 0:
                    return void (n.a !== t.a && kt(e, 3, r, t.a));
                case 1:
                    return void zt(n, t, e, r, St);
                case 2:
                    return void zt(n, t, e, r, Ht);
                case 3:
                    if (n.h !== t.h) return void kt(e, 0, r, t);
                    var m = Mt(n.d, t.d);
                    m && kt(e, 4, r, m);
                    var p = t.i(n.g, t.g);
                    return void (p && kt(e, 5, r, p));
            }
        }
    }
    function zt(n, t, e, r, u) {
        if (n.c === t.c && n.f === t.f) {
            var a = Mt(n.d, t.d);
            a && kt(e, 4, r, a), u(n, t, e, r);
        } else kt(e, 0, r, t);
    }
    function Mt(n, t, e) {
        var r;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in t) {
                var a = n[u], i = t[u];
                a === i && "value" !== u && "checked" !== u || "a0" === e && Ct(a, i) || ((r = r || {})[u] = i);
            } else (r = r || {})[u] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Mt(n[u], t[u] || {}, u);
            o && ((r = r || {})[u] = o);
        }
        for(var c in t)c in n || ((r = r || {})[c] = t[c]);
        return r;
    }
    function St(n, t, e, r) {
        var u = n.e, a = t.e, i = u.length, o = a.length;
        i > o ? kt(e, 6, r, {
            v: o,
            i: i - o
        }) : o > i && kt(e, 7, r, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, s = 0; c > s; s++){
            var f = u[s];
            xt(f, a[s], e, ++r), r += f.b || 0;
        }
    }
    function Ht(n, t, e, r) {
        for(var u = [], a = {}, i = [], o = n.e, c = t.e, s = o.length, f = c.length, l = 0, d = 0, b = r; s > l && f > d;){
            var h = (M = o[l]).a, v = (S = c[d]).a, m = M.b, p = S.b, g = void 0, $ = void 0;
            if (h !== v) {
                var w = o[l + 1], y = c[d + 1];
                if (w) {
                    var C = w.a, k = w.b;
                    $ = v === C;
                }
                if (y) {
                    var x = y.a, z = y.b;
                    g = h === x;
                }
                if (g && $) xt(m, z, u, ++b), At(a, u, h, p, d, i), b += m.b || 0, Lt(a, u, h, k, ++b), b += k.b || 0, l += 2, d += 2;
                else if (g) b++, At(a, u, v, p, d, i), xt(m, z, u, b), b += m.b || 0, l += 1, d += 2;
                else if ($) Lt(a, u, h, m, ++b), b += m.b || 0, xt(k, p, u, ++b), b += k.b || 0, l += 2, d += 1;
                else {
                    if (!w || C !== x) break;
                    Lt(a, u, h, m, ++b), At(a, u, v, p, d, i), b += m.b || 0, xt(k, z, u, ++b), b += k.b || 0, l += 2, d += 2;
                }
            } else xt(m, p, u, ++b), b += m.b || 0, l++, d++;
        }
        for(; s > l;){
            var M;
            b++, Lt(a, u, (M = o[l]).a, m = M.b, b), b += m.b || 0, l++;
        }
        for(; f > d;){
            var S, H = H || [];
            At(a, u, (S = c[d]).a, S.b, void 0, H), d++;
        }
        (u.length > 0 || i.length > 0 || H) && kt(e, 8, r, {
            w: u,
            x: i,
            y: H
        });
    }
    var Tt = "_elmW6BL";
    function At(n, t, e, r, u, a) {
        var i = n[e];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: r,
                r: u,
                s: void 0
            }
        }), void (n[e] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return xt(i.z, r, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        At(n, t, e + Tt, r, u, a);
    }
    function Lt(n, t, e, r, u) {
        var a = n[e];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return xt(r, a.z, i, u), void kt(t, 9, u, {
                    w: i,
                    A: a
                });
            }
            Lt(n, t, e + Tt, r, u);
        } else {
            var o = kt(t, 9, u, void 0);
            n[e] = {
                c: 1,
                z: r,
                r: u,
                s: o
            };
        }
    }
    function Vt(n, t, e, r) {
        Et(n, t, e, 0, 0, t.b, r);
    }
    function Et(n, t, e, r, u, a, i) {
        for(var o = e[r], c = o.r; c === u;){
            var s = o.$;
            if (1 === s) Vt(n, t.k, o.s, i);
            else if (8 === s) o.t = n, o.u = i, (f = o.s.w).length > 0 && Et(n, t, f, 0, u, a, i);
            else if (9 === s) {
                o.t = n, o.u = i;
                var f, l = o.s;
                l && (l.A.s = n, (f = l.w).length > 0 && Et(n, t, f, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = e[++r]) || (c = o.r) > a) return r;
        }
        var d = t.$;
        if (4 === d) {
            for(var b = t.k; 4 === b.$;)b = b.k;
            return Et(n, b, e, r, u + 1, a, n.elm_event_node_ref);
        }
        for(var h = t.e, v = n.childNodes, m = 0; h.length > m; m++){
            u++;
            var p = 1 === d ? h[m] : h[m].b, g = u + (p.b || 0);
            if (!(u > c || c > g || (o = e[r = Et(v[m], p, e, r, u, g, i)]) && (c = o.r) <= a)) return r;
            u = g;
        }
        return r;
    }
    function Zt(n, t) {
        for(var e = 0; t.length > e; e++){
            var r = t[e], u = r.t, a = Pt(u, r);
            u === n && (n = a);
        }
        return n;
    }
    function Pt(n, t) {
        switch(t.$){
            case 0:
                return function(n, t, e) {
                    var r = n.parentNode, u = vt(t, e);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), r && u !== n && r.replaceChild(u, n), u;
                }(n, t.s, t.u);
            case 4:
                return mt(n, t.u, t.s), n;
            case 3:
                return n.replaceData(0, n.length, t.s), n;
            case 1:
                return Zt(n, t.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = t.s : n.elm_event_node_ref = {
                    j: t.s,
                    p: t.u
                }, n;
            case 6:
                for(var e = t.s, r = 0; e.i > r; r++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var u = (e = t.s).e, a = n.childNodes[r = e.v]; u.length > r; r++)n.insertBefore(vt(u[r], t.u), a);
                return n;
            case 9:
                if (!(e = t.s)) return n.parentNode.removeChild(n), n;
                var i = e.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Zt(n, e.w), n;
            case 8:
                return function(n, t) {
                    var e = t.s, r = function(n, t) {
                        if (n) {
                            for(var e = Yn.createDocumentFragment(), r = 0; n.length > r; r++){
                                var u = n[r].A;
                                Wn(e, 2 === u.c ? u.s : vt(u.z, t.u));
                            }
                            return e;
                        }
                    }(e.y, t);
                    n = Zt(n, e.w);
                    for(var u = e.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : vt(o.z, t.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return r && Wn(n, r), n;
                }(n, t);
            case 5:
                return t.s(n);
            default:
                x(10);
        }
    }
    function _t(n) {
        if (3 === n.nodeType) return Bn(n.textContent);
        if (1 !== n.nodeType) return Bn("");
        for(var t = f, e = n.attributes, r = e.length; r--;){
            var u = e[r];
            t = l(A2(rt, u.name, u.value), t);
        }
        var a = n.tagName.toLowerCase(), i = f, o = n.childNodes;
        for(r = o.length; r--;)i = l(_t(o[r]), i);
        return A3(Kn, a, t, i);
    }
    var jt = F4(function(n, t, e, r) {
        return function(n, t, e, r, u, a) {
            var i = A2(tn, n, t ? t.flags : void 0);
            hr(i) || x(2);
            var o = {}, c = e(i.a), s = c.a, f = a(d, s), l = function(n, t) {
                var e;
                for(var r in Sn){
                    var u = Sn[r];
                    u.a && ((e = e || {})[r] = u.a(r, t)), n[r] = Tn(u, t);
                }
                return e;
            }(o, d);
            function d(n, t) {
                var e = A2(r, n, s);
                f(s = e.a, t), jn(o, e.b, u(s));
            }
            return jn(o, c.b, u(s)), l ? {
                ports: l
            } : {};
        }(t, r, n.Z, n.aq, n.ab, function(t, e) {
            var r = n.bk && n.bk(t), u = n.V, a = Yn.title, i = Yn.body, o = _t(i);
            return function(n, t) {
                t(n);
                var e = 0;
                function r() {
                    e = 1 === e ? 0 : (Nt(r), t(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (t(n), 2 === e && (e = 1)) : (0 === e && Nt(r), e = 2);
                };
            }(e, function(n) {
                Gn = r;
                var e = u(n), c = Kn("body")(f)(e.cb), s = function(n, t) {
                    var e = [];
                    return xt(n, t, e, 0), e;
                }(o, c);
                i = function(n, t, e, r) {
                    return 0 === e.length ? n : (Vt(n, t, e, r), Zt(n, e));
                }(i, o, s, t), o = c, Gn = 0, a !== e.c$ && (Yn.title = a = e.c$);
            });
        });
    }), Nt = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Ot() {
        return Pr(Yn.location.href).a || x(1);
    }
    var It = F2(function(n, t) {
        return A2(Jr, _r, hn(function() {
            history.pushState({}, "", t), n();
        }));
    }), qt = F2(function(n, t) {
        return A2(Jr, _r, hn(function() {
            history.replaceState({}, "", t), n();
        }));
    }), Dt = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Ft = "undefined" != typeof document ? document : Dt, Xt = "undefined" != typeof window ? window : Dt, Gt = F3(function(n, t, e) {
        return $n(hn(function() {
            function r(n) {
                gn(e(n));
            }
            return n.addEventListener(t, r, st && {
                passive: !0
            }), function() {
                n.removeEventListener(t, r);
            };
        }));
    }), Rt = F2(function(n, t) {
        var e = en(n, t);
        return hr(e) ? ke(e.a) : xe;
    });
    function Ut(n, t) {
        return hn(function(e) {
            Nt(function() {
                var r = document.getElementById(n);
                e(r ? bn(t(r)) : {
                    $: 1,
                    a: wr(n)
                });
            });
        });
    }
    var Yt = F2(function(n, t) {
        return Ut(t, function(t) {
            return t[n](), 0;
        });
    });
    var Wt = F2(function(n, t) {
        var e;
        return e = function() {
            return Xt.scroll(n, t), 0;
        }, hn(function(n) {
            Nt(function() {
                n(bn(e()));
            });
        });
    }), Bt = F3(function(n, t, e) {
        return Ut(n, function(n) {
            return n.scrollLeft = t, n.scrollTop = e, 0;
        });
    }), Jt = F2(function(n, t) {
        var e = "g";
        n.cF && (e += "m"), n.cd && (e += "i");
        try {
            return ke(RegExp(t, e));
        } catch (n) {
            return xe;
        }
    }), Kt = F2(function(n, t) {
        return null !== t.match(n);
    }), Qt = F4(function(n, t, e, r) {
        var u = 0;
        return r.replace(t, function(t) {
            if (u++ >= n) return t;
            for(var r = arguments.length - 3, a = Array(r); r > 0;){
                var i = arguments[r];
                a[--r] = i ? ke(i) : xe;
            }
            return e(A4(Ns, t, arguments[arguments.length - 2], u, b(a)));
        });
    }), ne = F3(function(n, t, e) {
        return hn(function(r) {
            function u(n) {
                r(t(e.ax.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Dd);
            }), a.addEventListener("timeout", function() {
                u(Gd);
            }), a.addEventListener("load", function() {
                u(function(n, t) {
                    return A2(t.status >= 200 && 300 > t.status ? qd : Od, function(n) {
                        return {
                            H: n.responseURL,
                            cY: n.status,
                            cZ: n.statusText,
                            s: te(n.getAllResponseHeaders())
                        };
                    }(t), n(t.response));
                }(e.ax.b, a));
            }), Rd(e.b_) && function(n, t, e) {
                t.upload.addEventListener("progress", function(r) {
                    t.c || gn(A2(Ud, n, i(e, Xd({
                        cW: r.loaded,
                        bX: r.total
                    }))));
                }), t.addEventListener("progress", function(r) {
                    t.c || gn(A2(Ud, n, i(e, Fd({
                        cP: r.loaded,
                        bX: r.lengthComputable ? ke(r.total) : xe
                    }))));
                });
            }(n, a, e.b_.a);
            try {
                a.open(e._, e.H, !0);
            } catch (n) {
                return u(Id(e.H));
            }
            return function(n, t) {
                for(var e = t.s; e.b; e = e.b)n.setRequestHeader(e.a.a, e.a.b);
                n.timeout = t.x.a || 0, n.responseType = t.ax.d, n.withCredentials = t.b7;
            }(a, e), e.cb.a && a.setRequestHeader("Content-Type", e.cb.a), a.send(e.cb.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function te(n) {
        if (!n) return ru;
        for(var t = ru, e = n.split("\r\n"), r = e.length; r--;){
            var u = e[r], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), o = u.substring(a + 2);
                t = A3(ju, i, function(n) {
                    return ke(Rd(n) ? o + ", " + n.a : o);
                }, t);
            }
        }
        return t;
    }
    var ee = F3(function(n, t, e) {
        return {
            $: 0,
            d: n,
            b: t,
            a: e
        };
    }), re = F2(function(n, t) {
        return {
            $: 0,
            d: t.d,
            b: t.b,
            a: function(e) {
                return n(t.a(e));
            }
        };
    }), ue = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), ae = 1, ie = 2, oe = 0, ce = d, se = F3(function(n, t, e) {
        for(;;){
            if (-2 === e.$) return t;
            var r = e.d, u = n, a = A3(n, e.b, e.c, A3(se, n, t, e.e));
            n = u, t = a, e = r;
        }
    }), fe = function(n) {
        return A3(se, F3(function(n, t, e) {
            return A2(ce, i(n, t), e);
        }), f, n);
    }, le = function(n) {
        return A3(se, F3(function(n, t, e) {
            return A2(ce, n, e);
        }), f, n);
    }, de = function(n) {
        return le(n);
    }, be = y, he = F3(function(n, t, e) {
        var r = e.c, u = e.d, a = F2(function(t, e) {
            return A3(be, t.$ ? n : a, e, t.a);
        });
        return A3(be, a, A3(be, n, t, u), r);
    }), ve = function(n) {
        return A3(he, ce, f, n);
    }, me = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pe = F2(function(n, t) {
        return {
            $: 3,
            a: n,
            b: t
        };
    }), ge = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), $e = F2(function(n, t) {
        return {
            $: 1,
            a: n,
            b: t
        };
    }), we = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ye = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ce = z, ke = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xe = {
        $: 1
    }, ze = j, Me = fn, Se = q, He = F2(function(n, t) {
        return A2(P, n, h(t));
    }), Te = F2(function(n, t) {
        return b(A2(Z, n, t));
    }), Ae = function(n) {
        return A2(He, "\n    ", A2(Te, "\n", n));
    }, Le = F3(function(n, t, e) {
        for(;;){
            if (!e.b) return t;
            var r = e.b, u = n, a = A2(n, e.a, t);
            n = u, t = a, e = r;
        }
    }), Ve = function(n) {
        return A3(Le, F2(function(n, t) {
            return t + 1;
        }), 0, n);
    }, Ee = v, Ze = F3(function(n, t, e) {
        for(;;){
            if (u(n, t) >= 1) return e;
            var r = n, a = t - 1, i = A2(ce, t, e);
            n = r, t = a, e = i;
        }
    }), Pe = F2(function(n, t) {
        return A3(Ze, n, t, f);
    }), _e = F2(function(n, t) {
        return A3(Ee, n, A2(Pe, 0, Ve(t) - 1), t);
    }), je = function(n) {
        var t = n.charCodeAt(0);
        return 55296 > t || t > 56319 ? t : 1024 * (t - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Ne = function(n) {
        var t = je(n);
        return t >= 97 && 122 >= t;
    }, Oe = function(n) {
        var t = je(n);
        return 90 >= t && t >= 65;
    }, Ie = function(n) {
        return Ne(n) || Oe(n) || function(n) {
            var t = je(n);
            return 57 >= t && t >= 48;
        }(n);
    }, qe = function(n) {
        return A3(Le, ce, f, n);
    }, De = function(n) {
        var t = n.charCodeAt(0);
        return isNaN(t) ? xe : ke(55296 > t || t > 56319 ? i(n[0], n.slice(1)) : i(n[0] + n[1], n.slice(2)));
    }, Fe = F2(function(n, t) {
        return "\n\n(" + Se(n + 1) + ") " + Ae(Xe(t));
    }), Xe = function(n) {
        return A2(Ge, n, f);
    }, Ge = F2(function(n, t) {
        n: for(;;)switch(n.$){
            case 0:
                var e = n.a, r = n.b, u = function() {
                    var n = De(e);
                    if (1 === n.$) return !1;
                    var t, r = n.a, u = r.b;
                    return (Ne(t = r.a) || Oe(t)) && A2(ze, Ie, u);
                }();
                n = r, t = A2(ce, u ? "." + e : "['" + e + "']", t);
                continue n;
            case 1:
                r = n.b;
                var a = "[" + Se(n.a) + "]";
                n = r, t = A2(ce, a, t);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = (t.b ? "The Json.Decode.oneOf at json" + A2(He, "", qe(t)) : "Json.Decode.oneOf") + " failed in the following " + Se(Ve(i)) + " ways:";
                        return A2(He, "\n\n", A2(ce, o, A2(_e, Fe, i)));
                    }
                    n = r = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (t.b ? " at json" + A2(He, "", qe(t)) : "!");
            default:
                var c = n.a, s = n.b;
                return (o = t.b ? "Problem with the value at json" + A2(He, "", qe(t)) + ":\n\n    " : "Problem with the given value:\n\n") + Ae(A2(Me, 4, s)) + "\n\n" + c;
        }
    }), Re = 32, Ue = F4(function(n, t, e, r) {
        return {
            $: 0,
            a: n,
            b: t,
            c: e,
            d: r
        };
    }), Ye = [], We = H, Be = F2(function(n, t) {
        return L(t) / L(n);
    }), Je = function(n) {
        return n;
    }, Ke = We(A2(Be, 2, Re)), Qe = A4(Ue, 0, Ke, Ye, Ye), nr = p, tr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, er = F2(function(n, t) {
        return t(n);
    }), rr = T, ur = function(n) {
        return n.length;
    }, ar = F2(function(n, t) {
        return u(n, t) > 0 ? n : t;
    }), ir = function(n) {
        return {
            $: 0,
            a: n
        };
    }, or = g, cr = F2(function(n, t) {
        for(;;){
            var e = A2(or, Re, n), r = e.b, u = A2(ce, ir(e.a), t);
            if (!r.b) return qe(u);
            n = r, t = u;
        }
    }), sr = function(n) {
        return n.a;
    }, fr = F2(function(n, t) {
        for(;;){
            var e = We(t / Re);
            if (1 === e) return A2(or, Re, n).a;
            n = A2(cr, n, f), t = e;
        }
    }), lr = F2(function(n, t) {
        if (t.j) {
            var e = t.j * Re, r = rr(A2(Be, Re, e - 1)), u = n ? qe(t.n) : t.n, a = A2(fr, u, t.j);
            return A4(Ue, ur(t.k) + e, A2(ar, 5, r * Ke), a, t.k);
        }
        return A4(Ue, ur(t.k), Ke, Ye, t.k);
    }), dr = F5(function(n, t, e, r, u) {
        for(;;){
            if (0 > t) return A2(lr, !1, {
                n: r,
                j: e / Re | 0,
                k: u
            });
            var a = tr(A3(nr, Re, t, n));
            t -= Re, r = A2(ce, a, r);
        }
    }), br = F2(function(n, t) {
        if (n > 0) {
            var e = n % Re;
            return A5(dr, t, n - e - Re, n, f, A3(nr, e, n - e, t));
        }
        return Qe;
    }), hr = function(n) {
        return !n.$;
    }, vr = J, mr = K, pr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, $r = function(n) {
        return n;
    }, wr = $r, yr = F6(function(n, t, e, r, u, a) {
        return {
            cn: a,
            bE: t,
            bM: r,
            bO: e,
            bR: n,
            cO: u
        };
    }), Cr = N, kr = function(n) {
        return n.length;
    }, xr = _, zr = F2(function(n, t) {
        return 1 > n ? t : A3(xr, n, kr(t), t);
    }), Mr = I, Sr = function(n) {
        return "" === n;
    }, Hr = F2(function(n, t) {
        return 1 > n ? "" : A3(xr, 0, n, t);
    }), Tr = function(n) {
        for(var t = 0, e = n.charCodeAt(0), r = 43 == e || 45 == e ? 1 : 0, u = r; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return xe;
            t = 10 * t + a - 48;
        }
        return u == r ? xe : ke(45 == e ? -t : t);
    }, Ar = F5(function(n, t, e, r, u) {
        if (Sr(u) || A2(Cr, "@", u)) return xe;
        var a = A2(Mr, ":", u);
        if (a.b) {
            if (a.b.b) return xe;
            var i = a.a, o = Tr(A2(zr, i + 1, u));
            if (1 === o.$) return xe;
            var c = o;
            return ke(A6(yr, n, A2(Hr, i, u), c, t, e, r));
        }
        return ke(A6(yr, n, u, xe, t, e, r));
    }), Lr = F4(function(n, t, e, r) {
        if (Sr(r)) return xe;
        var u = A2(Mr, "/", r);
        if (u.b) {
            var a = u.a;
            return A5(Ar, n, A2(zr, a, r), t, e, A2(Hr, a, r));
        }
        return A5(Ar, n, "/", t, e, r);
    }), Vr = F3(function(n, t, e) {
        if (Sr(e)) return xe;
        var r = A2(Mr, "?", e);
        if (r.b) {
            var u = r.a;
            return A4(Lr, n, ke(A2(zr, u + 1, e)), t, A2(Hr, u, e));
        }
        return A4(Lr, n, xe, t, e);
    }), Er = F2(function(n, t) {
        if (Sr(t)) return xe;
        var e = A2(Mr, "#", t);
        if (e.b) {
            var r = e.a;
            return A3(Vr, n, ke(A2(zr, r + 1, t)), A2(Hr, r, t));
        }
        return A3(Vr, n, xe, t);
    }), Zr = O, Pr = function(n) {
        return A2(Zr, "http://", n) ? A2(Er, 0, A2(zr, 7, n)) : A2(Zr, "https://", n) ? A2(Er, 1, A2(zr, 8, n)) : xe;
    }, _r = function() {
        for(;;);
    }, jr = bn, Nr = jr(0), Or = F4(function(n, t, e, r) {
        if (r.b) {
            var u = r.a, a = r.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, s = o.b;
                    if (s.b) {
                        var f = s.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, s.a, e > 500 ? A3(Le, n, t, qe(f)) : A4(Or, n, t, e + 1, f)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, t)));
                }
                return A2(n, u, A2(n, i, t));
            }
            return A2(n, u, t);
        }
        return t;
    }), Ir = F3(function(n, t, e) {
        return A4(Or, n, t, 0, e);
    }), qr = F2(function(n, t) {
        return A3(Ir, F2(function(t, e) {
            return A2(ce, n(t), e);
        }), f, t);
    }), Dr = vn, Fr = F2(function(n, t) {
        return A2(Dr, function(t) {
            return jr(n(t));
        }, t);
    }), Xr = F3(function(n, t, e) {
        return A2(Dr, function(t) {
            return A2(Dr, function(e) {
                return jr(A2(n, t, e));
            }, e);
        }, t);
    }), Gr = function(n) {
        return A3(Ir, Xr(ce), jr(f), n);
    }, Rr = An, Ur = F2(function(n, t) {
        var e = t;
        return $n(A2(Dr, Rr(n), e));
    });
    Sn.Task = Hn(Nr, F3(function(n, t) {
        return A2(Fr, function() {
            return 0;
        }, Gr(A2(qr, Ur(n), t)));
    }), F3(function() {
        return jr(0);
    }), F2(function(n, t) {
        return A2(Fr, n, t);
    }));
    var Yr, Wr, Br = Vn("Task"), Jr = F2(function(n, t) {
        return Br(A2(Fr, n, t));
    }), Kr = F4(function(n, t, e, r) {
        return {
            N: t,
            cK: r,
            T: e,
            H: n
        };
    }), Qr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tu = En, eu = {
        $: -2
    }, ru = eu, uu = F2(function(n, t) {
        return t.$ ? xe : ke(n(t.a));
    }), au = F3(function(n, t, e) {
        return t(n(e));
    }), iu = F2(function(n, t) {
        n: for(;;){
            if (n > 0) {
                if (t.b) {
                    n -= 1, t = t.b;
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), ou = F3(function(n, t, e) {
        var r = n(t);
        return r.$ ? e : A2(ce, r.a, e);
    }), cu = F2(function(n, t) {
        return A3(Ir, ou(n), f, t);
    }), su = F5(function(n, t, e, r, u) {
        return {
            $: -1,
            a: n,
            b: t,
            c: e,
            d: r,
            e: u
        };
    }), fu = F5(function(n, t, e, r, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== r.$ || r.a || -1 !== r.d.$ || r.d.a) return A5(su, n, t, e, r, u);
            var a = r.d;
            return i = r.e, A5(su, 0, r.b, r.c, A5(su, 1, a.b, a.c, a.d, a.e), A5(su, 1, t, e, i, u));
        }
        var i, o = u.b, c = u.c, s = u.d, f = u.e;
        return -1 !== r.$ || r.a ? A5(su, n, o, c, A5(su, 0, t, e, r, s), f) : A5(su, 0, t, e, A5(su, 1, r.b, r.c, r.d, i = r.e), A5(su, 1, o, c, s, f));
    }), lu = a, du = F3(function(n, t, e) {
        if (-2 === e.$) return A5(su, 0, n, t, eu, eu);
        var r = e.a, u = e.b, a = e.c, i = e.d, o = e.e;
        switch(A2(lu, n, u)){
            case 0:
                return A5(fu, r, u, a, A3(du, n, t, i), o);
            case 1:
                return A5(su, r, u, t, i, o);
            default:
                return A5(fu, r, u, a, i, A3(du, n, t, o));
        }
    }), bu = F3(function(n, t, e) {
        var r = A3(du, n, t, e);
        return -1 !== r.$ || r.a ? r : A5(su, 1, r.b, r.c, r.d, r.e);
    }), hu = function(n) {
        return A3(Le, F2(function(n, t) {
            return A3(bu, n.a, n.b, t);
        }), ru, n);
    }, vu = function(n) {
        return n.b ? ke(n.a) : xe;
    }, mu = F3(function(n, t, e) {
        return 1 === t.$ || 1 === e.$ ? xe : ke(A2(n, t.a, e.a));
    }), pu = F3(function(n, t, e) {
        var r = e.b;
        return i(n(e.a), t(r));
    }), gu = F2(function(n, t) {
        return i(n, t);
    }), $u = function(n) {
        try {
            return ke(decodeURIComponent(n));
        } catch (n) {
            return xe;
        }
    }, wu = F2(function(n, t) {
        return t.$ ? n : t.a;
    }), yu = function(n) {
        if (Sr(n)) return ru;
        var t = function(n) {
            return A2(wu, n, $u(n));
        };
        return hu(A2(qr, A2(pu, t, t), A2(cu, A2(au, Te("="), function(n) {
            return A3(mu, gu, vu(n), ke(A2(wu, "", vu(A2(iu, 1, n)))));
        }), A2(Te, "&", n))));
    }, Cu = F4(function(n, t, e, r) {
        return {
            N: r,
            aj: t,
            cO: A2(wu, ru, A2(uu, yu, e.cO)),
            cV: n,
            H: e
        };
    }), ku = F2(function(n, t) {
        return t.b ? A3(Ir, ce, t, n) : n;
    }), xu = function(n) {
        return A3(Ir, ku, f, n);
    }, zu = F2(function(n, t) {
        return xu(A2(qr, n, t));
    }), Mu = F5(function(n, t, e, r, u) {
        return {
            af: r,
            aj: e,
            ac: t,
            b0: u,
            ar: n
        };
    }), Su = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(ce, n.a, Su(n.b)) : f;
    }, Hu = F2(function(n, t) {
        return ke(1 === t.$ ? b([
            n
        ]) : A2(ce, n, t.a));
    }), Tu = F2(function(n, t) {
        n: for(;;){
            if (-2 === t.$) return xe;
            var e = t.c, r = t.d, u = t.e;
            switch(A2(lu, n, t.b)){
                case 0:
                    t = r;
                    continue n;
                case 1:
                    return ke(e);
                default:
                    t = u;
                    continue n;
            }
        }
    }), Au = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var t = n.d, e = n.e;
                return i = e.b, o = e.c, r = e.d, f = e.e, A5(su, 1, n.b, n.c, A5(su, 0, t.b, t.c, t.d, t.e), A5(su, 0, i, o, r, f));
            }
            var r, u = n.d, a = n.e, i = a.b, o = a.c, c = (r = a.d).d, s = r.e, f = a.e;
            return A5(su, 0, r.b, r.c, A5(su, 1, n.b, n.c, A5(su, 0, u.b, u.c, u.d, u.e), c), A5(su, 1, i, o, s, f));
        }
        return n;
    }, Lu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var t = n.d, e = n.e;
                return s = e.b, f = e.c, l = e.d, d = e.e, A5(su, 1, r = n.b, u = n.c, A5(su, 0, t.b, t.c, t.d, o = t.e), A5(su, 0, s, f, l, d));
            }
            var r = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, s = c.b, f = c.c, l = c.d, d = c.e;
            return A5(su, 0, a.b, a.c, A5(su, 1, i.b, i.c, i.d, i.e), A5(su, 1, r, u, o, A5(su, 0, s, f, l, d)));
        }
        return n;
    }, Vu = F7(function(n, t, e, r, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return Lu(t);
                        break n;
                    }
                    return Lu(t);
                }
                break n;
            }
            return t;
        }
        return A5(su, e, a.b, a.c, a.d, A5(su, 0, r, u, a.e, i));
    }), Eu = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var t = n.a, e = n.b, r = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = Au(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(fu, o.a, o.b, o.c, Eu(o.d), c);
                    }
                    return eu;
                }
                return A5(su, t, e, r, Eu(u), i);
            }
            return A5(su, t, e, r, Eu(u), i);
        }
        return eu;
    }, Zu = F2(function(n, t) {
        if (-2 === t.$) return eu;
        var e = t.a, r = t.b, a = t.c, i = t.d, o = t.e;
        if (0 > u(n, r)) {
            if (-1 === i.$ && 1 === i.a) {
                var c = i.d;
                if (-1 !== c.$ || c.a) {
                    var s = Au(t);
                    if (-1 === s.$) {
                        var f = s.e;
                        return A5(fu, s.a, s.b, s.c, A2(Zu, n, s.d), f);
                    }
                    return eu;
                }
                return A5(su, e, r, a, A2(Zu, n, i), o);
            }
            return A5(su, e, r, a, A2(Zu, n, i), o);
        }
        return A2(Pu, n, A7(Vu, n, t, e, r, a, i, o));
    }), Pu = F2(function(n, t) {
        if (-1 === t.$) {
            var r = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
            if (e(n, u)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(fu, r, c.b, c.c, i, Eu(o)) : eu;
            }
            return A5(fu, r, u, a, i, A2(Zu, n, o));
        }
        return eu;
    }), _u = F2(function(n, t) {
        var e = A2(Zu, n, t);
        return -1 !== e.$ || e.a ? e : A5(su, 1, e.b, e.c, e.d, e.e);
    }), ju = F3(function(n, t, e) {
        var r = t(A2(Tu, n, e));
        return r.$ ? A2(_u, n, e) : A3(bu, n, r.a, e);
    }), Nu = F2(function(n, t) {
        var e = A2(Te, "=", n);
        if (e.b && e.b.b && !e.b.b.b) {
            var r = e.b.a, u = $u(e.a);
            if (1 === u.$) return t;
            var a = u.a, i = $u(r);
            return 1 === i.$ ? t : A3(ju, a, Hu(i.a), t);
        }
        return t;
    }), Ou = F2(function(n, t) {
        var e;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var t = n.a, e = t.ac;
                    if (e.b) {
                        if ("" !== e.a || e.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return ke(t.b0);
                    }
                    return ke(t.b0);
                }
                return xe;
            }
        }(n(A5(Mu, f, function(n) {
            var t = A2(Te, "/", n);
            return Su(t.b && "" === t.a ? t.b : t);
        }(t.bM), 1 === (e = t.cO).$ ? ru : A3(Ir, Nu, ru, A2(Te, "&", e.a)), t.cn, $r)));
    }), Iu = F2(function(n, t) {
        return A5(Mu, t.ar, t.ac, t.aj, t.af, n(t.b0));
    }), qu = F2(function(n, t) {
        var e = t;
        return function(t) {
            var r = t.ar, u = t.ac, a = t.aj, i = t.af;
            return A2(qr, Iu(t.b0), e(A5(Mu, r, u, a, i, n)));
        };
    }), Du = function(n) {
        return function(t) {
            var r = t.ar, u = t.ac, a = t.aj, i = t.af, o = t.b0;
            if (u.b) {
                var c = u.a, s = u.b;
                return e(c, n) ? b([
                    A5(Mu, A2(ce, c, r), s, a, i, o)
                ]) : f;
            }
            return f;
        };
    }, Fu = Du("about"), Xu = function(n) {
        return b([
            n
        ]);
    }, Gu = Du("login"), Ru = Du("not-found"), Uu = Du("payment-confirmation"), Yu = Du("pricing"), Wu = Du("schedule"), Bu = b([
        A2(qu, 1, Xu),
        A2(qu, 0, Fu),
        A2(qu, 2, Gu),
        A2(qu, 3, Uu),
        A2(qu, 4, Yu),
        A2(qu, 5, Wu),
        A2(qu, 6, Ru)
    ]), Ju = A2(au, Ou((Yr = Bu, function(n) {
        return A2(zu, function(t) {
            return t(n);
        }, Yr);
    })), wu(6)), Ku = F3(function(n, t, e) {
        return A4(Cu, Ju(t), n, t, e);
    }), Qu = F2(function(n, t) {
        return {
            $: 1,
            a: n,
            b: t
        };
    }), na = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ta = F2(function(n, t) {
        return {
            $: 2,
            a: n,
            b: t
        };
    }), ea = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ra = F2(function(n, t) {
        return {
            $: 3,
            a: n,
            b: t
        };
    }), ua = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aa = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ia = F2(function(n, t) {
        return {
            $: 4,
            a: n,
            b: t
        };
    }), oa = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ca = F2(function(n, t) {
        return {
            $: 5,
            a: n,
            b: t
        };
    }), sa = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fa = F2(function(n, t) {
        return {
            $: 6,
            a: n,
            b: t
        };
    }), la = function(n) {
        return {
            $: 5,
            a: n
        };
    }, da = {
        $: 0
    }, ba = Zn, ha = En, va = ha(f), ma = qt, pa = F3(function(n, t, e) {
        return A2(A2(n, t, e), t, A4(Cu, e.cV, 0, e.H, e.N));
    }), ga = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $a = ga, wa = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ya = {
        $: 0
    }, Ca = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ka = Zn, xa = F2(function(n, t) {
        switch(t.$){
            case 0:
                return ya;
            case 1:
                return ga(A2(ka, n, t.a));
            case 2:
                return Ca(t.a);
            default:
                var e = t.a;
                return wa(A2(qr, xa(n), e));
        }
    }), za = Qn, Ma = za, Sa = F2(function(n, t) {
        return {
            cb: A2(qr, Ma(n), t.cb),
            c$: t.c$
        };
    }), Ha = {
        cb: f,
        c$: "Zeitplan"
    }, Ta = function(n) {
        var t = function(n) {
            return "/" + A2(He, "/", n);
        };
        switch(n){
            case 0:
                return t(b([
                    "about"
                ]));
            case 1:
                return t(f);
            case 2:
                return t(b([
                    "login"
                ]));
            case 3:
                return t(b([
                    "payment-confirmation"
                ]));
            case 4:
                return t(b([
                    "pricing"
                ]));
            case 5:
                return t(b([
                    "schedule"
                ]));
            default:
                return t(b([
                    "not-found"
                ]));
        }
    }, Aa = F3(function(n, t, e) {
        return function(n) {
            var t = n.cQ, e = n.c2, r = n.c3, u = n.cp, a = n.cA, o = n.cB, c = n.cK, s = n.c0, f = n.c1;
            return {
                Z: F4(function(n, o, f, l) {
                    var d = A4(Cu, e(f), n, f, l), b = A3(pa, c, o, d);
                    if (b.$) return i(t.cE, u(A2(ma, d.N, r(b.a))));
                    var h = b.a;
                    return A3(pu, s(d.aj), a, h.Z(0));
                }),
                ab: F5(function(n, t, r, u, a) {
                    var i = A4(Cu, e(u), n, u, a), o = A3(pa, c, r, i);
                    return o.$ ? va : A2(ba, f, o.a.ab(t));
                }),
                aq: F6(function(n, o, f, l, d, b) {
                    var h = A4(Cu, e(d), n, d, b), v = A3(pa, c, l, h);
                    if (v.$) return i(t.cE, u(A2(ma, h.N, r(v.a))));
                    var m = v.a;
                    return A3(pu, s(h.aj), a, A2(m.aq, o, f));
                }),
                V: F5(function(n, r, u, a, i) {
                    var s = A4(Cu, e(a), n, a, i), f = A3(pa, c, u, s);
                    return f.$ ? t.V : o(f.a.V(r));
                })
            };
        }({
            cp: $a,
            cA: xa(e),
            cB: Sa(e),
            cK: n,
            cQ: {
                cE: da,
                V: Ha
            },
            c0: t,
            c1: e,
            c2: Ju,
            c3: Ta
        });
    }), La = F2(function(n) {
        return n;
    }), Va = F2(function(n, t) {
        return i(t.a, n(t.b));
    }), Ea = {
        b5: function(n) {
            return {
                Z: La(n.Z),
                ab: n.ab,
                aq: n.aq,
                V: n.V
            };
        },
        bx: F2(function(n, t) {
            return {
                Z: function() {
                    return A2(Va, n, t.Z);
                },
                ab: t.ab,
                aq: F2(function(e, r) {
                    return A2(Va, n, A2(t.aq, e, r));
                }),
                V: t.V
            };
        }),
        a1: F2(function(n, t) {
            return {
                Z: function() {
                    return i(t.Z, n);
                },
                ab: function() {
                    return va;
                },
                aq: F2(function(e, r) {
                    return i(A2(t.aq, e, r), n);
                }),
                V: t.V
            };
        }),
        a2: F2(function(n, t) {
            return {
                Z: function() {
                    return i(0, n);
                },
                ab: function() {
                    return va;
                },
                aq: F2(function() {
                    return i(0, n);
                }),
                V: function() {
                    return t.V;
                }
            };
        })
    }, Za = function(n) {
        return F2(function() {
            return we(Ea.b5(n));
        });
    }, Pa = ya, _a = i({}, Pa), ja = function() {
        return va;
    }, Na = Ca, Oa = F2(function(n, t) {
        return i(t, Na(n));
    }), Ia = {
        $: 1
    }, qa = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Da = Kn("a"), Fa = Kn("blockquote"), Xa = ln, Ga = F2(function(n, t) {
        return A2(et, n, Xa(t));
    }), Ra = Ga("className"), Ua = Kn("code"), Ya = Kn("div"), Wa = F2(function(n, t) {
        return A2(Ya, A2(ce, Ra("container"), n), t);
    }), Ba = F2(function(n, t) {
        return A2(Ya, A2(ce, Ra("content"), n), t);
    }), Ja = function(n) {
        return n.a + "=" + n.b;
    }, Ka = function(n) {
        return n.b ? "?" + A2(He, "&", A2(qr, Ja, n)) : "";
    }, Qa = F4(function(n, t, e, r) {
        var u = s(function(n) {
            switch(n.$){
                case 0:
                    return "/";
                case 1:
                    return "";
                default:
                    return n.a + "/";
            }
        }(n), s(A2(He, "/", t), Ka(e)));
        return 1 === r.$ ? u : u + "#" + r.a;
    }), ni = F3(function(n, t, e) {
        return n + "/" + (A2(He, "/", t) + Ka(e));
    }), ti = F4(function(n, t, e, r) {
        return {
            aO: t,
            cL: r,
            cM: n,
            bX: e
        };
    }), ei = A4(ti, "fab", "facebook", i(512, 512), i("M504 256C504 119 393 8 256 8S8 119 8 256c0 123.8 90.69 226.4 209.3 245V327.7h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.3 482.4 504 379.8 504 256z", xe)), ri = function(n) {
        return {
            aX: f,
            bF: n,
            aM: xe,
            be: xe,
            bi: "img",
            c$: xe,
            a3: f
        };
    }, ui = ri(ei), ai = Kn("footer"), ii = A4(ti, "fab", "github", i(496, 512), i("M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z", xe)), oi = ri(ii), ci = Kn("h2"), si = A4(ti, "fas", "heart", i(512, 512), i("M0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84.02L256 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 .0003 232.4 .0003 190.9L0 190.9z", xe)), fi = ri(si), li = function(n) {
        var t;
        return A2(Ga, "href", it.test(t = n) ? "" : t);
    }, di = A4(ti, "fas", "music", i(512, 512), i("M511.1 367.1c0 44.18-42.98 80-95.1 80s-95.1-35.82-95.1-79.1c0-44.18 42.98-79.1 95.1-79.1c11.28 0 21.95 1.92 32.01 4.898V148.1L192 224l-.0023 208.1C191.1 476.2 149 512 95.1 512S0 476.2 0 432c0-44.18 42.98-79.1 95.1-79.1c11.28 0 21.95 1.92 32 4.898V126.5c0-12.97 10.06-26.63 22.41-30.52l319.1-94.49C472.1 .6615 477.3 0 480 0c17.66 0 31.97 14.34 32 31.99L511.1 367.1z", xe)), bi = ri(di), hi = Kn("p"), vi = Kn("span"), mi = Ga("target"), pi = Bn, gi = pi, $i = F2(function(n, t) {
        return A2(rt, function(n) {
            return at.test(n) ? "data-" + n : n;
        }(n), ct(t));
    }), wi = $i, yi = rt("class"), Ci = rt("id"), ki = ft, xi = ki, zi = Jn("http://www.w3.org/2000/svg"), Mi = zi("svg"), Si = pi, Hi = zi("title"), Ti = function(n) {
        return A2(wu, n.bF.bX, A2(uu, Ai, n.be));
    }, Ai = function(n) {
        return A2(wu, n.bF.bX, A2(uu, Ti, n.be));
    }, Li = zi("defs"), Vi = rt("height"), Ei = rt("width"), Zi = rt("x"), Pi = rt("y"), _i = b([
        Zi("0"),
        Pi("0"),
        Ei("100%"),
        Vi("100%")
    ]), ji = rt("fill"), Ni = zi("g"), Oi = zi("mask"), Ii = rt("mask"), qi = rt("maskContentUnits"), Di = rt("maskUnits"), Fi = function(n) {
        return !n;
    }, Xi = F2(function(n, t) {
        switch(n.$){
            case 0:
                return c(t, {
                    bX: t.bX + (e = n.a)
                });
            case 1:
                var e = n.b, r = n.a ? i(e, 0) : i(0, e);
                return c(t, {
                    c8: t.c8 + r.a,
                    c9: t.c9 + r.b
                });
            case 2:
                return c(t, {
                    cU: t.cU + n.a
                });
            default:
                return c(t, n.a ? {
                    cl: !t.cl
                } : {
                    cm: !t.cm
                });
        }
    }), Gi = {
        cl: !1,
        cm: !1,
        cU: 0,
        bX: 16,
        c8: 0,
        c9: 0
    }, Ri = zi("rect"), Ui = q, Yi = rt("transform"), Wi = F3(function(n, t, e) {
        var r = "translate(" + Ui(t / 2 * -1) + " -256)", u = "translate(" + Ui(n / 2) + " 256)", a = "translate(" + Ui(32 * e.c8) + "," + Ui(32 * e.c9) + ") ", i = "rotate(" + Ui(e.cU) + " 0 0)", o = e.bX / 16 * (e.cm ? -1 : 1), c = "scale(" + Ui(e.bX / 16 * (e.cl ? -1 : 1)) + ", " + Ui(o) + ") ";
        return {
            cv: Yi(s(a, s(c, i))),
            be: Yi(u),
            bM: Yi(r)
        };
    }), Bi = rt("d"), Ji = zi("path"), Ki = F2(function(n, t) {
        return A2(Ji, A2(ce, Bi(t), n), f);
    }), Qi = F2(function(n, t) {
        var e = t.cL;
        if (1 === e.b.$) return A2(Ki, n, e.a);
        var r = e.a, u = e.b.a;
        return A2(Ni, b([
            yi("fa-group")
        ]), b([
            A2(Ki, A2(ce, yi("fa-secondary"), n), r),
            A2(Ki, A2(ce, yi("fa-primary"), n), u)
        ]));
    }), no = F3(function(n, t, e) {
        var r = t.cv, u = t.bM;
        return A2(Ni, b([
            t.be
        ]), b([
            A2(Ni, b([
                r
            ]), b([
                A2(Qi, b([
                    ji(n),
                    u
                ]), e)
            ]))
        ]));
    }), to = F2(function(n, t) {
        var r, u = t.bF, a = t.be, i = e(r = function(n) {
            return A3(Le, Xi, Gi, n);
        }(t.a3), Gi) ? xe : ke(r), o = u.bX.a, c = Ti(t).a;
        if (i.$) return A2(Qi, b([
            ji(n)
        ]), u);
        var s = A3(Wi, c, o, i.a);
        return a.$ ? A3(no, n, s, u) : A4(eo, n, s, u, a.a);
    }), eo = F4(function(n, t, e, r) {
        var u = "mask-" + A2(wu, "", r.aM), a = A2(Oi, A2(ce, Ci(u), A2(ce, Di("userSpaceOnUse"), A2(ce, qi("userSpaceOnUse"), _i))), b([
            A2(to, "white", r),
            A3(no, "black", t, e)
        ])), i = A2(Li, f, b([
            a
        ])), o = A2(Ri, A2(ce, ji(n), A2(ce, Ii("url(#" + u + ")"), _i)), f);
        return A2(Ni, f, b([
            i,
            o
        ]));
    }), ro = to("currentColor"), uo = rt("viewBox"), ao = F2(function(n, t) {
        var e = n.bF, r = n.bi, u = n.aM, a = n.c$, o = n.aX, c = ro(n), s = function() {
            if (a.$) return i(A2(wi, "aria-hidden", "true"), b([
                c
            ]));
            var n = a.a, t = A2(wu, "", u) + "-title";
            return i(A2(wi, "aria-labelledby", t), b([
                A2(Hi, b([
                    Ci(t)
                ]), b([
                    Si(n)
                ])),
                c
            ]));
        }(), f = s.a, l = s.b, d = Ti(n), h = d.a, v = d.b, m = We(h / v * 16), p = b([
            "svg-inline--fa",
            "fa-" + e.aO,
            "fa-w-" + Se(m)
        ]);
        return A2(Mi, xu(b([
            b([
                A2(wi, "role", r),
                A2(wi, "xmlns", "http://www.w3.org/2000/svg"),
                uo("0 0 " + Se(h) + " " + Se(v)),
                f
            ]),
            A2(qr, yi, p),
            A2(qr, xi(_r), o),
            t
        ])), l);
    }), io = function(n) {
        return A2(ao, n, f);
    }, oo = A2(ai, b([
        Ra("footer hero is-dark zeitplan-footer")
    ]), b([
        A2(Ba, b([
            Ra("mt-3 is-flex is-flex-direction-column has-text-weight-bold")
        ]), b([
            A2(hi, f, b([
                gi("This project was made possible thanks to Professor Victor Drescher at Southeastern Louisiana University.")
            ])),
            A2(Ya, b([
                Ra("columns")
            ]), b([
                A2(Ya, b([
                    Ra("column is-4 is-flex is-flex-direction-column")
                ]), b([
                    A2(ci, b([
                        Ra("is-5 title")
                    ]), b([
                        gi("If you found Zeitplan useful")
                    ])),
                    A2(Da, b([
                        li(A3(ni, "https://github.com", b([
                            "sponsors",
                            "TheLetterTheta"
                        ]), f)),
                        mi("_blank")
                    ]), b([
                        A2(vi, b([
                            Ra("icon")
                        ]), b([
                            io(fi)
                        ])),
                        A2(vi, f, b([
                            gi("Sponsor the project")
                        ]))
                    ])),
                    A2(Da, b([
                        li(A3(ni, "https://github.com", b([
                            "TheLetterTheta",
                            "Zeitplan"
                        ]), f)),
                        mi("_blank")
                    ]), b([
                        A2(vi, b([
                            Ra("icon")
                        ]), b([
                            io(oi)
                        ])),
                        A2(vi, f, b([
                            gi("Suggest an edit")
                        ]))
                    ]))
                ])),
                A2(Ya, b([
                    Ra("column is-narrow p-0 divider is-vertical")
                ]), b([
                    gi("Also")
                ])),
                A2(Ya, b([
                    Ra("column is-4 is-flex is-flex-direction-column")
                ]), b([
                    A2(ci, b([
                        Ra("is-5 subtitle")
                    ]), b([
                        gi("Support Mr. Drescher by checking out")
                    ])),
                    A2(Da, b([
                        li(A3(ni, "https://www.facebook.com", b([
                            "DrescherMusic"
                        ]), f)),
                        mi("_blank")
                    ]), b([
                        A2(vi, b([
                            Ra("icon")
                        ]), b([
                            io(ui)
                        ])),
                        A2(vi, f, b([
                            gi("Facebook")
                        ]))
                    ])),
                    A2(Da, b([
                        li(A3(ni, "https://dreschermusic.com", f, f)),
                        mi("_blank")
                    ]), b([
                        A2(vi, b([
                            Ra("icon")
                        ]), b([
                            io(bi)
                        ])),
                        A2(vi, f, b([
                            gi("DrescherMusic.com")
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ])), co = Kn("h1"), so = Kn("i"), fo = Ga("id"), lo = nt, bo = F2(function(n, t) {
        return A2(lo, n, {
            $: 0,
            a: t
        });
    }), ho = function(n) {
        return A2(bo, "click", pr(n));
    }, vo = Kn("strong"), mo = tt, po = mo, go = {
        $: 9
    }, $o = {
        $: 0
    }, wo = function(n) {
        return A2(wi, "aria-hidden", n ? "true" : "false");
    }, yo = function(n) {
        return A2(wi, "aria-label", n);
    }, Co = Kn("button"), ko = F2(function(n, t) {
        return A3(Ir, F2(function(t, e) {
            return n(t) ? A2(ce, t, e) : e;
        }), f, t);
    }), xo = function(n) {
        return n.b;
    }, zo = function(n) {
        return Ra(A2(He, " ", A2(qr, sr, A2(ko, xo, n))));
    }, Mo = function(n) {
        return !!n.$;
    }, So = Ga("alt"), Ho = Kn("img"), To = function(n) {
        return A2(rt, "width", Se(n));
    }, Ao = Kn("nav"), Lo = function(n) {
        return A2(wi, "role", n);
    }, Vo = function(n) {
        var t, e;
        return A2(Ao, b([
            Ra("navbar is-primary"),
            Lo("navigation"),
            yo("main navigation")
        ]), b([
            A2(Ya, b([
                Ra("navbar-brand is-flex is-align-content-space-between")
            ]), b([
                A2(Ya, b([
                    Ra("navbar-item is-flex-grow-1")
                ]), b([
                    (t = n.T.bH, A2(Ho, b([
                        To(28),
                        A2(rt, "height", Se(28)),
                        So("Zeitplan logo"),
                        (e = t, A2(Ga, "src", ct(e)))
                    ]), f))
                ])),
                A2(Co, b([
                    Ra("navbar-burger is-flex-shrink-1"),
                    zo(b([
                        i("is-active", n.T.a9)
                    ])),
                    yo("menu"),
                    ho($o)
                ]), b([
                    A2(vi, b([
                        wo(!0)
                    ]), f),
                    A2(vi, b([
                        wo(!0)
                    ]), f),
                    A2(vi, b([
                        wo(!0)
                    ]), f)
                ]))
            ])),
            A2(Ya, b([
                Ra("navbar-menu"),
                zo(b([
                    i("is-active", n.T.a9)
                ]))
            ]), b([
                A2(Ya, b([
                    Ra("navbar-start")
                ]), s(b([
                    A2(Da, b([
                        Ra("navbar-item"),
                        li(Ta(1))
                    ]), b([
                        gi("Home")
                    ])),
                    A2(Da, b([
                        Ra("navbar-item"),
                        li(Ta(0))
                    ]), b([
                        gi("About")
                    ])),
                    A2(Da, b([
                        Ra("navbar-item"),
                        li(Ta(4))
                    ]), b([
                        gi("Pricing")
                    ]))
                ]), Mo(n.T.c5) ? f : b([
                    A2(Da, b([
                        Ra("navbar-item"),
                        li(Ta(5))
                    ]), b([
                        gi("Schedule")
                    ]))
                ]))),
                A2(Ya, b([
                    Ra("navbar-end")
                ]), b([
                    Mo(n.T.c5) ? A2(Da, b([
                        Ra("navbar-item"),
                        li(Ta(2))
                    ]), b([
                        gi("Log In")
                    ])) : A2(Da, b([
                        Ra("navbar-item"),
                        li("#"),
                        ho(go),
                        Lo("button")
                    ]), b([
                        gi("Logout")
                    ]))
                ]))
            ]))
        ]));
    }, Eo = F2(function(n) {
        return {
            cb: b([
                A2(Ma, $r, Vo({
                    bH: n.bH,
                    T: n
                })),
                A2(Ya, b([
                    Ra("is-small section")
                ]), b([
                    A2(Ya, b([
                        Ra("container")
                    ]), b([
                        A2(Ya, b([
                            Ra("hero is-dark")
                        ]), b([
                            A2(Ya, b([
                                Ra("hero-body")
                            ]), b([
                                A2(co, b([
                                    Ra("is-1 title")
                                ]), b([
                                    gi("About Zeitplan")
                                ])),
                                A2(ci, b([
                                    Ra("subtitle")
                                ]), b([
                                    gi("A place for questions and (hopefully) answers")
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                A2(Ya, b([
                    Ra("section")
                ]), b([
                    A2(Wa, f, b([
                        A2(Ba, f, b([
                            A2(Da, b([
                                ho(qa("whats-a-zeitplan")),
                                li(A4(Qa, Ia, f, f, ke("whats-a-zeitplan")))
                            ]), b([
                                A2(ci, b([
                                    fo("whats-a-zeitplan"),
                                    Ra("is-size-3")
                                ]), b([
                                    gi('What\'s a "Zeitplan"? ')
                                ]))
                            ])),
                            A2(hi, f, b([
                                gi('\n                        Before we answer that question, we need a little backstory...\n                        Victor Drescher is a music professor at Southeastern Louisiana University.\n                        The main developer of this application was one of his students, and was working on a piece\n                        of music that was German. Mr. Drescher proposed that it took him hours to plan out when to\n                        meet with his students on a weekly basis. Thus, the idea of "The Scheduler" was born!\n                        ')
                            ])),
                            A2(hi, f, b([
                                gi('\n                        The name, "The Scheduler" wasn\'t going to stick for very long. So, the project was renamed\n                        to the German word for "schedule" instead: Zeitplan! The name was originally meant as a placeholder\n                        for a more permanent name, but it eventually stuck. And so, the project is named Zeitplan to this day!\n                        ')
                            ])),
                            A2(Da, b([
                                ho(qa("what-does-it-do")),
                                li(A4(Qa, Ia, f, f, ke("what-does-it-do")))
                            ]), b([
                                A2(ci, b([
                                    fo("what-does-it-do"),
                                    Ra("is-size-3")
                                ]), b([
                                    gi("What does it do?")
                                ]))
                            ])),
                            A2(hi, f, b([
                                gi("Mr. Drescher's original dilema was this:")
                            ])),
                            A2(hi, b([
                                Ra("has-text-centered")
                            ]), b([
                                A2(so, f, b([
                                    gi("\n                        There are many apps that help you schedule a single meeting, but nothing that helps me schedule\n                        ~20+ meetings at the same time.\n                        ")
                                ]))
                            ])),
                            A2(hi, f, b([
                                gi("\n                    At first, it sounded unbelieveable. Surely there was something that could simply do the same thing 20x over,\n                    and still generate a schedule that fit? Right?\n                    ")
                            ])),
                            A2(hi, f, b([
                                gi("\n                    Wrong! Or if it exists, it's not well known enough to be doing people like Mr. Drescher any good.\n                    Nothing that even does 5 meetings at the same time. No matter, it sounds easy enough!\n                    ")
                            ])),
                            A2(hi, b([
                                Ra("has-text-centered")
                            ]), b([
                                A2(so, f, b([
                                    gi("\n                            Just find when each meeting can be scheduled and... oh... this isn't as easy as I thought. \n                            ")
                                ]))
                            ])),
                            A2(hi, f, b([
                                gi("\n                        So the problem isn't as easy as originally thought. Turns out what we need is something like a \n                        "),
                                A2(Ua, b([
                                    Ra("is-family-code")
                                ]), b([
                                    gi("cartesian product")
                                ])),
                                gi(" of all the meetings, and a lot of time looking for the "),
                                A2(vo, f, b([
                                    gi("right combination")
                                ])),
                                gi(" of those meetings that is a good schedule.")
                            ])),
                            A2(hi, f, b([
                                gi("\n                        And this is the process that many in Mr. Drescher's situation attempting to do by hand. That's where\n                        Zeitplan comes in.\n                        ")
                            ])),
                            A2(Fa, f, b([
                                A2(so, f, b([
                                    gi("\n                        What used to take me hours to sort student schedules now takes about 45 minutes- it’s fantastic.\n                        ")
                                ])),
                                A2(hi, f, b([
                                    gi("- Victor Drescher")
                                ]))
                            ])),
                            A2(Da, b([
                                ho(qa("faq")),
                                li(A4(Qa, Ia, f, f, ke("faq")))
                            ]), b([
                                A2(ci, b([
                                    fo("faq"),
                                    Ra("is-size-3")
                                ]), b([
                                    gi("Frequently Asked Questions")
                                ]))
                            ])),
                            A2(hi, f, b([
                                A2(vo, f, b([
                                    gi("How many meetings can I schedule?")
                                ]))
                            ])),
                            A2(hi, f, b([
                                gi("\n                    Currently, only a 1 week timeframe can be scheduled. The minimum size of a meeting is 30 min.\n                    There are (as everyone is already aware) 336 30-minute intervals in a week. So, the most meetings\n                    you could schedule at one time is 336.\n                    You can, however generate a schedule this way, and continue to use the program!\n                    ")
                            ])),
                            A2(hi, f, b([
                                A2(vo, f, b([
                                    gi("This is taking a long time. I think it's stuck")
                                ]))
                            ])),
                            A2(hi, b([
                                Ra("is-wrap-text")
                            ]), b([
                                gi("\n                    That's not a question, but I'll answer it anyway! The number of possible schedules we need to analyze for the default\n                    week view in Zeitplan is a whopping\n                    "),
                                A2(Ua, b([
                                    A2(po, "word-break", "break-all")
                                ]), b([
                                    gi("707,941,224,973,776,291,093,837,493,051,267,117,605,376,723,076,915,563,513,477,597,978,647,196,852,710,146,048,782,874,897,075,955,894,104,953,184,864,576,196,144,825,576,943,931,128,199,472,378,261,795,861,931,974,957,688,311,237,681,682,031,691,366,087,383,492,525,475,626,202,835,152,044,870,005,449,098,250,592,421,885,320,204,847,428,102,564,080,042,137,500,502,947,619,347,768,122,327,941,080,451,839,131,251,991,696,797,801,434,243,553,028,397,371,613,542,311,928,832,902,663,472,677,761,721,549,526,113,056,029,984,995,819,524,704,354,822,624,666,292,991,477,232,130,327,433,304,881,523,787,028,883,795,947,102,784,291,416,129,589,695,015,805,337,539,264,492,307,555,753,716,879,695,344,357,979,188,084,112,721,486,214,822,552,206,966,345,890,231,289,687,237,950,447,464,115,396,984,096,898,391,196,909,695,809,036,630,324,500,769,619,930,968,248,631,451,227,869,005,449,623,566,329,692,609,930,440,559,431,377,271,635,608,873,359,171,946,166,367,460,584,277,699,826,134,971,929,228,806,950,423,081,181,843,641,763,509,694,660,317,093,440,761,351,296,251,922,615,893,476,691,290,071,647,755,667,379,012,463,240,136,359,936")
                                ])),
                                gi("\n                    possible configurations. Luckily, a lot of work has been done to optimize what Zeitplan is doing, so that each check\n                    is as efficient as possible.\n                    ")
                            ]))
                        ]))
                    ]))
                ])),
                oo
            ]),
            c$: "Zeitplan - About"
        };
    }), Zo = F2(function(n) {
        return Za({
            Z: _a,
            ab: ja,
            aq: Oa,
            V: Eo(n)
        });
    }), Po = function(n) {
        return {
            am: n
        };
    }, _o = function(n) {
        var t = n.H.cn;
        n: for(; !t.$;)switch(t.a){
            case "participants":
                return i(Po(1), Pa);
            case "meetings":
                return i(Po(2), Pa);
            case "schedule":
                return i(Po(3), Pa);
            default:
                break n;
        }
        return i(Po(0), Pa);
    }, jo = function() {
        return va;
    }, No = function(n) {
        switch(n){
            case 0:
                return "overview";
            case 1:
                return "participants";
            case 2:
                return "meetings";
            default:
                return "schedule";
        }
    }, Oo = F2(function(n, t) {
        if (1 === n.$) {
            var e = n.a;
            return i(c(t, {
                am: e
            }), Na(qa(No(e))));
        }
        return i(t, Na(n.a));
    }), Io = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Do = Kn("li"), Fo = Kn("em"), Xo = Kn("section"), Go = A2(Xo, b([
        Ra("section is-large")
    ]), b([
        A2(co, b([
            Ra("title is-1")
        ]), b([
            gi("Step 2")
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("What is a meeting?")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi('\n            Zeitplan considers a "meeting" to be anything which you need scheduled. Meetings have a duration (30, 60, 90, 120\n            min.), a title (for identifying later), and participants. You can have one or more participants per meeting (for\n            groups).\n            ')
            ]))
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("Limitations")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n            Currently, meetings can only be scheduled in 30 minute intervals up to 2 hours in length. There is also no way\n            to currently schedule a meeting \n              "),
                A2(Fo, f, b([
                    gi("X minutes after")
                ])),
                gi("\n                some other meeting (consider a recurring meeting every day). Given that there is only space for 1 week of\n                times, there are a technical maximum of 336 meetings possible.\n                ")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n            You can consider helping out these limitations by submitting an issue, or a Pull Request with a solution!\n            ")
            ]))
        ]))
    ])), Ro = Kn("br"), Uo = F2(function(n, t) {
        return s(A2(He, "/", n), Ka(t));
    }), Yo = Kn("ul"), Wo = A2(Xo, b([
        Ra("section is-large")
    ]), b([
        A2(co, b([
            Ra("title is-1")
        ]), b([
            gi("Who is this for?")
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("subtitle is-3")
            ]), b([
                gi("Use cases")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi('\n        Zeitplan was originally created for this use case: A University\'s Music Instructor\'s\n        students and their schedules. "Participants" as we now call them originally were "students"; "meetings"\n        were ensembles and private lessons; the "schedule" was posted by the instructor for students to\n        adhere to all semester.\n        '),
                A2(Ro, f, f),
                gi("\n        Since then, Zeitplan has come a long way to accomodate more and more use cases. As a scheduling application,\n        it works great! If you think of something you'd like to see in this application, please \n        "),
                A2(Da, b([
                    li(A3(ni, "https://github.com", b([
                        "TheLetterTheta",
                        "Zeitplan",
                        "issues"
                    ]), f)),
                    mi("_blank")
                ]), b([
                    gi("check for an existing issue")
                ])),
                gi(" and consider showing support for it, or "),
                A2(Da, b([
                    li(A3(ni, "https://github.com", b([
                        "TheLetterTheta",
                        "Zeitplan",
                        "issues",
                        "new"
                    ]), f)),
                    mi("_blank")
                ]), b([
                    gi("open your own issue")
                ])),
                gi("\n         and let us know how we can improve.\n        ")
            ]))
        ])),
        A2(co, b([
            Ra("title is-1")
        ]), b([
            gi("Is this right for me?")
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("Does your calendar already do this")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n        Zeitplan is an excellent tool for what it does. Though there are many useful features for creating\n        schedules, it may not be best suited for your specific needs.\n        "),
                A2(Ro, f, f),
                gi("\n        Does it tell you when you can meet with one of your friends? Yes! Though, that feature exists in\n        many other calendars you are probably already using. You're more than welcome to use Zeitplan as\n        well, but it might not be the tool you're looking for.\n        "),
                A2(Ro, b([
                    Ra("block")
                ]), f),
                gi("\n        Here's what Zeitplan offers:\n        "),
                A2(Yo, f, b([
                    A2(Do, f, b([
                        gi("Managing any number of participants")
                    ])),
                    A2(Do, f, b([
                        gi("Availability at a glance")
                    ])),
                    A2(Do, f, b([
                        gi("Easy scheduling of group events")
                    ])),
                    A2(Do, f, b([
                        gi("A scheduler that searches for a solution")
                    ])),
                    A2(Do, f, b([
                        gi("Reliable technology designed for stability and performance")
                    ]))
                ])),
                gi("A solution? To what exactly?"),
                A2(Ro, f, f),
                gi("Well, check out our "),
                A2(Da, b([
                    li(A2(Uo, b([
                        "about"
                    ]), f))
                ]), b([
                    gi("about page")
                ])),
                gi(" for more details, but some schedules are definitely harder to manage than others")
            ]))
        ])),
        A2(Ro, f, f),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("subtitle is-3")
            ]), b([
                gi("Sponsors")
            ])),
            A2(hi, b([
                Ra("is-medium content")
            ]), b([
                gi("These are the people who have made Zeitplan possible."),
                A2(Yo, f, b([
                    A2(Do, f, b([
                        gi("Professor Victor Drescher "),
                        A2(Da, b([
                            li(A3(ni, "https://dreschermusic.com", f, f)),
                            mi("_blank")
                        ]), b([
                            gi("(DrescherMusic.com)")
                        ]))
                    ]))
                ])),
                gi("Want to be added? Consider "),
                A2(Da, b([
                    li(A3(ni, "https://github.com", b([
                        "sponsors",
                        "TheLetterTheta"
                    ]), f)),
                    mi("_blank")
                ]), b([
                    gi("becoming a sponsor!")
                ])),
                gi(" Check the sponsor tiers for more information")
            ]))
        ]))
    ])), Bo = A2(Xo, b([
        Ra("section is-large")
    ]), b([
        A2(co, b([
            Ra("title is-1")
        ]), b([
            gi("Step 1")
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("Who are the participants?")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi('\n            Anyone you need to meet with is considered a "participant". This does\n            '),
                A2(vo, f, b([
                    gi(" NOT ")
                ])),
                gi('\n            include yourself. You are always considered one of the "participants". You can have as many participants\n            setup as you want. Anyone who will need to be part of the schedule later should be setup.\n            ')
            ]))
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("Blocking times")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n            Other people are busy too! They have things to do in their weeks - work, classes, other meetings. Zeitplan\n            has a built in calendar for each participant to record these blocked times. When computing the final schedule,\n            participants will not be able to be scheduled during these times.\n            ")
            ]))
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("What about groups?")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n            Zeitplan can handle groups on its own. Do not worry about trying to find common times between the group members\n            beforehand. This also makes it easier to schedule things such as private lessons, and group meetings with the\n            same participant.\n            ")
            ]))
        ]))
    ])), Jo = A2(Xo, b([
        Ra("section is-large")
    ]), b([
        A2(co, b([
            Ra("title is-1")
        ]), b([
            gi("Zeitplan!")
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("Your Schedule")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n                Here, put the times you're available to have all of these meetings. This is what Zeitplan will look\n                through, to try to place your meetings.\n              ")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n                This is not the times you can't meet. You're not blocking any times in this section. Why? It didn't\n                feel very intuitive that way. If you'd like to meet between 8:00 - 10:00 on Monday, you would rather\n                enter 8:00 - 10:00 on Monday, than block off Sunday @ 12:00 - Monday @ 8:00 AND Monday @ 10:00 - Saturday\n                @ 12:00\n            ")
            ]))
        ])),
        A2(Ya, b([
            Ra("box")
        ]), b([
            A2(ci, b([
                Ra("is-3 subtitle")
            ]), b([
                gi("Make it yours")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n                You're no longer spending hours trying to fit these meetings into your life. You no longer have to sacrifice\n                your own schedule unnecessarilly just to make things easier.\n              ")
            ])),
            A2(hi, b([
                Ra("content is-medium")
            ]), b([
                gi("\n                From here, it's as easy as pressing a button - and letting Zeitplan handle the scheduling. Zeitplan will\n                do its best (which turns out to be really good) to find that perfect schedule for you. So go ahead and\n                try to give\n            "),
                A2(vo, f, b([
                    gi("yourself")
                ])),
                gi("\n            the best schedule you can. If it didn't work, play with your avaialable times a bit more, and try again. It's\n            as easy as pressing a button now. Each run should take a fraction of a second - often faster than humans can\n            detect, even.\n            ")
            ]))
        ]))
    ])), Ko = F2(function(n, t) {
        return {
            cb: b([
                A2(Ma, qo, Vo({
                    bH: n.bH,
                    T: n
                })),
                A2(Xo, b([
                    Ra("hero is-fullheight-with-navbar is-dark")
                ]), b([
                    A2(Ya, b([
                        Ra("hero-head")
                    ]), b([
                        A2(Ya, b([
                            Ra("section is-medium")
                        ]), b([
                            A2(Ya, b([
                                Ra("container")
                            ]), b([
                                A2(co, b([
                                    Ra("is-1 title")
                                ]), b([
                                    gi("Zeitplan")
                                ])),
                                A2(hi, b([
                                    Ra("subtitle")
                                ]), b([
                                    gi("A different kind of scheduler")
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("hero-body")
                    ]), b([
                        A2(Ya, b([
                            Ra("container")
                        ]), b([
                            A2(ci, b([
                                Ra("title")
                            ]), b([
                                gi("Does this describe you?")
                            ])),
                            A2(Ya, b([
                                Ra("content")
                            ]), b([
                                A2(Yo, f, b([
                                    A2(Do, b([
                                        Ra("subtitle")
                                    ]), b([
                                        gi("\n                            Are you spending too much time trying to fit everyone into your schedule?\n                            ")
                                    ])),
                                    A2(Do, b([
                                        Ra("subtitle")
                                    ]), b([
                                        gi("\n                            Do you need to setup a schedule that's more complex than your calendar currently\n                            helps you with?\n                            ")
                                    ])),
                                    A2(Do, b([
                                        Ra("subtitle")
                                    ]), b([
                                        gi("\n                            Have you ever settled for a schedule that asked too much of\n                            "),
                                        A2(vo, f, b([
                                            gi("you")
                                        ])),
                                        gi(" because you had given up?")
                                    ])),
                                    A2(Do, b([
                                        Ra("subtitle")
                                    ]), b([
                                        gi('\n                            Have you ever asked yourself, "There has to be an easier way to plan all these things!"\n                            ')
                                    ]))
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("is-flex")
                            ]), b([
                                A2(Ya, b([
                                    Ra("my-6")
                                ]), b([
                                    A2(ci, b([
                                        Ra("title")
                                    ]), b([
                                        gi("Ready to get started?")
                                    ])),
                                    A2(Co, b([
                                        Ra("button is-link")
                                    ]), b([
                                        A2(Da, b([
                                            li(Ta(2))
                                        ]), b([
                                            gi("Create an account or Log in here!")
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("hero-foot")
                    ]), b([
                        A2(Ya, b([
                            Ra("tabs is-large is-boxed is-fullwidth")
                        ]), b([
                            A2(Ya, b([
                                Ra("container")
                            ]), b([
                                A2(Yo, f, b([
                                    A2(Do, b([
                                        fo(No(0)),
                                        zo(b([
                                            i("is-active", !t.am)
                                        ]))
                                    ]), b([
                                        A2(Da, b([
                                            li(A4(Qa, Ia, f, f, ke(No(0)))),
                                            ho(Io(0))
                                        ]), b([
                                            gi("Overview / Is this for me?")
                                        ]))
                                    ])),
                                    A2(Do, b([
                                        fo(No(1)),
                                        zo(b([
                                            i("is-active", 1 === t.am)
                                        ]))
                                    ]), b([
                                        A2(Da, b([
                                            li(A4(Qa, Ia, f, f, ke(No(1)))),
                                            ho(Io(1))
                                        ]), b([
                                            gi("Setting up Participants")
                                        ]))
                                    ])),
                                    A2(Do, b([
                                        fo(No(2)),
                                        zo(b([
                                            i("is-active", 2 === t.am)
                                        ]))
                                    ]), b([
                                        A2(Da, b([
                                            li(A4(Qa, Ia, f, f, ke(No(2)))),
                                            ho(Io(2))
                                        ]), b([
                                            gi("Preplan your Meetings")
                                        ]))
                                    ])),
                                    A2(Do, b([
                                        fo(No(3)),
                                        zo(b([
                                            i("is-active", 3 === t.am)
                                        ]))
                                    ]), b([
                                        A2(Da, b([
                                            li(A4(Qa, Ia, f, f, ke(No(3)))),
                                            ho(Io(3))
                                        ]), b([
                                            gi("Plan your schedule")
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                A2(Ya, b([
                    Ra("container")
                ]), b([
                    function() {
                        switch(t.am){
                            case 0:
                                return Wo;
                            case 1:
                                return Bo;
                            case 2:
                                return Go;
                            default:
                                return Jo;
                        }
                    }()
                ])),
                oo
            ]),
            c$: "Zeitplan - Home"
        };
    }), Qo = F2(function(n, t) {
        return Za({
            Z: _o(t),
            ab: jo,
            aq: Oo,
            V: Ko(n)
        });
    }), nc = F2(function(n, t) {
        return {
            G: t,
            u: n
        };
    }), tc = It, ec = F2(function(n, t) {
        return A2(tc, t.N, Ta(n));
    }), rc = F2(function(n, t) {
        return i((function(n) {
            return function(t) {
                return function(e) {
                    return function(r) {
                        return function(u) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(c) {
                                            return function(s) {
                                                return {
                                                    l: n,
                                                    ae: t,
                                                    M: e,
                                                    i: o,
                                                    b: i,
                                                    cX: s,
                                                    h: 0,
                                                    aE: c,
                                                    I: a,
                                                    y: u,
                                                    C: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(A2(nc, "", ""))("")("")(xe)(xe)(xe)(xe)(!1)(xe)(xe), e(n, xe) ? Pa : $a(A2(ec, 5, t)));
    }), uc = function(n) {
        return {
            $: 25,
            a: n
        };
    }, ac = function(n) {
        return {
            $: 24,
            a: n
        };
    }, ic = function(n) {
        return {
            $: 22,
            a: n
        };
    }, oc = function(n) {
        return {
            $: 21,
            a: n
        };
    }, cc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, sc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fc = function(n) {
        return {
            $: 16,
            a: n
        };
    }, lc = function(n) {
        return {
            $: 15,
            a: n
        };
    }, dc = function(n) {
        return {
            $: 19,
            a: n
        };
    }, bc = function(n) {
        return {
            $: 18,
            a: n
        };
    }, hc = function(n) {
        return {
            $: 9,
            a: n
        };
    }, vc = function(n) {
        return {
            $: 8,
            a: n
        };
    }, mc = function(n) {
        return {
            $: 6,
            a: n
        };
    }, pc = function(n) {
        return {
            $: 5,
            a: n
        };
    }, gc = R, $c = Xn("forgotPasswordErr", gc), wc = Xn("forgotPasswordOk", gc), yc = Xn("forgotPasswordSubmitErr", gc), Cc = Xn("forgotPasswordSubmitOk", gc), kc = Xn("resendConfirmationCodeErr", gc), xc = Xn("resendConfirmationCodeOk", gc), zc = Xn("signInErr", gc), Mc = Xn("signInOk", gc), Sc = Xn("signInWithGoogleError", gc), Hc = Xn("signInWithGoogleSuccess", gc), Tc = Xn("signUpConfirmErr", gc), Ac = Xn("signUpConfirmOk", gc), Lc = Xn("signUpErr", gc), Vc = Xn("signUpOk", gc), Ec = function() {
        return ha(b([
            Mc(sc),
            zc(cc),
            Vc(pc),
            Lc(mc),
            Ac(vc),
            Hc(lc),
            Sc(fc),
            Tc(hc),
            xc(bc),
            kc(dc),
            wc(oc),
            $c(ic),
            Cc(ac),
            yc(uc)
        ]));
    }, Zc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Pc = F4(function(n, t, e, r) {
        return {
            by: t,
            bz: r,
            bG: e,
            b$: n
        };
    }), _c = F, jc = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Nc = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Oc = function(n) {
        return Nc(b([
            jc(xe),
            A2(vr, ke, n)
        ]));
    }, Ic = mr(er), qc = B, Dc = Y, Fc = F2(function(n, t) {
        return A3(Ir, Dc, t, n);
    }), Xc = tn, Gc = F3(function(n, t, e) {
        var r = function(n) {
            return Nc(b([
                n,
                jc(e)
            ]));
        };
        return A2(qc, function(u) {
            var a = A2(Xc, A2(Fc, n, gc), u);
            if (a.$) return pr(e);
            var i = a.a, o = A2(Xc, r(t), i);
            return o.$ ? A2(Fc, n, r(t)) : pr(o.a);
        }, gc);
    }), Rc = F4(function(n, t, e, r) {
        return A2(Ic, A3(Gc, n, t, e), r);
    }), Uc = F3(function(n, t, e) {
        return A2(Ic, A2(Dc, n, t), e);
    }), Yc = U, Wc = A3(Uc, "expires", _c, A3(Uc, "jwt", Yc, A4(Rc, b([
        "attributes",
        "email"
    ]), Oc(Yc), xe, A3(Uc, "username", Yc, pr(Pc))))), Bc = {
        $: 1
    }, Jc = {
        $: 2
    }, Kc = {
        $: 0
    }, Qc = function(n) {
        return pr(function() {
            switch(n){
                case "UserNotFoundException":
                    return Kc;
                case "NotAuthorizedException":
                    return Bc;
                case "UserNotConfirmedException":
                    return Jc;
                default:
                    return {
                        $: 3,
                        a: n
                    };
            }
        }());
    }, ns = A2(qc, Qc, A2(Dc, "code", Yc)), ts = {
        $: 0
    }, es = {
        $: 1
    }, rs = function(n) {
        return pr(function() {
            switch(n){
                case "UserNotFoundException":
                    return ts;
                case "LimitExceededException":
                    return es;
                default:
                    return {
                        $: 2,
                        a: n
                    };
            }
        }());
    }, us = A2(qc, rs, A2(Dc, "code", Yc)), as = {
        $: 0
    }, is = function(n) {
        return pr("CodeMismatchException" === n ? as : {
            $: 1,
            a: n
        });
    }, os = A2(qc, is, A2(Dc, "code", Yc)), cs = {
        $: 0
    }, ss = {
        $: 1
    }, fs = function(n) {
        return pr(function() {
            switch(n){
                case "CodeMismatchException":
                    return cs;
                case "InvalidParameterException":
                    return ss;
                default:
                    return {
                        $: 2,
                        a: n
                    };
            }
        }());
    }, ls = A2(qc, fs, A2(Dc, "code", Yc)), ds = {
        $: 0
    }, bs = function(n) {
        return pr("UsernameExistsException" === n ? ds : {
            $: 1,
            a: n
        });
    }, hs = A2(qc, bs, A2(Dc, "code", Yc)), vs = qn("forgotPassword", Xa), ms = function(n) {
        return A3(Le, F2(function(n, t) {
            return A3(dn, n.a, n.b, t);
        }), {}, n);
    }, ps = qn("forgotPasswordSubmit", function(n) {
        return ms(b([
            i("code", Xa(n.bt)),
            i("password", Xa(n.G)),
            i("username", Xa(n.u))
        ]));
    }), gs = function(n) {
        return n;
    }, $s = function(n) {
        return !!n.$;
    }, ws = F3(function(n, t, e) {
        if (1 === t.$) return me(t.a);
        var r = t.a;
        return 1 === e.$ ? me(e.a) : we(A2(n, r, e.a));
    }), ys = qn("resendConfirmationCode", Xa), Cs = qn("signIn", function(n) {
        return ms(b([
            i("password", Xa(n.G)),
            i("username", Xa(n.u))
        ]));
    }), ks = null, xs = qn("signInWithGoogle", function() {
        return ks;
    }), zs = ln, Ms = qn("signUp", function(n) {
        return ms(b([
            i("autoSignIn", zs(n.b9)),
            i("password", Xa(n.G)),
            i("username", Xa(n.u))
        ]));
    }), Ss = qn("signUpConfirm", function(n) {
        return ms(b([
            i("code", Xa(n.bt)),
            i("username", Xa(n.u))
        ]));
    }), Hs = F3(function(n, t, e) {
        return {
            by: t,
            c6: e,
            b$: n
        };
    }), Ts = X, As = A3(Uc, "userConfirmed", Ts, A4(Rc, b([
        "user",
        "username"
    ]), Oc(Yc), xe, A3(Uc, "userSub", Yc, pr(Hs)))), Ls = F2(function(n, t) {
        var e = n(t);
        return e.b ? me(e) : we(t);
    }), Vs = F2(function(n, t) {
        for(;;){
            if (!n.b) return f;
            var e = n.b, r = (0, n.a)(t);
            if (r.b) return r;
            n = e;
        }
    }), Es = function(n) {
        return function(t) {
            return A2(Vs, n, t);
        };
    }, Zs = F2(function(n, t) {
        return function(e) {
            return n(e) ? b([
                t
            ]) : f;
        };
    }), Ps = F2(function(n, t) {
        return A2(Zs, function(t) {
            return function(n) {
                for(;;){
                    var t = De(n);
                    if (t.$) return !0;
                    var e = t.a;
                    if (" " !== (r = e.a) && "\n" !== r && "	" !== r && "\r" !== r) return !1;
                    n = e.b;
                }
                var r;
            }(n(t));
        }, t);
    }), _s = F2(function(n, t) {
        return function(e) {
            return n(e) ? f : b([
                t
            ]);
        };
    }), js = function(n) {
        return Es(b([
            A2(Ps, $r, "You must retype the password"),
            A2(_s, function(t) {
                return e(t, n);
            }, "Passwords do not match")
        ]));
    }, Ns = F4(function(n, t, e, r) {
        return {
            cu: t,
            cC: n,
            cG: e,
            c_: r
        };
    }), Os = Kt, Is = Jt, qs = function(n) {
        return A2(Is, {
            cd: !1,
            cF: !1
        }, n);
    }, Ds = /.^/, Fs = Os(A2(wu, Ds, qs("[0-9]"))), Xs = Os(A2(wu, Ds, qs("[a-z]"))), Gs = Os(A2(wu, Ds, qs("[^a-zA-Z0-9]"))), Rs = Os(A2(wu, Ds, qs("[A-Z]"))), Us = Es(b([
        A2(Ps, $r, "Please enter a password"),
        A2(_s, Xs, "Password must contain a lowercase letter"),
        A2(_s, Rs, "Password must contain an uppercase letter"),
        A2(_s, Fs, "Password must contain a digit 0-9"),
        A2(_s, Gs, "Password must contain a special character"),
        A2(Zs, function(n) {
            return 12 > kr(n);
        }, "Password must be at least 12 characters")
    ])), Ys = A2(wu, Ds, A2(Is, {
        cd: !0,
        cF: !1
    }, "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$")), Ws = F2(function(n, t) {
        return function(e) {
            var r = n(e);
            return function(n) {
                return A2(Os, Ys, n);
            }(r) ? f : b([
                t(r)
            ]);
        };
    }), Bs = Es(b([
        A2(Ps, $r, "Please enter a username"),
        A2(Ws, $r, function() {
            return "Email must be an email";
        })
    ])), Js = F3(function(n, t, e) {
        switch(t.$){
            case 0:
                return i(c(e, {
                    h: t.a
                }), Pa);
            case 1:
                var r = A3(mu, ws(function(n) {
                    return function(t) {
                        return {
                            G: t,
                            u: n
                        };
                    };
                }), e.C, e.y);
                return i(e, r.$ || r.a.$ ? Pa : $a(Cs(f = r.a.a)));
            case 14:
                return i(c(e, {
                    i: !0
                }), $a(xs(0)));
            case 15:
                return i(c(e, {
                    i: !1,
                    h: 3
                }), Pa);
            case 16:
                return i(c(e, {
                    i: !1,
                    b: ke("Could not login with Google!"),
                    h: 0
                }), Pa);
            case 2:
                var u = A2(Xc, Wc, $ = t.a);
                if (u.$) return i(c(e, {
                    b: ke(Xe(u.a))
                }), Pa);
                var a = u.a;
                return i(c(e, {
                    b: xe
                }), Na(Zc(a)));
            case 3:
                var o = A2(Xc, ns, t.a);
                if (o.$) return i(c(e, {
                    b: ke("Something went wrong!")
                }), Pa);
                switch(o.a.$){
                    case 0:
                        return i(c(e, {
                            b: ke("Account does not exist! Please create an account to continue"),
                            h: 1
                        }), Pa);
                    case 1:
                        return i(c(e, {
                            b: ke("Wrong password")
                        }), Pa);
                    case 2:
                        return i(c(e, {
                            h: 2
                        }), Pa);
                    default:
                        return i(c(e, {
                            b: ke(o.a.a)
                        }), Pa);
                }
            case 4:
                var s = A3(mu, ws(function(n) {
                    return function(t) {
                        return {
                            b9: !0,
                            G: t,
                            u: n
                        };
                    };
                }), e.C, e.y);
                if (s.$ || s.a.$) return i(e, Pa);
                var f = s.a.a;
                return A2(wu, !0, A2(uu, $s, e.I)) ? i(e, Pa) : i(c(e, {
                    b: xe
                }), $a(Ms(f)));
            case 5:
                var l = A2(Xc, As, a = t.a);
                return i(c(e, l.$ ? {
                    b: ke("Something unexpected went wrong!")
                } : l.a.c6 ? {
                    b: xe,
                    h: 0
                } : {
                    ae: "",
                    b: xe,
                    h: 2
                }), Pa);
            case 6:
                var d = A2(Xc, hs, t.a);
                return i(d.$ ? c(e, {
                    b: ke("Something went wrong!")
                }) : c(e, d.a.$ ? {
                    b: ke(d.a.a)
                } : {
                    l: c(w = e.l, {
                        G: ""
                    }),
                    ae: "",
                    b: ke("An account with that email already exists - try logging in instead"),
                    h: 0,
                    I: xe
                }), Pa);
            case 7:
                return kr(e.M) ? i(e, $a(Ss({
                    bt: e.M,
                    u: e.l.u
                }))) : i(e, Pa);
            case 8:
                var b = A2(Xc, Wc, t.a);
                return b.$ ? i(c(e, {
                    b: ke("Could not verify user, please refresh the page")
                }), Pa) : (a = b.a, i(c(e, {
                    b: xe
                }), Na(Zc(a))));
            case 9:
                var h = A2(Xc, ls, t.a);
                if (h.$) return i(c(e, {
                    b: ke("Something went wrong! Please refresh the page, and login again.")
                }), Pa);
                switch(h.a.$){
                    case 0:
                        return i(c(e, {
                            b: ke("That code does not match")
                        }), Pa);
                    case 2:
                        return i(c(e, {
                            b: ke(h.a.a)
                        }), Pa);
                    default:
                        return i(c(e, {
                            b: ke("That is not a valid code")
                        }), Pa);
                }
            case 17:
                return i(c(e, {
                    i: !0
                }), $a(ys(e.l.u)));
            case 18:
                return i(c(e, {
                    i: !1,
                    aE: ke("A new confirmation code has been sent")
                }), Pa);
            case 19:
                return i(c(e, {
                    i: !1,
                    b: ke("Something went wrong!")
                }), Pa);
            case 20:
                return i(c(e, {
                    i: !0
                }), $a(vs(e.l.u)));
            case 21:
                return i(c(e, {
                    i: !1,
                    h: 5,
                    aE: ke("A code has been emailed to your account")
                }), Pa);
            case 22:
                var v = A2(Xc, us, t.a);
                if (v.$) return i(c(e, {
                    i: !1,
                    b: ke("Something went wrong - please refresh and try again.")
                }), Pa);
                switch(v.a.$){
                    case 0:
                        return i(c(e, {
                            i: !1,
                            b: ke("That account does not exist, try creating an account instead"),
                            h: 1
                        }), Pa);
                    case 1:
                        return i(c(e, {
                            i: !1,
                            b: ke("There have been too many attempts to reset that account password")
                        }), Pa);
                    default:
                        return i(c(e, {
                            i: !1,
                            b: ke("That account can't be recovered. Please file an issue if you believe there to be an error")
                        }), Pa);
                }
            case 23:
                var m = A3(mu, ws(function(n) {
                    return function(t) {
                        return {
                            G: t,
                            u: n
                        };
                    };
                }), e.C, e.y);
                return m.$ || m.a.$ ? i(e, Pa) : (f = m.a.a, i(c(e, {
                    i: !0
                }), $a(ps({
                    bt: e.M,
                    G: f.G,
                    u: f.u
                }))));
            case 24:
                return i(c(e, {
                    i: !1,
                    h: 0,
                    aE: ke("Your password has been reset - please login with your new credentials")
                }), Pa);
            case 25:
                var p = A2(Xc, os, t.a);
                return i(p.$ ? c(e, {
                    i: !1,
                    b: ke("Something went wrong")
                }) : c(e, p.a.$ ? {
                    i: !1,
                    b: ke("Your password could not be reset - please verify the information below again")
                } : {
                    i: !1,
                    b: ke("The code does not match")
                }), Pa);
            case 10:
                return i(c(e, {
                    b: xe
                }), Pa);
            case 11:
                return i(c(e, {
                    aE: xe
                }), Pa);
            case 12:
                return i(e, Na(t.a));
            default:
                var g = t.a, $ = t.b, w = e.l;
                return i(function() {
                    switch(g){
                        case 0:
                            var n = A2(Ls, Bs, $);
                            return c(e, {
                                l: c(w, {
                                    u: $
                                }),
                                C: ke(n)
                            });
                        case 1:
                            var t = A2(Ls, Us, $), r = A2(Ls, js($), e.ae);
                            return c(e, {
                                l: c(w, {
                                    G: $
                                }),
                                I: ke(r),
                                y: ke(t)
                            });
                        case 2:
                            return t = A2(Ls, js(e.l.G), $), c(e, {
                                ae: $,
                                I: ke(t)
                            });
                        default:
                            return c(e, {
                                M: $
                            });
                    }
                }(), Pa);
        }
    }), Ks = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Qs = yi("fa-4x"), nf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tf = {
        $: 1
    }, ef = {
        $: 14
    }, rf = {
        $: 17
    }, uf = {
        $: 20
    }, af = {
        $: 23
    }, of = F2(function(n, t) {
        return {
            $: 13,
            a: n,
            b: t
        };
    }), cf = {
        $: 7
    }, sf = {
        $: 4
    }, ff = F2(function(n, t) {
        return A2(et, n, zs(t));
    }), lf = ff("disabled"), df = Ga("htmlFor"), bf = Kn("form"), hf = ri(A4(ti, "fab", "google", i(488, 512), i("M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z", xe))), vf = Kn("header"), mf = Kn("input"), pf = Kn("label"), gf = F4(function(n, t, e, r) {
        return 1 === t.$ || 1 === e.$ || 1 === r.$ ? xe : ke(A3(n, t.a, e.a, r.a));
    }), $f = function(n) {
        return i(n, !0);
    }, wf = F2(function(n, t) {
        return A2(lo, n, {
            $: 1,
            a: t
        });
    }), yf = A2(Fc, b([
        "target",
        "value"
    ]), Yc), Cf = function(n) {
        return A2(wf, "input", A2(vr, $f, A2(vr, n, yf)));
    }, kf = function(n) {
        return i(n, !0);
    }, xf = F2(function(n, t) {
        return A2(lo, n, {
            $: 2,
            a: t
        });
    }), zf = function(n) {
        return A2(xf, "submit", A2(vr, kf, pr(n)));
    }, Mf = Ga("placeholder"), Sf = Ga("type"), Hf = ri(A4(ti, "fas", "user-plus", i(640, 512), i("M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM616 200h-48v-48C568 138.8 557.3 128 544 128s-24 10.75-24 24v48h-48C458.8 200 448 210.8 448 224s10.75 24 24 24h48v48C520 309.3 530.8 320 544 320s24-10.75 24-24v-48h48C629.3 248 640 237.3 640 224S629.3 200 616 200z", xe))), Tf = Ga("value"), Af = {
        $: 10
    }, Lf = function(n) {
        var t = n.b;
        if (t.$) return gi("");
        var e = t.a;
        return A2(Ya, b([
            Ra("notification is-danger is-light")
        ]), b([
            A2(Co, b([
                Sf("button"),
                Ra("delete"),
                ho(Af)
            ]), f),
            gi(e)
        ]));
    }, Vf = {
        $: 11
    }, Ef = function(n) {
        var t = n.aE;
        if (1 === t.$) return gi("");
        var e = t.a;
        return A2(Ya, b([
            Ra("notification is-success is-light")
        ]), b([
            A2(Co, b([
                Sf("button"),
                Ra("delete"),
                ho(Vf)
            ]), f),
            gi(e)
        ]));
    }, Zf = function(n) {
        var t, e, r, u, a;
        switch(n.h){
            case 3:
                return A2(Ya, b([
                    Ra("card")
                ]), b([
                    A2(Ya, b([
                        Ra("card-header")
                    ]), b([
                        A2(ci, b([
                            Ra("card-header-title")
                        ]), b([
                            gi("Please login to Google")
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("card-content")
                    ]), b([
                        A2(hi, f, b([
                            gi("Please wait while we attempt to contact Google")
                        ]))
                    ]))
                ]));
            case 0:
                return A2(bf, b([
                    zf(tf)
                ]), b([
                    A2(Co, b([
                        Ra("button is-primary is-fullwidth is-large"),
                        Sf("button"),
                        ho(ef)
                    ]), b([
                        A2(vi, b([
                            Ra("icon")
                        ]), b([
                            io(hf)
                        ])),
                        A2(vi, f, b([
                            gi("Login with Google")
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("divider py-3")
                    ]), b([
                        gi("Or")
                    ])),
                    A2(Ya, b([
                        Ra("card"),
                        A2(po, "width", "600px")
                    ]), b([
                        A2(vf, b([
                            Ra("card-header")
                        ]), b([
                            A2(ci, b([
                                Ra("card-header-title is-size-4")
                            ]), b([
                                gi("Login")
                            ])),
                            A2(Co, b([
                                Ra("card-header-icon"),
                                Sf("button"),
                                ho(nf(1))
                            ]), b([
                                A2(vi, b([
                                    Ra("mr-1")
                                ]), b([
                                    io(Hf)
                                ])),
                                A2(vi, f, b([
                                    gi("Sign Up")
                                ]))
                            ]))
                        ])),
                        A2(Ya, b([
                            Ra("card-content")
                        ]), A2(ce, Lf(n), A2(ce, Ef(n), b([
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("email")
                                ]), b([
                                    gi("Email")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.l.u),
                                        fo("email"),
                                        Ra("input"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.C)))
                                        ])),
                                        Sf("email"),
                                        Mf("Enter your email address..."),
                                        Cf(of(0))
                                    ]), f)
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("password")
                                ]), b([
                                    gi("Password")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.l.G),
                                        Ra("input"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.y)))
                                        ])),
                                        Sf("password"),
                                        fo("password"),
                                        Cf(of(1))
                                    ]), f)
                                ]))
                            ]))
                        ])))),
                        A2(Ya, b([
                            Ra("card-footer p-3 buttons")
                        ]), b([
                            A2(Ya, b([
                                Ra("is-flex is-flex-grow-1 is-justify-content-space-between")
                            ]), b([
                                A2(Ya, f, b([
                                    A2(Co, b([
                                        Ra("button is-primary"),
                                        Sf("submit"),
                                        lf(A2(wu, !1, A3(mu, function(n) {
                                            return function(t) {
                                                return $s(n) || $s(t);
                                            };
                                        }, n.C, n.y)))
                                    ]), b([
                                        gi("Log In")
                                    ]))
                                ])),
                                A2(Co, b([
                                    Ra("button is-text is-light"),
                                    Sf("button"),
                                    ho(nf(4))
                                ]), b([
                                    gi("Forgot Password?")
                                ]))
                            ]))
                        ]))
                    ]))
                ]));
            case 1:
                return A2(bf, b([
                    zf(sf)
                ]), b([
                    A2(Co, b([
                        Ra("button is-primary is-fullwidth is-large"),
                        Sf("button"),
                        ho(ef)
                    ]), b([
                        A2(vi, b([
                            Ra("icon")
                        ]), b([
                            io(hf)
                        ])),
                        A2(vi, f, b([
                            gi("Login with Google")
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("divider py-3")
                    ]), b([
                        gi("Or")
                    ])),
                    A2(Ya, b([
                        Ra("card"),
                        A2(po, "width", "600px")
                    ]), b([
                        A2(vf, b([
                            Ra("card-header")
                        ]), b([
                            A2(co, b([
                                Ra("card-header-title is-size-4")
                            ]), b([
                                gi("Create an account")
                            ]))
                        ])),
                        A2(Ya, b([
                            Ra("card-content")
                        ]), A2(ce, Lf(n), A2(ce, Ef(n), b([
                            A2(Ya, b([
                                Ra("field")
                            ]), s(b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("email")
                                ]), b([
                                    gi("Email")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.l.u),
                                        Ra("input"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.C)))
                                        ])),
                                        Sf("email"),
                                        fo("email"),
                                        Mf("Enter your email address..."),
                                        Cf(of(0))
                                    ]), f)
                                ]))
                            ]), (a = n.C, a.$ || 1 !== a.a.$ ? f : A2(wu, f, A2(uu, function(n) {
                                return b([
                                    A2(hi, b([
                                        Ra("help is-danger")
                                    ]), b([
                                        gi(n)
                                    ]))
                                ]);
                            }, vu(a.a.a)))))),
                            A2(Ya, b([
                                Ra("field")
                            ]), s(b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("password")
                                ]), b([
                                    gi("Password")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.l.G),
                                        Ra("input"),
                                        fo("password"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.y)))
                                        ])),
                                        Sf("password"),
                                        Cf(of(1))
                                    ]), f)
                                ]))
                            ]), (u = n.y, u.$ || 1 !== u.a.$ ? f : A2(wu, f, A2(uu, function(n) {
                                return b([
                                    A2(hi, b([
                                        Ra("help is-danger")
                                    ]), b([
                                        gi(n)
                                    ]))
                                ]);
                            }, vu(u.a.a)))))),
                            A2(Ya, b([
                                Ra("field")
                            ]), s(b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("confirm-password")
                                ]), b([
                                    gi("Confirm Password")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.ae),
                                        Ra("input"),
                                        fo("confirm-password"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.I)))
                                        ])),
                                        Sf("password"),
                                        Cf(of(2))
                                    ]), f)
                                ]))
                            ]), (r = n.I, r.$ || 1 !== r.a.$ ? f : A2(wu, f, A2(uu, function(n) {
                                return b([
                                    A2(hi, b([
                                        Ra("help is-danger")
                                    ]), b([
                                        gi(n)
                                    ]))
                                ]);
                            }, vu(r.a.a))))))
                        ])))),
                        A2(Ya, b([
                            Ra("card-footer p-3 buttons is-justify-content-space-between")
                        ]), b([
                            A2(Co, b([
                                Ra("button is-primary"),
                                Sf("submit"),
                                lf(A2(wu, !0, A4(gf, function(n) {
                                    return function(t) {
                                        return function(e) {
                                            return $s(n) || $s(t) || $s(e);
                                        };
                                    };
                                }, n.C, n.y, n.I)))
                            ]), b([
                                gi("Sign Up")
                            ])),
                            A2(Co, b([
                                Ra("button is-text is-light"),
                                Sf("button"),
                                ho(nf(0))
                            ]), b([
                                gi("Already have an account? Log In")
                            ]))
                        ]))
                    ]))
                ]));
            case 2:
                return A2(bf, b([
                    zf(cf)
                ]), b([
                    A2(Ya, b([
                        Ra("card"),
                        A2(po, "width", "600px")
                    ]), b([
                        A2(vf, b([
                            Ra("card-header")
                        ]), b([
                            A2(co, b([
                                Ra("card-header-title is-size-4")
                            ]), b([
                                gi("Confirm your account")
                            ]))
                        ])),
                        A2(Ya, b([
                            Ra("card-content")
                        ]), A2(ce, Lf(n), A2(ce, Ef(n), b([
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("code")
                                ]), b([
                                    gi("Confirmation Code")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.M),
                                        Ra("input"),
                                        fo("code"),
                                        Sf("text"),
                                        Mf("Enter the code sent to your email"),
                                        Cf(of(3))
                                    ]), f)
                                ]))
                            ]))
                        ])))),
                        A2(Ya, b([
                            Ra("card-footer p-3 buttons")
                        ]), b([
                            A2(Co, b([
                                Ra("button is-primary"),
                                Sf("submit"),
                                lf(!kr(n.M))
                            ]), b([
                                gi("Check Confirmation Code")
                            ])),
                            A2(Co, b([
                                Ra("button is-text is-light"),
                                Sf("button"),
                                ho(rf)
                            ]), b([
                                gi("Send new verification code")
                            ]))
                        ]))
                    ]))
                ]));
            case 4:
                return A2(bf, b([
                    zf(uf)
                ]), b([
                    A2(Ya, b([
                        Ra("card"),
                        A2(po, "width", "600px")
                    ]), b([
                        A2(vf, b([
                            Ra("card-header")
                        ]), b([
                            A2(co, b([
                                Ra("card-header-title is-size-4")
                            ]), b([
                                gi("Forgot Password")
                            ]))
                        ])),
                        A2(Ya, b([
                            Ra("card-content")
                        ]), A2(ce, Lf(n), A2(ce, Ef(n), b([
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("email")
                                ]), b([
                                    gi("Email")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.l.u),
                                        Ra("input"),
                                        fo("email"),
                                        Sf("email"),
                                        Mf("Enter your account email address"),
                                        Cf(of(0))
                                    ]), f)
                                ]))
                            ]))
                        ])))),
                        A2(Ya, b([
                            Ra("card-footer is-justify-content-space-between p-3 buttons")
                        ]), b([
                            A2(Co, b([
                                Ra("button is-primary"),
                                Sf("submit"),
                                lf(A2(wu, !0, A2(uu, $s, n.C)))
                            ]), b([
                                gi("Send reset code")
                            ])),
                            A2(Co, b([
                                Ra("button is-text is-light"),
                                Sf("button"),
                                ho(nf(0))
                            ]), b([
                                gi("Back to Login")
                            ]))
                        ]))
                    ]))
                ]));
            default:
                return A2(bf, b([
                    zf(af)
                ]), b([
                    A2(Ya, b([
                        Ra("card"),
                        A2(po, "width", "600px")
                    ]), b([
                        A2(vf, b([
                            Ra("card-header")
                        ]), b([
                            A2(co, b([
                                Ra("card-header-title is-size-4")
                            ]), b([
                                gi("Forgot Password Reset")
                            ]))
                        ])),
                        A2(Ya, b([
                            Ra("card-content")
                        ]), A2(ce, Lf(n), A2(ce, Ef(n), b([
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("email")
                                ]), b([
                                    gi("Email")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.l.u),
                                        Ra("input"),
                                        fo("email"),
                                        Sf("email"),
                                        Mf("Enter your account email address"),
                                        lf(!0)
                                    ]), f)
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("code")
                                ]), b([
                                    gi("Verification Code")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), b([
                                    A2(mf, b([
                                        Tf(n.M),
                                        Ra("input"),
                                        fo("code"),
                                        Sf("text"),
                                        Mf("Enter the verification code sent to your email"),
                                        Cf(of(3))
                                    ]), f)
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("password")
                                ]), b([
                                    gi("New Password")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), s(b([
                                    A2(mf, b([
                                        Tf(n.l.G),
                                        Ra("input"),
                                        fo("password"),
                                        Sf("password"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.y)))
                                        ])),
                                        Mf("Enter your new password"),
                                        Cf(of(1))
                                    ]), f)
                                ]), (e = n.y, e.$ || 1 !== e.a.$ ? f : A2(wu, f, A2(uu, function(n) {
                                    return b([
                                        A2(hi, b([
                                            Ra("help is-danger")
                                        ]), b([
                                            gi(n)
                                        ]))
                                    ]);
                                }, vu(e.a.a))))))
                            ])),
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label"),
                                    df("confirm-password")
                                ]), b([
                                    gi("Confirm New Password")
                                ])),
                                A2(Ya, b([
                                    Ra("control")
                                ]), s(b([
                                    A2(mf, b([
                                        Tf(n.ae),
                                        Ra("input"),
                                        fo("confirm-password"),
                                        zo(b([
                                            i("is-danger", A2(wu, !1, A2(uu, $s, n.I)))
                                        ])),
                                        Sf("password"),
                                        Mf("Re-enter your password"),
                                        Cf(of(2))
                                    ]), f)
                                ]), (t = n.I, t.$ || 1 !== t.a.$ ? f : A2(wu, f, A2(uu, function(n) {
                                    return b([
                                        A2(hi, b([
                                            Ra("help is-danger")
                                        ]), b([
                                            gi(n)
                                        ]))
                                    ]);
                                }, vu(t.a.a))))))
                            ]))
                        ])))),
                        A2(Ya, b([
                            Ra("card-footer is-justify-content-space-between p-3 buttons")
                        ]), b([
                            A2(Co, b([
                                Ra("button is-primary"),
                                lf(A2(wu, !0, A4(gf, function(t) {
                                    return function(e) {
                                        return function(r) {
                                            return $s(t) || $s(e) || $s(r) || 1 > kr(n.M);
                                        };
                                    };
                                }, n.C, n.y, n.I))),
                                Sf("submit")
                            ]), b([
                                gi("Reset Password")
                            ])),
                            A2(Co, b([
                                Ra("button is-text is-light"),
                                Sf("button"),
                                ho(nf(0))
                            ]), b([
                                gi("Back to Login")
                            ]))
                        ]))
                    ]))
                ]));
        }
    }, Pf = yi("fa-spin"), _f = ri(A4(ti, "fas", "spinner", i(512, 512), i("M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z", xe))), jf = F2(function(n, t) {
        return c(t, {
            aX: s(t.aX, n)
        });
    }), Nf = F2(function(n, t) {
        return {
            cb: b([
                A2(Ma, Ks, Vo({
                    bH: n.bH,
                    T: n
                })),
                A2(Xo, b([
                    Ra("section is-large")
                ]), b([
                    A2(Ya, b([
                        Ra("columns is-centered")
                    ]), b([
                        A2(Ya, b([
                            Ra("column is-narrow")
                        ]), b(t.i ? [
                            A2(Ya, b([
                                A2(po, "display", "grid"),
                                A2(po, "place-items", "center")
                            ]), b([
                                A2(vi, b([
                                    A2(po, "grid-column", "1"),
                                    A2(po, "grid-row", "1"),
                                    A2(po, "z-index", "2")
                                ]), b([
                                    io(A2(jf, b([
                                        Pf,
                                        Qs
                                    ]), _f))
                                ])),
                                A2(Ya, b([
                                    A2(po, "grid-column", "1"),
                                    A2(po, "grid-row", "1"),
                                    Ra("loading ignore-pointer-events is-clipped")
                                ]), b([
                                    Zf(t)
                                ]))
                            ]))
                        ] : [
                            Zf(t)
                        ]))
                    ]))
                ])),
                oo
            ]),
            c$: "Zeitplan - Login"
        };
    }), Of = F2(function(n, t) {
        return Za({
            Z: A2(rc, n.c5, t),
            ab: Ec,
            aq: Js(t),
            V: Nf(n)
        });
    }), If = function() {
        return va;
    }, qf = F2(function(n, t) {
        return i(t, Na(n));
    }), Df = F2(function(n, t) {
        return {
            cb: t,
            c$: n
        };
    }), Ff = Kn("article"), Xf = F2(function(n, t) {
        return A2(Df, "Zeitplan - Schedule", b([
            A2(Ma, $r, Vo({
                bH: n.bH,
                T: n
            })),
            A2(Xo, b([
                Ra("section is-large")
            ]), b([
                A2(Ya, b([
                    Ra("columns is-centered")
                ]), b([
                    A2(Ya, b([
                        Ra("column is-6")
                    ]), b([
                        t.aE ? A2(Ff, b([
                            Ra("message is-danger")
                        ]), b([
                            A2(Ya, b([
                                Ra("message-header")
                            ]), b([
                                A2(hi, f, b([
                                    gi("Unable to process your payment!")
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("message-body")
                            ]), b([
                                gi("\n                            Something went wrong trying to add credits to your account! Please try again in a few hours, or submit an issue to the GitHub link below.\n                            ")
                            ]))
                        ])) : A2(Ff, b([
                            Ra("message is-success")
                        ]), b([
                            A2(Ya, b([
                                Ra("message-header")
                            ]), b([
                                A2(hi, f, b([
                                    gi("Successfully processed payment!")
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("message-body")
                            ]), b([
                                gi("\n                            Credits have been added to your account. If you do not see the increased amount, please allow at least 24 hours for payments to process, and refresh the page. If you still do not see your credits - submit an issue to the GitHub link below.\n                            ")
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            oo
        ]));
    }), Gf = F2(function(n, t) {
        var r;
        return Za({
            Z: (r = A2(Tu, "redirect_status", t.cO), i({
                aE: e(r, ke("succeeded")) ? 0 : 1
            }, Pa)),
            ab: If,
            aq: qf,
            V: Xf(n)
        });
    }), Rf = i({}, Pa), Uf = function() {
        return va;
    }, Yf = F2(function(n, t) {
        return i(t, Na(n));
    }), Wf = F2(function(n) {
        return {
            cb: b([
                A2(Ma, $r, Vo({
                    bH: n.bH,
                    T: n
                })),
                A2(Ya, b([
                    Ra("is-small section")
                ]), b([
                    A2(Ya, b([
                        Ra("container")
                    ]), b([
                        A2(Ya, b([
                            Ra("hero is-dark")
                        ]), b([
                            A2(Ya, b([
                                Ra("hero-body")
                            ]), b([
                                A2(co, b([
                                    Ra("is-1 title")
                                ]), b([
                                    gi("Pricing")
                                ])),
                                A2(ci, b([
                                    Ra("subtitle")
                                ]), b([
                                    gi("Because nothing in life is free")
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                A2(Xo, b([
                    Ra("section")
                ]), b([
                    A2(Ya, b([
                        Ra("container")
                    ]), b([
                        A2(ci, b([
                            Ra("is-1 title")
                        ]), b([
                            gi("Costs")
                        ])),
                        A2(Ya, b([
                            Ra("content is-medium")
                        ]), b([
                            A2(hi, f, b([
                                gi("\n                    Countless hours have gone into the devlopment of Zeitplan to make it a\n                    high quality product. At least until version 1.1.0, the entire development\n                    of Zeitplan has been entirely funded by a single developer. We ask that you download\n                    the project, or sign up for an account and purchase credits to help support projects like\n                    this, and provide a positive community for this kind of work. If you found the\n                    project useful, consider sharing it with your friends!\n                    ")
                            ]))
                        ])),
                        A2(ci, b([
                            Ra("is-1 title")
                        ]), b([
                            gi("Early Adoption Period")
                        ])),
                        A2(Ya, b([
                            Ra("content is-medium")
                        ]), b([
                            A2(hi, f, b([
                                gi("\n                    Currently, there are no associated costs to using Zeitplan. Each user when signing up\n                    will receive 10 credits to use to schedule their meetings with. Scheduling meetings may\n                    cost multiple credits based on the complexity of the schedule. This is due to the fact\n                    that these computations are expensive to run.\n                    ")
                            ]))
                        ])),
                        A2(ci, b([
                            Ra("is-1 title")
                        ]), b([
                            gi("Cloud Access")
                        ])),
                        A2(Ya, b([
                            Ra("content is-medium")
                        ]), b([
                            A2(hi, f, b([
                                gi("\n                        Zeitplan can also be run from this website. Simply Sign Up for an account,\n                        and schedule meetings to your hearts content!\n                    ")
                            ])),
                            A2(Yo, f, b([
                                A2(Do, f, b([
                                    gi("Access anywhere")
                                ])),
                                A2(Do, f, b([
                                    gi("Access anytime")
                                ])),
                                A2(Do, f, b([
                                    gi("Search for your perfect schedule on powerful Cloud computers")
                                ]))
                            ]))
                        ])),
                        A2(ci, b([
                            Ra("is-1 title")
                        ]), b([
                            gi("Desktop Download")
                        ])),
                        A2(Ya, b([
                            Ra("content is-medium")
                        ]), b([
                            A2(hi, f, b([
                                gi("\n                    Download and run Zeitplan unlimited on your own computer!\n                    ")
                            ])),
                            A2(Yo, f, b([
                                A2(Do, f, b([
                                    gi("Features"),
                                    A2(Yo, f, b([
                                        A2(Do, f, b([
                                            gi("Unlimited use")
                                        ])),
                                        A2(Do, f, b([
                                            gi("Infinite search time")
                                        ])),
                                        A2(Do, f, b([
                                            gi("No recurring charges")
                                        ]))
                                    ]))
                                ])),
                                A2(Do, f, b([
                                    gi("Limitations"),
                                    A2(Yo, f, b([
                                        A2(Do, f, b([
                                            gi("No sync with cloud")
                                        ])),
                                        A2(Do, f, b([
                                            gi("Limited by your computer")
                                        ])),
                                        A2(Do, f, b([
                                            gi("Isolated from participants")
                                        ])),
                                        A2(Do, f, b([
                                            gi("No guranteed updates")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            gi("\n                        Downloading Zeitplan Desktop is a one time fee of $50.\n                        ")
                        ]))
                    ]))
                ])),
                oo
            ]),
            c$: "Zeitplan - Pricing"
        };
    }), Bf = F2(function(n) {
        return Za({
            Z: Rf,
            ab: Uf,
            aq: Yf,
            V: Wf(n)
        });
    }), Jf = F2(function(n, t) {
        return {
            $: 9,
            a: n,
            b: t
        };
    }), Kf = {
        $: 0
    }, Qf = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tl = {
        $: 33
    }, el = F3(function(n, t, e) {
        return n(t(e));
    }), rl = mn, ul = F2(function(n, t) {
        return Br(A2(rl, A2(el, A2(el, jr, n), me), A2(Dr, A2(el, A2(el, jr, n), we), t)));
    }), al = wa, il = ru, ol = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), cl = hn(function(n) {
        n(bn(A2(ol, -(new Date).getTimezoneOffset(), f)));
    }), sl = {
        $: 3
    }, fl = i({
        X: f,
        m: f,
        bf: f,
        h: sl,
        bm: !0
    }, Pa), ll = $r, dl = (Wr = ll, hn(function(n) {
        n(bn(Wr(Date.now())));
    })), bl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hl = function(n) {
        return 1 === n.$ ? {
            $: 2,
            a: n.a
        } : {
            $: 3,
            a: n.a
        };
    }, vl = {
        $: 1
    }, ml = F4(function(n, t, e, r) {
        return {
            a5: t,
            f: e,
            R: r,
            c5: n
        };
    }), pl = function(n) {
        return {
            $: 3,
            b: n
        };
    }, gl = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), $l = F3(function(n, t, e) {
        return {
            $: 0,
            a: n,
            b: t,
            c: e
        };
    }), wl = F3(function(n, t, e) {
        return A3($l, n, t, e);
    }), yl = F4(function(n, t, e, r) {
        return {
            at: r,
            ay: e,
            an: t,
            aC: n
        };
    }), Cl = 3432918353, kl = 461845907, xl = F2(function(n, t) {
        return (65535 & t) * n + (((t >>> 16) * n & 65535) << 16);
    }), zl = F2(function(n, t) {
        return t << n | t >>> 32 - n;
    }), Ml = E, Sl = F2(function(n, t) {
        return A2(xl, 5, A2(zl, 13, n ^ A2(xl, kl, A2(zl, 15, A2(xl, Cl, t))))) + 3864292196;
    }), Hl = F2(function(n, t) {
        var e = t.ay | (255 & je(n)) << t.aC;
        return 24 === t.aC ? {
            at: t.at + 1,
            ay: 0,
            an: A2(Sl, t.an, e),
            aC: 0
        } : {
            at: t.at + 1,
            ay: e,
            an: t.an,
            aC: t.aC + 8
        };
    }), Tl = F2(function(n, t) {
        var e, r, u, a;
        return ((a = A2(xl, 3266489909, (u = A2(xl, 2246822507, (r = ((e = A3(Ml, Hl, A4(yl, 0, n, 0, 0), t)).ay ? e.an ^ A2(xl, kl, A2(zl, 15, A2(xl, Cl, e.ay))) : e.an) ^ e.at) ^ r >>> 16)) ^ u >>> 13)) ^ a >>> 16) >>> 0;
    }), Al = function(n) {
        return !n.b;
    }, Ll = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, El = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zl = function(n) {
        return {
            $: 8,
            b: n
        };
    }, Pl = function(n) {
        switch(n.$){
            case 0:
                return n.a;
            case 1:
                return function(n) {
                    var t = Nc(b([
                        A2(vr, A2(el, Vl, qr(Ll)), pl(gc)),
                        A2(vr, A2(el, El, qr(Va(Ll))), Zl(gc))
                    ])), e = A2(Xc, t, n);
                    return e.$ ? A2(Me, 0, n) : Pl(e.a);
                }(n.a);
            case 2:
                return "[" + A2(He, ", ", A2(qr, Pl, n.a)) + "]";
            default:
                return "{" + A2(He, ", ", A2(qr, function(n) {
                    return n.a + ": " + Pl(n.b);
                }, n.a)) + "}";
        }
    }, _l = function(n) {
        return n.a + ": " + Pl(n.b);
    }, jl = function(n) {
        return n.b ? "(" + A2(He, ", ", A2(qr, _l, n)) + ")" : "";
    }, Nl = function(n) {
        return b([
            n
        ]);
    }, Ol = function(n) {
        return n.$ ? n.a.bB : n.a;
    }, Il = function(n) {
        return A2(uu, function(t) {
            return s(Ol(n), Se(t));
        }, function(n) {
            var t, e;
            return A2(uu, Tl(0), n.$ ? (t = n.b, "__typename" === n.a.bB ? xe : ke((e = A2(ku, b([
                n.a.c4
            ]), Nl(jl(t))), A2(He, "", e)))) : Al(t = n.b) ? xe : ke(jl(t)));
        }(n));
    }, ql = function(n) {
        return A2(wu, Ol(n), Il(n));
    }, Dl = F4(function(n, t, e, r) {
        var u = e.a, a = e.b;
        return A2(gl, b([
            A3(wl, n, t, u)
        ]), Nc(b([
            A2(Dc, n, r(a)),
            A2(Dc, ql(A3(wl, n, t, u)), r(a))
        ])));
    }), Fl = F3(function(n, t, e) {
        return {
            X: e,
            m: t,
            aO: n
        };
    }), Xl = F2(function(n, t) {
        return {
            $: 1,
            a: n,
            b: t
        };
    }), Gl = F2(function(n, t) {
        return A2(Xl, n, t);
    }), Rl = F4(function(n, t, e, r) {
        var u = A2(Gl, {
            bB: t,
            c4: n
        }, e);
        return A2(gl, b([
            u
        ]), Nc(b([
            A2(Dc, t, r),
            A2(Dc, ql(u), r)
        ])));
    }), Ul = A4(Rl, "(List String)", "blockedDays", f, pl(Yc)), Yl = F2(function(n, t) {
        return {
            c: t,
            g: n
        };
    }), Wl = A4(Rl, "Int", "end", f, _c), Bl = A4(Rl, "Int", "start", f, _c), Jl = function(n) {
        return A2(gl, f, pr(n));
    }, Kl = F2(function(n, t) {
        var e = n.b, r = t.b;
        return A2(gl, s(n.a, t.a), A3(mr, er, e, r));
    }), Ql = A2(Kl, Wl, A2(Kl, Bl, Jl(Yl))), nd = A4(Rl, "String", "name", f, Yc), td = A2(Kl, Ul, A2(Kl, A4(Dl, "events", f, Ql, A2(au, $r, pl)), A2(Kl, nd, Jl(Fl)))), ed = F4(function(n, t, e, r) {
        return {
            au: n,
            z: t,
            a: e,
            c$: r
        };
    }), rd = Nc(b([
        Yc,
        A2(vr, Ui, G),
        A2(vr, Se, _c),
        A2(vr, function(n) {
            return n ? "true" : "false";
        }, Ts)
    ])), ud = {
        a7: {
            ch: A2(vr, $r, rd),
            a8: function(n) {
                return Xa(n);
            }
        },
        bu: {
            ch: A2(vr, $r, rd),
            a8: function(n) {
                return Xa(n);
            }
        }
    }, ad = {
        a7: ud.a7,
        bu: ud.bu
    }, id = A4(Rl, "ScalarCodecs.Long", "created", f, ad.bu.ch), od = A4(Rl, "Int", "duration", f, _c), cd = A4(Rl, "(List String)", "participants", f, pl(Yc)), sd = A2(Kl, A4(Rl, "String", "title", f, Yc), A2(Kl, cd, A2(Kl, od, A2(Kl, id, Jl(ed))))), fd = ln, ld = function(n) {
        return Ll(fd(n));
    }, dd = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), bd = Ll(ks), hd = F3(function(n, t, e) {
        switch(t.$){
            case 0:
                return ke(A2(dd, n, e(t.a)));
            case 1:
                return xe;
            default:
                return ke(A2(dd, n, bd));
        }
    }), vd = F3(function(n, t, e) {
        return A2(dd, n, e(t));
    }), md = function(n) {
        return Ll(Xa(n));
    }, pd = F3(function(n, t, e) {
        var r = n({
            bc: vl
        }), u = A2(cu, $r, b([
            A3(hd, "nextToken", r.bc, md)
        ]));
        return A4(Dl, "schedules", s(u, b([
            A3(vd, "limit", t.cx, ld)
        ])), e, A2(au, $r, Oc));
    }), gd = F2(function(n, t) {
        return {
            bv: n,
            bc: t
        };
    }), $d = F4(function(n, t, e, r) {
        return {
            au: r,
            aZ: e,
            bA: t,
            bh: n
        };
    }), wd = A4(Rl, "ScalarCodecs.Long", "created", f, ad.bu.ch), yd = A4(Rl, "(Maybe String)", "error", f, Oc(Yc)), Cd = A4(Rl, "(Maybe (List String))", "failed", f, Oc(pl(Yc))), kd = F2(function(n, t) {
        return {
            aM: n,
            ap: t
        };
    }), xd = A4(Rl, "String", "id", f, Yc), zd = A2(Kl, A4(Dl, "time", f, Ql, $r), A2(Kl, xd, Jl(kd))), Md = A2(Kl, wd, A2(Kl, yd, A2(Kl, Cd, A2(Kl, function(n) {
        return A4(Dl, "results", f, n, A2(au, $r, A2(au, pl, Oc)));
    }(zd), Jl($d))))), Sd = A4(Rl, "(Maybe String)", "nextToken", f, Oc(Yc)), Hd = A2(Kl, Sd, A2(Kl, function(n) {
        return A4(Dl, "data", f, n, A2(au, $r, pl));
    }(Md), Jl(gd))), Td = F2(function(n, t) {
        return {
            J: n,
            m: t
        };
    }), Ad = A4(Rl, "Int", "credits", f, _c), Ld = A2(Kl, function(n) {
        return A4(Dl, "events", f, n, A2(au, $r, pl));
    }(Ql), A2(Kl, Ad, Jl(Td))), Vd = A2(Kl, A3(pd, La({
        bc: vl
    }), {
        cx: 5
    }, Hd), A2(Kl, function(n) {
        return A4(Dl, "meetings", f, n, A2(au, $r, pl));
    }(sd), A2(Kl, function(n) {
        return A4(Dl, "calendars", f, n, A2(au, $r, pl));
    }(td), A2(Kl, function(n) {
        return A4(Dl, "user", f, n, $r);
    }(Ld), Jl(ml))))), Ed = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), Zd = function(n) {
        return A2(Dc, "data", n.b);
    }, Pd = F2(function(n, t) {
        return {
            aJ: n,
            aY: A2(Ed, xe, t),
            ax: Zd(t),
            s: f,
            ai: xe,
            ak: f,
            x: xe,
            as: !1
        };
    }), _d = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jd = F2(function(n, t) {
        return {
            bU: n,
            bY: t
        };
    }), Nd = jr(A2(jd, ru, f)), Od = F2(function(n, t) {
        return {
            $: 3,
            a: n,
            b: t
        };
    }), Id = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qd = F2(function(n, t) {
        return {
            $: 4,
            a: n,
            b: t
        };
    }), Dd = {
        $: 2
    }, Fd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gd = {
        $: 1
    }, Rd = function(n) {
        return !n.$;
    }, Ud = Ln, Yd = function(n) {
        return hn(function(t) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, t(bn(0));
        });
    }, Wd = $n, Bd = F3(function(n, t, e) {
        n: for(;;){
            if (t.b) {
                var r = t.a, u = t.b;
                if (r.$) {
                    var a = r.a;
                    return A2(Dr, function(t) {
                        var r = a.b_;
                        return A3(Bd, n, u, 1 === r.$ ? e : A3(bu, r.a, t, e));
                    }, Wd(A3(ne, n, Rr(n), a)));
                }
                var i = r.a, o = A2(Tu, i, e);
                if (1 === o.$) {
                    t = u;
                    continue n;
                }
                return A2(Dr, function() {
                    return A3(Bd, n, u, A2(_u, i, e));
                }, Yd(o.a));
            }
            return jr(e);
        }
    }), Jd = F4(function(n, t, e, r) {
        return A2(Dr, function(n) {
            return jr(A2(jd, n, e));
        }, A3(Bd, n, t, r.bU));
    }), Kd = F4(function(n, t, r, u) {
        var a = u.b;
        return e(t, u.a) ? ke(A2(Rr, n, a(r))) : xe;
    }), Qd = F3(function(n, t, e) {
        return A2(Dr, function() {
            return jr(e);
        }, Gr(A2(cu, A3(Kd, n, t.a, t.b), e.bY)));
    }), nb = F2(function(n, t) {
        if (t.$) {
            var e = t.a;
            return _d({
                b7: e.b7,
                cb: e.cb,
                ax: A2(re, n, e.ax),
                s: e.s,
                _: e._,
                x: e.x,
                b_: e.b_,
                H: e.H
            });
        }
        return {
            $: 0,
            a: t.a
        };
    }), tb = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    });
    Sn.Http = Hn(Nd, Jd, Qd, nb, F2(function(n, t) {
        return A2(tb, t.a, A2(au, t.b, n));
    }));
    var eb, rb, ub, ab = Vn("Http"), ib = (Vn("Http"), function(n) {
        return ab(_d({
            b7: !1,
            cb: n.cb,
            ax: n.ax,
            s: n.s,
            _: n._,
            x: n.x,
            b_: n.b_,
            H: n.H
        }));
    }), ob = function(n) {
        return ab(_d({
            b7: !0,
            cb: n.cb,
            ax: n.ax,
            s: n.s,
            _: n._,
            x: n.x,
            b_: n.b_,
            H: n.H
        }));
    }, cb = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), sb = function(n) {
        if (n.$) return me({
            $: 1,
            a: n.a
        });
        var t = n.a;
        if (t.$) {
            var e = t.a;
            return me(A2(cb, e.a, e.b));
        }
        return we(t.a);
    }, fb = F2(function(n, t) {
        return {
            $: 3,
            a: n,
            b: t
        };
    }), lb = {
        $: 2
    }, db = {
        $: 1
    }, bb = nn, hb = F2(function(n, t) {
        return A3(ee, "", $r, A2(au, t, n));
    }), vb = F2(function(n, t) {
        return A2(hb, n, function(n) {
            switch(n.$){
                case 0:
                    return me({
                        $: 0,
                        a: n.a
                    });
                case 1:
                    return me(db);
                case 2:
                    return me(lb);
                case 3:
                    return me(A2(fb, n.a, n.b));
                default:
                    var e = A2(bb, t, n.b);
                    return e.$ ? me({
                        $: 4,
                        a: e.a
                    }) : we(e.a);
            }
        });
    }), mb = {
        $: 0
    }, pb = function(n) {
        return A2(ue, "application/json", A2(Me, 0, n));
    }, gb = F2(function(n, t) {
        return t.$ ? xe : n(t.a);
    }), $b = F2(function(n, t) {
        return 1 > n ? t : A3(xr, 0, -n, t);
    }), wb = 4294967295 >>> 32 - Ke, yb = $, Cb = F3(function(n, t, e) {
        for(;;){
            var r = A2(yb, wb & t >>> n, e);
            if (r.$) return A2(yb, wb & t, r.a);
            n -= Ke, e = r.a;
        }
    }), kb = function(n) {
        return n >>> 5 << 5;
    }, xb = F2(function(n, t) {
        var e = t.a, r = t.b, a = t.c, i = t.d;
        return 0 > n || u(n, e) > -1 ? xe : u(n, kb(e)) > -1 ? ke(A2(yb, wb & n, i)) : ke(A3(Cb, r, n, a));
    }), zb = F2(function(n, t) {
        var e = t.cC, r = A2(el, zr(1), $b(1))(e);
        return A2(wu, "", A2(gb, function(t) {
            return A2(xb, t, n);
        }, Tr(r)));
    }), Mb = F3(function(n, t, e) {
        for(;;){
            var r = A2(or, Re, n), a = r.a, i = r.b;
            if (0 > u(ur(a), Re)) return A2(lr, !0, {
                n: t,
                j: e,
                k: a
            });
            n = i, t = A2(ce, tr(a), t), e += 1;
        }
    }), Sb = function(n) {
        return n.b ? A3(Mb, n, f, 0) : Qe;
    }, Hb = A2(wu, Ds, qs("\\{\\d+\\}")), Tb = Qt(1 / 0), Ab = F2(function(n, t) {
        var e = Sb(t);
        return A3(Tb, Hb, zb(e), n);
    }), Lb = {
        e: ru,
        o: f
    }, Vb = F2(function(n, t) {
        return A2(Tu, n, t.e);
    }), Eb = F2(function(n, t) {
        return !A2(Tu, n, t).$;
    }), Zb = F3(function(n, t, r) {
        var u = r, a = s(A2(Eb, n, u.e) ? A2(ko, function(t) {
            return !e(t, n);
        }, u.o) : u.o, b([
            n
        ]));
        return {
            e: A3(bu, n, t, u.e),
            o: a
        };
    }), Pb = F2(function(n, t) {
        var r = t;
        return {
            e: A2(_u, n, r.e),
            o: A2(Eb, n, r.e) ? A2(ko, function(t) {
                return !e(t, n);
            }, r.o) : r.o
        };
    }), _b = F3(function(n, t, e) {
        var r = e, u = A2(Tu, n, r.e);
        if (u.$) {
            var a = t(xe);
            return a.$ ? e : A3(Zb, n, a.a, e);
        }
        var i = t(ke(u.a));
        return i.$ ? A2(Pb, n, e) : {
            e: A3(ju, n, La(ke(i.a)), r.e),
            o: r.o
        };
    }), jb = F3(function(n, t, e) {
        return n > 0 ? A3(jb, n >> 1, s(t, t), 1 & n ? s(e, t) : e) : e;
    }), Nb = F2(function(n, t) {
        return A3(jb, n, t, "");
    }), Ob = function(n) {
        return A2(Nb, n, "  ");
    }, Ib = A2(Xl, {
        bB: "__typename",
        c4: ""
    }, f), qb = F3(function(n, t, e) {
        var r = n.$ ? "" : s(n.a, t.$ ? ":" : ": ");
        return A2(uu, function(n) {
            return s(Ob(A2(wu, 0, t)), s(r, n));
        }, function() {
            if (e.$) return ke(s(n = e.a.bB, jl(r = e.b)));
            var n = e.a, r = e.b, u = e.c;
            if (1 === t.$) return ke(n + (jl(r) + "{") + A2(Db, xe, u) + "}");
            var a = t.a;
            return ke(n + (jl(r) + " {\n") + A2(Db, ke(a), u) + "\n" + Ob(a) + "}");
        }());
    }), Db = F2(function(n, t) {
        var e, r;
        return A2(He, n.$ ? " " : "\n", A2(cu, $r, A2(qr, function(t) {
            var e = t.a;
            return A3(qb, t.b, A2(uu, Ce(1), n), e);
        }, (e = function(n) {
            return Al(n) ? A2(ce, Ib, n) : n;
        }(function(n) {
            var t, e;
            return e = n, A2(cu, function(n) {
                return A2(Tu, n, t.e);
            }, (t = A3(Le, F2(function(n, t) {
                if (n.$) return A3(_b, ql(n), function(t) {
                    return ke(A2(wu, n, t));
                }, t);
                var e = n.c;
                return A3(_b, ql(n), function(t) {
                    if (1 === t.$) return ke(n);
                    if (t.a.$) return ke(n);
                    var r = t.a;
                    return ke(A3($l, r.a, r.b, s(r.c, e)));
                }, t);
            }), Lb, e)).o);
        }(t)), r = A3(Le, F2(function(n, t) {
            return A3(_b, n, function(n) {
                return ke(1 === n.$ ? 0 : n.a + 1);
            }, t);
        }), Lb, A2(qr, Ol, e)), A2(qr, function(n) {
            return i(n, A2(wu, 0, A2(Vb, Ol(n), r)) ? Il(n) : xe);
        }, e)))));
    }), Fb = F2(function(n, t) {
        return A2(Ab, "{0} {\n{1}\n}", b([
            n,
            A2(Db, ke(0), t)
        ]));
    }), Xb = F2(function(n, t) {
        return "query " + n + " {" + A2(Db, xe, t.a) + "}";
    }), Gb = F3(function(n, t, e) {
        return A2(Ab, "{0} {1} {\n{2}\n}", b([
            n,
            t,
            A2(Db, ke(0), e)
        ]));
    }), Rb = F2(function(n, t) {
        return A3(Gb, "query", n, t.a);
    }), Ub = function(n) {
        return encodeURIComponent(n);
    }, Yb = F2(function(n, t) {
        return A2(au, Te(n), He(t));
    }), Wb = A2(au, Ub, A2(Yb, "%20", "+")), Bb = function(n) {
        var t = n.b;
        return Wb(n.a) + "=" + Wb(t);
    }, Jb = F2(function(n, t) {
        return Al(n) ? t : t + "?" + A2(He, "&", A2(qr, Bb, n));
    }), Kb = F5(function(n, t, r, a, o) {
        var c = function() {
            if (a.$) return i(function(n) {
                return "{" + A2(Db, xe, n.a) + "}";
            }(o), f);
            var n = a.a;
            return i(A2(Xb, n, o), b([
                i("operationName", n)
            ]));
        }(), l = c.b, d = A2(Jb, s(r, A2(ce, i("query", c.a), l)), t);
        if (e(n, ke(1)) || u(kr(d), 2e3) > -1 && !e(n, ke(0))) {
            var h = function() {
                if (a.$) return i(function(n) {
                    return A2(Fb, "query", n.a);
                }(o), f);
                var n = a.a;
                return i(A2(Rb, n, o), b([
                    i("operationName", Xa(n))
                ]));
            }(), v = h.b;
            return {
                cb: pb(ms(A2(ce, i("query", Xa(h.a)), v))),
                _: 1,
                H: A2(Jb, r, t)
            };
        }
        return {
            cb: mb,
            _: 0,
            H: d
        };
    }), Qb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, th = F3(function(n, t, e) {
        return {
            aY: e,
            cz: t,
            cD: n
        };
    }), eh = F2(function(n, t) {
        return {
            cg: t,
            cy: n
        };
    }), rh = A3(mr, eh, A2(Dc, "line", _c), A2(Dc, "column", _c)), uh = Q, ah = A2(Dc, "errors", pl(A4(uh, th, A2(Dc, "message", Yc), (eb = A2(Dc, "locations", pl(rh)), Nc(b([
        A2(vr, ke, eb),
        pr(xe)
    ]))), A2(vr, _u("locations"), A2(vr, _u("message"), function(n) {
        return A2(vr, hu, Zl(n));
    }(gc)))))), ih = function(n) {
        return A2(vr, me, A2(vr, gu(n), ah));
    }, oh = function() {
        for(;;){
            var n = A2(bb, gc, "null");
            if (!n.$) return n.a;
        }
    }, ch = function(n) {
        return Nc(b([
            A2(qc, ih, A2(vr, Qb, n)),
            A2(qc, ih, A2(vr, nh, A2(Dc, "data", gc))),
            A2(qc, ih, pr(nh(oh())))
        ]));
    }, sh = function(n) {
        return Nc(b([
            ch(n),
            A2(vr, we, n)
        ]));
    }, fh = F2(function(n, t) {
        return A3(Gb, "mutation", n, t.a);
    }), lh = function(n) {
        var t = n, e = t.aY;
        if (e.$) {
            var r = e.a, u = (o = t.ai).$ ? function(n) {
                return A2(Fb, "mutation", n.a);
            }(r) : A2(fh, o.a, r);
            return {
                cb: pb(ms(A2(ku, b([
                    i("query", Xa(u))
                ]), (a = t.ai, a.$ ? f : b([
                    i("operationName", Xa(a.a))
                ]))))),
                ch: sh(t.ax),
                s: t.s,
                _: "POST",
                x: t.x,
                H: A2(Jb, t.ak, t.aJ)
            };
        }
        var a, o, c = e.a, s = e.b, l = A5(Kb, c.$ ? ke(1) : c.a ? xe : ke(0), t.aJ, t.ak, t.ai, s);
        return {
            cb: l.cb,
            ch: sh(t.ax),
            s: t.s,
            _: l._ ? "Post" : "GET",
            x: t.x,
            H: l.H
        };
    }, dh = F2(function(n, t) {
        var e;
        return {
            cb: (e = lh(t)).cb,
            ax: A2(vb, A2(au, sb, n), e.ch),
            s: e.s,
            _: e._,
            x: e.x,
            b_: xe,
            H: e.H
        };
    }), bh = F2(function(n, t) {
        return (t.as ? ob : ib)(A2(dh, n, t));
    }), hh = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), vh = hh, mh = F3(function(n, t, e) {
        var r = e;
        return c(r, {
            s: A2(ce, A2(vh, n, t), r.s)
        });
    }), ph = F2(function(n, t) {
        return A2(bh, A2(au, hl, bl), A3(mh, "Authorization", t, A2(Pd, n, Vd)));
    }), gh = Bt, $h = F2(function(n, t) {
        var e = fl.a, r = fl.b, u = fl.b;
        return i({
            p: c(fl.a, {
                bm: !1
            }),
            ad: 5,
            aK: xe,
            J: 0,
            D: n.bC,
            aw: il,
            a_: !1,
            O: 2,
            d: il,
            ag: 0,
            ah: "",
            az: xe,
            f: ru,
            w: Kf,
            aP: "",
            a0: xe,
            F: e,
            P: il,
            Q: "",
            a: ru,
            aA: 0,
            aB: !1,
            R: f,
            bj: xe,
            S: xe,
            U: 0,
            aF: xe,
            b1: xe,
            a4: xe
        }, al(b([
            A2(xa, function(n) {
                return A2(Jf, 0, n);
            }, r),
            A2(xa, function(n) {
                return A2(Jf, 1, n);
            }, u),
            $a(A2(ul, function() {
                return tl;
            }, A3(gh, "participant-calendar", 0, 310))),
            $a(A2(ph, n.bC, t.bG)),
            $a(A2(Jr, nl, cl)),
            $a(A2(Jr, Qf, dl))
        ])));
    }), wh = F2(function(n) {
        var t = n.c5;
        return t.$ ? {
            $: 1,
            a: 1
        } : {
            $: 0,
            a: t.a
        };
    }), yh = (rb = {
        ca: wh,
        cj: Pa,
        cp: $a
    }, ub = F2(function(n, t) {
        return F2(function(e, r) {
            var u = A2(rb.ca, e, r);
            return u.$ ? me(u.a) : we(n(t(u.a)));
        });
    }), {
        b5: ub(Ea.b5),
        bx: ub(Ea.bx(rb.cp)),
        a1: ub(Ea.a1(rb.cj)),
        a2: ub(Ea.a2(rb.cj))
    }), Ch = function() {
        return va;
    }, kh = function(n) {
        return {
            $: 21,
            a: n
        };
    }, xh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zh = {
        $: 1
    }, Mh = F3(function(n, t, e) {
        return {
            z: t,
            a: e,
            c$: n
        };
    }), Sh = F2(function(n, t) {
        return {
            X: t,
            m: n
        };
    }), Hh = {
        $: 10
    }, Th = {
        $: 14
    }, Ah = F3(function(n, t, e) {
        for(;;){
            if (-2 === e.$) return t;
            var r = e.e, u = n, a = A3(n, e.b, e.c, A3(Ah, n, t, e.d));
            n = u, t = a, e = r;
        }
    }), Lh = F2(function(n, t) {
        return A3(Ah, F3(function(t, e, r) {
            return A2(n, t, e) ? A3(bu, t, e, r) : r;
        }), ru, t);
    }), Vh = Yt("focus"), Eh = F2(function(n, t) {
        return A3(bu, n, 0, t);
    }), Zh = function(n) {
        return -2 === n.$;
    }, Ph = function(n) {
        return Zh(n);
    }, _h = function(n) {
        switch(n.$){
            case 6:
            case 1:
            case 7:
            case 10:
            case 11:
                return !0;
            default:
                return !1;
        }
    }, jh = F2(function(n, t) {
        if (-2 === t.$) return eu;
        var e = t.b, r = t.d, u = t.e;
        return A5(su, t.a, e, A2(n, e, t.c), A2(jh, n, r), A2(jh, n, u));
    }), Nh = F2(function(n, t) {
        return t.$ ? me(t.a) : we(n(t.a));
    }), Oh = F2(function(n, t) {
        return t.$ ? me(n(t.a)) : we(t.a);
    }), Ih = A2(Ps, $r, "Must enter a title"), qh = F2(function(n, t) {
        return A2(Eb, n, t);
    }), Dh = F2(function(n, t) {
        return A3(Ah, F3(function(t, e, r) {
            var u = r.a, a = r.b;
            return A2(n, t, e) ? i(A3(bu, t, e, u), a) : i(u, A3(bu, t, e, a));
        }), i(ru, ru), t);
    }), Fh = function(n) {
        return n;
    }, Xh = F2(function(n, t) {
        return A2(_u, n, t);
    }), Gh = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Rh = F3(function(n, t, e) {
        return {
            bq: n,
            bs: t,
            bL: e
        };
    }), Uh = A4(Rl, "(Maybe Int)", "amount", f, Oc(_c)), Yh = F2(function(n, t) {
        return A4(Dl, "beginCheckout", b([
            A3(vd, "credits", n.J, ld)
        ]), t, $r);
    }), Wh = A4(Rl, "String", "clientSecret", f, Yc), Bh = A4(Rl, "ScalarCodecs.Id", "orderId", f, ad.a7.ch), Jh = F2(function(n, t) {
        var e;
        return {
            aJ: n,
            aY: (e = t, {
                $: 1,
                a: e
            }),
            ax: Zd(t),
            s: f,
            ai: xe,
            ak: f,
            x: xe,
            as: !1
        };
    }), Kh = F3(function(n, t, e) {
        return A2(bh, A2(au, hl, Gh), A3(mh, "Authorization", t, A2(Jh, n, function(n) {
            return A2(Yh, {
                J: n
            }, A2(Kl, Bh, A2(Kl, Wh, A2(Kl, Uh, Jl(Rh)))));
        }(e))));
    }), Qh = function(n) {
        return {
            $: 28,
            a: n
        };
    }, nv = A4(Rl, "(Maybe String)", "error", f, Oc(Yc)), tv = function(n) {
        return A4(Dl, "validate", f, n, $r);
    }(A2(Kl, nv, Jl(function(n) {
        return {
            aZ: n
        };
    }))), ev = F2(function(n, t) {
        return A2(bh, A2(au, hl, Qh), A3(mh, "Authorization", t, A2(Pd, n, tv)));
    }), rv = function(n) {
        return {
            $: 29,
            a: n
        };
    }, uv = F2(function(n, t) {
        return A4(Dl, "computeSchedule", b([
            A3(vd, "credits", n.J, ld)
        ]), t, $r);
    }), av = A2(uv, {
        J: 1
    }, Md), iv = F2(function(n, t) {
        return A2(bh, A2(au, hl, rv), A3(mh, "Authorization", t, A2(Jh, n, av)));
    }), ov = F3(function(n, t, e) {
        return {
            z: e,
            a: n,
            c$: t
        };
    }), cv = A2(gl, f, pr(0)), sv = F2(function(n, t) {
        return Vl(A2(qr, n, t));
    }), fv = function(n) {
        return Ll(n);
    }, lv = F2(function(n, t) {
        return A2(au, n(t).a8, fv);
    }), dv = F3(function(n, t, e) {
        var r = n({
            au: vl
        }), u = A2(cu, $r, b([
            A3(hd, "created", r.au, A2(lv, function(n) {
                return n.bu;
            }, ad))
        ]));
        return A4(Dl, "saveMeeting", s(u, b([
            A3(vd, "participants", t.a, sv(md)),
            A3(vd, "title", t.c$, md),
            A3(vd, "duration", t.z, ld)
        ])), e, $r);
    }), bv = F2(function(n, t) {
        return A3(dv, function() {
            return function(n) {
                return {
                    au: n
                };
            }({
                $: 0,
                a: Se(n)
            });
        }, A3(ov, de(t.a), t.c$, t.z), cv);
    }), hv = F4(function(n, t, e, r) {
        return A2(bh, function() {
            return tl;
        }, A3(mh, "Authorization", t, A2(Jh, n, A2(bv, e, r))));
    }), vv = function(n) {
        return {
            au: n
        };
    }, mv = F2(function(n, t) {
        return A4(Dl, "deleteMeeting", b([
            A3(vd, "created", n.au, A2(lv, function(n) {
                return n.bu;
            }, ad))
        ]), t, A2(au, $r, Oc));
    }), pv = F3(function(n, t, e) {
        return A2(bh, function() {
            return tl;
        }, A3(mh, "Authorization", t, A2(Jh, n, function(n) {
            return A2(mv, {
                au: Se(n)
            }, A2(Kl, id, Jl(vv)));
        }(e))));
    }), gv = F2(function(n, t) {
        return A4(Dl, "deleteCalendar", b([
            A3(vd, "name", n.aO, md)
        ]), t, A2(au, $r, Oc));
    }), $v = F3(function(n, t, e) {
        return A2(bh, function() {
            return tl;
        }, A3(mh, "Authorization", t, A2(Jh, n, function(n) {
            return A2(gv, {
                aO: n
            }, cv);
        }(e))));
    }), wv = function(n) {
        return {
            $: 12,
            a: n
        };
    }, yv = F2(function(n, t) {
        return {
            c: t,
            g: n
        };
    }), Cv = function(n) {
        var t;
        return t = b([
            i("start", ke(ld(n.g))),
            i("end", ke(ld(n.c)))
        ]), El(A2(cu, function(n) {
            var t = n.a;
            return A2(gb, function(n) {
                return ke(i(t, n));
            }, n.b);
        }, t));
    }, kv = F2(function(n, t) {
        return A4(Dl, "saveEvents", b([
            A3(vd, "events", n.m, sv(Cv))
        ]), t, A2(au, $r, pl));
    }), xv = F3(function(n, t, e) {
        return A2(bh, A2(au, hl, wv), A3(mh, "Authorization", t, A2(Jh, n, function(n) {
            return A2(kv, function(n) {
                return {
                    m: n
                };
            }(A2(qr, function(n) {
                return {
                    c: n.c,
                    g: n.g
                };
            }, n)), A2(Kl, Wl, A2(Kl, Bl, Jl(yv))));
        }(e))));
    }), zv = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Mv = F3(function(n, t, e) {
        return {
            X: e,
            m: t,
            aO: n
        };
    }), Sv = function(n) {
        return {
            aO: n
        };
    }, Hv = function(n) {
        switch(n){
            case 6:
                return "Sunday";
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            default:
                return "Saturday";
        }
    }, Tv = F2(function(n, t) {
        return A4(Dl, "saveCalendar", b([
            A3(vd, "name", n.aO, md),
            A3(vd, "events", n.m, sv(Cv)),
            A3(vd, "blockedDays", n.X, sv(md))
        ]), t, $r);
    }), Av = F2(function(n, t) {
        return A2(Tv, A3(Mv, n, A2(qr, function(n) {
            return {
                c: n.c,
                g: n.g
            };
        }, t.m), A2(qr, Hv, t.X)), A2(Kl, nd, Jl(Sv)));
    }), Lv = F4(function(n, t, e, r) {
        return A2(bh, A2(au, hl, zv), A3(mh, "Authorization", t, A2(Jh, n, A2(Av, e, r))));
    }), Vv = F2(function(n, t) {
        return A5(su, 1, n, t, eu, eu);
    }), Ev = function(n) {
        return A2(Vv, n, 0);
    }, Zv = F2(function(n, t) {
        for(;;){
            if (-2 === t.$) return n;
            var e = t.d;
            n = A2(Zv, n + 1, t.e), t = e;
        }
    }), Pv = function(n) {
        return A2(Zv, 0, n);
    }, _v = function(n) {
        return Pv(n);
    }, jv = Mn, Nv = function(n) {
        switch(n){
            case "Sunday":
                return ke(6);
            case "Monday":
                return ke(0);
            case "Tuesday":
                return ke(1);
            case "Wednesday":
                return ke(2);
            case "Thursday":
                return ke(3);
            case "Friday":
                return ke(4);
            case "Saturday":
                return ke(5);
            default:
                return xe;
        }
    }, Ov = function(n) {
        return n.toUpperCase();
    }, Iv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Dv = F4(function(n, t, e, r) {
        return {
            a6: r,
            Y: e,
            c: t,
            g: n
        };
    }), Fv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xv = F2(function(n, t) {
        return 0 > u(n, t) ? n : t;
    }), Gv = F2(function(n, t) {
        return A3(Ir, F2(function(t, e) {
            var r = e.a, u = e.b;
            return n(t) ? i(A2(ce, t, r), u) : i(r, A2(ce, t, u));
        }), i(f, f), t);
    }), Rv = F2(function(n, t) {
        var e = A2(Gv, function(t) {
            return 0 > u(t.c, n.g - 1) || u(t.g, 1 + n.c) > 0;
        }, t), r = e.a, a = A3(Le, function(n) {
            return function(t) {
                return c(n, {
                    c: A2(ar, n.c, t.c),
                    g: A2(Xv, n.g, t.g)
                });
            };
        }, n, e.b);
        return i(a, A2(ce, a, r));
    }), Uv = Sb(b([
        6,
        0,
        1,
        2,
        3,
        4,
        5
    ])), Yv = F2(function(n, t) {
        for(;;){
            if (!t.b) return !1;
            var e = t.b;
            if (n(t.a)) return !0;
            t = e;
        }
    }), Wv = F2(function(n, t) {
        return A2(Yv, function(t) {
            return e(t, n);
        }, t);
    }), Bv = 48, Jv = F2(function(n, t) {
        switch(n.$){
            case 12:
                return i(t, Pa);
            case 11:
                var r = n.a;
                return i(c(t, {
                    X: A2(Wv, r, t.X) ? A2(ko, function(n) {
                        return !e(n, r);
                    }, t.X) : A2(ce, r, t.X)
                }), Pa);
            case 3:
                var a = function(n) {
                    return c(n, {
                        Y: !1
                    });
                };
                return i(c(t, {
                    m: A2(qr, a, t.m),
                    h: sl
                }), Pa);
            case 0:
                return i(c(t, {
                    h: Iv({
                        r: d = A4(Dv, s = n.a, s, !1, f),
                        ao: ke(d),
                        ap: s
                    })
                }), Pa);
            case 1:
                var o = t.h;
                return i(2 === o.$ ? c(t, {
                    m: A2(Rv, d = o.a.r, t.m).b,
                    h: sl
                }) : t, Pa);
            case 2:
                var s = n.a, l = t.h;
                if (2 === l.$) {
                    var d = l.a.r, b = 0 > u(s, y = l.a.ap) ? i(s, y) : i(y, s), h = c(d, {
                        c: b.b,
                        g: b.a
                    });
                    return i(c(t, {
                        h: Iv({
                            r: h,
                            ao: ke(h),
                            ap: y
                        })
                    }), Pa);
                }
                return i(t, Pa);
            case 4:
                d = n.a, s = n.b;
                var v = A2(qr, function(n) {
                    return e(n, d) ? c(n, {
                        Y: !0
                    }) : n;
                }, t.m);
                return i(c(t, {
                    m: v,
                    h: qv({
                        r: d,
                        ao: xe,
                        ap: s
                    })
                }), Pa);
            case 5:
                s = n.a;
                var m = t.h;
                if (1 === m.$) {
                    var p = s - (y = m.a.ap);
                    return h = c(d = m.a.r, {
                        c: A2(Xv, Bv * (x = Uv, x.a), d.c + p),
                        g: A2(ar, 1, d.g + p)
                    }), i(c(t, {
                        h: qv({
                            r: h,
                            ao: ke(c(h, {
                                Y: !0
                            })),
                            ap: s
                        })
                    }), Pa);
                }
                return i(t, Pa);
            case 7:
                var g = t.h;
                if (1 === g.$) {
                    var $ = A2(Rv, c(d = g.a.r, {
                        Y: !1
                    }), A2(ko, function(n) {
                        return !n.Y;
                    }, t.m));
                    return i(c(t, {
                        m: $.b,
                        h: sl
                    }), Pa);
                }
                return i(t, Pa);
            case 6:
                return d = n.a, i(c(t, {
                    m: ko(function(n) {
                        return !e(n, d);
                    })(t.m)
                }), Pa);
            case 8:
                return i(c(t, {
                    h: Fv({
                        c: w = n.a,
                        r: d = n.b
                    })
                }), Pa);
            case 9:
                var w, y = n.a, C = t.h;
                return C.$ ? i(t, Pa) : (h = c(d = C.a.r, (w = C.a.c) ? {
                    c: A2(ar, d.g, y)
                } : {
                    g: A2(Xv, d.c, y)
                }), i(c(t, {
                    m: A2(qr, function(n) {
                        return e(n, d) ? h : n;
                    }, t.m),
                    h: Fv({
                        c: w,
                        r: h
                    })
                }), Pa));
            default:
                var k = t.h;
                return i(k.$ ? t : c(t, {
                    m: A2(Rv, d = k.a.r, t.m).b,
                    h: sl
                }), Pa);
        }
        var x;
    }), Kv = F3(function(n, t, r) {
        switch(t.$){
            case 32:
                switch(t.a){
                    case "individual":
                        return i(c(r, {
                            ag: 0
                        }), Pa);
                    case "group":
                        return i(c(r, {
                            ag: 1
                        }), Pa);
                    default:
                        return i(r, Pa);
                }
            case 31:
                return i(c(r, {
                    w: xh(zh)
                }), $a(A2(iv, r.D, n.bG)));
            case 29:
                return i(3 === (Q = t.a).$ ? c(r, {
                    J: r.J - 1,
                    w: Kf,
                    R: A2(ce, Q.a, r.R)
                }) : r, Pa);
            case 30:
                return i(c(r, {
                    w: xh(zh)
                }), $a(A2(ev, r.D, n.bG)));
            case 28:
                var u = t.a;
                return i(1 === r.w.$ ? c(r, {
                    w: xh(u)
                }) : r, Pa);
            case 2:
                return i(c(r, {
                    a4: ke(t.a)
                }), Pa);
            case 3:
                return i(c(r, {
                    a0: ke(t.a)
                }), Pa);
            case 1:
                if (3 === (u = t.a).$) {
                    var a = function(n) {
                        return {
                            a6: f,
                            Y: !1,
                            c: n.c,
                            g: n.g
                        };
                    }, l = vu(A2(qr, function(n) {
                        return n.aO;
                    }, (nn = u.a).a5)), d = A2(wu, f, A2(uu, function(n) {
                        return n.bv;
                    }, nn.R)), h = hu(A2(qr, function(n) {
                        return i(n.aO, A2(Sh, A2(qr, a, n.m), A2(cu, Nv, n.X)));
                    }, nn.a5)), v = A2(wu, xe, A2(uu, function(n) {
                        return n.bc;
                    }, nn.R)), m = hu(A2(qr, function(n) {
                        return i(A2(wu, 0, Tr(n.au)), A3(Mh, n.c$, n.z, A3(Le, Eh, il, n.a)));
                    }, nn.f)), p = nn.c5.J, g = r.F, $ = function() {
                        if (l.$) return g;
                        var n = l.a, t = A2(wu, i(g.X, g.m), A2(uu, function(n) {
                            return i(n.X, n.m);
                        }, A2(Tu, n, h)));
                        return c(g, {
                            X: t.a,
                            m: t.b
                        });
                    }(), w = c(r.p, {
                        m: A2(qr, a, nn.c5.m)
                    });
                    return i(c(r, {
                        p: w,
                        J: p,
                        a_: !0,
                        f: m,
                        F: $,
                        a: h,
                        R: d,
                        bj: v,
                        S: l
                    }), Pa);
                }
                return i(r, Pa);
            case 0:
                var y = t.a, C = A2(wu, i((g = r.F).X, g.m), A2(uu, function(n) {
                    return i(n.X, n.m);
                }, A2(Tu, y, r.a)));
                return $ = c(g, {
                    X: C.a,
                    m: C.b
                }), i(c(r, {
                    F: $,
                    S: ke(y)
                }), Pa);
            case 6:
                var k = t.a, x = A2(Dh, function() {
                    return function(n) {
                        return e(n.a, Ev(k));
                    };
                }, r.f), z = x.a;
                return i(c(r, {
                    w: (rn = {
                        bp: A2(Lh, function() {
                            return function(n) {
                                return A2(qh, k, n.a);
                            };
                        }, x.b),
                        N: k,
                        bT: z
                    }, {
                        $: 4,
                        a: rn
                    })
                }), Pa);
            case 7:
                var M = A2(Xh, k = t.a, r.d), S = r.F, H = A2(jh, function() {
                    return function(n) {
                        return c(n, {
                            a: A2(Xh, k, n.a)
                        });
                    };
                }, A2(Lh, function() {
                    return function(n) {
                        return !e(n.a, Ev(k));
                    };
                }, r.f)), T = A2(_u, k, r.a), A = vu(fe(T)), L = A2(wu, i(f, f), A2(uu, function(n) {
                    var t = n.b;
                    return i(t.m, t.X);
                }, A));
                return $ = c(S, {
                    X: L.b,
                    m: L.a
                }), i(c(r, {
                    d: M,
                    f: H,
                    w: Kf,
                    F: $,
                    a: T,
                    S: A2(uu, function(n) {
                        return n.a;
                    }, A)
                }), $a(A3($v, r.D, n.bG, k)));
            case 14:
                var V = al(A2(qr, function(t) {
                    return A2(wu, Pa, A2(uu, function(e) {
                        return $a(A4(Lv, r.D, n.bG, t, e));
                    }, A2(Tu, t, r.a)));
                }, de(r.P)));
                return i(c(r, {
                    P: il
                }), V);
            case 4:
                var E = t.a, Z = A2(Ls, (tn = r.a, en = b([
                    A2(Ps, $r, "Must enter a participant name"),
                    A2(Zs, function(n) {
                        return A2(Eb, n, tn);
                    }, "Participant already exists!")
                ]), function(n) {
                    return A3(Le, F2(function(t, e) {
                        return s(e, t(n));
                    }), f, en);
                }), E);
                return i(c(r, {
                    aP: E,
                    aF: ke(Z)
                }), Pa);
            case 5:
                var P = A2(uu, Nh(gs), r.aF);
                if (P.$ || P.a.$) return i(r, Pa);
                E = P.a.a;
                var _ = A2(Sh, f, f);
                return i(c(r, {
                    aP: "",
                    a: A3(bu, E, _, r.a),
                    aF: xe
                }), $a(A4(Lv, r.D, n.bG, E, _)));
            case 8:
                return i(r, Pa);
            case 10:
                return i(c(r, {
                    aB: !1
                }), $a(A3(xv, r.D, n.bG, r.p.m)));
            case 12:
                return i(r, Pa);
            case 9:
                var j = t.b;
                if (1 === (g = t.a)) {
                    var N = A2(Jv, j, r.p), O = N.a, I = N.b, q = _h(j) && !r.aB ? i(!0, $a(A2(Jr, function() {
                        return Hh;
                    }, jv(6e3)))) : i(r.aB, Pa), D = q.b;
                    return i(c(r, {
                        p: O,
                        aB: q.a
                    }), al(b([
                        A2(xa, function(n) {
                            return A2(Jf, 1, n);
                        }, I),
                        D
                    ])));
                }
                var F = A2(Jv, j, r.F), X = (O = F.a, I = F.b, function() {
                    var n = r.S;
                    if (n.$) return o(r.a, r.P, Pa);
                    var t = n.a;
                    return o(A3(ju, t, uu(function(n) {
                        return c(n, {
                            X: O.X,
                            m: O.m
                        });
                    }), r.a), _h(j) ? A2(Eh, t, r.P) : r.P, _h(j) && Ph(r.P) ? $a(A2(Jr, function() {
                        return Th;
                    }, jv(6e3))) : Pa);
                }());
                return D = X.c, i(c(r, {
                    F: O,
                    P: X.b,
                    a: h = X.a
                }), al(b([
                    A2(xa, function(n) {
                        return A2(Jf, 0, n);
                    }, I),
                    D
                ])));
            case 13:
                var G = t.a;
                return i(c(r, {
                    U: G
                }), 1 === G ? $a(A2(ul, function() {
                    return tl;
                }, Vh("participant-name-input"))) : Pa);
            case 11:
                return i(r, Na(t.a));
            case 15:
                return i(c(r, {
                    Q: E = t.a
                }), Pa);
            case 16:
                return E = t.a, h = t.b && 100 >= _v(r.d) ? A2(Eh, E, r.d) : A2(Xh, E, r.d), i(c(r, {
                    d: h
                }), Pa);
            case 17:
                var R = A2(wu, r.d, A2(uu, function(n) {
                    return A2(qh, n, r.d) ? A2(Xh, n, r.d) : _v(r.d) > 100 ? r.d : A2(Eh, n, r.d);
                }, vu(A2(ko, Sr(r.Q) ? La(!0) : A2(au, Ov, Cr(Ov(r.Q))), le(r.a)))));
                return i(c(r, {
                    d: R,
                    Q: ""
                }), Pa);
            case 20:
                return i(r, $a(A2(Jr, kh, dl)));
            case 21:
                var U = t.a, Y = A2(Ls, Ih, r.ah);
                if (Y.$) return i(r, Pa);
                var W = {
                    z: r.O,
                    a: r.d,
                    c$: Y.a
                };
                return i(c(r, {
                    f: A3(bu, U, W, r.f)
                }), $a(A4(hv, r.D, n.bG, U, W)));
            case 18:
                var B = t.a, J = A2(Oh, vu, A2(Ls, Ih, B));
                return i(J.$ ? c(r, {
                    ah: B,
                    az: J.a
                }) : c(r, {
                    ah: B,
                    az: xe
                }), Pa);
            case 19:
                return i(c(r, {
                    O: A2(wu, 0, Tr(t.a))
                }), Pa);
            case 23:
                return i(c(r, {
                    f: A2(_u, U = t.a, r.f)
                }), $a(A3(pv, r.D, n.bG, U)));
            case 22:
                return i(c(r, {
                    aw: A2(t.a ? Eh : Xh, U = t.b, r.aw)
                }), Pa);
            case 24:
                var K = t.a;
                return D = 1 === K && e(r.aK, xe) ? $a(A3(Kh, r.D, n.bG, r.ad)) : Pa, i(c(r, {
                    aA: K
                }), D);
            case 25:
                var Q, nn;
                return 3 === (Q = t.a).$ ? (U = (nn = Q.a).bL, i(c(r, {
                    aK: ke(nn.bs)
                }), Pa)) : i(r, Pa);
            case 26:
                return i(c(r, {
                    ad: A2(wu, 5, Tr(t.a))
                }), Pa);
            case 27:
                return i(c(r, {
                    w: t.a
                }), Pa);
            default:
                return i(r, Pa);
        }
        var tn, en, rn;
    }), Qv = function(n) {
        return {
            $: 27,
            a: n
        };
    }, nm = function(n) {
        return {
            $: 13,
            a: n
        };
    }, tm = function(n) {
        return {
            $: 11,
            a: n
        };
    }, em = ri(A4(ti, "fas", "calendar-plus", i(448, 512), i("M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32zM448 464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192H448V464zM200 272V328H144C130.7 328 120 338.7 120 352C120 365.3 130.7 376 144 376H200V432C200 445.3 210.7 456 224 456C237.3 456 248 445.3 248 432V376H304C317.3 376 328 365.3 328 352C328 338.7 317.3 328 304 328H248V272C248 258.7 237.3 248 224 248C210.7 248 200 258.7 200 272z", xe))), rm = ri(A4(ti, "fas", "calendar-week", i(448, 512), i("M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM80 256C71.16 256 64 263.2 64 272V336C64 344.8 71.16 352 80 352H368C376.8 352 384 344.8 384 336V272C384 263.2 376.8 256 368 256H80z", xe))), um = ri(A4(ti, "fas", "robot", i(640, 512), i("M9.375 233.4C3.375 239.4 0 247.5 0 256v128c0 8.5 3.375 16.62 9.375 22.62S23.5 416 32 416h32V224H32C23.5 224 15.38 227.4 9.375 233.4zM464 96H352V32c0-17.62-14.38-32-32-32S288 14.38 288 32v64H176C131.8 96 96 131.8 96 176V448c0 35.38 28.62 64 64 64h320c35.38 0 64-28.62 64-64V176C544 131.8 508.3 96 464 96zM256 416H192v-32h64V416zM224 296C201.9 296 184 278.1 184 256S201.9 216 224 216S264 233.9 264 256S246.1 296 224 296zM352 416H288v-32h64V416zM448 416h-64v-32h64V416zM416 296c-22.12 0-40-17.88-40-40S393.9 216 416 216S456 233.9 456 256S438.1 296 416 296zM630.6 233.4C624.6 227.4 616.5 224 608 224h-32v192h32c8.5 0 16.62-3.375 22.62-9.375S640 392.5 640 384V256C640 247.5 636.6 239.4 630.6 233.4z", xe))), am = {
        $: 30
    }, im = {
        $: 20
    }, om = F2(function(n, t) {
        return {
            $: 22,
            a: n,
            b: t
        };
    }), cm = {
        $: 3
    }, sm = {
        $: 17
    }, fm = F2(function(n, t) {
        return {
            $: 16,
            a: n,
            b: t
        };
    }), lm = function(n) {
        return {
            $: 19,
            a: n
        };
    }, dm = function(n) {
        return {
            $: 32,
            a: n
        };
    }, bm = function(n) {
        return {
            $: 18,
            a: n
        };
    }, hm = function(n) {
        return {
            $: 15,
            a: n
        };
    }, vm = ri(A4(ti, "fas", "plus", i(448, 512), i("M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z", xe))), mm = F2(function(n, t) {
        return !A2(Yv, A2(el, Fi, n), t);
    }), pm = Kn("aside"), gm = ri(A4(ti, "fas", "check", i(448, 512), i("M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z", xe))), $m = ff("checked"), wm = ri(A4(ti, "far", "circle-xmark", i(512, 512), i("M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z", xe))), ym = ri(A4(ti, "fas", "clock", i(512, 512), i("M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z", xe))), Cm = function(n) {
        return {
            $: 4,
            a: n
        };
    }, km = {
        $: 5
    }, xm = function(n) {
        return A2(bf, b([
            Ra("form"),
            zf(km)
        ]), b([
            A2(pf, b([
                Ra("label"),
                df("participant-name-input")
            ]), b([
                gi("Add Participant")
            ])),
            A2(Ya, b([
                Ra("field has-addons")
            ]), b([
                A2(Ya, b([
                    Ra("control"),
                    A2(po, "width", "100%")
                ]), b([
                    A2(mf, b([
                        Ra("input"),
                        fo("participant-name-input"),
                        zo(b([
                            i("is-danger", A2(wu, !1, A2(uu, $s, n.aF)))
                        ])),
                        Sf("text"),
                        Tf(n.aP),
                        Mf("Name"),
                        Cf(Cm)
                    ]), f)
                ])),
                A2(Ya, b([
                    Ra("control")
                ]), b([
                    A2(Co, b([
                        Ra("button is-success"),
                        Sf("submit")
                    ]), b([
                        io(vm)
                    ]))
                ]))
            ]))
        ]));
    }, zm = function(n) {
        var t, r, u;
        return t = A2(wu, 0, vu(A2(cu, function(t) {
            var r = t.a;
            return e(t.b, n) ? ke(r) : xe;
        }, (u = (r = Uv).a, A3(he, F2(function(n, t) {
            var e = t.a, r = t.b;
            return i(e - 1, A2(ce, i(e, n), r));
        }), i(u - 1, f), r).b)))), A4(Dv, t * Bv, (t + 1) * Bv, !1, f);
    }, Mm = S, Sm = function(n) {
        switch(n){
            case 0:
                return "0 min";
            case 1:
                return "30 min";
            case 2:
                return "1 hour";
            case 3:
                return "90 min";
            case 4:
                return "2 hours";
            default:
                var t = n, e = 1 === A2(Mm, 2, t) ? " 30 min" : "";
                return s(Se(t / 2 | 0) + " hours", e);
        }
    }, Hm = V, Tm = function(n) {
        return A2(Hm, n, "");
    }, Am = F3(function(n, t, e) {
        return s(A2(Nb, n - kr(e), Tm(t)), e);
    }), Lm = F2(function(n, t) {
        return rr(n / t);
    }), Vm = F3(function(n, t, e) {
        for(;;){
            if (!e.b) return t + n;
            var r = e.a, a = e.b;
            if (0 > u(r.g, t)) return t + r.bK;
            e = a;
        }
    }), Em = F2(function(n, t) {
        var e = n.b;
        return A3(Vm, n.a, A2(Lm, t, 6e4), e);
    }), Zm = function(n) {
        var t = A2(Lm, n, 1440) + 719468, e = (0 > t ? t - 146096 : t) / 146097 | 0, r = t - 146097 * e, u = (r - (r / 1460 | 0) + (r / 36524 | 0) - (r / 146096 | 0)) / 365 | 0, a = r - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, o = i + (10 > i ? 3 : -9);
        return {
            bw: a - ((153 * i + 2) / 5 | 0) + 1,
            bJ: o,
            b4: u + 400 * e + (o > 2 ? 0 : 1)
        };
    }, Pm = F2(function(n, t) {
        return Zm(A2(Em, n, t)).bw;
    }), _m = F2(function(n, t) {
        return A2(Mm, 24, A2(Lm, A2(Em, n, t), 60));
    }), jm = F2(function(n, t) {
        return A2(Mm, 60, A2(Em, n, t));
    }), Nm = F2(function(n, t) {
        switch(Zm(A2(Em, n, t)).bJ){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), Om = F2(function(n, t) {
        return A2(Mm, 60, A2(Lm, t, 1e3));
    }), Im = F2(function(n, t) {
        switch(A2(Mm, 7, A2(Lm, A2(Em, n, t), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), qm = F2(function(n, t) {
        return Zm(A2(Em, n, t)).b4;
    }), Dm = F3(function(n, t, e) {
        var r, a = A2(_m, t, e), i = A2(qm, t, e), o = 0 > u(n - e, 6048e5), c = A3(Am, 2, "0", Se(A2(Om, t, e))), s = function() {
            switch(A2(Nm, t, e)){
                case 0:
                    return "01";
                case 1:
                    return "02";
                case 2:
                    return "03";
                case 3:
                    return "04";
                case 4:
                    return "05";
                case 5:
                    return "06";
                case 6:
                    return "07";
                case 7:
                    return "08";
                case 8:
                    return "09";
                case 9:
                    return "10";
                case 10:
                    return "11";
                default:
                    return "12";
            }
        }(), f = A3(Am, 2, "0", Se(A2(jm, t, e))), l = 12 > a ? "AM" : "PM", d = (r = A2(Mm, 12, a)) ? Se(r) : "12", b = A2(Pm, t, e), h = function() {
            switch(A2(Im, t, e)){
                case 0:
                    return "Monday";
                case 1:
                    return "Tuesday";
                case 2:
                    return "Wednesday";
                case 3:
                    return "Thursday";
                case 4:
                    return "Friday";
                case 5:
                    return "Saturday";
                default:
                    return "Sunday";
            }
        }();
        return o ? h + " " + d + ":" + f + ":" + c + " " + l : s + "/" + Se(b) + "/" + Se(i) + " " + d + ":" + f + ":" + c + " " + l;
    }), Fm = function(n) {
        return A3(Le, function(n) {
            return function(t) {
                return A2(Rv, n, t).b;
            };
        }, f, n);
    }, Xm = A2(Fc, b([
        "target",
        "checked"
    ]), Ts), Gm = Kn("option"), Rm = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Um = function(n) {
        return A2(Yo, b([
            Ra("menu-list participant-list")
        ]), A2(qr, function(t) {
            var r, u = t.a;
            return A2(Do, b([
                Ra("participant-list-item"),
                ho((r = u, {
                    $: 0,
                    a: r
                }))
            ]), b([
                A2(Da, b([
                    li("#"),
                    Ra("participant-name"),
                    zo(b([
                        i("is-active", e(n.S, ke(u)))
                    ]))
                ]), b([
                    gi(u),
                    e(n.S, ke(u)) ? A2(Co, b([
                        Ra("delete"),
                        A2(wf, "click", pr(i(Rm(u), !0)))
                    ]), f) : gi("")
                ]))
            ]));
        }, fe(n.a)));
    }, Ym = ri(A4(ti, "fas", "magnifying-glass", i(512, 512), i("M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z", xe))), Wm = Kn("select"), Bm = ff("selected"), Jm = m, Km = F2(function(n, t) {
        return A3(Ir, function(n) {
            return function(t) {
                var e = A2(Gv, function(t) {
                    return 0 > u(t.c, n.g - 1) || u(t.g, 1 + n.c) > 0;
                }, t), r = e.a;
                return s(A3(Ir, function(t) {
                    return function(e) {
                        return u(t.g, n.g) > -1 && 1 > u(t.c, n.c) ? e : 0 > u(t.g, n.g) ? A2(ce, c(t, {
                            c: n.g - 1
                        }), e) : u(t.c, n.c) > 0 ? A2(ce, c(t, {
                            g: n.c + 1
                        }), e) : e;
                    };
                }, f, e.b), r);
            };
        }, n, t);
    }), Qm = Kn("table"), np = F3(function(n, t, e) {
        n: for(;;){
            if (n > 0) {
                if (t.b) {
                    var r = t.a;
                    n -= 1, t = t.b, e = A2(ce, r, e);
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), tp = F2(function(n, t) {
        return qe(A3(np, n, t, f));
    }), ep = F3(function(n, t, e) {
        if (t > 0) {
            var r = i(t, e);
            n: for(;;){
                t: for(;;){
                    if (!r.b.b) return e;
                    if (!r.b.b.b) {
                        if (1 === r.a) break n;
                        break t;
                    }
                    switch(r.a){
                        case 1:
                            break n;
                        case 2:
                            var u = r.b;
                            return b([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (r.b.b.b.b) {
                                var a = r.b, o = a.b;
                                return b([
                                    a.a,
                                    o.a,
                                    o.b.a
                                ]);
                            }
                            break t;
                        default:
                            if (r.b.b.b.b && r.b.b.b.b.b) {
                                var c = r.b, s = c.b, l = s.b, d = l.b, h = d.b;
                                return A2(ce, c.a, A2(ce, s.a, A2(ce, l.a, A2(ce, d.a, n > 1e3 ? A2(tp, t - 4, h) : A3(ep, n + 1, t - 4, h)))));
                            }
                            break t;
                    }
                }
                return e;
            }
            return b([
                r.b.a
            ]);
        }
        return f;
    }), rp = F2(function(n, t) {
        return A3(ep, 0, n, t);
    }), up = Kn("tbody"), ap = Kn("td"), ip = Kn("tfoot"), op = Kn("th"), cp = Kn("thead"), sp = function(n) {
        var t = 30 * A2(Mm, Bv, n - 1), e = A2(Mm, 60, t), r = t / 60 | 0, u = r > 12 ? i("PM", r - 12) : 12 === r ? i("PM", 12) : i("AM", r || 12), a = u.a;
        return Se(u.b) + ":" + A3(Am, 2, "0", Se(e)) + " " + a;
    }, fp = function(n) {
        return A2(wu, "", A2(uu, Hv, A2(xb, n / Bv | 0, Uv)));
    }, lp = F2(function(n, t) {
        var r = sp(n), u = fp(n), a = sp(1 + t), i = fp(t);
        return e(u, i) ? u + " " + r + " - " + a : u + " " + r + " - " + i + " " + a;
    }), dp = function(n) {
        return A2(wi, "data-tooltip", n);
    }, bp = Kn("tr"), hp = ri(A4(ti, "fas", "user", i(448, 512), i("M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z", xe))), vp = ri(A4(ti, "fas", "users", i(640, 512), i("M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 33.71-12.78 64.21-33.16 88h199.7C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192z", xe))), mp = function(n) {
        return A3(se, F3(function(n, t, e) {
            return A2(ce, t, e);
        }), f, n);
    }, pp = F2(function(n, t) {
        return {
            $: 4,
            a: n,
            b: t
        };
    }), gp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $p = {
        $: 1
    }, wp = {
        $: 7
    }, yp = {
        $: 10
    }, Cp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kp = {
        $: 3
    }, xp = {
        $: 12
    }, zp = F2(function(n, t) {
        return {
            $: 8,
            a: n,
            b: t
        };
    }), Mp = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Sp = function(n) {
        return A2(wi, "aria-label", n);
    }, Hp = ri(A4(ti, "fas", "calendar-minus", i(448, 512), i("M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM312 376C325.3 376 336 365.3 336 352C336 338.7 325.3 328 312 328H136C122.7 328 112 338.7 112 352C112 365.3 122.7 376 136 376H312z", xe))), Tp = ri(A4(ti, "fas", "xmark", i(320, 512), i("M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z", xe))), Ap = Tp, Lp = w, Vp = k, Ep = F2(function(n, t) {
        var e = t.c, r = t.d, u = {
            n: f,
            j: 0,
            k: A3(Vp, n, kb(t.a), r)
        }, a = F2(function(t, e) {
            if (t.$) {
                var r = tr(A3(Vp, n, e.j * Re, t.a));
                return {
                    n: A2(ce, r, e.n),
                    j: e.j + 1,
                    k: e.k
                };
            }
            return A3(Lp, a, e, t.a);
        });
        return A2(lr, !0, A3(Lp, a, u, e));
    }), Zp = C, Pp = F2(function(n, t) {
        var e = t.d, r = function(t) {
            return t.$ ? tr(A2(Zp, n, t.a)) : ir(A2(Zp, r, t.a));
        };
        return A4(Ue, t.a, t.b, A2(Zp, r, t.c), A2(Zp, n, e));
    }), _p = function(n) {
        return A2(bo, "mouseenter", pr(n));
    }, jp = function(n) {
        return A2(bo, "mouseup", pr(n));
    }, Np = Kn("wbr"), Op = function(n) {
        var t, r = function(n) {
            return A2(op, f, b([
                A2(vi, b([
                    Ra("day-name")
                ]), b([
                    gi(Hv(n))
                ]))
            ]));
        }, a = function(t) {
            var e, r = A2(Wv, t, n.X);
            return A2(ap, b([
                Ra("all-day-interval"),
                ho((e = t, {
                    $: 11,
                    a: e
                })),
                zo(b([
                    i("all-day-blocked", r)
                ]))
            ]), b([
                A2(vi, b([
                    Ra("icon-text")
                ]), b(r ? [
                    A2(vi, b([
                        Ra("icon")
                    ]), b([
                        io(Hp)
                    ])),
                    A2(vi, f, b([
                        gi("Remove event")
                    ]))
                ] : [
                    A2(vi, b([
                        Ra("icon")
                    ]), b([
                        io(em)
                    ])),
                    A2(vi, f, b([
                        gi("Whole day event")
                    ]))
                ]))
            ]));
        }, o = function(n) {
            return A2(wf, n, pr(i(xp, !0)));
        }, c = function() {
            var t = n.h;
            switch(t.$){
                case 2:
                case 1:
                    return t.a.ao;
                default:
                    return xe;
            }
        }(), l = F3(function(t, r, a) {
            var l = Bv * r + t, d = vu(A2(ko, function(n) {
                return u(l, n.g) > -1 && 1 > u(l, n.c);
            }, n.m)), h = vu(A2(ko, function(n) {
                return u(l, n.g) > -1 && 1 > u(l, n.c);
            }, n.bf)), v = function(n) {
                return A2(Ya, b([
                    Ra("event draft"),
                    zo(s(b([
                        i("event-start", e(n.g, l)),
                        i("event-end", e(n.c, l)),
                        i("dragging", n.Y)
                    ]), n.a6))
                ]), e(n.g, l) ? b([
                    A2(hi, b([
                        Ra("event-time")
                    ]), b([
                        gi(sp(n.g) + " - " + sp(1 + n.c))
                    ]))
                ]) : f);
            }, m = A2(gb, function(n) {
                return u(l, n.g) > -1 && 1 > u(l, n.c) ? ke(n) : xe;
            }, c), p = A2(Wv, a, n.X), g = function() {
                if (p) return f;
                var t, e;
                switch(n.h.$){
                    case 3:
                        return b([
                            (e = l, t = {
                                $: 0,
                                a: e
                            }, A2(bo, "mousedown", pr(t)))
                        ]);
                    case 2:
                        return b([
                            _p(Cp(l)),
                            jp($p)
                        ]);
                    case 1:
                        return b([
                            _p(gp(l)),
                            jp(wp)
                        ]);
                    default:
                        return b([
                            _p(Mp(l)),
                            jp(yp)
                        ]);
                }
            }(), $ = function(n) {
                return p ? Ra("blocked") : n;
            };
            return A2(ap, A2(ce, zo(b([
                i("first-row", 1 === t),
                i("last-row", e(t, Bv)),
                i("overlay-event", !e(h, xe)),
                i("blocked", p)
            ])), g), A2(rp, 1, qe(s(function() {
                if (d.$) return f;
                var n, r = d.a;
                return b([
                    A2(Ya, b([
                        Ra("event"),
                        zo(s(b([
                            i("event-start", e(r.g, l)),
                            i("event-end", e(r.c, l)),
                            i("dragging", r.Y)
                        ]), r.a6)),
                        $(A2(wf, "mousedown", pr(i(A2(pp, r, l), !0))))
                    ]), e(r.g, l) || 1 === t ? s(e(r.g, l) ? b([
                        A2(Co, b([
                            Ra("event-resize"),
                            $(A2(wf, "mousedown", pr(i(A2(zp, 0, r), !0)))),
                            Sp("Resize start of event")
                        ]), f)
                    ]) : f, b([
                        A2(hi, b([
                            Ra("event-time")
                        ]), b([
                            gi(sp(r.g) + " - "),
                            A2(Np, f, f),
                            gi(sp(1 + r.c))
                        ])),
                        A2(Co, b([
                            $(ho((n = r, {
                                $: 6,
                                a: n
                            }))),
                            o("mouseup"),
                            o("mousedown"),
                            Ra("event-close"),
                            Sp("Delete event"),
                            Sf("button")
                        ]), b([
                            io(Ap)
                        ]))
                    ])) : e(r.c, l) ? b([
                        A2(Co, b([
                            Ra("event-resize"),
                            $(A2(wf, "mousedown", pr(i(A2(zp, 1, r), !0)))),
                            Sp("Resize end of event")
                        ]), f)
                    ]) : f)
                ]);
            }(), A2(wu, f, A2(uu, A2(au, v, Nl), m))))));
        });
        return A2(Qm, A2(ce, Ra("calendar"), A2(ce, Ra("week"), e(n.h, sl) ? f : b([
            (t = kp, A2(bo, "mouseleave", pr(t)))
        ]))), b([
            A2(cp, f, b([
                A2(bp, b([
                    Ra("week-header")
                ]), A2(ce, A2(op, b([
                    Ra("time-header")
                ]), f), ve(A2(Pp, r, Uv))))
            ])),
            A2(up, f, A2(ce, n.bm ? A2(bp, b([
                Ra("all-day-row")
            ]), A2(ce, A2(ap, f, f), ve(A2(Pp, a, Uv)))) : A2(bp, b([
                A2(po, "height", "10px")
            ]), f), A2(qr, function(n) {
                return A2(bp, f, A2(ce, A2(ap, b([
                    Ra("display-time")
                ]), b([
                    A2(hi, f, b([
                        gi(sp(n))
                    ]))
                ])), ve(A2(Ep, l(n), Uv))));
            }, A2(Pe, 1, Bv))))
        ]));
    }, Ip = function(n) {
        switch(n.U){
            case 0:
                return A2(Ya, b([
                    Ra("columns p-2")
                ]), b([
                    A2(Ya, b([
                        Ra("column is-full")
                    ]), b([
                        A2(Ya, b([
                            fo("available-calendar")
                        ]), b([
                            A2(Ma, Jf(1), Op(n.p))
                        ]))
                    ]))
                ]));
            case 1:
                return A2(Ya, b([
                    Ra("columns")
                ]), b([
                    A2(Ya, b([
                        Ra("column is-one-fifth")
                    ]), b([
                        A2(Ya, b([
                            Ra("columns is-multiline")
                        ]), b([
                            A2(Ya, b([
                                Ra("column is-full")
                            ]), b([
                                xm(n)
                            ])),
                            A2(Ya, b([
                                Ra("column is-full")
                            ]), b([
                                A2(pm, b([
                                    Ra("menu")
                                ]), b([
                                    A2(hi, b([
                                        Ra("menu-label")
                                    ]), b([
                                        gi("Participants")
                                    ])),
                                    Um(n)
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("column")
                    ]), b([
                        A2(Ya, b([
                            fo("participant-calendar"),
                            zo(b([
                                i("loading ignore-pointer-events", e(n.S, xe))
                            ]))
                        ]), b([
                            A2(Ma, Jf(0), Op(n.F))
                        ]))
                    ]))
                ]));
            case 2:
                var t = !Al(A2(ko, function(t) {
                    return u(t.c - t.g + 1, n.O) > -1;
                }, A2(Km, s(n.p.m, A2(qr, zm, n.p.X)), Fm(xu(A2(qr, function(t) {
                    return A2(wu, f, A2(uu, function(n) {
                        return s(n.m, A2(qr, zm, n.X));
                    }, A2(Tu, t, n.a)));
                }, de(n.d)))))));
                return A2(Ya, b([
                    Ra("meeting-configuration container columns")
                ]), b([
                    A2(pm, b([
                        Ra("column is-one-quarter")
                    ]), b([
                        A2(Ya, b([
                            Ra("columns is-multiline")
                        ]), b([
                            A2(bf, b([
                                Ra("column is-full"),
                                zf(im)
                            ]), b([
                                A2(Ya, b([
                                    Ra("field")
                                ]), b([
                                    A2(pf, b([
                                        Ra("label")
                                    ]), b([
                                        gi("Title")
                                    ])),
                                    A2(mf, b([
                                        Ra("input"),
                                        zo(b([
                                            i("is-danger", !e(n.az, xe))
                                        ])),
                                        Sf("text"),
                                        Tf(n.ah),
                                        Cf(bm)
                                    ]), f),
                                    function() {
                                        var t = n.az;
                                        if (t.$) return gi("");
                                        var e = t.a;
                                        return A2(hi, b([
                                            Ra("help is-danger")
                                        ]), b([
                                            gi(e)
                                        ]));
                                    }()
                                ])),
                                A2(Ya, b([
                                    Ra("field")
                                ]), b([
                                    A2(pf, b([
                                        Ra("label")
                                    ]), b([
                                        gi("Duration")
                                    ])),
                                    A2(Ya, b([
                                        Ra("control has-icons-left")
                                    ]), b([
                                        A2(Ya, b([
                                            Ra("select is-fullwidth is-rounded is-medium")
                                        ]), b([
                                            A2(Wm, b([
                                                Cf(lm)
                                            ]), b([
                                                A2(Gm, b([
                                                    Tf("1"),
                                                    Bm(1 === n.O)
                                                ]), b([
                                                    gi("30 min")
                                                ])),
                                                A2(Gm, b([
                                                    Tf("2"),
                                                    Bm(2 === n.O)
                                                ]), b([
                                                    gi("1 hour")
                                                ])),
                                                A2(Gm, b([
                                                    Tf("3"),
                                                    Bm(3 === n.O)
                                                ]), b([
                                                    gi("90 min")
                                                ])),
                                                A2(Gm, b([
                                                    Tf("4"),
                                                    Bm(4 === n.O)
                                                ]), b([
                                                    gi("2 hours")
                                                ]))
                                            ]))
                                        ])),
                                        A2(Ya, b([
                                            Ra("icon is-small is-left")
                                        ]), b([
                                            io(ym)
                                        ]))
                                    ]))
                                ])),
                                A2(Ya, b([
                                    Ra("panel is-info meeting-panel")
                                ]), b([
                                    A2(ci, b([
                                        Ra("panel-heading")
                                    ]), b([
                                        gi("Select Participants"),
                                        A2(vi, b([
                                            Ra("ml-2")
                                        ]), b([
                                            gi(Ph(n.d) ? "" : "(" + Se(_v(n.d)) + ")")
                                        ]))
                                    ])),
                                    A2(Ya, b([
                                        Ra("panel-block")
                                    ]), b([
                                        A2(hi, b([
                                            Ra("control has-icons-left")
                                        ]), b([
                                            A2(bf, b([
                                                zf(sm)
                                            ]), b([
                                                A2(mf, b([
                                                    Ra("input"),
                                                    Sf("search"),
                                                    Tf(n.Q),
                                                    Mf("Search"),
                                                    Cf(hm)
                                                ]), f),
                                                A2(vi, b([
                                                    Ra("icon is-left")
                                                ]), b([
                                                    io(Ym)
                                                ]))
                                            ]))
                                        ]))
                                    ])),
                                    A2(Ya, b([
                                        Ra("panel-block")
                                    ]), b([
                                        A2(Ya, b([
                                            Ra("control has-icons-left")
                                        ]), b([
                                            A2(Ya, b([
                                                Ra("select is-fullwidth is-rounded is-small")
                                            ]), b([
                                                A2(Wm, b([
                                                    Cf(dm)
                                                ]), b([
                                                    A2(Gm, b([
                                                        Tf("single"),
                                                        Bm(!n.ag)
                                                    ]), b([
                                                        gi("Individual")
                                                    ])),
                                                    A2(Gm, b([
                                                        Tf("group"),
                                                        Bm(1 === n.ag)
                                                    ]), b([
                                                        gi("Group")
                                                    ]))
                                                ]))
                                            ])),
                                            A2(Ya, b([
                                                Ra("icon is-small is-left")
                                            ]), b([
                                                io(n.ag ? vp : hp)
                                            ]))
                                        ]))
                                    ])),
                                    A2(Ya, b([
                                        Ra("meeting-participant-list")
                                    ]), A2(_e, function(t) {
                                        return function(e) {
                                            var r;
                                            return A2(pf, b([
                                                Ra("panel-block"),
                                                zo(b([
                                                    i("is-active", A2(qh, e, n.d)),
                                                    i("highlighted", !t)
                                                ]))
                                            ]), b([
                                                A2(mf, b([
                                                    Sf("checkbox"),
                                                    lf(_v(n.d) >= 100),
                                                    $m(A2(qh, e, n.d)),
                                                    (r = fm(e), A2(bo, "change", A2(vr, r, Xm)))
                                                ]), f),
                                                gi(e)
                                            ]));
                                        };
                                    }, A2(ko, Sr(n.Q) ? La(!0) : A2(au, Ov, Cr(Ov(n.Q))), le(n.a))))
                                ])),
                                A2(Ya, b([
                                    Ra("field")
                                ]), b([
                                    A2(Ya, b([
                                        Ra("control"),
                                        A2(po, "width", "100%")
                                    ]), b([
                                        A2(Co, b([
                                            Ra("button is-success is-medium is-fullwidth"),
                                            lf(Ph(n.d) || Sr(n.ah))
                                        ]), b([
                                            A2(vi, f, b([
                                                gi("Create Meeting")
                                            ])),
                                            A2(vi, b([
                                                dp("This meeting " + (t ? "can" : "can not") + " be scheduled"),
                                                Ra("icon has-tooltip-arrow has-tooltip-bottom"),
                                                zo(b([
                                                    i("is-danger", !t)
                                                ]))
                                            ]), b([
                                                io(t ? gm : wm)
                                            ]))
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("column meeting-list")
                    ]), b([
                        A2(Ya, b([
                            Ra("columns is-multiline")
                        ]), mp(A2(jh, function(t) {
                            return function(e) {
                                var r, a, o = A2(ko, function(n) {
                                    return u(n.c - n.g + 1, e.z) > -1;
                                }, A2(Km, s(n.p.m, A2(qr, zm, n.p.X)), Fm(xu(A2(qr, function(t) {
                                    return A2(wu, f, A2(uu, function(n) {
                                        return s(n.m, A2(qr, zm, n.X));
                                    }, A2(Tu, t, n.a)));
                                }, de(e.a)))))), c = A2(qh, t, n.aw);
                                return A2(Ya, b([
                                    Ra("column meeting-item is-4 panel is-primary"),
                                    zo(b([
                                        i("is-danger", Al(o))
                                    ]))
                                ]), s(b([
                                    A2(Ya, b([
                                        Ra("panel-heading is-flex is-justify-content-space-between")
                                    ]), b([
                                        A2(vi, f, b([
                                            gi(e.c$ + " (" + Sm(e.z) + ")")
                                        ])),
                                        A2(Co, b([
                                            Ra("delete"),
                                            ho((a = t, {
                                                $: 23,
                                                a: a
                                            }))
                                        ]), f)
                                    ])),
                                    A2(Ya, b([
                                        Ra("panel-block")
                                    ]), b([
                                        A2(Ya, b([
                                            Ra("tags are-medium")
                                        ]), A2(qr, function(n) {
                                            return A2(vi, b([
                                                Ra("tag is-dark")
                                            ]), b([
                                                gi(n)
                                            ]));
                                        }, de(e.a)))
                                    ]))
                                ]), s(A2(qr, function(n) {
                                    return A2(Da, b([
                                        Ra("panel-block ignore-pointer-events")
                                    ]), b([
                                        A2(vi, b([
                                            Ra("panel-icon")
                                        ]), b([
                                            io(ym)
                                        ])),
                                        gi(n)
                                    ]));
                                }, A2(qr, function(n) {
                                    return A2(lp, n.g, n.c);
                                }, (r = A2(Jm, function(n) {
                                    return n.g;
                                }, o), c ? r : A2(rp, 3, r)))), Al(o) ? b([
                                    A2(Da, b([
                                        Ra("panel-block ignore-pointer-events")
                                    ]), b([
                                        gi("This meeting can not be scheduled!")
                                    ]))
                                ]) : Ve(o) > 3 ? b([
                                    A2(Ya, b([
                                        Ra("panel-block")
                                    ]), b([
                                        A2(Co, b([
                                            ho(A2(om, !c, t)),
                                            Ra("button is-small is-outlined is-fullwidth")
                                        ]), b([
                                            gi(c ? "Show Less" : "Show More")
                                        ]))
                                    ]))
                                ]) : f)));
                            };
                        }, n.f)))
                    ]))
                ]));
            default:
                return A2(Ya, b([
                    Ra("columns p-2")
                ]), b([
                    A2(Ya, b([
                        Ra("column is-3")
                    ]), b([
                        A2(Ya, b([
                            Ra("card")
                        ]), b([
                            A2(Ya, b([
                                Ra("card-content")
                            ]), b([
                                A2(Ya, b([
                                    Ra("media")
                                ]), b([
                                    A2(Ya, b([
                                        Ra("media-left")
                                    ]), b([
                                        io(hp)
                                    ])),
                                    A2(Ya, b([
                                        Ra("media-content")
                                    ]), b([
                                        A2(ci, b([
                                            Ra("title is-4")
                                        ]), b([
                                            gi("Credits: " + Se(n.J))
                                        ])),
                                        A2(hi, b([
                                            Ra("subtitle is-6")
                                        ]), b([
                                            gi("Each credit can be used to compute a schedule")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(ai, b([
                                Ra("card-footer")
                            ]), b([
                                A2(Co, b([
                                    Ra("card-footer-item button is-success"),
                                    ho(Qv(cm))
                                ]), b([
                                    gi("Purchase more credits")
                                ]))
                            ])),
                            A2(Ya, b([
                                Ra("modal")
                            ]), f)
                        ]))
                    ])),
                    A2(Ya, b([
                        Ra("column is-9")
                    ]), b([
                        A2(Qm, b([
                            Ra("table is-fullwidth is-striped")
                        ]), b([
                            A2(cp, f, b([
                                A2(bp, f, b([
                                    A2(op, f, b([
                                        gi("Created")
                                    ])),
                                    A2(op, f, b([
                                        gi("Failed Meetings")
                                    ])),
                                    A2(op, f, b([
                                        gi("Errors")
                                    ])),
                                    A2(op, f, b([
                                        gi("Status")
                                    ])),
                                    A2(op, f, b([
                                        A2(Co, b([
                                            ho(am),
                                            Ra("button is-rounded")
                                        ]), b([
                                            io(vm)
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(up, f, A2(qr, function(t) {
                                var e, r;
                                return A2(bp, f, b([
                                    A2(ap, f, b([
                                        gi(A2(wu, "", A4(gf, function(n) {
                                            return function(t) {
                                                return function(e) {
                                                    return A3(Dm, n, t, e);
                                                };
                                            };
                                        }, n.a0, n.a4, A2(uu, ll, Tr(t.au)))))
                                    ])),
                                    A2(ap, f, b([
                                        gi(A2(He, ",", A2(cu, function(t) {
                                            return A2(uu, function(n) {
                                                return n.c$ + " (" + Sm(n.z) + ")";
                                            }, A2(gb, function(t) {
                                                return A2(Tu, t, n.f);
                                            }, Tr(t)));
                                        }, A2(wu, f, t.bA))))
                                    ])),
                                    A2(ap, f, (e = A2(wu, "", t.aZ), r = kr(e) > 20, A2(ce, gi(A2(Hr, 20, e)), r ? b([
                                        A2(vi, b([
                                            dp(e),
                                            Ra("has-tooltip-bottom has-tooltip-multiline")
                                        ]), b([
                                            gi("...")
                                        ]))
                                    ]) : f))),
                                    A2(ap, f, function() {
                                        var e = t.bh;
                                        if (e.$) return f;
                                        var r = e.a, a = A2(mm, function(t) {
                                            var e = t.ap;
                                            return A2(Yv, function(n) {
                                                return 1 > u(n.g, e.g) && u(n.c, e.c) > -1;
                                            }, n.p.m);
                                        }, r), i = A2(mm, function(t) {
                                            return A2(wu, !0, A2(uu, function(t) {
                                                return A2(Eb, t, n.f);
                                            }, Tr(t.aM)));
                                        }, r);
                                        return b([
                                            A2(hi, f, b([
                                                gi("Meetings exist? "),
                                                A2(vi, f, b([
                                                    io(i ? gm : Tp)
                                                ]))
                                            ])),
                                            A2(hi, f, b([
                                                gi("Times still fit? "),
                                                A2(vi, f, b([
                                                    io(a ? gm : Tp)
                                                ]))
                                            ]))
                                        ]);
                                    }()),
                                    A2(ap, f, b([
                                        function() {
                                            var n = t.bh;
                                            if (n.$) return gi("");
                                            var e, r = n.a;
                                            return A2(Co, b([
                                                Ra("button is-link is-small is-icon is-rounded"),
                                                ho(Qv((e = r, {
                                                    $: 2,
                                                    a: e
                                                })))
                                            ]), b([
                                                io(Ym)
                                            ]));
                                        }()
                                    ]))
                                ]));
                            }, n.R)),
                            A2(ip, f, f)
                        ]))
                    ]))
                ]));
        }
    }, qp = {
        $: 31
    }, Dp = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Fp = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Xp = ri(A4(ti, "fas", "coins", i(512, 512), i("M512 80C512 98.01 497.7 114.6 473.6 128C444.5 144.1 401.2 155.5 351.3 158.9C347.7 157.2 343.9 155.5 340.1 153.9C300.6 137.4 248.2 128 192 128C183.7 128 175.6 128.2 167.5 128.6L166.4 128C142.3 114.6 128 98.01 128 80C128 35.82 213.1 0 320 0C426 0 512 35.82 512 80V80zM160.7 161.1C170.9 160.4 181.3 160 192 160C254.2 160 309.4 172.3 344.5 191.4C369.3 204.9 384 221.7 384 240C384 243.1 383.3 247.9 381.9 251.7C377.3 264.9 364.1 277 346.9 287.3C346.9 287.3 346.9 287.3 346.9 287.3C346.8 287.3 346.6 287.4 346.5 287.5L346.5 287.5C346.2 287.7 345.9 287.8 345.6 288C310.6 307.4 254.8 320 192 320C132.4 320 79.06 308.7 43.84 290.9C41.97 289.9 40.15 288.1 38.39 288C14.28 274.6 0 258 0 240C0 205.2 53.43 175.5 128 164.6C138.5 163 149.4 161.8 160.7 161.1L160.7 161.1zM391.9 186.6C420.2 182.2 446.1 175.2 468.1 166.1C484.4 159.3 499.5 150.9 512 140.6V176C512 195.3 495.5 213.1 468.2 226.9C453.5 234.3 435.8 240.5 415.8 245.3C415.9 243.6 416 241.8 416 240C416 218.1 405.4 200.1 391.9 186.6V186.6zM384 336C384 354 369.7 370.6 345.6 384C343.8 384.1 342 385.9 340.2 386.9C304.9 404.7 251.6 416 192 416C129.2 416 73.42 403.4 38.39 384C14.28 370.6 .0003 354 .0003 336V300.6C12.45 310.9 27.62 319.3 43.93 326.1C83.44 342.6 135.8 352 192 352C248.2 352 300.6 342.6 340.1 326.1C347.9 322.9 355.4 319.2 362.5 315.2C368.6 311.8 374.3 308 379.7 304C381.2 302.9 382.6 301.7 384 300.6L384 336zM416 278.1C434.1 273.1 452.5 268.6 468.1 262.1C484.4 255.3 499.5 246.9 512 236.6V272C512 282.5 507 293 497.1 302.9C480.8 319.2 452.1 332.6 415.8 341.3C415.9 339.6 416 337.8 416 336V278.1zM192 448C248.2 448 300.6 438.6 340.1 422.1C356.4 415.3 371.5 406.9 384 396.6V432C384 476.2 298 512 192 512C85.96 512 .0003 476.2 .0003 432V396.6C12.45 406.9 27.62 415.3 43.93 422.1C83.44 438.6 135.8 448 192 448z", xe))), Gp = M, Rp = A, Up = function(n) {
        return 25 * Rp(9 * A2(Gp, n, .725));
    }, Yp = F3(function(n, t, e) {
        return s(e, A2(Nb, n - kr(e), Tm(t)));
    }), Wp = function(n) {
        var t = Up(n);
        return "$" + Se(t / 100 | 0) + "." + A3(Yp, 2, "0", Se(A2(Mm, 100, t)));
    }, Bp = F2(function(n, t) {
        return A3(Ir, F2(function(t, e) {
            return A3(ju, n(t), A2(au, uu(ce(t)), A2(au, wu(b([
                t
            ])), ke)), e);
        }), ru, t);
    }), Jp = Kn("h3"), Kp = Kn("h4"), Qp = function(n) {
        return Kn(function(n) {
            return ut.test(n) ? "p" : n;
        }(n));
    }, ng = function(n) {
        switch(n){
            case 6:
                return 0;
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            default:
                return 6;
        }
    }, tg = function(n) {
        var t, r, a = n.w;
        switch(a.$){
            case 0:
                return gi("");
            case 4:
                var o = a.a.N, c = a.a.bT, l = a.a.bp, d = Pv(c) + Pv(l);
                return 25 > d ? A2(Ya, b([
                    Ra("modal-card")
                ]), b([
                    A2(vf, b([
                        Ra("modal-card-head")
                    ]), b([
                        A2(Jp, b([
                            Ra("modal-card-title")
                        ]), b([
                            gi("Are you sure you want to delete "),
                            A2(Ua, f, b([
                                gi(o)
                            ])),
                            gi("?")
                        ])),
                        A2(Co, b([
                            Ra("delete"),
                            ho(Qv(Kf))
                        ]), f)
                    ])),
                    Zh(c) && Zh(l) ? A2(Xo, b([
                        Ra("modal-card-body")
                    ]), b([
                        A2(Ya, b([
                            Ra("content")
                        ]), b([
                            A2(hi, f, b([
                                gi("This participant has not been added to any meetings.")
                            ]))
                        ]))
                    ])) : A2(Xo, b([
                        Ra("modal-card-body")
                    ]), b([
                        A2(Ya, b([
                            Ra("columns")
                        ]), b([
                            Zh(c) ? gi("") : A2(Ya, b([
                                Ra("content column")
                            ]), b([
                                A2(Kp, b([
                                    Ra("subtitle is-6")
                                ]), b([
                                    gi("These meetings will be deleted:")
                                ])),
                                A2(Yo, f, A2(qr, function(n) {
                                    return A2(Do, f, b([
                                        A2(Ua, f, b([
                                            gi(n.c$)
                                        ]))
                                    ]));
                                }, mp(c)))
                            ])),
                            Zh(l) ? gi("") : A2(Ya, b([
                                Ra("content column")
                            ]), b([
                                A2(Kp, b([
                                    Ra("subtitle is-6")
                                ]), b([
                                    A2(Ua, f, b([
                                        gi(o)
                                    ])),
                                    gi(" will be removed from these meetings")
                                ])),
                                A2(Yo, f, A2(qr, function(n) {
                                    return A2(Do, f, b([
                                        A2(Ua, f, b([
                                            gi(n.c$)
                                        ]))
                                    ]));
                                }, mp(l)))
                            ]))
                        ]))
                    ])),
                    A2(ai, b([
                        Ra("modal-card-foot")
                    ]), b([
                        A2(Co, b([
                            Ra("button is-success"),
                            ho((r = o, {
                                $: 7,
                                a: r
                            }))
                        ]), b([
                            gi("Confirm")
                        ])),
                        A2(Co, b([
                            Ra("button is-danger"),
                            ho(Qv(Kf))
                        ]), b([
                            gi("Cancel")
                        ]))
                    ]))
                ])) : A2(Ya, b([
                    Ra("modal-content")
                ]), b([
                    A2(Xo, b([
                        Ra("message is-danger")
                    ]), b([
                        A2(Ya, b([
                            Ra("message-header")
                        ]), b([
                            A2(hi, f, b([
                                gi("Unable to delete this participant")
                            ])),
                            A2(Co, b([
                                Ra("delete"),
                                ho(Qv(Kf))
                            ]), f)
                        ])),
                        A2(Ya, b([
                            Ra("message-body")
                        ]), b([
                            A2(hi, f, b([
                                gi("\n                            This participant is a member of too many meetings. Please delete this participant's\n                            meetings manually until there are 24 meetings or less.\n                            ")
                            ])),
                            A2(hi, f, b([
                                gi("Currently, there are " + Se(d) + " meetings with this participant")
                            ]))
                        ]))
                    ]))
                ]));
            case 2:
                var h = a.a, v = !A2(Yv, function(t) {
                    return A2(wu, !0, A2(uu, function(t) {
                        return A2(Eb, t, n.f);
                    }, Tr(t.aM)));
                }, h), m = !A2(mm, function(t) {
                    return A2(wu, !0, A2(uu, function(t) {
                        return A2(Eb, t, n.f);
                    }, Tr(t.aM)));
                }, h), p = A2(Bp, function(n) {
                    return A2(wu, 0, A2(uu, ng, A2(xb, n.ap.g / Bv | 0, Uv)));
                }, A2(cu, function(t) {
                    return A2(uu, function(n) {
                        return {
                            bI: n,
                            ap: t.ap
                        };
                    }, A2(gb, function(t) {
                        return A2(Tu, t, n.f);
                    }, Tr(t.aM)));
                }, h)), g = A2(Qm, b([
                    Ra("table is-bordered is-fullwidth is-striped")
                ]), b([
                    A2(cp, f, b([
                        A2(bp, f, b([
                            A2(op, b([
                                Ra("table_day-header"),
                                To(150)
                            ]), b([
                                gi("Day")
                            ])),
                            A2(op, b([
                                Ra("table_time-header"),
                                To(200)
                            ]), b([
                                gi("Time")
                            ])),
                            A2(op, b([
                                Ra("table_meeting-header")
                            ]), b([
                                A2(Ya, b([
                                    Ra("is-flex")
                                ]), b([
                                    A2(vi, b([
                                        Ra("is-flex-grow-1")
                                    ]), b([
                                        gi("Meeting")
                                    ])),
                                    A2(Co, b([
                                        Ra("is-flex-shrink-1 delete"),
                                        ho(Qv(Kf))
                                    ]), f)
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(up, f, xu(mp(A2(jh, function(n) {
                        return function(t) {
                            var e;
                            return A2(ce, A2(bp, b([
                                A2(po, "display", "none")
                            ]), f), A2(ce, A2(bp, f, b([
                                A2(ap, b([
                                    Ra("table_day-row"),
                                    (e = 1 + Ve(t), A2(rt, "rowspan", Se(e)))
                                ]), b([
                                    gi(A2(wu, "", A2(uu, Hv, A2(xb, n, Uv))))
                                ]))
                            ])), A2(qr, function(n) {
                                var t = n.bI, e = n.ap;
                                return A2(bp, f, b([
                                    A2(ap, b([
                                        Ra("table_time-row")
                                    ]), b([
                                        gi(sp(e.g) + " - " + sp(e.c))
                                    ])),
                                    A2(ap, b([
                                        Ra("table_meeting-row content")
                                    ]), b([
                                        A2(Ua, f, b([
                                            gi(t.c$)
                                        ])),
                                        gi(" (" + Sm(t.z) + ")"),
                                        A2(Ya, b([
                                            Ra("tags are-small")
                                        ]), A2(qr, function(n) {
                                            return A2(vi, b([
                                                Ra("tag is-dark")
                                            ]), b([
                                                gi(n)
                                            ]));
                                        }, de(t.a)))
                                    ]))
                                ]));
                            }, A2(Jm, function(n) {
                                return n.ap.g;
                            }, t))));
                        };
                    }, p))))
                ]));
                return A2(Ya, b([
                    Ra("modal-content container"),
                    A2(po, "display", "grid"),
                    A2(po, "place-items", "center")
                ]), b(v ? [
                    A2(Ya, b([
                        Ra("message is-danger")
                    ]), b([
                        A2(Ya, b([
                            Ra("message-header")
                        ]), b([
                            gi("Meetings Deleted"),
                            A2(Co, b([
                                Ra("delete"),
                                ho(Qv(Kf))
                            ]), f)
                        ])),
                        A2(Ya, b([
                            Ra("message-body")
                        ]), b([
                            gi("None of the meetings exist anymore!")
                        ]))
                    ]))
                ] : m ? [
                    A2(Ya, b([
                        Ra("message is-danger")
                    ]), b([
                        A2(Ya, b([
                            Ra("message-header")
                        ]), b([
                            gi("Missing Meetings"),
                            A2(Co, b([
                                Ra("delete"),
                                ho(Qv(Kf))
                            ]), f)
                        ])),
                        A2(Ya, b([
                            Ra("message-body")
                        ]), b([
                            gi("This result was run with meetings that have been deleted!")
                        ]))
                    ])),
                    g
                ] : [
                    g
                ]));
            case 1:
                var $ = a.a;
                switch($.$){
                    case 1:
                        return A2(Ya, b([
                            Ra("modal-card")
                        ]), b([
                            A2(Ya, b([
                                Ra("modal-card-body")
                            ]), b([
                                io(A2(jf, b([
                                    Pf
                                ]), _f))
                            ]))
                        ]));
                    case 3:
                        var w = $.a.aZ;
                        if (1 === w.$) {
                            var y = mp(A2(Lh, function() {
                                return function(t) {
                                    return Al(A2(ko, function(n) {
                                        return u(n.c - n.g + 1, t.z) > -1;
                                    }, A2(Km, s(n.p.m, A2(qr, zm, n.p.X)), Fm(xu(A2(qr, function(t) {
                                        return A2(wu, f, A2(uu, function(n) {
                                            return s(n.m, A2(qr, zm, n.X));
                                        }, A2(Tu, t, n.a)));
                                    }, de(t.a)))))));
                                };
                            }, n.f));
                            return A2(Ya, b([
                                Ra("modal-card")
                            ]), b([
                                A2(vf, b([
                                    Ra("modal-card-head")
                                ]), b([
                                    A2(hi, b([
                                        Ra("modal-card-title")
                                    ]), b([
                                        gi("Review")
                                    ]))
                                ])),
                                A2(Xo, b([
                                    Ra("modal-card-body")
                                ]), s(b([
                                    A2(Ya, b([
                                        Ra("content")
                                    ]), b([
                                        A2(Jp, f, b([
                                            gi("Please note:")
                                        ])),
                                        A2(hi, f, b([
                                            gi("\n                                            A credit will be deducted from your account. Though Zeitplan is highly\n                                            optimized for finding the solution, it is not guranteed that a solution\n                                            exists, nor that a solution will be found if it does exist. With a single\n                                            credit, we will search over 10,000 configurations to identify a solution.\n                                            Regardless of if a solution is found, the credit will be deducted from your account,\n                                            as we do still perform the search.\n                                            ")
                                        ]))
                                    ]))
                                ]), Al(y) ? f : b([
                                    A2(Ya, b([
                                        Ra("message is-warning")
                                    ]), b([
                                        A2(Ya, b([
                                            Ra("message-header")
                                        ]), b([
                                            gi("The following meetings will not be scheduled")
                                        ])),
                                        A2(Ya, b([
                                            Ra("message-body")
                                        ]), b([
                                            A2(Ya, b([
                                                Ra("content")
                                            ]), b([
                                                A2(Yo, f, A2(qr, function(n) {
                                                    return A2(Do, f, b([
                                                        gi(n.c$ + " (" + Sm(n.z) + ")")
                                                    ]));
                                                }, y))
                                            ]))
                                        ]))
                                    ]))
                                ]))),
                                A2(ai, b([
                                    Ra("modal-card-foot")
                                ]), b([
                                    A2(Co, b([
                                        ho(qp),
                                        Ra("button is-success")
                                    ]), b([
                                        gi("Schedule")
                                    ]))
                                ]))
                            ]));
                        }
                        var C = w.a;
                        return A2(Ya, b([
                            Ra("message is-danger")
                        ]), b([
                            A2(Ya, b([
                                Ra("message-header")
                            ]), b([
                                gi("Can't schedule meeting!")
                            ])),
                            A2(Ya, b([
                                Ra("message-body")
                            ]), b([
                                gi(C)
                            ]))
                        ]));
                    default:
                        return A2(Ya, f, f);
                }
            default:
                return A2(Ya, b([
                    Ra("modal-content")
                ]), b([
                    A2(Ya, b([
                        Ra("box")
                    ]), b([
                        A2(Ya, b([
                            Ra("tabs is-centered")
                        ]), b([
                            A2(Yo, f, b([
                                A2(Do, b([
                                    zo(b([
                                        i("is-active", !n.aA)
                                    ]))
                                ]), b([
                                    A2(Da, b([
                                        Ra("ignore-pointer-events")
                                    ]), b([
                                        gi("Select Credits")
                                    ]))
                                ])),
                                A2(Do, b([
                                    zo(b([
                                        i("is-active", 1 === n.aA)
                                    ]))
                                ]), b([
                                    A2(Da, b([
                                        Ra("ignore-pointer-events")
                                    ]), b([
                                        gi("Checkout with Stripe")
                                    ]))
                                ]))
                            ]))
                        ])),
                        n.aA ? A2(Ya, f, b([
                            A2(hi, b([
                                Ra("subtitle")
                            ]), b([
                                gi("Pay securely with Stripe")
                            ])),
                            A2(hi, b([
                                Ra("subtitle is-6 mt-1")
                            ]), b([
                                gi("Total: " + Wp(n.ad))
                            ])),
                            A2(wu, io(A2(jf, b([
                                Pf
                            ]), _f)), A2(uu, function(t) {
                                var e = Up(n.ad);
                                return A3(Qp, "stripe-web-component", b([
                                    A2(wi, "amount", Se(e)),
                                    A2(wi, "client-secret", t)
                                ]), f);
                            }, n.aK)),
                            A2(hi, b([
                                Ra("subtitle is-6 mt-1")
                            ]), b([
                                gi("Note: you will be redirected to a confirmation page upon successful payment")
                            ]))
                        ])) : A2(bf, b([
                            zf(Fp(1))
                        ]), b([
                            A2(Ya, b([
                                Ra("field")
                            ]), b([
                                A2(pf, b([
                                    Ra("label")
                                ]), b([
                                    gi("Choose how many credits to purchase")
                                ])),
                                A2(Ya, b([
                                    Ra("control has-icons-left")
                                ]), b([
                                    A2(Ya, b([
                                        Ra("select is-fullwidth is-rounded is-medium")
                                    ]), b([
                                        A2(Wm, b([
                                            Cf(Dp)
                                        ]), (t = b([
                                            5,
                                            10,
                                            25,
                                            50
                                        ]), A2(qr, function(t) {
                                            return A2(Gm, b([
                                                Tf(Se(t)),
                                                Bm(e(n.ad, t))
                                            ]), b([
                                                gi(Se(t) + " - " + Wp(t))
                                            ]));
                                        }, t)))
                                    ])),
                                    A2(Ya, b([
                                        Ra("icon is-small is-left")
                                    ]), b([
                                        io(Xp)
                                    ]))
                                ]))
                            ])),
                            A2(hi, b([
                                Ra("subtitle")
                            ]), b([
                                gi("Note: purchasing more credits is cheaper per-credit.")
                            ])),
                            A2(Co, b([
                                Ra("button is-success")
                            ]), b([
                                gi("Continue to Checkout")
                            ]))
                        ]))
                    ]))
                ]));
        }
    }, eg = F2(function(n, t) {
        return A2(Df, "Zeitplan - Schedule", b([
            A2(Ya, b([
                Ra("zeitplan-container"),
                zo(b([
                    i("is-clipped", !e(t.w, Kf))
                ]))
            ]), b([
                A2(Ma, tm, Vo({
                    bH: n.bH,
                    T: n
                })),
                A2(Ya, b([
                    Ra("modal"),
                    zo(b([
                        i("is-active", !e(t.w, Kf))
                    ]))
                ]), b([
                    A2(Ya, b([
                        Ra("modal-background"),
                        ho(Qv(Kf))
                    ]), f),
                    tg(t)
                ])),
                A2(Ya, b([
                    Ra("pageloader"),
                    zo(b([
                        i("is-active", !t.a_)
                    ]))
                ]), b([
                    A2(vi, b([
                        Ra("title")
                    ]), b([
                        gi("Please wait while we fetch your information")
                    ]))
                ])),
                A2(Ya, b([
                    Ra("container is-fullhd")
                ]), b([
                    A2(Ya, b([
                        Ra("box mt-2")
                    ]), b([
                        A2(Yo, b([
                            Ra("steps is-centered has-content-centered")
                        ]), b([
                            A2(Do, b([
                                dp("Add times for your meetings"),
                                Ra("steps-segment has-tooltip-bottom has-tooltip-multiline"),
                                zo(b([
                                    i("is-active", !t.U)
                                ]))
                            ]), b([
                                A2(Da, b([
                                    li("#"),
                                    Ra("has-text-dark"),
                                    ho(nm(0))
                                ]), b([
                                    A2(vi, b([
                                        Ra("steps-marker icon is-small")
                                    ]), b([
                                        io(rm)
                                    ])),
                                    A2(Ya, b([
                                        Ra("steps-content")
                                    ]), b([
                                        gi("Available Times")
                                    ]))
                                ]))
                            ])),
                            A2(Do, b([
                                dp("Add people to meet with - and block off times they can't meet"),
                                Ra("steps-segment has-tooltip-bottom has-tooltip-multiline"),
                                zo(b([
                                    i("is-active", 1 === t.U),
                                    i("ignore-pointer-events", Al(t.p.m))
                                ]))
                            ]), b([
                                A2(Da, b([
                                    li("#"),
                                    Ra("has-text-dark"),
                                    ho(nm(1))
                                ]), b([
                                    A2(vi, b([
                                        Ra("steps-marker icon is-small")
                                    ]), b([
                                        io(vp)
                                    ])),
                                    A2(Ya, b([
                                        Ra("steps-content")
                                    ]), b([
                                        gi("Participants"),
                                        A2(vi, b([
                                            Ra("ml-2")
                                        ]), b([
                                            gi(Zh(t.a) ? "" : "(" + Se(Pv(t.a)) + ")")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(Do, b([
                                dp("Setup meetings with your participants"),
                                Ra("steps-segment has-tooltip-bottom has-tooltip-multiline"),
                                zo(b([
                                    i("is-active", 2 === t.U),
                                    i("ignore-pointer-events", Zh(t.a))
                                ]))
                            ]), b([
                                A2(Da, b([
                                    li("#"),
                                    Ra("has-text-dark"),
                                    ho(nm(2))
                                ]), b([
                                    A2(vi, b([
                                        Ra("steps-marker icon is-small")
                                    ]), b([
                                        io(em)
                                    ])),
                                    A2(Ya, b([
                                        Ra("steps-content")
                                    ]), b([
                                        gi("Meetings"),
                                        A2(vi, b([
                                            Ra("ml-2")
                                        ]), b([
                                            gi(Zh(t.f) ? "" : "(" + Se(Pv(t.f)) + ")")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(Do, b([
                                dp("Find a way to schedule your meetings"),
                                Ra("steps-segment has-tooltip-bottom has-tooltip-multiline"),
                                zo(b([
                                    i("is-active", 3 === t.U),
                                    i("ignore-pointer-events", Zh(t.f))
                                ]))
                            ]), b([
                                A2(Da, b([
                                    li("#"),
                                    Ra("has-text-dark"),
                                    ho(nm(3))
                                ]), b([
                                    A2(vi, b([
                                        Ra("steps-marker icon is-small")
                                    ]), b([
                                        io(um)
                                    ])),
                                    A2(Ya, b([
                                        Ra("steps-content")
                                    ]), b([
                                        gi("Compute Schedule")
                                    ]))
                                ]))
                            ]))
                        ])),
                        Ip(t)
                    ]))
                ])),
                oo
            ]))
        ]));
    }), rg = F2(function(n) {
        return yh.b5(function(t) {
            return {
                Z: A2($h, n, t),
                ab: Ch,
                aq: Kv(t),
                V: eg(n)
            };
        });
    }), ug = F2(function(n, t) {
        return {
            Z: F4(function(n) {
                return i(t(n), Pa);
            }),
            ab: F5(function() {
                return va;
            }),
            aq: F6(function(n) {
                return i(t(n), Pa);
            }),
            V: F5(function() {
                return A2(Sa, _r, n);
            })
        };
    }), ag = {
        cb: b([
            gi("Page not found.")
        ]),
        c$: "Page not found."
    }, ig = {
        aH: A3(Aa, Zo, Qu, na),
        aL: A3(Aa, Qo, ta, ea),
        aN: A3(Aa, Of, ra, ua),
        a$: A2(ug, ag, aa),
        aQ: A3(Aa, Gf, ia, oa),
        aR: A3(Aa, Bf, ca, sa),
        aS: A3(Aa, rg, fa, la)
    }, og = function(n) {
        switch(n){
            case 0:
                return ig.aH.Z(0);
            case 1:
                return ig.aL.Z(0);
            case 2:
                return ig.aN.Z(0);
            case 3:
                return ig.aQ.Z(0);
            case 4:
                return ig.aR.Z(0);
            case 5:
                return ig.aS.Z(0);
            default:
                return ig.a$.Z(0);
        }
    }, cg = F4(function(n, t, e, r) {
        return {
            a9: t,
            bC: r,
            bH: n,
            c5: e
        };
    }), sg = {
        $: 6
    }, fg = F3(function(n, t, e) {
        return {
            bC: e,
            bH: n,
            c5: t
        };
    }), lg = A3(Uc, "graphQlEndpoint", Yc, A3(Uc, "currentlyLoggedInUser", Oc(Wc), A3(Uc, "logo", Yc, pr(fg)))), dg = F2(function(n, t) {
        return A2(Jr, La(t), A2(Dr, jv, A2(Fr, Je, A2(Fr, function(t) {
            return n - t;
        }, A2(Fr, Fh, dl)))));
    }), bg = tu(f), hg = F2(function(n, t) {
        var e = A2(Xc, lg, t);
        if (e.$) return i(A4(cg, "", !1, xe, ""), bg);
        var r = e.a, u = A2(wu, bg, A2(uu, function(n) {
            return A2(dg, n.bz - 6e4, sg);
        }, r.c5));
        return i(A4(cg, r.bH, !1, r.c5, r.bC), u);
    }), vg = F2(function(n, t) {
        var e = n.a, r = n.b;
        switch(t.$){
            case 0:
                return bg;
            case 1:
                return A2(ka, r, t.a);
            case 2:
                return A2(Jr, e, jr(t.a));
            default:
                var u = t.a;
                return tu(A2(qr, vg(i(e, r)), u));
        }
    }), mg = F3(function(n, t, e) {
        var r = A2(hg, A3(Ku, 0, t, e), n), u = r.a, a = r.b, o = A4(og, Ju(t), u, t, e), c = o.b;
        return i(A4(Kr, t, e, u, o.a), tu(b([
            A2(ka, nu, a),
            A2(vg, i(nu, Qr), c)
        ])));
    }), pg = function(n) {
        switch(n.$){
            case 0:
                return F3(function() {
                    return va;
                });
            case 1:
                return A2(ig.aH.ab, n.a, n.b);
            case 2:
                return A2(ig.aL.ab, n.a, n.b);
            case 3:
                return A2(ig.aN.ab, n.a, n.b);
            case 4:
                return A2(ig.aQ.ab, n.a, n.b);
            case 5:
                return A2(ig.aR.ab, n.a, n.b);
            case 6:
                return A2(ig.aS.ab, n.a, n.b);
            default:
                return A2(ig.a$.ab, n.a, 0);
        }
    }, gg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $g = function(n) {
        return {
            $: 5,
            a: n
        };
    }, wg = {
        $: 4
    }, yg = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Cg = F3(function(n, t, e) {
        return {
            $: 0,
            a: n,
            b: t,
            c: e
        };
    }), kg = F2(function(n, t) {
        return {
            bN: t,
            bY: n
        };
    }), xg = jr(A2(kg, f, ru)), zg = function(n) {
        return i(s(n.a ? "w_" : "d_", n.b), n);
    }, Mg = F6(function(n, t, e, r, a, o) {
        var c = A3(Ah, F3(function(r, a, o) {
            n: for(;;){
                var c = o.a, s = o.b;
                if (c.b) {
                    var f = c.a, l = f.a, d = f.b, b = c.b;
                    if (0 > u(l, r)) {
                        o = i(b, A3(n, l, d, s));
                        continue n;
                    }
                    return u(l, r) > 0 ? i(c, A3(e, r, a, s)) : i(b, A4(t, l, d, a, s));
                }
                return i(c, A3(e, r, a, s));
            }
        }), i(fe(r), o), a), s = c.a, f = c.b;
        return A3(Le, F2(function(t, e) {
            return A3(n, t.a, t.b, e);
        }), f, s);
    }), Sg = F2(function(n, t) {
        return {
            r: t,
            N: n
        };
    }), Hg = F3(function(n, t, e) {
        return A2(Fr, function(n) {
            return i(t, n);
        }, A3(Gt, e.a ? Xt : Ft, e.b, function(e) {
            return A2(Ud, n, A2(Sg, t, e));
        }));
    }), Tg = F2(function(n, t) {
        return A3(Ah, bu, t, n);
    }), Ag = F3(function(n, t, e) {
        var r = F3(function(t, e, r) {
            var u = r.c;
            return o(r.a, r.b, A2(ce, A3(Hg, n, t, e), u));
        }), u = F3(function(n, t, e) {
            var r = e.b, u = e.c;
            return o(A2(ce, t, e.a), r, u);
        }), a = F4(function(n, t, e, r) {
            var u = r.c;
            return o(r.a, A3(bu, n, t, r.b), u);
        }), i = A2(qr, zg, t), c = A6(Mg, u, a, r, e.bN, hu(i), o(f, ru, f)), s = c.b, l = c.c;
        return A2(Dr, function(n) {
            return jr(A2(kg, i, A2(Tg, s, hu(n))));
        }, A2(Dr, function() {
            return Gr(l);
        }, Gr(A2(qr, Yd, c.a))));
    }), Lg = F3(function(n, t, r) {
        var u = t.N, a = t.r, i = function(n) {
            var t = n.b.c;
            return e(n.a, u) ? A2(Rt, t, a) : xe;
        }, o = A2(cu, i, r.bY);
        return A2(Dr, function() {
            return jr(r);
        }, Gr(A2(qr, Rr(n), o)));
    });
    Sn["Browser.Events"] = Hn(xg, Ag, Lg, 0, F2(function(n, t) {
        return A3(Cg, t.a, t.b, A2(vr, n, t.c));
    }));
    var Vg, Eg, Zg, Pg, _g, jg = Vn("Browser.Events"), Ng = F3(function(n, t, e) {
        return jg(A3(Cg, n, t, e));
    }), Og = F2(function(n, t) {
        return n(t ? 1 : 0);
    }), Ig = Xn("refreshToken", gc), qg = Xn("signOutErr", gc), Dg = Xn("signOutOk", gc), Fg = F2(function() {
        var n, t;
        return ha(b([
            Dg(function() {
                return wg;
            }),
            qg($g),
            Ig(gg),
            (n = yg, t = void 0 !== Yn.hidden ? {
                cs: "hidden",
                ce: "visibilitychange"
            } : void 0 !== Yn.mozHidden ? {
                cs: "mozHidden",
                ce: "mozvisibilitychange"
            } : void 0 !== Yn.msHidden ? {
                cs: "msHidden",
                ce: "msvisibilitychange"
            } : void 0 !== Yn.webkitHidden ? {
                cs: "webkitHidden",
                ce: "webkitvisibilitychange"
            } : {
                cs: "hidden",
                ce: "visibilitychange"
            }, A3(Ng, 0, t.ce, A2(vr, Og(n), A2(Dc, "target", A2(Dc, t.cs, Ts)))))
        ]));
    }), Xg = F2(function(n, t) {
        return 1 === n.$ ? t : t + ":" + Se(n.a);
    }), Gg = F3(function(n, t, e) {
        return 1 === t.$ ? e : s(e, s(n, t.a));
    }), Rg = F2(function(n, t) {
        var e = i(n, t);
        n: for(;;)switch(e.a.$){
            case 0:
                if (1 === e.b.$) {
                    var r = e.b;
                    return A3(ig.aH.aq, r.a, e.a.a, r.b);
                }
                break n;
            case 1:
                if (2 === e.b.$) {
                    var u = e.b;
                    return A3(ig.aL.aq, u.a, e.a.a, u.b);
                }
                break n;
            case 2:
                if (3 === e.b.$) {
                    var a = e.b;
                    return A3(ig.aN.aq, a.a, e.a.a, a.b);
                }
                break n;
            case 3:
                if (4 === e.b.$) {
                    var o = e.b;
                    return A3(ig.aQ.aq, o.a, e.a.a, o.b);
                }
                break n;
            case 4:
                if (5 === e.b.$) {
                    var c = e.b;
                    return A3(ig.aR.aq, c.a, e.a.a, c.b);
                }
                break n;
            default:
                if (6 === e.b.$) {
                    var s = e.b;
                    return A3(ig.aS.aq, s.a, e.a.a, s.b);
                }
                break n;
        }
        return F3(function() {
            return i(t, Pa);
        });
    }), Ug = {
        $: 2
    }, Yg = A3(Uc, "expires", _c, A3(Uc, "jwt", Yc, pr(F2(function(n, t) {
        return {
            bz: t,
            bG: n
        };
    })))), Wg = qn("requestRefreshToken", function() {
        return ks;
    }), Bg = Wt, Jg = F2(function(n, t) {
        return A2(ul, function() {
            return n;
        }, A2(Dr, function(n) {
            return A2(Bg, n.bx.c8, n.bx.c9);
        }, function(n) {
            return Ut(n, function(n) {
                var t, e, r = n.getBoundingClientRect(), u = Xt.pageXOffset, a = Xt.pageYOffset;
                return {
                    bW: (t = Ft.body, e = Ft.documentElement, {
                        b3: Math.max(t.scrollWidth, t.offsetWidth, e.scrollWidth, e.offsetWidth, e.clientWidth),
                        bD: Math.max(t.scrollHeight, t.offsetHeight, e.scrollHeight, e.offsetHeight, e.clientHeight)
                    }),
                    b2: {
                        c8: u,
                        c9: a,
                        b3: Ft.documentElement.clientWidth,
                        bD: Ft.documentElement.clientHeight
                    },
                    bx: {
                        c8: u + r.left,
                        c9: a + r.top,
                        b3: r.width,
                        bD: r.height
                    }
                };
            });
        }(t)));
    }), Kg = qn("signOut", function() {
        return ks;
    }), Qg = F3(function(n, t, e) {
        switch(t.$){
            case 0:
                return i(c(e, {
                    a9: !e.a9
                }), bg);
            case 1:
                return i(e, A2(Jg, Ug, t.a));
            case 2:
            case 5:
                return i(e, bg);
            case 3:
                return i(c(e, {
                    c5: ke(s = t.a)
                }), tu(b([
                    A2(ec, 5, n),
                    A2(dg, s.bz - 6e4, sg)
                ])));
            case 4:
                return i(c(e, {
                    c5: xe
                }), A2(ec, 2, n));
            case 6:
                return i(e, Wg(0));
            case 7:
                var r = A2(Xc, Yg, t.a);
                if (r.$) return i(e, bg);
                var u = r.a, a = e.c5;
                if (a.$) return i(e, bg);
                var o = c(s = a.a, {
                    bz: u.bz,
                    bG: u.bG
                });
                return i(c(e, {
                    c5: ke(o)
                }), A2(dg, u.bz - 6e4, sg));
            case 8:
                if (t.a) return i(e, bg);
                var s, f = e.c5;
                return i(e, f.$ ? bg : A2(dg, (s = f.a).bz - 6e4, sg));
            default:
                return i(c(e, {
                    c5: xe
                }), e.c5.$ ? bg : Kg(0));
        }
    }), n$ = function(n) {
        switch(n.$){
            case 0:
                return F3(function() {
                    return Ha;
                });
            case 1:
                return A2(ig.aH.V, n.a, n.b);
            case 2:
                return A2(ig.aL.V, n.a, n.b);
            case 3:
                return A2(ig.aN.V, n.a, n.b);
            case 4:
                return A2(ig.aQ.V, n.a, n.b);
            case 5:
                return A2(ig.aR.V, n.a, n.b);
            case 6:
                return A2(ig.aS.V, n.a, n.b);
            default:
                return A2(ig.a$.V, n.a, 0);
        }
    };
    Vg = {
        Main: {
            init: (Zg = (Eg = {
                Z: mg,
                cH: function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                },
                cI: function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                },
                ab: function(n) {
                    return ha(b([
                        A2(ba, Qr, A4(pg, n.cK, n.T, n.H, n.N)),
                        A2(ba, nu, A2(Fg, A3(Ku, 0, n.H, n.N), n.T))
                    ]));
                },
                aq: F2(function(n, t) {
                    switch(n.$){
                        case 1:
                            return i(t, n.a.$ ? function(n) {
                                return A2(Jr, _r, hn(function() {
                                    try {
                                        Xt.location = n;
                                    } catch (n) {
                                        Yn.location.reload(!1);
                                    }
                                }));
                            }(r = n.a.a) : A2(tc, t.N, function(n) {
                                return A3(Gg, "#", n.cn, A3(Gg, "?", n.cO, s(A2(Xg, n.bO, s(n.bR ? "https://" : "http://", n.bE)), n.bM)));
                            }(r = n.a.a)));
                        case 0:
                            var r;
                            if (e((r = n.a).bM, t.H.bM)) return i(c(t, {
                                H: r
                            }), bg);
                            var u = A4(og, Ju(r), t.T, r, t.N), a = u.b;
                            return i(c(t, {
                                cK: v = u.a,
                                H: r
                            }), A2(vg, i(nu, Qr), a));
                        case 2:
                            var o = n.a, f = A3(Qg, A3(Ku, 0, t.H, t.N), o, t.T), l = f.a, d = f.b, h = A4(og, Ju(t.H), l, t.H, t.N);
                            return a = h.b, e(v = h.a, da) ? i(c(t, {
                                cK: v,
                                T: l
                            }), tu(b([
                                A2(ka, nu, d),
                                A2(vg, i(nu, Qr), a)
                            ]))) : i(c(t, {
                                T: l
                            }), A2(ka, nu, d));
                        default:
                            var v, m = A5(Rg, n.a, t.cK, t.T, t.H, t.N);
                            return a = m.b, i(c(t, {
                                cK: v = m.a
                            }), A2(vg, i(nu, Qr), a));
                    }
                }),
                V: function(n) {
                    var t;
                    return {
                        cb: (t = A2(Sa, Qr, A4(n$, n.cK, n.T, n.H, n.N))).cb,
                        c$: t.c$
                    };
                }
            }).cH, Pg = Eg.cI, _g = function() {
                _g.a(Zg(Ot()));
            }, jt({
                bk: function(n) {
                    return _g.a = n, Xt.addEventListener("popstate", _g), 0 > Xt.navigator.userAgent.indexOf("Trident") || Xt.addEventListener("hashchange", _g), F2(function(t, e) {
                        if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button >= 1 || t.target || t.hasAttribute("download"))) {
                            e.preventDefault();
                            var r = t.href, u = Ot(), a = Pr(r).a;
                            n(Pg(a && u.bR === a.bR && u.bE === a.bE && u.bO.a === a.bO.a ? {
                                $: 0,
                                a: a
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(r)));
                        }
                    });
                },
                Z: function(n) {
                    return A3(Eg.Z, n, Ot(), _g);
                },
                V: Eg.V,
                aq: Eg.aq,
                ab: Eg.ab
            }))(gc)(0)
        }
    }, n.Elm ? function n(t, e) {
        for(var r in e)r in t ? "init" == r ? x(6) : n(t[r], e[r]) : t[r] = e[r];
    }(n.Elm, Vg) : n.Elm = Vg;
}($8c1f3845b573e132$exports);


var $05b5adc44cf00d6f$var$V3_URL = "https://js.stripe.com/v3";
var $05b5adc44cf00d6f$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $05b5adc44cf00d6f$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $05b5adc44cf00d6f$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($05b5adc44cf00d6f$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$05b5adc44cf00d6f$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $05b5adc44cf00d6f$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($05b5adc44cf00d6f$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $05b5adc44cf00d6f$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "2.1.0",
        startTime: startTime
    });
};
var $05b5adc44cf00d6f$var$stripePromise = null;
var $05b5adc44cf00d6f$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($05b5adc44cf00d6f$var$stripePromise !== null) return $05b5adc44cf00d6f$var$stripePromise;
    $05b5adc44cf00d6f$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($05b5adc44cf00d6f$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $05b5adc44cf00d6f$var$findScript();
            if (script && params) console.warn($05b5adc44cf00d6f$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $05b5adc44cf00d6f$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $05b5adc44cf00d6f$var$stripePromise;
};
var $05b5adc44cf00d6f$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $05b5adc44cf00d6f$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $05b5adc44cf00d6f$var$stripePromise$1 = Promise.resolve().then(function() {
    return $05b5adc44cf00d6f$var$loadScript(null);
});
var $05b5adc44cf00d6f$var$loadCalled = false;
$05b5adc44cf00d6f$var$stripePromise$1["catch"](function(err) {
    if (!$05b5adc44cf00d6f$var$loadCalled) console.warn(err);
});
var $05b5adc44cf00d6f$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $05b5adc44cf00d6f$var$loadCalled = true;
    var startTime = Date.now();
    return $05b5adc44cf00d6f$var$stripePromise$1.then(function(maybeStripe) {
        return $05b5adc44cf00d6f$var$initStripe(maybeStripe, args, startTime);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9937be76c87bee28$exports = {};

$parcel$export($9937be76c87bee28$exports, "Amplify", function () { return $9937be76c87bee28$export$a3858a9a153cffc7; });
var $f4253d4db4a331c2$exports = {};

$parcel$export($f4253d4db4a331c2$exports, "ConsoleLogger", function () { return $f4253d4db4a331c2$export$ba6a9c7ac8291f7f; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var $257f6bc0cd8f9ac2$export$480ff6141d16ea0 = 26;
var $257f6bc0cd8f9ac2$export$b28184bf79b04783 = 1048576;
var $257f6bc0cd8f9ac2$export$a21f820c9933d674 = 256000;
var $257f6bc0cd8f9ac2$export$13470c6f1642bbce = "Logging";
var $257f6bc0cd8f9ac2$export$d781556e70493844 = "AWSCloudWatch";
var $257f6bc0cd8f9ac2$export$9a85ff898770a423 = "No credentials";
var $257f6bc0cd8f9ac2$export$569d67cd7966b708 = [
    "ResourceNotFoundException",
    "InvalidSequenceTokenException"
];


var $f4253d4db4a331c2$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $f4253d4db4a331c2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f4253d4db4a331c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f4253d4db4a331c2$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var $f4253d4db4a331c2$export$ee432113040024a6;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})($f4253d4db4a331c2$export$ee432113040024a6 || ($f4253d4db4a331c2$export$ee432113040024a6 = {}));
var $f4253d4db4a331c2$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = $f4253d4db4a331c2$export$ee432113040024a6.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $f4253d4db4a331c2$var$LOG_LEVELS[logger_level_name];
        var type_level = $f4253d4db4a331c2$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === $f4253d4db4a331c2$export$ee432113040024a6.ERROR && console.error) log = console.error.bind(console);
        if (type === $f4253d4db4a331c2$export$ee432113040024a6.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
        var message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = "".concat(prefix, " - ").concat(msg[0]);
            log(message);
        } else if (msg.length === 1) {
            message = "".concat(prefix, " ").concat(msg[0]);
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
            log("".concat(prefix, " - ").concat(msg[0]), obj);
        } else {
            message = "".concat(prefix, " ").concat(msg);
            log(prefix, msg);
        }
        try {
            for(var _b = $f4253d4db4a331c2$var$__values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f4253d4db4a331c2$var$__spreadArray([
            $f4253d4db4a331c2$export$ee432113040024a6.INFO
        ], $f4253d4db4a331c2$var$__read(msg), false));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f4253d4db4a331c2$var$__spreadArray([
            $f4253d4db4a331c2$export$ee432113040024a6.INFO
        ], $f4253d4db4a331c2$var$__read(msg), false));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f4253d4db4a331c2$var$__spreadArray([
            $f4253d4db4a331c2$export$ee432113040024a6.WARN
        ], $f4253d4db4a331c2$var$__read(msg), false));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f4253d4db4a331c2$var$__spreadArray([
            $f4253d4db4a331c2$export$ee432113040024a6.ERROR
        ], $f4253d4db4a331c2$var$__read(msg), false));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f4253d4db4a331c2$var$__spreadArray([
            $f4253d4db4a331c2$export$ee432113040024a6.DEBUG
        ], $f4253d4db4a331c2$var$__read(msg), false));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f4253d4db4a331c2$var$__spreadArray([
            $f4253d4db4a331c2$export$ee432113040024a6.VERBOSE
        ], $f4253d4db4a331c2$var$__read(msg), false));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $257f6bc0cd8f9ac2$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();


var $9937be76c87bee28$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9937be76c87bee28$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("Amplify");
var $9937be76c87bee28$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Notifications = null;
        this.Logger = (0, $f4253d4db4a331c2$exports.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $9937be76c87bee28$var$logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $9937be76c87bee28$var$logger.debug("no getModuleName method for component", comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $9937be76c87bee28$var$logger.debug("amplify config", this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $9937be76c87bee28$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $9937be76c87bee28$export$a3858a9a153cffc7 = new $9937be76c87bee28$export$b412d755cfa0136();


var $a43376df97178647$exports = {};

$parcel$export($a43376df97178647$exports, "Platform", function () { return $a43376df97178647$export$2dffd0b5373a4389; });
$parcel$export($a43376df97178647$exports, "getAmplifyUserAgent", function () { return $a43376df97178647$export$ede38edb26c0bfdf; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a2c3ec90eedc2a0c$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($a2c3ec90eedc2a0c$export$638889172ebce0c4 || ($a2c3ec90eedc2a0c$export$638889172ebce0c4 = {}));
var $a2c3ec90eedc2a0c$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($a2c3ec90eedc2a0c$export$3a8840c5b2ecf003 || ($a2c3ec90eedc2a0c$export$3a8840c5b2ecf003 = {}));
var $a2c3ec90eedc2a0c$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["UpdateEndpoint"] = "2";
})($a2c3ec90eedc2a0c$export$30c16f5c43437fd7 || ($a2c3ec90eedc2a0c$export$30c16f5c43437fd7 = {}));
var $a2c3ec90eedc2a0c$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($a2c3ec90eedc2a0c$export$126e20fdc0f0d34b || ($a2c3ec90eedc2a0c$export$126e20fdc0f0d34b = {}));
var $a2c3ec90eedc2a0c$export$900b1436d7e65f4;
(function(AuthAction) {
    // SignUp = '1',
    // ConfirmSignUp = '2',
    // ResendSignUp = '3',
    // SignIn = '4',
    // GetMFAOptions = '5',
    // GetPreferredMFA = '6',
    // SetPreferredMFA = '7',
    // DisableSMS = '8',
    // EnableSMS = '9',
    // SetupTOTP = '10',
    // VerifyTotpToken = '11',
    // ConfirmSignIn = '12',
    // CompleteNewPassword = '13',
    // SendCustomChallengeAnswer = '14',
    // DeleteUserAttributes = '15',
    // DeleteUser = '16',
    // UpdateUserAttributes = '17',
    // UserAttributes = '18',
    // CurrentUserPoolUser = '19',
    // CurrentAuthenticatedUser = '20',
    // CurrentSession = '21',
    // VerifyUserAttribute = '22',
    // VerifyUserAttributeSubmit = '23',
    // VerifyCurrentUserAttribute = '24',
    // VerifyCurrentUserAttributeSubmit = '25',
    // SignOut = '26',
    // ChangePassword = '27',
    // ForgotPassword = '28',
    // ForgotPasswordSubmit = '29',
    AuthAction["FederatedSignIn"] = "30";
// CurrentUserInfo = '31',
// RememberDevice = '32',
// ForgetDevice = '33',
// FetchDevices = '34',
})($a2c3ec90eedc2a0c$export$900b1436d7e65f4 || ($a2c3ec90eedc2a0c$export$900b1436d7e65f4 = {}));
var $a2c3ec90eedc2a0c$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($a2c3ec90eedc2a0c$export$2f5a715aba4cde93 || ($a2c3ec90eedc2a0c$export$2f5a715aba4cde93 = {}));
var $a2c3ec90eedc2a0c$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["None"] = "0";
})($a2c3ec90eedc2a0c$export$afafab3eb8fc6fef || ($a2c3ec90eedc2a0c$export$afafab3eb8fc6fef = {}));
var $a2c3ec90eedc2a0c$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["None"] = "0";
})($a2c3ec90eedc2a0c$export$c01a8c16ffda791e || ($a2c3ec90eedc2a0c$export$c01a8c16ffda791e = {}));
var $a2c3ec90eedc2a0c$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($a2c3ec90eedc2a0c$export$68e0695a774ab7fa || ($a2c3ec90eedc2a0c$export$68e0695a774ab7fa = {}));
var $a2c3ec90eedc2a0c$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($a2c3ec90eedc2a0c$export$aa89b4c447a07cee || ($a2c3ec90eedc2a0c$export$aa89b4c447a07cee = {}));
var $a2c3ec90eedc2a0c$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($a2c3ec90eedc2a0c$export$ade48b30f1e78672 || ($a2c3ec90eedc2a0c$export$ade48b30f1e78672 = {}));
var $a2c3ec90eedc2a0c$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["None"] = "0";
})($a2c3ec90eedc2a0c$export$2c5ee06ab9fa5040 || ($a2c3ec90eedc2a0c$export$2c5ee06ab9fa5040 = {}));
var $a2c3ec90eedc2a0c$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["Put"] = "1";
    StorageAction["Get"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
})($a2c3ec90eedc2a0c$export$d4f3c54b808b00ce || ($a2c3ec90eedc2a0c$export$d4f3c54b808b00ce = {}));


// generated by genversion
var $f64157388cbe5308$export$83d89fbfd8236492 = "5.3.10";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ec594bab60dd5471$exports = {};
// shim for using process in browser
var $ec594bab60dd5471$var$process = $ec594bab60dd5471$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ec594bab60dd5471$var$cachedSetTimeout;
var $ec594bab60dd5471$var$cachedClearTimeout;
function $ec594bab60dd5471$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ec594bab60dd5471$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ec594bab60dd5471$var$cachedSetTimeout = setTimeout;
        else $ec594bab60dd5471$var$cachedSetTimeout = $ec594bab60dd5471$var$defaultSetTimout;
    } catch (e) {
        $ec594bab60dd5471$var$cachedSetTimeout = $ec594bab60dd5471$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ec594bab60dd5471$var$cachedClearTimeout = clearTimeout;
        else $ec594bab60dd5471$var$cachedClearTimeout = $ec594bab60dd5471$var$defaultClearTimeout;
    } catch (e) {
        $ec594bab60dd5471$var$cachedClearTimeout = $ec594bab60dd5471$var$defaultClearTimeout;
    }
})();
function $ec594bab60dd5471$var$runTimeout(fun) {
    if ($ec594bab60dd5471$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ec594bab60dd5471$var$cachedSetTimeout === $ec594bab60dd5471$var$defaultSetTimout || !$ec594bab60dd5471$var$cachedSetTimeout) && setTimeout) {
        $ec594bab60dd5471$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ec594bab60dd5471$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ec594bab60dd5471$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ec594bab60dd5471$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ec594bab60dd5471$var$runClearTimeout(marker) {
    if ($ec594bab60dd5471$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ec594bab60dd5471$var$cachedClearTimeout === $ec594bab60dd5471$var$defaultClearTimeout || !$ec594bab60dd5471$var$cachedClearTimeout) && clearTimeout) {
        $ec594bab60dd5471$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ec594bab60dd5471$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ec594bab60dd5471$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ec594bab60dd5471$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ec594bab60dd5471$var$queue = [];
var $ec594bab60dd5471$var$draining = false;
var $ec594bab60dd5471$var$currentQueue;
var $ec594bab60dd5471$var$queueIndex = -1;
function $ec594bab60dd5471$var$cleanUpNextTick() {
    if (!$ec594bab60dd5471$var$draining || !$ec594bab60dd5471$var$currentQueue) return;
    $ec594bab60dd5471$var$draining = false;
    if ($ec594bab60dd5471$var$currentQueue.length) $ec594bab60dd5471$var$queue = $ec594bab60dd5471$var$currentQueue.concat($ec594bab60dd5471$var$queue);
    else $ec594bab60dd5471$var$queueIndex = -1;
    if ($ec594bab60dd5471$var$queue.length) $ec594bab60dd5471$var$drainQueue();
}
function $ec594bab60dd5471$var$drainQueue() {
    if ($ec594bab60dd5471$var$draining) return;
    var timeout = $ec594bab60dd5471$var$runTimeout($ec594bab60dd5471$var$cleanUpNextTick);
    $ec594bab60dd5471$var$draining = true;
    var len = $ec594bab60dd5471$var$queue.length;
    while(len){
        $ec594bab60dd5471$var$currentQueue = $ec594bab60dd5471$var$queue;
        $ec594bab60dd5471$var$queue = [];
        while(++$ec594bab60dd5471$var$queueIndex < len)if ($ec594bab60dd5471$var$currentQueue) $ec594bab60dd5471$var$currentQueue[$ec594bab60dd5471$var$queueIndex].run();
        $ec594bab60dd5471$var$queueIndex = -1;
        len = $ec594bab60dd5471$var$queue.length;
    }
    $ec594bab60dd5471$var$currentQueue = null;
    $ec594bab60dd5471$var$draining = false;
    $ec594bab60dd5471$var$runClearTimeout(timeout);
}
$ec594bab60dd5471$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ec594bab60dd5471$var$queue.push(new $ec594bab60dd5471$var$Item(fun, args));
    if ($ec594bab60dd5471$var$queue.length === 1 && !$ec594bab60dd5471$var$draining) $ec594bab60dd5471$var$runTimeout($ec594bab60dd5471$var$drainQueue);
};
// v8 likes predictible objects
function $ec594bab60dd5471$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ec594bab60dd5471$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ec594bab60dd5471$var$process.title = "browser";
$ec594bab60dd5471$var$process.browser = true;
$ec594bab60dd5471$var$process.env = {};
$ec594bab60dd5471$var$process.argv = [];
$ec594bab60dd5471$var$process.version = ""; // empty string to avoid regexp issues
$ec594bab60dd5471$var$process.versions = {};
function $ec594bab60dd5471$var$noop() {}
$ec594bab60dd5471$var$process.on = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.addListener = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.once = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.off = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.removeListener = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.removeAllListeners = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.emit = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.prependListener = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.prependOnceListener = $ec594bab60dd5471$var$noop;
$ec594bab60dd5471$var$process.listeners = function(name) {
    return [];
};
$ec594bab60dd5471$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ec594bab60dd5471$var$process.cwd = function() {
    return "/";
};
$ec594bab60dd5471$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ec594bab60dd5471$var$process.umask = function() {
    return 0;
};


var $0f44672ec4dd72cb$export$a15eed0e463030a9 = function() {
    return typeof $parcel$global !== "undefined";
};
var $0f44672ec4dd72cb$export$a5e7eb32e5221222 = function() {
    return typeof globalThis !== "undefined";
};
var $0f44672ec4dd72cb$export$daba2802a1a41c1f = function() {
    return typeof window !== "undefined";
};
var $0f44672ec4dd72cb$export$b949ebcb877faa59 = function() {
    return typeof document !== "undefined";
};
var $0f44672ec4dd72cb$export$ba10401363d0f7f6 = function() {
    return typeof $ec594bab60dd5471$exports !== "undefined";
};
var $0f44672ec4dd72cb$export$252f88727cff70c7 = function(object, prefix) {
    return !!Object.keys(object).find(function(key) {
        return key.startsWith(prefix);
    });
};



function $ab6e792d0f9fb8d6$export$ba3f37c54f0f7805() {
    var elementKeyPrefixedWithReact = function(key) {
        return key.startsWith("_react") || key.startsWith("__react");
    };
    var elementIsReactEnabled = function(element) {
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    var allElementsWithId = function() {
        return Array.from(document.querySelectorAll("[id]"));
    };
    return (0, $0f44672ec4dd72cb$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $ab6e792d0f9fb8d6$export$86269c582305790() {
    return (0, $0f44672ec4dd72cb$export$ba10401363d0f7f6)() && typeof $ec594bab60dd5471$exports.env !== "undefined" && !!Object.keys($ec594bab60dd5471$exports.env).find(function(key) {
        return key.includes("react");
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $dcc7f727d8eddb83$export$d91d90d62b78936d() {
    return (0, $0f44672ec4dd72cb$export$daba2802a1a41c1f)() && (0, $0f44672ec4dd72cb$export$252f88727cff70c7)(window, "__VUE");
}
function $dcc7f727d8eddb83$export$257a4c0f8294a101() {
    return (0, $0f44672ec4dd72cb$export$a15eed0e463030a9)() && (0, $0f44672ec4dd72cb$export$252f88727cff70c7)($parcel$global, "__VUE");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $31e01009691828a6$export$6dafc32a94edaed3() {
    return (0, $0f44672ec4dd72cb$export$daba2802a1a41c1f)() && (0, $0f44672ec4dd72cb$export$252f88727cff70c7)(window, "__SVELTE");
}
function $31e01009691828a6$export$819dcb7fe144d8b0() {
    return (0, $0f44672ec4dd72cb$export$ba10401363d0f7f6)() && typeof $ec594bab60dd5471$exports.env !== "undefined" && !!Object.keys($ec594bab60dd5471$exports.env).find(function(key) {
        return key.includes("svelte");
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $70d6a19e73efed0e$export$f8462bcf03110eff() {
    // @ts-ignore
    return (0, $0f44672ec4dd72cb$export$daba2802a1a41c1f)() && window["next"] && typeof window["next"] === "object";
}
function $70d6a19e73efed0e$export$61c08ed144a5d4ca() {
    return (0, $0f44672ec4dd72cb$export$a15eed0e463030a9)() && ((0, $0f44672ec4dd72cb$export$252f88727cff70c7)($parcel$global, "__next") || (0, $0f44672ec4dd72cb$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $6314a41f5d97ebf8$export$bed54a4e6d9d25fb() {
    return (0, $0f44672ec4dd72cb$export$daba2802a1a41c1f)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function $6314a41f5d97ebf8$export$fb3ce982948d27e8() {
    // @ts-ignore
    return (0, $0f44672ec4dd72cb$export$a15eed0e463030a9)() && typeof $parcel$global["__NUXT_PATHS__"] !== "undefined";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $3c11d81bd4030f67$export$b5a20bd39eb02ba0() {
    var angularVersionSetInDocument = Boolean((0, $0f44672ec4dd72cb$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    var angularContentSetInWindow = Boolean(// @ts-ignore
    (0, $0f44672ec4dd72cb$export$daba2802a1a41c1f)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $3c11d81bd4030f67$export$8ab518c8987c870f() {
    var _a;
    return (0, $0f44672ec4dd72cb$export$ba10401363d0f7f6)() && typeof $ec594bab60dd5471$exports.env === "object" && ((_a = undefined, _a === void 0) ? void 0 : _a.startsWith("ng ")) || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $d39ea28f911c14b1$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $065cfaab038fdce4$export$85fd46d5e29a4f7e() {
    // @ts-ignore
    return (0, $0f44672ec4dd72cb$export$a15eed0e463030a9)() && typeof $parcel$global["expo"] !== "undefined";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $701d813a52d98177$export$41b1270b988065fb() {
    return (0, $0f44672ec4dd72cb$export$daba2802a1a41c1f)();
}


// These are in the order of detection where when both are detectable, the early Framework will be reported
var $f0fc8cbdb893935f$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $065cfaab038fdce4$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $d39ea28f911c14b1$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $70d6a19e73efed0e$export$f8462bcf03110eff)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $6314a41f5d97ebf8$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $3c11d81bd4030f67$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).React,
        detectionMethod: (0, $ab6e792d0f9fb8d6$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $dcc7f727d8eddb83$export$d91d90d62b78936d)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $31e01009691828a6$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $701d813a52d98177$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $70d6a19e73efed0e$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $6314a41f5d97ebf8$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $ab6e792d0f9fb8d6$export$86269c582305790)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $dcc7f727d8eddb83$export$257a4c0f8294a101)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $3c11d81bd4030f67$export$8ab518c8987c870f)
    },
    {
        platform: (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $31e01009691828a6$export$819dcb7fe144d8b0)
    }
];
function $f0fc8cbdb893935f$export$17b446b869dad473() {
    var _a;
    return ((_a = $f0fc8cbdb893935f$var$detectionMap.find(function(detectionEntry) {
        return detectionEntry.detectionMethod();
    })) === null || _a === void 0 ? void 0 : _a.platform) || (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).ServerSideUnknown;
}


// We want to cache detection since the framework won't change
var $f366a4c083aea7f0$var$frameworkCache;
var $f366a4c083aea7f0$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
var $f366a4c083aea7f0$var$resetTriggered = false;
var $f366a4c083aea7f0$var$SSR_RESET_TIMEOUT = 10; // ms
var $f366a4c083aea7f0$var$WEB_RESET_TIMEOUT = 10; // ms
var $f366a4c083aea7f0$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
var $f366a4c083aea7f0$export$9ce73e459ec93b6a = function() {
    if (!$f366a4c083aea7f0$var$frameworkCache) {
        $f366a4c083aea7f0$var$frameworkCache = (0, $f0fc8cbdb893935f$export$17b446b869dad473)();
        if ($f366a4c083aea7f0$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($f366a4c083aea7f0$export$d56891f33aa26edc.length)$f366a4c083aea7f0$export$d56891f33aa26edc.pop()();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $f366a4c083aea7f0$export$d56891f33aa26edc.forEach(function(fcn) {
            return fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $f366a4c083aea7f0$var$resetTimeout((0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).ServerSideUnknown, $f366a4c083aea7f0$var$SSR_RESET_TIMEOUT);
        $f366a4c083aea7f0$var$resetTimeout((0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).WebUnknown, $f366a4c083aea7f0$var$WEB_RESET_TIMEOUT);
    }
    return $f366a4c083aea7f0$var$frameworkCache;
};
var $f366a4c083aea7f0$export$5d5c467ce0b213f = function(fcn) {
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($f366a4c083aea7f0$var$resetTriggered) return;
    $f366a4c083aea7f0$export$d56891f33aa26edc.push(fcn);
};
function $f366a4c083aea7f0$export$d2adf65b87e47523() {
    $f366a4c083aea7f0$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $f366a4c083aea7f0$var$resetTimeout(framework, delay) {
    if ($f366a4c083aea7f0$var$frameworkCache === framework && !$f366a4c083aea7f0$var$resetTriggered) setTimeout(function() {
        $f366a4c083aea7f0$export$d2adf65b87e47523();
        $f366a4c083aea7f0$var$resetTriggered = true;
        setTimeout($f366a4c083aea7f0$export$9ce73e459ec93b6a, $f366a4c083aea7f0$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


var $a43376df97178647$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a43376df97178647$var$BASE_USER_AGENT = "aws-amplify";
var $a43376df97178647$var$PlatformBuilder = /** @class */ function() {
    function PlatformBuilder() {
        this.userAgent = "".concat($a43376df97178647$var$BASE_USER_AGENT, "/").concat((0, $f64157388cbe5308$export$83d89fbfd8236492));
    }
    Object.defineProperty(PlatformBuilder.prototype, "framework", {
        get: function() {
            return (0, $f366a4c083aea7f0$export$9ce73e459ec93b6a)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformBuilder.prototype, "isReactNative", {
        get: function() {
            return this.framework === (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).ReactNative || this.framework === (0, $a2c3ec90eedc2a0c$export$638889172ebce0c4).Expo;
        },
        enumerable: false,
        configurable: true
    });
    PlatformBuilder.prototype.observeFrameworkChanges = function(fcn) {
        (0, $f366a4c083aea7f0$export$5d5c467ce0b213f)(fcn);
    };
    return PlatformBuilder;
}();
var $a43376df97178647$export$2dffd0b5373a4389 = new $a43376df97178647$var$PlatformBuilder();
var $a43376df97178647$export$7d201307d8979e21 = function(_a) {
    var _b = _a === void 0 ? {} : _a, category = _b.category, action = _b.action, framework = _b.framework;
    var userAgent = [
        [
            $a43376df97178647$var$BASE_USER_AGENT,
            (0, $f64157388cbe5308$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $f366a4c083aea7f0$export$9ce73e459ec93b6a)()
    ]);
    return userAgent;
};
var $a43376df97178647$export$ede38edb26c0bfdf = function(customUserAgentDetails) {
    var userAgent = $a43376df97178647$export$7d201307d8979e21(customUserAgentDetails);
    var userAgentString = userAgent.map(function(_a) {
        var _b = $a43376df97178647$var$__read(_a, 2), agentKey = _b[0], agentValue = _b[1];
        return "".concat(agentKey, "/").concat(agentValue);
    }).join(" ");
    return userAgentString;
};





var $a81f69f3afceb158$exports = {};

$parcel$export($a81f69f3afceb158$exports, "Hub", function () { return $a81f69f3afceb158$export$8c41bb232f1008b1; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $a81f69f3afceb158$var$__assign = undefined && undefined.__assign || function() {
    $a81f69f3afceb158$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a81f69f3afceb158$var$__assign.apply(this, arguments);
};
var $a81f69f3afceb158$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a81f69f3afceb158$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a81f69f3afceb158$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("Hub");
var $a81f69f3afceb158$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function $a81f69f3afceb158$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $a81f69f3afceb158$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype._remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $a81f69f3afceb158$var$logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.patterns = $a81f69f3afceb158$var$__spreadArray([], $a81f69f3afceb158$var$__read(this.patterns.filter(function(x) {
                return x !== pattern_1;
            })), false);
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $a81f69f3afceb158$var$logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.listeners[channel] = $a81f69f3afceb158$var$__spreadArray([], $a81f69f3afceb158$var$__read(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            })), false);
        }
    };
    /**
     * @deprecated Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype.remove = function(channel, listener) {
        this._remove(channel, listener);
    };
    /**
     * Used to send a Hub event.
     *
     * @param channel - The channel on which the event will be broadcast
     * @param payload - The HubPayload
     * @param source  - The source of the event; defaults to ''
     * @param ampSymbol - Symbol used to determine if the event is dispatched internally on a protected channel
     *
     */ HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $a81f69f3afceb158$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $a81f69f3afceb158$var$logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
        var capsule = {
            channel: channel,
            payload: $a81f69f3afceb158$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $a81f69f3afceb158$var$logger.error(e);
        }
    };
    /**
     * Used to listen for Hub events.
     *
     * @param channel - The channel on which to listen
     * @param callback - The callback to execute when an event is received on the specified channel
     * @param listenerName - The name of the listener; defaults to 'noname'
     * @returns A function which can be called to cancel the listener.
     *
     */ HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($a81f69f3afceb158$var$isLegacyCallback(callback)) {
            $a81f69f3afceb158$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this._remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $a81f69f3afceb158$var$logger.debug("Dispatching to ".concat(channel, " with "), payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $a81f69f3afceb158$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $a81f69f3afceb158$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $a81f69f3afceb158$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $a81f69f3afceb158$var$__assign($a81f69f3afceb158$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $a81f69f3afceb158$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $a81f69f3afceb158$export$8c41bb232f1008b1 = new $a81f69f3afceb158$export$6b38ef2be9abbbb9("__default__");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $298b72353aedb430$exports = {};

$parcel$export($298b72353aedb430$exports, "I18n", function () { return $298b72353aedb430$export$dbe3113d60765c1a; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $298b72353aedb430$var$__assign = undefined && undefined.__assign || function() {
    $298b72353aedb430$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $298b72353aedb430$var$__assign.apply(this, arguments);
};
var $298b72353aedb430$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("I18n");
/**
 * Language transition class
 */ var $298b72353aedb430$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $298b72353aedb430$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = $298b72353aedb430$var$__assign($298b72353aedb430$var$__assign({}, lang_dict), vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();




var $383a6ad6c508abf8$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("I18n");
var $383a6ad6c508abf8$var$_config = null;
var $383a6ad6c508abf8$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $383a6ad6c508abf8$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $383a6ad6c508abf8$var$logger.debug("configure I18n");
        if (!config) return $383a6ad6c508abf8$var$_config;
        $383a6ad6c508abf8$var$_config = Object.assign({}, $383a6ad6c508abf8$var$_config, config.I18n || config);
        I18n.createInstance();
        return $383a6ad6c508abf8$var$_config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $383a6ad6c508abf8$var$logger.debug("create I18n instance");
        if ($383a6ad6c508abf8$var$_i18n) return;
        $383a6ad6c508abf8$var$_i18n = new (0, $298b72353aedb430$exports.I18n)($383a6ad6c508abf8$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $383a6ad6c508abf8$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return $383a6ad6c508abf8$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $383a6ad6c508abf8$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $383a6ad6c508abf8$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$383a6ad6c508abf8$var$_i18n) $383a6ad6c508abf8$var$_i18n = new (0, $298b72353aedb430$exports.I18n)($383a6ad6c508abf8$var$_config);
        return true;
    };
    return I18n;
}();
(0, $9937be76c87bee28$exports.Amplify).register($383a6ad6c508abf8$export$dbe3113d60765c1a);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $75cf6438f6eb1e84$var$MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/apng",
        ext: "apng"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/x-icon",
        ext: "cur"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/jpeg",
        ext: "jfif"
    },
    {
        type: "image/jpeg",
        ext: "pjp"
    },
    {
        type: "image/jpeg",
        ext: "pjpeg"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/webp",
        ext: "webp"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var $75cf6438f6eb1e84$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $75cf6438f6eb1e84$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === "desc" ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
        if (typeof a_val === "undefined") return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $75cf6438f6eb1e84$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === "string") delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $75cf6438f6eb1e84$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = "application/octet-stream";
    var name = filename.toLowerCase();
    var filtered = $75cf6438f6eb1e84$var$MIME_MAP.filter(function(mime) {
        return name.endsWith("." + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $75cf6438f6eb1e84$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith("text/")) return true;
    return "application/json" === type || "application/xml" === type || "application/sh" === type;
};
var $75cf6438f6eb1e84$export$9e15fb06e64c4810 = function() {
    var result = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $75cf6438f6eb1e84$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $75cf6438f6eb1e84$export$97b87b8868ff7a3c = function() {
    if (typeof self === "undefined") return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var $75cf6438f6eb1e84$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    var isNode = typeof $ec594bab60dd5471$exports !== "undefined" && $ec594bab60dd5471$exports.versions != null && $ec594bab60dd5471$exports.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $75cf6438f6eb1e84$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$75cf6438f6eb1e84$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $75cf6438f6eb1e84$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $75cf6438f6eb1e84$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$75cf6438f6eb1e84$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $75cf6438f6eb1e84$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $75cf6438f6eb1e84$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};



var $e0246317a77f60f2$exports = {};

$parcel$export($e0246317a77f60f2$exports, "parseAWSExports", function () { return $e0246317a77f60f2$export$1ef2e9c2da492d; });

var $e0246317a77f60f2$var$__assign = undefined && undefined.__assign || function() {
    $e0246317a77f60f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e0246317a77f60f2$var$__assign.apply(this, arguments);
};
var $e0246317a77f60f2$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("Parser");
var $e0246317a77f60f2$export$1ef2e9c2da492d = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config["aws_mobile_analytics_app_id"]) {
        var Analytics = {
            AWSPinpoint: {
                appId: config["aws_mobile_analytics_app_id"],
                region: config["aws_mobile_analytics_app_region"]
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) amplifyConfig.Auth = {
        userPoolId: config["aws_user_pools_id"],
        userPoolWebClientId: config["aws_user_pools_web_client_id"],
        region: config["aws_cognito_region"],
        identityPoolId: config["aws_cognito_identity_pool_id"],
        identityPoolRegion: config["aws_cognito_region"],
        mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
        signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
    // Storage
    var storageConfig;
    if (config["aws_user_files_s3_bucket"]) storageConfig = {
        AWSS3: {
            bucket: config["aws_user_files_s3_bucket"],
            region: config["aws_user_files_s3_bucket_region"],
            dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config["Logging"]) amplifyConfig.Logging = $e0246317a77f60f2$var$__assign($e0246317a77f60f2$var$__assign({}, config["Logging"]), {
        region: config["aws_project_region"]
    });
    // Geo
    if (config["geo"]) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo["amazon_location_service"]) amplifyConfig.Geo = {
            AmazonLocationService: config.geo["amazon_location_service"]
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    $e0246317a77f60f2$var$logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
    return amplifyConfig;
};





var $57cc9456a9b994f0$exports = {};

$parcel$export($57cc9456a9b994f0$exports, "Credentials", function () { return $57cc9456a9b994f0$export$a9627919734faa48; });

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $21568620555e7153$var$dataMemory = {};
/** @class */ var $21568620555e7153$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $21568620555e7153$var$dataMemory[key] = value;
        return $21568620555e7153$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($21568620555e7153$var$dataMemory, key) ? $21568620555e7153$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $21568620555e7153$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $21568620555e7153$var$dataMemory = {};
        return $21568620555e7153$var$dataMemory;
    };
    return MemoryStorage;
}();
var $21568620555e7153$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = $21568620555e7153$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $79a760b710130cc2$exports = {};

$parcel$export($79a760b710130cc2$exports, "GoogleOAuth", function () { return $79a760b710130cc2$export$75ace714083c1340; });


var $9234a6f4744a0813$exports = {};

$parcel$export($9234a6f4744a0813$exports, "NonRetryableError", function () { return $9234a6f4744a0813$export$1e38badc838ad384; });
$parcel$export($9234a6f4744a0813$exports, "jitteredBackoff", function () { return $9234a6f4744a0813$export$caea50bde345f648; });
$parcel$export($9234a6f4744a0813$exports, "jitteredExponentialRetry", function () { return $9234a6f4744a0813$export$a24aa7705df9cf44; });

var $9234a6f4744a0813$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9234a6f4744a0813$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9234a6f4744a0813$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9234a6f4744a0813$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9234a6f4744a0813$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9234a6f4744a0813$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("Util");
var $9234a6f4744a0813$export$1e38badc838ad384 = /** @class */ function(_super) {
    $9234a6f4744a0813$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $9234a6f4744a0813$export$490cab1f6f83794d = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $9234a6f4744a0813$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    return $9234a6f4744a0813$var$__awaiter(this, void 0, void 0, function() {
        var _this = this;
        return $9234a6f4744a0813$var$__generator(this, function(_a) {
            if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return $9234a6f4744a0813$var$__awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return $9234a6f4744a0813$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _b, _c, err_1, retryIn_1;
                                        return $9234a6f4744a0813$var$__generator(this, function(_d) {
                                            switch(_d.label){
                                                case 0:
                                                    attempt++;
                                                    $9234a6f4744a0813$var$logger.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _b = {};
                                                    _c = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, $9234a6f4744a0813$var$__spreadArray([], $9234a6f4744a0813$var$__read(args), false))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_b.value = _c.apply(void 0, [
                                                            _d.sent()
                                                        ]), _b)
                                                    ];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    lastError = err_1;
                                                    $9234a6f4744a0813$var$logger.debug("error on ".concat(functionToRetry.name), err_1);
                                                    if ($9234a6f4744a0813$export$490cab1f6f83794d(err_1)) {
                                                        $9234a6f4744a0813$var$logger.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    $9234a6f4744a0813$var$logger.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _d.sent();
                                                    _d.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var $9234a6f4744a0813$var$MAX_DELAY_MS = 300000;
function $9234a6f4744a0813$export$caea50bde345f648(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $9234a6f4744a0813$var$MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $9234a6f4744a0813$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = $9234a6f4744a0813$var$MAX_DELAY_MS;
    return $9234a6f4744a0813$export$9369b12211e1fce4(functionToRetry, args, $9234a6f4744a0813$export$caea50bde345f648(maxDelayMs), onTerminate);
};


var $79a760b710130cc2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $79a760b710130cc2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $79a760b710130cc2$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("CognitoCredentials");
var $79a760b710130cc2$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser) {
        $79a760b710130cc2$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        $79a760b710130cc2$var$logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $79a760b710130cc2$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $79a760b710130cc2$var$__awaiter(this, void 0, void 0, function() {
            return $79a760b710130cc2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $79a760b710130cc2$var$logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $79a760b710130cc2$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $79a760b710130cc2$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            $79a760b710130cc2$var$logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $79a760b710130cc2$var$logger.debug("google Auth undefined");
                    rej(new (0, $9234a6f4744a0813$exports.NonRetryableError)("google Auth undefined"));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $79a760b710130cc2$var$logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === "network_error") // Not using NonRetryableError so handler will be retried
                        rej("Network error reloading google auth response");
                        else rej(new (0, $9234a6f4744a0813$exports.NonRetryableError)("Failed to reload google auth response"));
                    });
                } else rej(new (0, $9234a6f4744a0813$exports.NonRetryableError)("User is not signed in with Google"));
            }).catch(function(err) {
                $79a760b710130cc2$var$logger.debug("Failed to refresh google token", err);
                rej(new (0, $9234a6f4744a0813$exports.NonRetryableError)("Failed to refresh google token"));
            });
        });
    };
    return GoogleOAuth;
}();


var $623b1f63b802e48f$exports = {};

$parcel$export($623b1f63b802e48f$exports, "FacebookOAuth", function () { return $623b1f63b802e48f$export$1b6b8b5328e38349; });



var $623b1f63b802e48f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $623b1f63b802e48f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $623b1f63b802e48f$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("CognitoCredentials");
var $623b1f63b802e48f$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser) {
        $623b1f63b802e48f$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        $623b1f63b802e48f$var$logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $623b1f63b802e48f$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $623b1f63b802e48f$var$__awaiter(this, void 0, void 0, function() {
            return $623b1f63b802e48f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $623b1f63b802e48f$var$logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $623b1f63b802e48f$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $623b1f63b802e48f$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser) fb = window["FB"];
        if (!fb) {
            var errorMessage = "no fb sdk available";
            $623b1f63b802e48f$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $9234a6f4744a0813$exports.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = "no response from facebook when refreshing the jwt token";
                    $623b1f63b802e48f$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $9234a6f4744a0813$exports.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = "the jwtToken is undefined";
                        $623b1f63b802e48f$var$logger.debug(errorMessage);
                        rej(new (0, $9234a6f4744a0813$exports.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();


var $8d0f3340a91e99f9$export$75ace714083c1340 = new (0, $79a760b710130cc2$exports.GoogleOAuth)();
var $8d0f3340a91e99f9$export$1b6b8b5328e38349 = new (0, $623b1f63b802e48f$exports.FacebookOAuth)();




var $8cf65959d6849117$exports = {};

$parcel$export($8cf65959d6849117$exports, "getCredentialsForIdentity", function () { return $8cf65959d6849117$export$a49c1c173ab96b58; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $db135bb327a2c524$exports = {};

$parcel$export($db135bb327a2c524$exports, "cognitoIdentityTransferHandler", function () { return $db135bb327a2c524$export$8029646671d2c482; });
$parcel$export($db135bb327a2c524$exports, "defaultConfig", function () { return $db135bb327a2c524$export$f84bd70098573c5c; });
$parcel$export($db135bb327a2c524$exports, "getSharedHeaders", function () { return $db135bb327a2c524$export$a46bbeaba09f7285; });
$parcel$export($db135bb327a2c524$exports, "buildHttpRpcRequest", function () { return $db135bb327a2c524$export$a692bdb7eb624f96; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $368228166a08b862$exports = {};

$parcel$export($368228166a08b862$exports, "getDnsSuffix", function () { return $368228166a08b862$export$1c28e37cdcc37f6d; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var $182057ddc9a43b57$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
var $182057ddc9a43b57$export$d7c12af0c0f12206 = {
    partitions: [
        $182057ddc9a43b57$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


var $368228166a08b862$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $368228166a08b862$export$1c28e37cdcc37f6d = function(region) {
    var e_1, _a;
    var partitions = (0, $182057ddc9a43b57$export$d7c12af0c0f12206).partitions;
    try {
        for(var partitions_1 = $368228166a08b862$var$__values(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()){
            var _b = partitions_1_1.value, regions = _b.regions, outputs = _b.outputs, regionRegex = _b.regionRegex;
            var regex = new RegExp(regionRegex);
            if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (partitions_1_1 && !partitions_1_1.done && (_a = partitions_1.return)) _a.call(partitions_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $182057ddc9a43b57$export$72f3cee421ee8a74).outputs.dnsSuffix;
};

var $cb5799ee8aa283f5$exports = {};

$parcel$export($cb5799ee8aa283f5$exports, "parseJsonError", function () { return $cb5799ee8aa283f5$export$be467dfcc0538e25; });
$parcel$export($cb5799ee8aa283f5$exports, "parseJsonBody", function () { return $cb5799ee8aa283f5$export$759bcb35b0d1bf81; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c613b0c835758a49$exports = {};

$parcel$export($c613b0c835758a49$exports, "parseMetadata", function () { return $c613b0c835758a49$export$978f9418fe0cb26c; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c613b0c835758a49$var$__assign = undefined && undefined.__assign || function() {
    $c613b0c835758a49$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c613b0c835758a49$var$__assign.apply(this, arguments);
};
var $c613b0c835758a49$export$978f9418fe0cb26c = function(response) {
    var _a, _b;
    var headers = response.headers, statusCode = response.statusCode;
    return $c613b0c835758a49$var$__assign($c613b0c835758a49$var$__assign({}, $c613b0c835758a49$var$isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_b = (_a = headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    });
};
var $c613b0c835758a49$var$isMetadataBearer = function(response) {
    return typeof (response === null || response === void 0 ? void 0 : response["$metadata"]) === "object";
};


var $cb5799ee8aa283f5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cb5799ee8aa283f5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cb5799ee8aa283f5$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cb5799ee8aa283f5$export$be467dfcc0538e25 = function(response) {
    return $cb5799ee8aa283f5$var$__awaiter(void 0, void 0, void 0, function() {
        var body, sanitizeErrorCode, code, message, error;
        var _a, _b, _c, _d, _e;
        return $cb5799ee8aa283f5$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    return [
                        4 /*yield*/ ,
                        $cb5799ee8aa283f5$export$759bcb35b0d1bf81(response)
                    ];
                case 1:
                    body = _f.sent();
                    sanitizeErrorCode = function(rawValue) {
                        var _a = $cb5799ee8aa283f5$var$__read(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a[0];
                        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
                        return cleanValue;
                    };
                    code = sanitizeErrorCode((_c = (_b = (_a = response.headers["x-amzn-errortype"]) !== null && _a !== void 0 ? _a : body.code) !== null && _b !== void 0 ? _b : body.__type) !== null && _c !== void 0 ? _c : "UnknownError");
                    message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : "Unknown error";
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, $c613b0c835758a49$exports.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var $cb5799ee8aa283f5$export$759bcb35b0d1bf81 = function(response) {
    return $cb5799ee8aa283f5$var$__awaiter(void 0, void 0, void 0, function() {
        var output;
        return $cb5799ee8aa283f5$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) throw new Error("Missing response payload");
                    return [
                        4 /*yield*/ ,
                        response.body.json()
                    ];
                case 1:
                    output = _a.sent();
                    return [
                        2 /*return*/ ,
                        Object.assign(output, {
                            $metadata: (0, $c613b0c835758a49$exports.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3a6532522727d350$exports = {};

$parcel$export($3a6532522727d350$exports, "retryMiddleware", function () { return $3a6532522727d350$export$a3922aa5f87bae85; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3a6532522727d350$var$__assign = undefined && undefined.__assign || function() {
    $3a6532522727d350$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a6532522727d350$var$__assign.apply(this, arguments);
};
var $3a6532522727d350$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3a6532522727d350$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3a6532522727d350$var$DEFAULT_RETRY_ATTEMPTS = 3;
var $3a6532522727d350$export$a3922aa5f87bae85 = function(_a) {
    var _b = _a.maxAttempts, maxAttempts = _b === void 0 ? $3a6532522727d350$var$DEFAULT_RETRY_ATTEMPTS : _b, retryDecider = _a.retryDecider, computeDelay = _a.computeDelay, abortSignal = _a.abortSignal;
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return function(next, context) {
        return function retryMiddleware(request) {
            var _a;
            return $3a6532522727d350$var$__awaiter(this, void 0, void 0, function() {
                var error, attemptsCount, response, handleTerminalErrorOrResponse, e_1, delay;
                return $3a6532522727d350$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            attemptsCount = (_a = context.attemptsCount) !== null && _a !== void 0 ? _a : 0;
                            handleTerminalErrorOrResponse = function() {
                                if (response) {
                                    $3a6532522727d350$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                                    return response;
                                } else {
                                    $3a6532522727d350$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                                    throw error;
                                }
                            };
                            _b.label = 1;
                        case 1:
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                11
                            ];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _b.sent();
                            error = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _b.sent();
                            error = e_1;
                            response = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                            attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
                            context.attemptsCount = attemptsCount;
                            return [
                                4 /*yield*/ ,
                                retryDecider(response, error)
                            ];
                        case 6:
                            if (!_b.sent()) return [
                                3 /*break*/ ,
                                9
                            ];
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                8
                            ];
                            delay = computeDelay(attemptsCount);
                            return [
                                4 /*yield*/ ,
                                $3a6532522727d350$var$cancellableSleep(delay, abortSignal)
                            ];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                        case 10:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 11:
                            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error("Request aborted.");
                            else return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var $3a6532522727d350$var$cancellableSleep = function(timeoutMs, abortSignal) {
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    var timeoutId;
    var sleepPromiseResolveFn;
    var sleepPromise = new Promise(function(resolve) {
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
var $3a6532522727d350$var$addOrIncrementMetadataAttempts = function(nextHandlerOutput, attempts) {
    var _a;
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = $3a6532522727d350$var$__assign($3a6532522727d350$var$__assign({}, (_a = nextHandlerOutput["$metadata"]) !== null && _a !== void 0 ? _a : {}), {
        attempts: attempts
    });
};


var $4e10143f82b19ded$exports = {};

$parcel$export($4e10143f82b19ded$exports, "userAgentMiddleware", function () { return $4e10143f82b19ded$export$62c460923941c0b0; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $4e10143f82b19ded$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4e10143f82b19ded$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4e10143f82b19ded$export$62c460923941c0b0 = function(_a) {
    var _b = _a.userAgentHeader, userAgentHeader = _b === void 0 ? "x-amz-user-agent" : _b, _c = _a.userAgentValue, userAgentValue = _c === void 0 ? "" : _c;
    return function(next) {
        return function userAgentMiddleware(request) {
            return $4e10143f82b19ded$var$__awaiter(this, void 0, void 0, function() {
                var result, headerName, response;
                return $4e10143f82b19ded$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(userAgentValue.trim().length === 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 2:
                            headerName = userAgentHeader.toLowerCase();
                            request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _a.sent();
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var $25d365198c73a0e0$export$f074d76e52925468 = function(coreHandler, middleware) {
    return function(request, options) {
        var context = {};
        var composedHandler = function(request) {
            return coreHandler(request, options);
        };
        for(var i = middleware.length - 1; i >= 0; i--){
            var m = middleware[i];
            var resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };
};


var $5bc087394f4cf2fe$exports = {};

$parcel$export($5bc087394f4cf2fe$exports, "fetchTransferHandler", function () { return $5bc087394f4cf2fe$export$d2573baf35521e4c; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $5743a2024163df74$exports = {};


$5743a2024163df74$exports = self.fetch || (self.fetch = (parcelRequire("dGtP5")).default || (parcelRequire("dGtP5")));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var $2d21d53aa8734573$export$580ad1ce15092b15 = function(payloadAccessor) {
    var cached;
    return function() {
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


var $5bc087394f4cf2fe$var$__assign = undefined && undefined.__assign || function() {
    $5bc087394f4cf2fe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5bc087394f4cf2fe$var$__assign.apply(this, arguments);
};
var $5bc087394f4cf2fe$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5bc087394f4cf2fe$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5bc087394f4cf2fe$var$shouldSendBody = function(method) {
    return ![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
};
var $5bc087394f4cf2fe$export$d2573baf35521e4c = function(_a, _b) {
    var url = _a.url, method = _a.method, headers = _a.headers, body = _a.body;
    var abortSignal = _b.abortSignal;
    return $5bc087394f4cf2fe$var$__awaiter(void 0, void 0, void 0, function() {
        var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
        var _c, _d;
        return $5bc087394f4cf2fe$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    _e.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url, {
                            method: method,
                            headers: headers,
                            body: $5bc087394f4cf2fe$var$shouldSendBody(method) ? body : undefined,
                            signal: abortSignal
                        })
                    ];
                case 1:
                    resp = _e.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_1 = _e.sent();
                    // TODO: needs to revise error handling in v6
                    // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
                    // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
                    if (e_1 instanceof TypeError) throw new Error("Network error");
                    throw e_1;
                case 3:
                    responseHeaders = {};
                    (_c = resp.headers) === null || _c === void 0 || _c.forEach(function(value, key) {
                        responseHeaders[key.toLowerCase()] = value;
                    });
                    httpResponse = {
                        statusCode: resp.status,
                        headers: responseHeaders,
                        body: null
                    };
                    bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
                        text: (0, $2d21d53aa8734573$export$580ad1ce15092b15)(function() {
                            return resp.text();
                        }),
                        blob: (0, $2d21d53aa8734573$export$580ad1ce15092b15)(function() {
                            return resp.blob();
                        }),
                        json: (0, $2d21d53aa8734573$export$580ad1ce15092b15)(function() {
                            return resp.json();
                        })
                    });
                    return [
                        2 /*return*/ ,
                        $5bc087394f4cf2fe$var$__assign($5bc087394f4cf2fe$var$__assign({}, httpResponse), {
                            body: bodyWithMixin
                        })
                    ];
            }
        });
    });
};


var $9376d9d5d6399fbb$export$ed7e1ccf00f39c4a = (0, $25d365198c73a0e0$export$f074d76e52925468)((0, $5bc087394f4cf2fe$exports.fetchTransferHandler), [
    (0, $4e10143f82b19ded$exports.userAgentMiddleware),
    (0, $3a6532522727d350$exports.retryMiddleware)
]);



var $c17360db547d26d3$exports = {};

$parcel$export($c17360db547d26d3$exports, "getRetryDecider", function () { return $c17360db547d26d3$export$b919d98317a7685f; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var $c269d3a29c0a6a6f$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
var $c269d3a29c0a6a6f$export$7b87435661177a94 = function(errorCode) {
    return $c269d3a29c0a6a6f$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);
};


var $c17360db547d26d3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c17360db547d26d3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c17360db547d26d3$export$b919d98317a7685f = function(errorParser) {
    return function(response, error) {
        return $c17360db547d26d3$var$__awaiter(void 0, void 0, void 0, function() {
            var errorCode, _a, statusCode;
            var _b;
            return $c17360db547d26d3$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(error !== null && error !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = error;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            errorParser(response)
                        ];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        errorCode = ((_b = _a) !== null && _b !== void 0 ? _b : {}).name;
                        statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
                        return [
                            2 /*return*/ ,
                            $c17360db547d26d3$var$isConnectionError(error) || $c17360db547d26d3$var$isThrottlingError(statusCode, errorCode) || (0, $c269d3a29c0a6a6f$export$7b87435661177a94)(errorCode) || $c17360db547d26d3$var$isServerSideError(statusCode, errorCode)
                        ];
                }
            });
        });
    };
};
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
var $c17360db547d26d3$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
var $c17360db547d26d3$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $c17360db547d26d3$var$isThrottlingError = function(statusCode, errorCode) {
    return statusCode === 429 || $c17360db547d26d3$var$THROTTLING_ERROR_CODES.includes(errorCode);
};
var $c17360db547d26d3$var$isConnectionError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "Network error";
};
var $c17360db547d26d3$var$isServerSideError = function(statusCode, errorCode) {
    return [
        500,
        502,
        503,
        504
    ].includes(statusCode) || $c17360db547d26d3$var$TIMEOUT_ERROR_CODES.includes(errorCode);
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.

var $269fde7456d0a7aa$var$DEFAULT_MAX_DELAY_MS = 300000;
var $269fde7456d0a7aa$export$caea50bde345f648 = function(attempt) {
    var delayFunction = (0, $9234a6f4744a0813$exports.jitteredBackoff)($269fde7456d0a7aa$var$DEFAULT_MAX_DELAY_MS);
    var delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $269fde7456d0a7aa$var$DEFAULT_MAX_DELAY_MS : delay;
};




var $db135bb327a2c524$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $db135bb327a2c524$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * The service name used to sign requests if the API requires authentication.
 */ var $db135bb327a2c524$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var $db135bb327a2c524$var$endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://cognito-identity.".concat(region, ".").concat((0, $368228166a08b862$exports.getDnsSuffix)(region)))
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var $db135bb327a2c524$var$disableCacheMiddleware = function() {
    return function(next, context) {
        return function disableCacheMiddleware(request) {
            return $db135bb327a2c524$var$__awaiter(this, void 0, void 0, function() {
                return $db135bb327a2c524$var$__generator(this, function(_a) {
                    request.headers["cache-control"] = "no-store";
                    return [
                        2 /*return*/ ,
                        next(request)
                    ];
                });
            });
        };
    };
};
var $db135bb327a2c524$export$8029646671d2c482 = (0, $25d365198c73a0e0$export$f074d76e52925468)((0, $9376d9d5d6399fbb$export$ed7e1ccf00f39c4a), [
    $db135bb327a2c524$var$disableCacheMiddleware
]);
var $db135bb327a2c524$export$f84bd70098573c5c = {
    service: $db135bb327a2c524$var$SERVICE_NAME,
    endpointResolver: $db135bb327a2c524$var$endpointResolver,
    retryDecider: (0, $c17360db547d26d3$exports.getRetryDecider)((0, $cb5799ee8aa283f5$exports.parseJsonError)),
    computeDelay: (0, $269fde7456d0a7aa$export$caea50bde345f648),
    userAgentValue: (0, $a43376df97178647$exports.getAmplifyUserAgent)()
};
(0, $f366a4c083aea7f0$export$5d5c467ce0b213f)(function() {
    $db135bb327a2c524$export$f84bd70098573c5c.userAgentValue = (0, $a43376df97178647$exports.getAmplifyUserAgent)();
});
var $db135bb327a2c524$export$a46bbeaba09f7285 = function(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "AWSCognitoIdentityService.".concat(operation)
    };
};
var $db135bb327a2c524$export$a692bdb7eb624f96 = function(_a, headers, body) {
    var url = _a.url;
    return {
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    };
};



var $8204b8b06f8287fc$exports = {};

$parcel$export($8204b8b06f8287fc$exports, "composeServiceApi", function () { return $8204b8b06f8287fc$export$880429a8ae983d4d; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $8204b8b06f8287fc$var$__assign = undefined && undefined.__assign || function() {
    $8204b8b06f8287fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8204b8b06f8287fc$var$__assign.apply(this, arguments);
};
var $8204b8b06f8287fc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8204b8b06f8287fc$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8204b8b06f8287fc$export$880429a8ae983d4d = function(transferHandler, serializer, deserializer, defaultConfig) {
    return function(config, input) {
        return $8204b8b06f8287fc$var$__awaiter(void 0, void 0, void 0, function() {
            var resolvedConfig, endpoint, request, response;
            return $8204b8b06f8287fc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolvedConfig = $8204b8b06f8287fc$var$__assign($8204b8b06f8287fc$var$__assign({}, defaultConfig), config);
                        return [
                            4 /*yield*/ ,
                            resolvedConfig.endpointResolver(resolvedConfig, input)
                        ];
                    case 1:
                        endpoint = _a.sent();
                        return [
                            4 /*yield*/ ,
                            serializer(input, endpoint)
                        ];
                    case 2:
                        request = _a.sent();
                        return [
                            4 /*yield*/ ,
                            transferHandler(request, $8204b8b06f8287fc$var$__assign({}, resolvedConfig))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            deserializer(response)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
};


var $8cf65959d6849117$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8cf65959d6849117$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8cf65959d6849117$var$getCredentialsForIdentitySerializer = function(input, endpoint) {
    var headers = (0, $db135bb327a2c524$exports.getSharedHeaders)("GetCredentialsForIdentity");
    var body = JSON.stringify(input);
    return (0, $db135bb327a2c524$exports.buildHttpRpcRequest)(endpoint, headers, body);
};
var $8cf65959d6849117$var$getCredentialsForIdentityDeserializer = function(response) {
    return $8cf65959d6849117$var$__awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return $8cf65959d6849117$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $cb5799ee8aa283f5$exports.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $cb5799ee8aa283f5$exports.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            Credentials: $8cf65959d6849117$var$deserializeCredentials(body.Credentials),
                            $metadata: (0, $c613b0c835758a49$exports.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var $8cf65959d6849117$var$deserializeCredentials = function(output) {
    if (output === void 0) output = {};
    return {
        AccessKeyId: output["AccessKeyId"],
        SecretKey: output["SecretKey"],
        SessionToken: output["SessionToken"],
        Expiration: new Date(output["Expiration"] * 1000)
    };
};
var $8cf65959d6849117$export$a49c1c173ab96b58 = (0, $8204b8b06f8287fc$exports.composeServiceApi)((0, $db135bb327a2c524$exports.cognitoIdentityTransferHandler), $8cf65959d6849117$var$getCredentialsForIdentitySerializer, $8cf65959d6849117$var$getCredentialsForIdentityDeserializer, (0, $db135bb327a2c524$exports.defaultConfig));

var $5026151a50237003$exports = {};

$parcel$export($5026151a50237003$exports, "getId", function () { return $5026151a50237003$export$218c8c3169c024d2; });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $5026151a50237003$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5026151a50237003$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5026151a50237003$var$getIdSerializer = function(input, endpoint) {
    var headers = (0, $db135bb327a2c524$exports.getSharedHeaders)("GetId");
    var body = JSON.stringify(input);
    return (0, $db135bb327a2c524$exports.buildHttpRpcRequest)(endpoint, headers, body);
};
var $5026151a50237003$var$getIdDeserializer = function(response) {
    return $5026151a50237003$var$__awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return $5026151a50237003$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $cb5799ee8aa283f5$exports.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $cb5799ee8aa283f5$exports.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            $metadata: (0, $c613b0c835758a49$exports.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var $5026151a50237003$export$218c8c3169c024d2 = (0, $8204b8b06f8287fc$exports.composeServiceApi)((0, $db135bb327a2c524$exports.cognitoIdentityTransferHandler), $5026151a50237003$var$getIdSerializer, $5026151a50237003$var$getIdDeserializer, (0, $db135bb327a2c524$exports.defaultConfig));




var $57cc9456a9b994f0$var$__assign = undefined && undefined.__assign || function() {
    $57cc9456a9b994f0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $57cc9456a9b994f0$var$__assign.apply(this, arguments);
};
var $57cc9456a9b994f0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $57cc9456a9b994f0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $57cc9456a9b994f0$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("Credentials");
var $57cc9456a9b994f0$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $57cc9456a9b994f0$var$COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var $57cc9456a9b994f0$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $57cc9456a9b994f0$var$dispatchCredentialsEvent = function(event, data, message) {
    (0, $a81f69f3afceb158$exports.Hub).dispatch("core", {
        event: event,
        data: data,
        message: message
    }, "Credentials", $57cc9456a9b994f0$var$AMPLIFY_SYMBOL);
};
var $57cc9456a9b994f0$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers["google"] = (0, $8d0f3340a91e99f9$export$75ace714083c1340).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, $8d0f3340a91e99f9$export$1b6b8b5328e38349).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return "Credentials";
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $57cc9456a9b994f0$var$__assign($57cc9456a9b994f0$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $21568620555e7153$export$a2bd19c49e4760e8)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        $57cc9456a9b994f0$var$dispatchCredentialsEvent("credentials_configured", null, "Credentials has been configured successfully");
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $57cc9456a9b994f0$var$logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "".concat($57cc9456a9b994f0$var$COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $57cc9456a9b994f0$var$logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $57cc9456a9b994f0$var$logger.debug("getting new cred promise");
            this._gettingCredPromise = (0, $75cf6438f6eb1e84$export$8f33cb495ca11832)(this._keepAlive());
        } else $57cc9456a9b994f0$var$logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $57cc9456a9b994f0$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $57cc9456a9b994f0$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $57cc9456a9b994f0$var$logger.debug("checking if credentials exists and not expired");
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $57cc9456a9b994f0$var$logger.debug("credentials not changed and not expired, directly return");
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $57cc9456a9b994f0$var$logger.debug("need to get a new credential or refresh the existing one");
                        _a = this.Auth, Auth = _a === void 0 ? (0, $9937be76c87bee28$exports.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== "function") // If Auth module is not imported, do a best effort to get guest credentials
                        return [
                            2 /*return*/ ,
                            this._setCredentialsForGuest()
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $57cc9456a9b994f0$var$logger.debug("ttl has passed but token is not yet expired");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $57cc9456a9b994f0$var$logger.debug("Error attempting to refreshing the session", err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $57cc9456a9b994f0$var$logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $57cc9456a9b994f0$var$logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            $57cc9456a9b994f0$var$logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            $57cc9456a9b994f0$var$logger.debug("getting refreshed jwt token from federation provider");
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $57cc9456a9b994f0$var$logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $9234a6f4744a0813$exports.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $57cc9456a9b994f0$var$logger.debug("refresh federated token sucessfully", data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
            if (!isNetworkError) _this.clear();
            $57cc9456a9b994f0$var$logger.debug("refresh federated token failed", e);
            return Promise.reject("refreshing federation token failed: " + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $57cc9456a9b994f0$var$logger.debug("no credentials for expiration check");
            return true;
        }
        $57cc9456a9b994f0$var$logger.debug("are these credentials expired?", credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        var _a;
        return $57cc9456a9b994f0$var$__awaiter(this, void 0, void 0, function() {
            var _b, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
            var _this = this;
            return $57cc9456a9b994f0$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        $57cc9456a9b994f0$var$logger.debug("setting credentials for guest");
                        if (!((_a = this._config) === null || _a === void 0 ? void 0 : _a.identityPoolId)) // If Credentials are not configured thru Auth module,
                        // doing best effort to check if the library was configured
                        this._config = Object.assign({}, this._config, (0, $e0246317a77f60f2$exports.parseAWSExports)(this._config || {}).Auth);
                        _b = this._config, identityPoolId = _b.identityPoolId, region = _b.region, mandatorySignIn = _b.mandatorySignIn, identityPoolRegion = _b.identityPoolRegion;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            $57cc9456a9b994f0$var$logger.debug("No Cognito Identity pool provided for unauthenticated access");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Identity pool provided for unauthenticated access")
                            ];
                        }
                        if (!identityPoolRegion && !region) {
                            $57cc9456a9b994f0$var$logger.debug("region is not configured for getting the credentials");
                            return [
                                2 /*return*/ ,
                                Promise.reject("region is not configured for getting the credentials")
                            ];
                        }
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _c._identityId = _d.sent();
                        cognitoConfig = {
                            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
                        };
                        guestCredentialsProvider = function() {
                            return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                                var IdentityId, Credentials;
                                return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!identityId) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, $5026151a50237003$exports.getId)(cognitoConfig, {
                                                    IdentityPoolId: identityPoolId
                                                })
                                            ];
                                        case 1:
                                            IdentityId = _a.sent().IdentityId;
                                            this._identityId = IdentityId;
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                4 /*yield*/ ,
                                                (0, $8cf65959d6849117$exports.getCredentialsForIdentity)(cognitoConfig, {
                                                    IdentityId: this._identityId
                                                })
                                            ];
                                        case 3:
                                            Credentials = _a.sent().Credentials;
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    identityId: this._identityId,
                                                    accessKeyId: Credentials.AccessKeyId,
                                                    secretAccessKey: Credentials.SecretKey,
                                                    sessionToken: Credentials.SessionToken,
                                                    expiration: Credentials.Expiration
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                        credentials = guestCredentialsProvider().catch(function(err) {
                            return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                                return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                                    throw err;
                                });
                            });
                        });
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                                    var guestCredentialsProvider_1;
                                    var _this = this;
                                    return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '".concat(identityId, "' not found."))) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                $57cc9456a9b994f0$var$logger.debug("Failed to load guest credentials");
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                guestCredentialsProvider_1 = function() {
                                                    return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, Credentials;
                                                        return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, $5026151a50237003$exports.getId)(cognitoConfig, {
                                                                            IdentityPoolId: identityPoolId
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, $8cf65959d6849117$exports.getCredentialsForIdentity)(cognitoConfig, {
                                                                            IdentityId: IdentityId
                                                                        })
                                                                    ];
                                                                case 2:
                                                                    Credentials = _a.sent().Credentials;
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        {
                                                                            identityId: IdentityId,
                                                                            accessKeyId: Credentials.AccessKeyId,
                                                                            secretAccessKey: Credentials.SecretKey,
                                                                            sessionToken: Credentials.SessionToken,
                                                                            expiration: Credentials.Expiration
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = guestCredentialsProvider_1().catch(function(err) {
                                                    return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                                                        return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, "guest", false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var _this = this;
        var provider = params.provider, token = params.token;
        var identity_id = params.identity_id;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            $57cc9456a9b994f0$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            $57cc9456a9b994f0$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        var authenticatedCredentialsProvider = function() {
            return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                var IdentityId, Credentials;
                return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!identity_id) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $5026151a50237003$exports.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            identity_id = IdentityId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, $8cf65959d6849117$exports.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: identity_id,
                                    Logins: logins
                                })
                            ];
                        case 3:
                            Credentials = _a.sent().Credentials;
                            return [
                                2 /*return*/ ,
                                {
                                    identityId: identity_id,
                                    accessKeyId: Credentials.AccessKeyId,
                                    secretAccessKey: Credentials.SecretKey,
                                    sessionToken: Credentials.SessionToken,
                                    expiration: Credentials.Expiration
                                }
                            ];
                    }
                });
            });
        };
        var credentials = authenticatedCredentialsProvider().catch(function(err) {
            return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $57cc9456a9b994f0$var$logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            $57cc9456a9b994f0$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            $57cc9456a9b994f0$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return $57cc9456a9b994f0$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $5026151a50237003$exports.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                (0, $8cf65959d6849117$exports.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                })
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            $57cc9456a9b994f0$var$logger.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                            if (guestIdentityId === primaryIdentityId) $57cc9456a9b994f0$var$logger.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $57cc9456a9b994f0$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $57cc9456a9b994f0$var$logger.debug("Load credentials successfully", credentials);
                                if (this._identityId && !credentials.identityId) credentials["identityId"] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $57cc9456a9b994f0$var$CREDENTIALS_TTL;
                                if (source === "federated") {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $57cc9456a9b994f0$var$logger.debug("Failed to put federated info into auth storage", e);
                                    }
                                }
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $57cc9456a9b994f0$var$logger.debug("Failed to load credentials", credentials);
                    $57cc9456a9b994f0$var$logger.debug("Error loading credentials", err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            $57cc9456a9b994f0$var$logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $57cc9456a9b994f0$var$__awaiter(this, void 0, void 0, function() {
            return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $57cc9456a9b994f0$var$logger.debug("removing aws-amplify-federatedInfo from storage");
                this._storage.removeItem("aws-amplify-federatedInfo");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return $57cc9456a9b994f0$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        $57cc9456a9b994f0$var$logger.debug("Failed to get the cached guest identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return $57cc9456a9b994f0$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        $57cc9456a9b994f0$var$logger.debug("Failed to cache guest identityId", e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return $57cc9456a9b994f0$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return $57cc9456a9b994f0$var$__generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                $57cc9456a9b994f0$var$logger.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $57cc9456a9b994f0$export$a9627919734faa48 = new $57cc9456a9b994f0$export$9be509043bd0c09a(null);
(0, $9937be76c87bee28$exports.Amplify).register($57cc9456a9b994f0$export$a9627919734faa48);




var $28660863c1e5e1c0$exports = {};

$parcel$export($28660863c1e5e1c0$exports, "UniversalStorage", function () { return $28660863c1e5e1c0$export$ded9c57084144144; });
var $454260303336358b$exports = {};

$parcel$export($454260303336358b$exports, "default", function () { return $454260303336358b$export$2e2bcd8739ae039; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $ec2621b29d3c1fef$export$98e6a39c04603d36;
var $ec2621b29d3c1fef$export$dfdc1655ccc5b9cb;
"use strict";
$ec2621b29d3c1fef$export$98e6a39c04603d36 = $ec2621b29d3c1fef$var$parse;
$ec2621b29d3c1fef$export$dfdc1655ccc5b9cb = $ec2621b29d3c1fef$var$serialize;
/**
 * Module variables.
 * @private
 */ var $ec2621b29d3c1fef$var$decode = decodeURIComponent;
var $ec2621b29d3c1fef$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $ec2621b29d3c1fef$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $ec2621b29d3c1fef$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $ec2621b29d3c1fef$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $ec2621b29d3c1fef$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $ec2621b29d3c1fef$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $ec2621b29d3c1fef$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$ec2621b29d3c1fef$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$ec2621b29d3c1fef$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$ec2621b29d3c1fef$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$ec2621b29d3c1fef$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $ec2621b29d3c1fef$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $ae6bf4459591ce3d$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function $ae6bf4459591ce3d$export$bfce569af136abdc() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function $ae6bf4459591ce3d$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === "string") return $ec2621b29d3c1fef$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function $ae6bf4459591ce3d$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function $ae6bf4459591ce3d$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $ae6bf4459591ce3d$var$cleanupCookieValue(value);
    if ($ae6bf4459591ce3d$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $ae6bf4459591ce3d$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}


var $454260303336358b$var$__assign = undefined && undefined.__assign || function() {
    $454260303336358b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $454260303336358b$var$__assign.apply(this, arguments);
};
var $454260303336358b$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $ae6bf4459591ce3d$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $ae6bf4459591ce3d$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $ec2621b29d3c1fef$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $ae6bf4459591ce3d$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $ae6bf4459591ce3d$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = $454260303336358b$var$__assign($454260303336358b$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $ec2621b29d3c1fef$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $454260303336358b$var$__assign($454260303336358b$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $454260303336358b$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $ec2621b29d3c1fef$export$dfdc1655ccc5b9cb(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $454260303336358b$export$2e2bcd8739ae039 = $454260303336358b$var$Cookies;


var $ac6e4350089b752a$export$2e2bcd8739ae039 = (0, $454260303336358b$exports.default);



var $28660863c1e5e1c0$var$__assign = undefined && undefined.__assign || function() {
    $28660863c1e5e1c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28660863c1e5e1c0$var$__assign.apply(this, arguments);
};
var $28660863c1e5e1c0$var$isBrowser = (0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser;
var $28660863c1e5e1c0$var$ONE_YEAR_IN_MS = 31536000000;
var $28660863c1e5e1c0$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $ac6e4350089b752a$export$2e2bcd8739ae039)();
        this.store = $28660863c1e5e1c0$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $ac6e4350089b752a$export$2e2bcd8739ae039)(context.req.headers.cookie) : new (0, $ac6e4350089b752a$export$2e2bcd8739ae039)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: false,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: "/"
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split(".").pop();
        var sessionTokenTypes = [
            "LastAuthUser",
            "accessToken",
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            "refreshToken",
            // Required for CognitoUserSession
            "idToken"
        ];
        if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : "")) this.setUniversalItem(key, value, {
            expires: new Date(Date.now() + $28660863c1e5e1c0$var$ONE_YEAR_IN_MS)
        });
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value, options) {
        if (options === void 0) options = {};
        this.cookies.set(key, value, $28660863c1e5e1c0$var$__assign($28660863c1e5e1c0$var$__assign({}, options), {
            path: "/",
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: $28660863c1e5e1c0$var$isBrowser && window.location.hostname === "localhost" ? false : true
        }));
    };
    return UniversalStorage;
}();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $e8845aba11406a5b$var$hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var $e8845aba11406a5b$export$ea26e09ecef8d08d = $e8845aba11406a5b$var$hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var $e8845aba11406a5b$export$16032fc466434892 = "x-amz-user-agent";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $8802f8fc69825140$export$b855308a44508212(str) {
    return str.split("").map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, "0");
    }).join("");
}
function $8802f8fc69825140$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join("");
}


var $943a05682aeb540e$export$a002182e51710d39 = {
    userAgent: (0, $a43376df97178647$exports.Platform).userAgent
};
var /**
 * @deprecated use named import
 */ $943a05682aeb540e$export$2e2bcd8739ae039 = (0, $9937be76c87bee28$exports.Amplify);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $k48zG = parcelRequire("k48zG");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $63aec004f3b0b8d2$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($63aec004f3b0b8d2$export$eeb013770cb92342 || ($63aec004f3b0b8d2$export$eeb013770cb92342 = {}));
function $63aec004f3b0b8d2$export$9b905d6895bdc426(obj) {
    var keys = [
        "provider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $63aec004f3b0b8d2$export$828f8efbdf71714b(obj) {
    var keys = [
        "customProvider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $63aec004f3b0b8d2$export$6bae5520ca265d22(obj) {
    var keys = [
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $63aec004f3b0b8d2$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $63aec004f3b0b8d2$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})($63aec004f3b0b8d2$export$edb367c0a140d3db || ($63aec004f3b0b8d2$export$edb367c0a140d3db = {}));
function $63aec004f3b0b8d2$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $63aec004f3b0b8d2$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($63aec004f3b0b8d2$export$cfce9c15015bef96 || ($63aec004f3b0b8d2$export$cfce9c15015bef96 = {}));



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $1a8afb23c42827ae$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ecff6d910093d6a3$export$a143d493d941bafc;
var $ecff6d910093d6a3$export$e4cf37d7f6fb9e0a;
var $ecff6d910093d6a3$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $ecff6d910093d6a3$export$599f31c3813fae4d;
"use strict";

var $2IpUO = parcelRequire("2IpUO");

var $7CwwS = parcelRequire("7CwwS");
var $a5ed280e91905dae$exports = {};
var $a5ed280e91905dae$var$toString = {}.toString;
$a5ed280e91905dae$exports = Array.isArray || function(arr) {
    return $a5ed280e91905dae$var$toString.call(arr) == "[object Array]";
};


$ecff6d910093d6a3$export$a143d493d941bafc = $ecff6d910093d6a3$var$Buffer;
$ecff6d910093d6a3$export$e4cf37d7f6fb9e0a = $ecff6d910093d6a3$var$SlowBuffer;
$ecff6d910093d6a3$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $ecff6d910093d6a3$var$typedArraySupport();
$ecff6d910093d6a3$export$599f31c3813fae4d = $ecff6d910093d6a3$var$kMaxLength();
function $ecff6d910093d6a3$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $ecff6d910093d6a3$var$kMaxLength() {
    return $ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $ecff6d910093d6a3$var$createBuffer(that, length) {
    if ($ecff6d910093d6a3$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $ecff6d910093d6a3$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $ecff6d910093d6a3$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ecff6d910093d6a3$var$Buffer(arg, encodingOrOffset, length) {
    if (!$ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $ecff6d910093d6a3$var$Buffer)) return new $ecff6d910093d6a3$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $ecff6d910093d6a3$var$allocUnsafe(this, arg);
    }
    return $ecff6d910093d6a3$var$from(this, arg, encodingOrOffset, length);
}
$ecff6d910093d6a3$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$ecff6d910093d6a3$var$Buffer._augment = function(arr) {
    arr.__proto__ = $ecff6d910093d6a3$var$Buffer.prototype;
    return arr;
};
function $ecff6d910093d6a3$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $ecff6d910093d6a3$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $ecff6d910093d6a3$var$fromString(that, value, encodingOrOffset);
    return $ecff6d910093d6a3$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ecff6d910093d6a3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ecff6d910093d6a3$var$from(null, value, encodingOrOffset, length);
};
if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $ecff6d910093d6a3$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $ecff6d910093d6a3$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $ecff6d910093d6a3$var$Buffer[Symbol.species] === $ecff6d910093d6a3$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($ecff6d910093d6a3$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $ecff6d910093d6a3$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $ecff6d910093d6a3$var$alloc(that, size, fill, encoding) {
    $ecff6d910093d6a3$var$assertSize(size);
    if (size <= 0) return $ecff6d910093d6a3$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $ecff6d910093d6a3$var$createBuffer(that, size).fill(fill, encoding) : $ecff6d910093d6a3$var$createBuffer(that, size).fill(fill);
    return $ecff6d910093d6a3$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ecff6d910093d6a3$var$Buffer.alloc = function(size, fill, encoding) {
    return $ecff6d910093d6a3$var$alloc(null, size, fill, encoding);
};
function $ecff6d910093d6a3$var$allocUnsafe(that, size) {
    $ecff6d910093d6a3$var$assertSize(size);
    that = $ecff6d910093d6a3$var$createBuffer(that, size < 0 ? 0 : $ecff6d910093d6a3$var$checked(size) | 0);
    if (!$ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ecff6d910093d6a3$var$Buffer.allocUnsafe = function(size) {
    return $ecff6d910093d6a3$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ecff6d910093d6a3$var$Buffer.allocUnsafeSlow = function(size) {
    return $ecff6d910093d6a3$var$allocUnsafe(null, size);
};
function $ecff6d910093d6a3$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$ecff6d910093d6a3$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $ecff6d910093d6a3$var$byteLength(string, encoding) | 0;
    that = $ecff6d910093d6a3$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $ecff6d910093d6a3$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $ecff6d910093d6a3$var$checked(array.length) | 0;
    that = $ecff6d910093d6a3$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $ecff6d910093d6a3$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $ecff6d910093d6a3$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $ecff6d910093d6a3$var$fromArrayLike(that, array);
    return that;
}
function $ecff6d910093d6a3$var$fromObject(that, obj) {
    if ($ecff6d910093d6a3$var$Buffer.isBuffer(obj)) {
        var len = $ecff6d910093d6a3$var$checked(obj.length) | 0;
        that = $ecff6d910093d6a3$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $ecff6d910093d6a3$var$isnan(obj.length)) return $ecff6d910093d6a3$var$createBuffer(that, 0);
            return $ecff6d910093d6a3$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $a5ed280e91905dae$exports(obj.data)) return $ecff6d910093d6a3$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $ecff6d910093d6a3$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ecff6d910093d6a3$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ecff6d910093d6a3$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $ecff6d910093d6a3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ecff6d910093d6a3$var$Buffer.alloc(+length);
}
$ecff6d910093d6a3$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$ecff6d910093d6a3$var$Buffer.compare = function compare(a, b) {
    if (!$ecff6d910093d6a3$var$Buffer.isBuffer(a) || !$ecff6d910093d6a3$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ecff6d910093d6a3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$ecff6d910093d6a3$var$Buffer.concat = function concat(list, length) {
    if (!$a5ed280e91905dae$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ecff6d910093d6a3$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $ecff6d910093d6a3$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$ecff6d910093d6a3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ecff6d910093d6a3$var$byteLength(string, encoding) {
    if ($ecff6d910093d6a3$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $ecff6d910093d6a3$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $ecff6d910093d6a3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $ecff6d910093d6a3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ecff6d910093d6a3$var$Buffer.byteLength = $ecff6d910093d6a3$var$byteLength;
function $ecff6d910093d6a3$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $ecff6d910093d6a3$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $ecff6d910093d6a3$var$utf8Slice(this, start, end);
        case "ascii":
            return $ecff6d910093d6a3$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $ecff6d910093d6a3$var$latin1Slice(this, start, end);
        case "base64":
            return $ecff6d910093d6a3$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ecff6d910093d6a3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$ecff6d910093d6a3$var$Buffer.prototype._isBuffer = true;
function $ecff6d910093d6a3$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ecff6d910093d6a3$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$ecff6d910093d6a3$var$swap(this, i, i + 1);
    return this;
};
$ecff6d910093d6a3$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $ecff6d910093d6a3$var$swap(this, i, i + 3);
        $ecff6d910093d6a3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ecff6d910093d6a3$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $ecff6d910093d6a3$var$swap(this, i, i + 7);
        $ecff6d910093d6a3$var$swap(this, i + 1, i + 6);
        $ecff6d910093d6a3$var$swap(this, i + 2, i + 5);
        $ecff6d910093d6a3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ecff6d910093d6a3$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $ecff6d910093d6a3$var$utf8Slice(this, 0, length);
    return $ecff6d910093d6a3$var$slowToString.apply(this, arguments);
};
$ecff6d910093d6a3$var$Buffer.prototype.equals = function equals(b) {
    if (!$ecff6d910093d6a3$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $ecff6d910093d6a3$var$Buffer.compare(this, b) === 0;
};
$ecff6d910093d6a3$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $ecff6d910093d6a3$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$ecff6d910093d6a3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$ecff6d910093d6a3$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ecff6d910093d6a3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $ecff6d910093d6a3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ecff6d910093d6a3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ecff6d910093d6a3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ecff6d910093d6a3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $ecff6d910093d6a3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ecff6d910093d6a3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ecff6d910093d6a3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ecff6d910093d6a3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ecff6d910093d6a3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ecff6d910093d6a3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ecff6d910093d6a3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ecff6d910093d6a3$var$utf8Write(buf, string, offset, length) {
    return $ecff6d910093d6a3$var$blitBuffer($ecff6d910093d6a3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ecff6d910093d6a3$var$asciiWrite(buf, string, offset, length) {
    return $ecff6d910093d6a3$var$blitBuffer($ecff6d910093d6a3$var$asciiToBytes(string), buf, offset, length);
}
function $ecff6d910093d6a3$var$latin1Write(buf, string, offset, length) {
    return $ecff6d910093d6a3$var$asciiWrite(buf, string, offset, length);
}
function $ecff6d910093d6a3$var$base64Write(buf, string, offset, length) {
    return $ecff6d910093d6a3$var$blitBuffer($ecff6d910093d6a3$var$base64ToBytes(string), buf, offset, length);
}
function $ecff6d910093d6a3$var$ucs2Write(buf, string, offset, length) {
    return $ecff6d910093d6a3$var$blitBuffer($ecff6d910093d6a3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ecff6d910093d6a3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $ecff6d910093d6a3$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $ecff6d910093d6a3$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $ecff6d910093d6a3$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $ecff6d910093d6a3$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $ecff6d910093d6a3$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ecff6d910093d6a3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ecff6d910093d6a3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ecff6d910093d6a3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $2IpUO.fromByteArray(buf);
    else return $2IpUO.fromByteArray(buf.slice(start, end));
}
function $ecff6d910093d6a3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ecff6d910093d6a3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $ecff6d910093d6a3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ecff6d910093d6a3$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $ecff6d910093d6a3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ecff6d910093d6a3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ecff6d910093d6a3$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ecff6d910093d6a3$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ecff6d910093d6a3$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $ecff6d910093d6a3$var$toHex(buf[i]);
    return out;
}
function $ecff6d910093d6a3$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ecff6d910093d6a3$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $ecff6d910093d6a3$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $ecff6d910093d6a3$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ecff6d910093d6a3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$ecff6d910093d6a3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ecff6d910093d6a3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ecff6d910093d6a3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ecff6d910093d6a3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ecff6d910093d6a3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ecff6d910093d6a3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ecff6d910093d6a3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ecff6d910093d6a3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ecff6d910093d6a3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ecff6d910093d6a3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ecff6d910093d6a3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ecff6d910093d6a3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ecff6d910093d6a3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ecff6d910093d6a3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ecff6d910093d6a3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, true, 23, 4);
};
$ecff6d910093d6a3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, false, 23, 4);
};
$ecff6d910093d6a3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, true, 52, 8);
};
$ecff6d910093d6a3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, false, 52, 8);
};
function $ecff6d910093d6a3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ecff6d910093d6a3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$ecff6d910093d6a3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ecff6d910093d6a3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ecff6d910093d6a3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $ecff6d910093d6a3$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$ecff6d910093d6a3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $ecff6d910093d6a3$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $ecff6d910093d6a3$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $ecff6d910093d6a3$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$ecff6d910093d6a3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $ecff6d910093d6a3$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $ecff6d910093d6a3$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ecff6d910093d6a3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ecff6d910093d6a3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $ecff6d910093d6a3$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $ecff6d910093d6a3$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $ecff6d910093d6a3$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$ecff6d910093d6a3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $ecff6d910093d6a3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $ecff6d910093d6a3$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $ecff6d910093d6a3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $ecff6d910093d6a3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ecff6d910093d6a3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ecff6d910093d6a3$var$writeFloat(this, value, offset, true, noAssert);
};
$ecff6d910093d6a3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ecff6d910093d6a3$var$writeFloat(this, value, offset, false, noAssert);
};
function $ecff6d910093d6a3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $ecff6d910093d6a3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ecff6d910093d6a3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ecff6d910093d6a3$var$writeDouble(this, value, offset, true, noAssert);
};
$ecff6d910093d6a3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ecff6d910093d6a3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ecff6d910093d6a3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$ecff6d910093d6a3$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ecff6d910093d6a3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$ecff6d910093d6a3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $ecff6d910093d6a3$var$Buffer.isBuffer(val) ? val : $ecff6d910093d6a3$var$utf8ToBytes(new $ecff6d910093d6a3$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $ecff6d910093d6a3$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $ecff6d910093d6a3$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $ecff6d910093d6a3$var$stringtrim(str).replace($ecff6d910093d6a3$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $ecff6d910093d6a3$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $ecff6d910093d6a3$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $ecff6d910093d6a3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $ecff6d910093d6a3$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ecff6d910093d6a3$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ecff6d910093d6a3$var$base64ToBytes(str) {
    return $2IpUO.toByteArray($ecff6d910093d6a3$var$base64clean(str));
}
function $ecff6d910093d6a3$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $ecff6d910093d6a3$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}


var $3fc38dbe75aac85b$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $3fc38dbe75aac85b$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$3fc38dbe75aac85b$var$crypto && typeof window !== "undefined" && window.msCrypto) $3fc38dbe75aac85b$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$3fc38dbe75aac85b$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $3fc38dbe75aac85b$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$3fc38dbe75aac85b$var$crypto && true) try {
    $3fc38dbe75aac85b$var$crypto = (parcelRequire("lsgQ0"));
} catch (err) {}
function $3fc38dbe75aac85b$export$2e2bcd8739ae039() {
    if ($3fc38dbe75aac85b$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $3fc38dbe75aac85b$var$crypto.getRandomValues === "function") try {
            return $3fc38dbe75aac85b$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $3fc38dbe75aac85b$var$crypto.randomBytes === "function") try {
            return $3fc38dbe75aac85b$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $3b1a9e39fc9aafd9$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $3b1a9e39fc9aafd9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $3fc38dbe75aac85b$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $3b1a9e39fc9aafd9$var$hexStringify(this);
    };
    return WordArray;
}();


var $ebd7417dff5d36ff$exports = {};
"use strict";
Object.defineProperty($ebd7417dff5d36ff$exports, "__esModule", {
    value: true
});

var $k48zG = parcelRequire("k48zG");

(0, $k48zG.__exportStar)((parcelRequire("aHKG5")), $ebd7417dff5d36ff$exports);


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $4ac4735ff6f08d90$export$2e2bcd8739ae039 = $4ac4735ff6f08d90$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $4ac4735ff6f08d90$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $4ac4735ff6f08d90$var$nbi() {
    return new $4ac4735ff6f08d90$var$BigInteger(null);
}
// Bits per digit
var $4ac4735ff6f08d90$var$dbits;
// JavaScript engine analysis
var $4ac4735ff6f08d90$var$canary = 0xdeadbeefcafe;
var $4ac4735ff6f08d90$var$j_lm = ($4ac4735ff6f08d90$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $4ac4735ff6f08d90$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $4ac4735ff6f08d90$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $4ac4735ff6f08d90$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $4ac4735ff6f08d90$var$inBrowser = typeof navigator !== "undefined";
if ($4ac4735ff6f08d90$var$inBrowser && $4ac4735ff6f08d90$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $4ac4735ff6f08d90$var$BigInteger.prototype.am = $4ac4735ff6f08d90$var$am2;
    $4ac4735ff6f08d90$var$dbits = 30;
} else if ($4ac4735ff6f08d90$var$inBrowser && $4ac4735ff6f08d90$var$j_lm && navigator.appName != "Netscape") {
    $4ac4735ff6f08d90$var$BigInteger.prototype.am = $4ac4735ff6f08d90$var$am1;
    $4ac4735ff6f08d90$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $4ac4735ff6f08d90$var$BigInteger.prototype.am = $4ac4735ff6f08d90$var$am3;
    $4ac4735ff6f08d90$var$dbits = 28;
}
$4ac4735ff6f08d90$var$BigInteger.prototype.DB = $4ac4735ff6f08d90$var$dbits;
$4ac4735ff6f08d90$var$BigInteger.prototype.DM = (1 << $4ac4735ff6f08d90$var$dbits) - 1;
$4ac4735ff6f08d90$var$BigInteger.prototype.DV = 1 << $4ac4735ff6f08d90$var$dbits;
var $4ac4735ff6f08d90$var$BI_FP = 52;
$4ac4735ff6f08d90$var$BigInteger.prototype.FV = Math.pow(2, $4ac4735ff6f08d90$var$BI_FP);
$4ac4735ff6f08d90$var$BigInteger.prototype.F1 = $4ac4735ff6f08d90$var$BI_FP - $4ac4735ff6f08d90$var$dbits;
$4ac4735ff6f08d90$var$BigInteger.prototype.F2 = 2 * $4ac4735ff6f08d90$var$dbits - $4ac4735ff6f08d90$var$BI_FP;
// Digit conversions
var $4ac4735ff6f08d90$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $4ac4735ff6f08d90$var$BI_RC = new Array();
var $4ac4735ff6f08d90$var$rr, $4ac4735ff6f08d90$var$vv;
$4ac4735ff6f08d90$var$rr = "0".charCodeAt(0);
for($4ac4735ff6f08d90$var$vv = 0; $4ac4735ff6f08d90$var$vv <= 9; ++$4ac4735ff6f08d90$var$vv)$4ac4735ff6f08d90$var$BI_RC[$4ac4735ff6f08d90$var$rr++] = $4ac4735ff6f08d90$var$vv;
$4ac4735ff6f08d90$var$rr = "a".charCodeAt(0);
for($4ac4735ff6f08d90$var$vv = 10; $4ac4735ff6f08d90$var$vv < 36; ++$4ac4735ff6f08d90$var$vv)$4ac4735ff6f08d90$var$BI_RC[$4ac4735ff6f08d90$var$rr++] = $4ac4735ff6f08d90$var$vv;
$4ac4735ff6f08d90$var$rr = "A".charCodeAt(0);
for($4ac4735ff6f08d90$var$vv = 10; $4ac4735ff6f08d90$var$vv < 36; ++$4ac4735ff6f08d90$var$vv)$4ac4735ff6f08d90$var$BI_RC[$4ac4735ff6f08d90$var$rr++] = $4ac4735ff6f08d90$var$vv;
function $4ac4735ff6f08d90$var$int2char(n) {
    return $4ac4735ff6f08d90$var$BI_RM.charAt(n);
}
function $4ac4735ff6f08d90$var$intAt(s, i) {
    var c = $4ac4735ff6f08d90$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $4ac4735ff6f08d90$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $4ac4735ff6f08d90$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $4ac4735ff6f08d90$var$nbv(i) {
    var r = $4ac4735ff6f08d90$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $4ac4735ff6f08d90$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $4ac4735ff6f08d90$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $4ac4735ff6f08d90$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $4ac4735ff6f08d90$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $4ac4735ff6f08d90$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $4ac4735ff6f08d90$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $4ac4735ff6f08d90$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $4ac4735ff6f08d90$var$bnNegate() {
    var r = $4ac4735ff6f08d90$var$nbi();
    $4ac4735ff6f08d90$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $4ac4735ff6f08d90$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $4ac4735ff6f08d90$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $4ac4735ff6f08d90$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $4ac4735ff6f08d90$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $4ac4735ff6f08d90$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $4ac4735ff6f08d90$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $4ac4735ff6f08d90$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $4ac4735ff6f08d90$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $4ac4735ff6f08d90$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $4ac4735ff6f08d90$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $4ac4735ff6f08d90$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $4ac4735ff6f08d90$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $4ac4735ff6f08d90$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $4ac4735ff6f08d90$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $4ac4735ff6f08d90$var$nbi();
    var y = $4ac4735ff6f08d90$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $4ac4735ff6f08d90$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $4ac4735ff6f08d90$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $4ac4735ff6f08d90$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $4ac4735ff6f08d90$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $4ac4735ff6f08d90$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $4ac4735ff6f08d90$var$bnMod(a) {
    var r = $4ac4735ff6f08d90$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($4ac4735ff6f08d90$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $4ac4735ff6f08d90$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $4ac4735ff6f08d90$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $4ac4735ff6f08d90$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $4ac4735ff6f08d90$var$bnAdd(a) {
    var r = $4ac4735ff6f08d90$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $4ac4735ff6f08d90$var$bnSubtract(a) {
    var r = $4ac4735ff6f08d90$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $4ac4735ff6f08d90$var$bnMultiply(a) {
    var r = $4ac4735ff6f08d90$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $4ac4735ff6f08d90$var$bnDivide(a) {
    var r = $4ac4735ff6f08d90$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $4ac4735ff6f08d90$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $4ac4735ff6f08d90$var$montConvert(x) {
    var r = $4ac4735ff6f08d90$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($4ac4735ff6f08d90$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $4ac4735ff6f08d90$var$montRevert(x) {
    var r = $4ac4735ff6f08d90$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $4ac4735ff6f08d90$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $4ac4735ff6f08d90$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $4ac4735ff6f08d90$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$4ac4735ff6f08d90$var$Montgomery.prototype.convert = $4ac4735ff6f08d90$var$montConvert;
$4ac4735ff6f08d90$var$Montgomery.prototype.revert = $4ac4735ff6f08d90$var$montRevert;
$4ac4735ff6f08d90$var$Montgomery.prototype.reduce = $4ac4735ff6f08d90$var$montReduce;
$4ac4735ff6f08d90$var$Montgomery.prototype.mulTo = $4ac4735ff6f08d90$var$montMulTo;
$4ac4735ff6f08d90$var$Montgomery.prototype.sqrTo = $4ac4735ff6f08d90$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $4ac4735ff6f08d90$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $4ac4735ff6f08d90$var$nbv(1), z = new $4ac4735ff6f08d90$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $4ac4735ff6f08d90$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $4ac4735ff6f08d90$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $4ac4735ff6f08d90$var$nbi(), t;
    i = $4ac4735ff6f08d90$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$4ac4735ff6f08d90$var$BigInteger.prototype.copyTo = $4ac4735ff6f08d90$var$bnpCopyTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.fromInt = $4ac4735ff6f08d90$var$bnpFromInt;
$4ac4735ff6f08d90$var$BigInteger.prototype.fromString = $4ac4735ff6f08d90$var$bnpFromString;
$4ac4735ff6f08d90$var$BigInteger.prototype.clamp = $4ac4735ff6f08d90$var$bnpClamp;
$4ac4735ff6f08d90$var$BigInteger.prototype.dlShiftTo = $4ac4735ff6f08d90$var$bnpDLShiftTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.drShiftTo = $4ac4735ff6f08d90$var$bnpDRShiftTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.lShiftTo = $4ac4735ff6f08d90$var$bnpLShiftTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.rShiftTo = $4ac4735ff6f08d90$var$bnpRShiftTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.subTo = $4ac4735ff6f08d90$var$bnpSubTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.multiplyTo = $4ac4735ff6f08d90$var$bnpMultiplyTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.squareTo = $4ac4735ff6f08d90$var$bnpSquareTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.divRemTo = $4ac4735ff6f08d90$var$bnpDivRemTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.invDigit = $4ac4735ff6f08d90$var$bnpInvDigit;
$4ac4735ff6f08d90$var$BigInteger.prototype.addTo = $4ac4735ff6f08d90$var$bnpAddTo;
// public
$4ac4735ff6f08d90$var$BigInteger.prototype.toString = $4ac4735ff6f08d90$var$bnToString;
$4ac4735ff6f08d90$var$BigInteger.prototype.negate = $4ac4735ff6f08d90$var$bnNegate;
$4ac4735ff6f08d90$var$BigInteger.prototype.abs = $4ac4735ff6f08d90$var$bnAbs;
$4ac4735ff6f08d90$var$BigInteger.prototype.compareTo = $4ac4735ff6f08d90$var$bnCompareTo;
$4ac4735ff6f08d90$var$BigInteger.prototype.bitLength = $4ac4735ff6f08d90$var$bnBitLength;
$4ac4735ff6f08d90$var$BigInteger.prototype.mod = $4ac4735ff6f08d90$var$bnMod;
$4ac4735ff6f08d90$var$BigInteger.prototype.equals = $4ac4735ff6f08d90$var$bnEquals;
$4ac4735ff6f08d90$var$BigInteger.prototype.add = $4ac4735ff6f08d90$var$bnAdd;
$4ac4735ff6f08d90$var$BigInteger.prototype.subtract = $4ac4735ff6f08d90$var$bnSubtract;
$4ac4735ff6f08d90$var$BigInteger.prototype.multiply = $4ac4735ff6f08d90$var$bnMultiply;
$4ac4735ff6f08d90$var$BigInteger.prototype.divide = $4ac4735ff6f08d90$var$bnDivide;
$4ac4735ff6f08d90$var$BigInteger.prototype.modPow = $4ac4735ff6f08d90$var$bnModPow;
// "constants"
$4ac4735ff6f08d90$var$BigInteger.ZERO = $4ac4735ff6f08d90$var$nbv(0);
$4ac4735ff6f08d90$var$BigInteger.ONE = $4ac4735ff6f08d90$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $1877b6fac33917aa$var$randomBytes(nBytes) {
    return (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(new (0, $3b1a9e39fc9aafd9$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $1877b6fac33917aa$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $1877b6fac33917aa$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $1877b6fac33917aa$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $1877b6fac33917aa$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)($1877b6fac33917aa$var$initN, 16);
        this.g = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $ecff6d910093d6a3$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $1877b6fac33917aa$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $1877b6fac33917aa$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $1877b6fac33917aa$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $4ac4735ff6f08d90$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $ebd7417dff5d36ff$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $ecff6d910093d6a3$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $ecff6d910093d6a3$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $ebd7417dff5d36ff$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $ebd7417dff5d36ff$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $4ac4735ff6f08d90$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $4ac4735ff6f08d90$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $ecff6d910093d6a3$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $1877b6fac33917aa$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $4ac4735ff6f08d90$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $1877b6fac33917aa$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $4ac4735ff6f08d90$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $e3be2c5878e9fc5e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $ecff6d910093d6a3$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $12c9e4e4b13597da$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $12c9e4e4b13597da$var$_setPrototypeOf(subClass, superClass);
}
function $12c9e4e4b13597da$var$_setPrototypeOf(o, p) {
    $12c9e4e4b13597da$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $12c9e4e4b13597da$var$_setPrototypeOf(o, p);
}
/** @class */ var $12c9e4e4b13597da$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $12c9e4e4b13597da$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $e3be2c5878e9fc5e$export$2e2bcd8739ae039));



function $7a21823654c70032$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $7a21823654c70032$var$_setPrototypeOf(subClass, superClass);
}
function $7a21823654c70032$var$_setPrototypeOf(o, p) {
    $7a21823654c70032$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7a21823654c70032$var$_setPrototypeOf(o, p);
}
/** @class */ var $7a21823654c70032$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $7a21823654c70032$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $e3be2c5878e9fc5e$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $e6b9dd9fd45b106a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $4a9cbb04ac54ebd3$export$83d89fbfd8236492 = "5.0.4";


var $0e77d950584738b3$var$BASE_USER_AGENT = "aws-amplify/" + (0, $4a9cbb04ac54ebd3$export$83d89fbfd8236492);
var $0e77d950584738b3$export$2dffd0b5373a4389 = {
    userAgent: $0e77d950584738b3$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $0e77d950584738b3$export$7935961ef7719cb0 = function getUserAgent() {
    return $0e77d950584738b3$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $0e77d950584738b3$export$2e2bcd8739ae039 = $0e77d950584738b3$export$2dffd0b5373a4389;







/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $95e770680909d0a2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $16f7b1cb863d3b57$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $16f7b1cb863d3b57$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $16f7b1cb863d3b57$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $16f7b1cb863d3b57$var$weekNames[now.getUTCDay()];
        var month = $16f7b1cb863d3b57$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $10c9da3e6ed1135a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $038f1beaecb652bc$var$dataMemory = {};
var $038f1beaecb652bc$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $038f1beaecb652bc$var$dataMemory[key] = value;
        return $038f1beaecb652bc$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($038f1beaecb652bc$var$dataMemory, key) ? $038f1beaecb652bc$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $038f1beaecb652bc$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $038f1beaecb652bc$var$dataMemory = {};
        return $038f1beaecb652bc$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $038f1beaecb652bc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $038f1beaecb652bc$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $527d9ea0159b8e34$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $527d9ea0159b8e34$var$userAgent = $527d9ea0159b8e34$var$isNavigatorAvailable ? (0, $0e77d950584738b3$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var $527d9ea0159b8e34$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $038f1beaecb652bc$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $1877b6fac33917aa$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $16f7b1cb863d3b57$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $ecff6d910093d6a3$export$a143d493d941bafc).concat([
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $ebd7417dff5d36ff$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $1877b6fac33917aa$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $527d9ea0159b8e34$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $1877b6fac33917aa$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $1877b6fac33917aa$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $16f7b1cb863d3b57$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $4ac4735ff6f08d90$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $ecff6d910093d6a3$export$a143d493d941bafc).concat([
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $ebd7417dff5d36ff$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $1877b6fac33917aa$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $1877b6fac33917aa$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $ecff6d910093d6a3$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $527d9ea0159b8e34$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $10c9da3e6ed1135a$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $7a21823654c70032$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $12c9e4e4b13597da$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $e6b9dd9fd45b106a$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $95e770680909d0a2$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $7a21823654c70032$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $12c9e4e4b13597da$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $e6b9dd9fd45b106a$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $95e770680909d0a2$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $c1e64b8a4f86a20e$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $c1e64b8a4f86a20e$export$2ef00488675027c = "auth";


// constructor
function $5f3d608f1af6a48b$var$UserAgent() {}
// public
$5f3d608f1af6a48b$var$UserAgent.prototype.userAgent = (0, $0e77d950584738b3$export$7935961ef7719cb0)();
var $5f3d608f1af6a48b$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($5f3d608f1af6a48b$var$UserAgent.prototype.userAgent && !$5f3d608f1af6a48b$var$UserAgent.prototype.userAgent.includes(content)) $5f3d608f1af6a48b$var$UserAgent.prototype.userAgent = $5f3d608f1af6a48b$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$5f3d608f1af6a48b$var$UserAgent.prototype.userAgent || $5f3d608f1af6a48b$var$UserAgent.prototype.userAgent === "") $5f3d608f1af6a48b$var$UserAgent.prototype.userAgent = content;
};
var $5f3d608f1af6a48b$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $5f3d608f1af6a48b$var$UserAgent.category = (0, $c1e64b8a4f86a20e$export$2ef00488675027c);
};
var $5f3d608f1af6a48b$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $5f3d608f1af6a48b$var$UserAgent.framework = framework;
};
var $5f3d608f1af6a48b$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $5f3d608f1af6a48b$var$UserAgent.category ? " " + $5f3d608f1af6a48b$var$UserAgent.category : "";
    var uaFramework = $5f3d608f1af6a48b$var$UserAgent.framework ? " framework/" + $5f3d608f1af6a48b$var$UserAgent.framework : "";
    var userAgent = "" + $5f3d608f1af6a48b$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$5f3d608f1af6a48b$export$2e2bcd8739ae039 = $5f3d608f1af6a48b$var$UserAgent;


function $e3b87b0426a12ee8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e3b87b0426a12ee8$var$_setPrototypeOf(subClass, superClass);
}
function $e3b87b0426a12ee8$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e3b87b0426a12ee8$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e3b87b0426a12ee8$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e3b87b0426a12ee8$var$_construct(Class, arguments, $e3b87b0426a12ee8$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e3b87b0426a12ee8$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e3b87b0426a12ee8$var$_wrapNativeSuper(Class);
}
function $e3b87b0426a12ee8$var$_construct(Parent, args, Class) {
    if ($e3b87b0426a12ee8$var$_isNativeReflectConstruct()) $e3b87b0426a12ee8$var$_construct = Reflect.construct.bind();
    else $e3b87b0426a12ee8$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e3b87b0426a12ee8$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e3b87b0426a12ee8$var$_construct.apply(null, arguments);
}
function $e3b87b0426a12ee8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e3b87b0426a12ee8$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e3b87b0426a12ee8$var$_setPrototypeOf(o, p) {
    $e3b87b0426a12ee8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e3b87b0426a12ee8$var$_setPrototypeOf(o, p);
}
function $e3b87b0426a12ee8$var$_getPrototypeOf(o) {
    $e3b87b0426a12ee8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e3b87b0426a12ee8$var$_getPrototypeOf(o);
}
var $e3b87b0426a12ee8$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $e3b87b0426a12ee8$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $e3b87b0426a12ee8$var$_wrapNativeSuper(Error));
/** @class */ var $e3b87b0426a12ee8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $e3b87b0426a12ee8$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $e3b87b0426a12ee8$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $5f3d608f1af6a48b$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $e3b87b0426a12ee8$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $e3b87b0426a12ee8$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $e3b87b0426a12ee8$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $e3b87b0426a12ee8$var$_wrapNativeSuper(Error));
var $e3b87b0426a12ee8$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $e3b87b0426a12ee8$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $e3b87b0426a12ee8$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $e3b87b0426a12ee8$var$logger.debug("error on " + functionToRetry.name, err);
        if ($e3b87b0426a12ee8$var$isNonRetryableError(err)) {
            $e3b87b0426a12ee8$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $e3b87b0426a12ee8$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $e3b87b0426a12ee8$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $e3b87b0426a12ee8$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $e3b87b0426a12ee8$var$MAX_DELAY_MS = 300000;
function $e3b87b0426a12ee8$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $e3b87b0426a12ee8$var$MAX_DELAY_MS;
    return $e3b87b0426a12ee8$var$retry(functionToRetry, args, $e3b87b0426a12ee8$var$jitteredBackoff(maxDelayMs));
}




var $68f8ca288782a4d2$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $68f8ca288782a4d2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $68f8ca288782a4d2$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $e3b87b0426a12ee8$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $038f1beaecb652bc$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $527d9ea0159b8e34$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $527d9ea0159b8e34$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $45fa4d41ccfa8437$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $45fa4d41ccfa8437$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $50efc6e7847b2f34$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $45fa4d41ccfa8437$exports.set(key, value, options);
        return $45fa4d41ccfa8437$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $45fa4d41ccfa8437$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $45fa4d41ccfa8437$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $45fa4d41ccfa8437$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();










// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $5cd7a19cd0a84897$export$98e6a39c04603d36;
var $5cd7a19cd0a84897$export$f7ad0328861e2f03;
var $5cd7a19cd0a84897$export$7daf1a5d2f4dd018;
var $5cd7a19cd0a84897$export$d9468344d3651243;
var $5cd7a19cd0a84897$export$59d795186a5d3f58;
"use strict";

var $cX4QS = parcelRequire("cX4QS");
var $1581548d68c85533$exports = {};
"use strict";
$1581548d68c85533$exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};


$5cd7a19cd0a84897$export$98e6a39c04603d36 = $5cd7a19cd0a84897$var$urlParse;
$5cd7a19cd0a84897$export$f7ad0328861e2f03 = $5cd7a19cd0a84897$var$urlResolve;
$5cd7a19cd0a84897$export$7daf1a5d2f4dd018 = $5cd7a19cd0a84897$var$urlResolveObject;
$5cd7a19cd0a84897$export$d9468344d3651243 = $5cd7a19cd0a84897$var$urlFormat;
$5cd7a19cd0a84897$export$59d795186a5d3f58 = $5cd7a19cd0a84897$var$Url;
function $5cd7a19cd0a84897$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $5cd7a19cd0a84897$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $5cd7a19cd0a84897$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$5cd7a19cd0a84897$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$5cd7a19cd0a84897$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$5cd7a19cd0a84897$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($5cd7a19cd0a84897$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$5cd7a19cd0a84897$var$autoEscape = [
    "'"
].concat($5cd7a19cd0a84897$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$5cd7a19cd0a84897$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($5cd7a19cd0a84897$var$autoEscape), $5cd7a19cd0a84897$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $5cd7a19cd0a84897$var$hostnameMaxLen = 255, $5cd7a19cd0a84897$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $5cd7a19cd0a84897$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$5cd7a19cd0a84897$var$unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
$5cd7a19cd0a84897$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$5cd7a19cd0a84897$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
var $746e087b598db07a$export$2f872c0f2117be69;
var $746e087b598db07a$export$98e6a39c04603d36;
var $746e087b598db07a$export$c564cdbbe6da493;
var $746e087b598db07a$export$fac44ee5b035f737;
"use strict";

$746e087b598db07a$export$2f872c0f2117be69 = $746e087b598db07a$export$98e6a39c04603d36 = (parcelRequire("kVoG6"));

$746e087b598db07a$export$c564cdbbe6da493 = $746e087b598db07a$export$fac44ee5b035f737 = (parcelRequire("3o3ca"));


function $5cd7a19cd0a84897$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $1581548d68c85533$exports.isObject(url) && url instanceof $5cd7a19cd0a84897$var$Url) return url;
    var u = new $5cd7a19cd0a84897$var$Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$5cd7a19cd0a84897$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$1581548d68c85533$exports.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $5cd7a19cd0a84897$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $746e087b598db07a$export$98e6a39c04603d36(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = $5cd7a19cd0a84897$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $5cd7a19cd0a84897$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$5cd7a19cd0a84897$var$hostlessProtocol[proto] && (slashes || proto && !$5cd7a19cd0a84897$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $5cd7a19cd0a84897$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($5cd7a19cd0a84897$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $5cd7a19cd0a84897$var$nonHostChars.length; i++){
            var hec = rest.indexOf($5cd7a19cd0a84897$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($5cd7a19cd0a84897$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($5cd7a19cd0a84897$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($5cd7a19cd0a84897$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $5cd7a19cd0a84897$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $cX4QS.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$5cd7a19cd0a84897$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = $5cd7a19cd0a84897$var$autoEscape.length; i < l; i++){
        var ae = $5cd7a19cd0a84897$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $746e087b598db07a$export$98e6a39c04603d36(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($5cd7a19cd0a84897$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $5cd7a19cd0a84897$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($1581548d68c85533$exports.isString(obj)) obj = $5cd7a19cd0a84897$var$urlParse(obj);
    if (!(obj instanceof $5cd7a19cd0a84897$var$Url)) return $5cd7a19cd0a84897$var$Url.prototype.format.call(obj);
    return obj.format();
}
$5cd7a19cd0a84897$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $1581548d68c85533$exports.isObject(this.query) && Object.keys(this.query).length) query = $746e087b598db07a$export$fac44ee5b035f737(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || $5cd7a19cd0a84897$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $5cd7a19cd0a84897$var$urlResolve(source, relative) {
    return $5cd7a19cd0a84897$var$urlParse(source, false, true).resolve(relative);
}
$5cd7a19cd0a84897$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($5cd7a19cd0a84897$var$urlParse(relative, false, true)).format();
};
function $5cd7a19cd0a84897$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $5cd7a19cd0a84897$var$urlParse(source, false, true).resolveObject(relative);
}
$5cd7a19cd0a84897$var$Url.prototype.resolveObject = function(relative) {
    if ($1581548d68c85533$exports.isString(relative)) {
        var rel = new $5cd7a19cd0a84897$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $5cd7a19cd0a84897$var$Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if ($5cd7a19cd0a84897$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$5cd7a19cd0a84897$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$5cd7a19cd0a84897$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$5cd7a19cd0a84897$var$slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$1581548d68c85533$exports.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$1581548d68c85533$exports.isNull(result.pathname) || !$1581548d68c85533$exports.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$1581548d68c85533$exports.isNull(result.pathname) || !$1581548d68c85533$exports.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$5cd7a19cd0a84897$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $5cd7a19cd0a84897$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $k48zG = parcelRequire("k48zG");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $8479343af84982cc$var$SELF = "_self";
var $8479343af84982cc$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $8479343af84982cc$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $33f58ce8c48d9b52$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var $33f58ce8c48d9b52$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var $33f58ce8c48d9b52$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var $33f58ce8c48d9b52$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var $33f58ce8c48d9b52$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $07b588fd8d21e909$export$a143d493d941bafc;
var $07b588fd8d21e909$export$e4cf37d7f6fb9e0a;
var $07b588fd8d21e909$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $07b588fd8d21e909$export$599f31c3813fae4d;
"use strict";

var $2IpUO = parcelRequire("2IpUO");

var $7CwwS = parcelRequire("7CwwS");

$07b588fd8d21e909$export$a143d493d941bafc = $07b588fd8d21e909$var$Buffer;
$07b588fd8d21e909$export$e4cf37d7f6fb9e0a = $07b588fd8d21e909$var$SlowBuffer;
$07b588fd8d21e909$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $07b588fd8d21e909$var$typedArraySupport();
$07b588fd8d21e909$export$599f31c3813fae4d = $07b588fd8d21e909$var$kMaxLength();
function $07b588fd8d21e909$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $07b588fd8d21e909$var$kMaxLength() {
    return $07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $07b588fd8d21e909$var$createBuffer(that, length) {
    if ($07b588fd8d21e909$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $07b588fd8d21e909$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $07b588fd8d21e909$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $07b588fd8d21e909$var$Buffer(arg, encodingOrOffset, length) {
    if (!$07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $07b588fd8d21e909$var$Buffer)) return new $07b588fd8d21e909$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $07b588fd8d21e909$var$allocUnsafe(this, arg);
    }
    return $07b588fd8d21e909$var$from(this, arg, encodingOrOffset, length);
}
$07b588fd8d21e909$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$07b588fd8d21e909$var$Buffer._augment = function(arr) {
    arr.__proto__ = $07b588fd8d21e909$var$Buffer.prototype;
    return arr;
};
function $07b588fd8d21e909$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $07b588fd8d21e909$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $07b588fd8d21e909$var$fromString(that, value, encodingOrOffset);
    return $07b588fd8d21e909$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $07b588fd8d21e909$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $07b588fd8d21e909$var$from(null, value, encodingOrOffset, length);
};
if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $07b588fd8d21e909$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $07b588fd8d21e909$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $07b588fd8d21e909$var$Buffer[Symbol.species] === $07b588fd8d21e909$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($07b588fd8d21e909$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $07b588fd8d21e909$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $07b588fd8d21e909$var$alloc(that, size, fill, encoding) {
    $07b588fd8d21e909$var$assertSize(size);
    if (size <= 0) return $07b588fd8d21e909$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $07b588fd8d21e909$var$createBuffer(that, size).fill(fill, encoding) : $07b588fd8d21e909$var$createBuffer(that, size).fill(fill);
    return $07b588fd8d21e909$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $07b588fd8d21e909$var$Buffer.alloc = function(size, fill, encoding) {
    return $07b588fd8d21e909$var$alloc(null, size, fill, encoding);
};
function $07b588fd8d21e909$var$allocUnsafe(that, size) {
    $07b588fd8d21e909$var$assertSize(size);
    that = $07b588fd8d21e909$var$createBuffer(that, size < 0 ? 0 : $07b588fd8d21e909$var$checked(size) | 0);
    if (!$07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $07b588fd8d21e909$var$Buffer.allocUnsafe = function(size) {
    return $07b588fd8d21e909$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $07b588fd8d21e909$var$Buffer.allocUnsafeSlow = function(size) {
    return $07b588fd8d21e909$var$allocUnsafe(null, size);
};
function $07b588fd8d21e909$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$07b588fd8d21e909$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $07b588fd8d21e909$var$byteLength(string, encoding) | 0;
    that = $07b588fd8d21e909$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $07b588fd8d21e909$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $07b588fd8d21e909$var$checked(array.length) | 0;
    that = $07b588fd8d21e909$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $07b588fd8d21e909$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $07b588fd8d21e909$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $07b588fd8d21e909$var$fromArrayLike(that, array);
    return that;
}
function $07b588fd8d21e909$var$fromObject(that, obj) {
    if ($07b588fd8d21e909$var$Buffer.isBuffer(obj)) {
        var len = $07b588fd8d21e909$var$checked(obj.length) | 0;
        that = $07b588fd8d21e909$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $07b588fd8d21e909$var$isnan(obj.length)) return $07b588fd8d21e909$var$createBuffer(that, 0);
            return $07b588fd8d21e909$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $a5ed280e91905dae$exports(obj.data)) return $07b588fd8d21e909$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $07b588fd8d21e909$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $07b588fd8d21e909$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $07b588fd8d21e909$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $07b588fd8d21e909$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $07b588fd8d21e909$var$Buffer.alloc(+length);
}
$07b588fd8d21e909$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$07b588fd8d21e909$var$Buffer.compare = function compare(a, b) {
    if (!$07b588fd8d21e909$var$Buffer.isBuffer(a) || !$07b588fd8d21e909$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$07b588fd8d21e909$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$07b588fd8d21e909$var$Buffer.concat = function concat(list, length) {
    if (!$a5ed280e91905dae$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $07b588fd8d21e909$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $07b588fd8d21e909$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$07b588fd8d21e909$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $07b588fd8d21e909$var$byteLength(string, encoding) {
    if ($07b588fd8d21e909$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $07b588fd8d21e909$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $07b588fd8d21e909$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $07b588fd8d21e909$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$07b588fd8d21e909$var$Buffer.byteLength = $07b588fd8d21e909$var$byteLength;
function $07b588fd8d21e909$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $07b588fd8d21e909$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $07b588fd8d21e909$var$utf8Slice(this, start, end);
        case "ascii":
            return $07b588fd8d21e909$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $07b588fd8d21e909$var$latin1Slice(this, start, end);
        case "base64":
            return $07b588fd8d21e909$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $07b588fd8d21e909$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$07b588fd8d21e909$var$Buffer.prototype._isBuffer = true;
function $07b588fd8d21e909$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$07b588fd8d21e909$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$07b588fd8d21e909$var$swap(this, i, i + 1);
    return this;
};
$07b588fd8d21e909$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $07b588fd8d21e909$var$swap(this, i, i + 3);
        $07b588fd8d21e909$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$07b588fd8d21e909$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $07b588fd8d21e909$var$swap(this, i, i + 7);
        $07b588fd8d21e909$var$swap(this, i + 1, i + 6);
        $07b588fd8d21e909$var$swap(this, i + 2, i + 5);
        $07b588fd8d21e909$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$07b588fd8d21e909$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $07b588fd8d21e909$var$utf8Slice(this, 0, length);
    return $07b588fd8d21e909$var$slowToString.apply(this, arguments);
};
$07b588fd8d21e909$var$Buffer.prototype.equals = function equals(b) {
    if (!$07b588fd8d21e909$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $07b588fd8d21e909$var$Buffer.compare(this, b) === 0;
};
$07b588fd8d21e909$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $07b588fd8d21e909$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$07b588fd8d21e909$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$07b588fd8d21e909$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $07b588fd8d21e909$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $07b588fd8d21e909$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($07b588fd8d21e909$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $07b588fd8d21e909$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $07b588fd8d21e909$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $07b588fd8d21e909$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$07b588fd8d21e909$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$07b588fd8d21e909$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $07b588fd8d21e909$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$07b588fd8d21e909$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $07b588fd8d21e909$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $07b588fd8d21e909$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $07b588fd8d21e909$var$utf8Write(buf, string, offset, length) {
    return $07b588fd8d21e909$var$blitBuffer($07b588fd8d21e909$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $07b588fd8d21e909$var$asciiWrite(buf, string, offset, length) {
    return $07b588fd8d21e909$var$blitBuffer($07b588fd8d21e909$var$asciiToBytes(string), buf, offset, length);
}
function $07b588fd8d21e909$var$latin1Write(buf, string, offset, length) {
    return $07b588fd8d21e909$var$asciiWrite(buf, string, offset, length);
}
function $07b588fd8d21e909$var$base64Write(buf, string, offset, length) {
    return $07b588fd8d21e909$var$blitBuffer($07b588fd8d21e909$var$base64ToBytes(string), buf, offset, length);
}
function $07b588fd8d21e909$var$ucs2Write(buf, string, offset, length) {
    return $07b588fd8d21e909$var$blitBuffer($07b588fd8d21e909$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$07b588fd8d21e909$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $07b588fd8d21e909$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $07b588fd8d21e909$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $07b588fd8d21e909$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $07b588fd8d21e909$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $07b588fd8d21e909$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $07b588fd8d21e909$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$07b588fd8d21e909$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $07b588fd8d21e909$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $2IpUO.fromByteArray(buf);
    else return $2IpUO.fromByteArray(buf.slice(start, end));
}
function $07b588fd8d21e909$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $07b588fd8d21e909$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $07b588fd8d21e909$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $07b588fd8d21e909$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $07b588fd8d21e909$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $07b588fd8d21e909$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $07b588fd8d21e909$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $07b588fd8d21e909$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $07b588fd8d21e909$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $07b588fd8d21e909$var$toHex(buf[i]);
    return out;
}
function $07b588fd8d21e909$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$07b588fd8d21e909$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $07b588fd8d21e909$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $07b588fd8d21e909$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $07b588fd8d21e909$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$07b588fd8d21e909$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$07b588fd8d21e909$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$07b588fd8d21e909$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$07b588fd8d21e909$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$07b588fd8d21e909$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$07b588fd8d21e909$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$07b588fd8d21e909$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$07b588fd8d21e909$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$07b588fd8d21e909$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$07b588fd8d21e909$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$07b588fd8d21e909$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$07b588fd8d21e909$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$07b588fd8d21e909$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$07b588fd8d21e909$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$07b588fd8d21e909$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, true, 23, 4);
};
$07b588fd8d21e909$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, false, 23, 4);
};
$07b588fd8d21e909$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, true, 52, 8);
};
$07b588fd8d21e909$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, false, 52, 8);
};
function $07b588fd8d21e909$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$07b588fd8d21e909$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$07b588fd8d21e909$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $07b588fd8d21e909$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$07b588fd8d21e909$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $07b588fd8d21e909$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$07b588fd8d21e909$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $07b588fd8d21e909$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$07b588fd8d21e909$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $07b588fd8d21e909$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$07b588fd8d21e909$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $07b588fd8d21e909$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $07b588fd8d21e909$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$07b588fd8d21e909$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $07b588fd8d21e909$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$07b588fd8d21e909$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $07b588fd8d21e909$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$07b588fd8d21e909$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $07b588fd8d21e909$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$07b588fd8d21e909$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $07b588fd8d21e909$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$07b588fd8d21e909$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$07b588fd8d21e909$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $07b588fd8d21e909$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$07b588fd8d21e909$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $07b588fd8d21e909$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$07b588fd8d21e909$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $07b588fd8d21e909$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$07b588fd8d21e909$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $07b588fd8d21e909$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $07b588fd8d21e909$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $07b588fd8d21e909$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $07b588fd8d21e909$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$07b588fd8d21e909$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $07b588fd8d21e909$var$writeFloat(this, value, offset, true, noAssert);
};
$07b588fd8d21e909$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $07b588fd8d21e909$var$writeFloat(this, value, offset, false, noAssert);
};
function $07b588fd8d21e909$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $07b588fd8d21e909$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$07b588fd8d21e909$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $07b588fd8d21e909$var$writeDouble(this, value, offset, true, noAssert);
};
$07b588fd8d21e909$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $07b588fd8d21e909$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$07b588fd8d21e909$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$07b588fd8d21e909$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$07b588fd8d21e909$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$07b588fd8d21e909$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $07b588fd8d21e909$var$Buffer.isBuffer(val) ? val : $07b588fd8d21e909$var$utf8ToBytes(new $07b588fd8d21e909$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $07b588fd8d21e909$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $07b588fd8d21e909$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $07b588fd8d21e909$var$stringtrim(str).replace($07b588fd8d21e909$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $07b588fd8d21e909$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $07b588fd8d21e909$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $07b588fd8d21e909$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $07b588fd8d21e909$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $07b588fd8d21e909$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $07b588fd8d21e909$var$base64ToBytes(str) {
    return $2IpUO.toByteArray($07b588fd8d21e909$var$base64clean(str));
}
function $07b588fd8d21e909$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $07b588fd8d21e909$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}





var $012cd0c36439364b$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $012cd0c36439364b$var$dispatchAuthEvent = function(event, data, message) {
    (0, $a81f69f3afceb158$exports.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $012cd0c36439364b$var$AMPLIFY_SYMBOL);
};
var $012cd0c36439364b$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("OAuth");
var $012cd0c36439364b$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $8479343af84982cc$export$9b38228bd9928080);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error("scopes must be a String Array");
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === "string";
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, $63aec004f3b0b8d2$export$eeb013770cb92342).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $8802f8fc69825140$export$b855308a44508212)(customState) : generatedState;
        $33f58ce8c48d9b52$export$42fffed799c298bb(state);
        var pkce_key = this._generateRandom(128);
        $33f58ce8c48d9b52$export$14934cb45d589fa1(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var scopesString = this._scopes.join(" ");
        var queryString = Object.entries((0, $k48zG.__assign)((0, $k48zG.__assign)({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = (0, $k48zG.__read)(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $012cd0c36439364b$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a, access_token, refresh_token, id_token, error;
            var _b;
            return (0, $k48zG.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        code = ((0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = (0, $k48zG.__read)(_a, 2), k = _c[0], v = _c[1];
                            return (0, $k48zG.__assign)((0, $k48zG.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).pathname || "/";
                        redirectSignInPathname = (0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(this._config.redirectSignIn).pathname || "/";
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        $012cd0c36439364b$var$dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $33f58ce8c48d9b52$export$742ac7ded61fbfce();
                        oAuthTokenBody = (0, $k48zG.__assign)({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $012cd0c36439364b$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = (0, $k48zG.__read)(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        customUserAgentDetails = {
                            category: (0, $a2c3ec90eedc2a0c$export$3a8840c5b2ecf003).Auth,
                            action: (0, $a2c3ec90eedc2a0c$export$900b1436d7e65f4).FederatedSignIn
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: (_b = {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }, _b[0, $e8845aba11406a5b$export$16032fc466434892] = (0, $a43376df97178647$exports.getAmplifyUserAgent)(customUserAgentDetails), _b),
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.sent().json()
                        ];
                    case 2:
                        _a = _c.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return (0, $k48zG.__generator)(this, function(_b) {
                _a = ((0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).hash || "#").substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = (0, $k48zG.__read)(_a, 2), k = _c[0], v = _c[1];
                    return (0, $k48zG.__assign)((0, $k48zG.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $012cd0c36439364b$var$dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                $012cd0c36439364b$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return (0, $k48zG.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? (0, $k48zG.__assign)((0, $k48zG.__assign)({}, ((0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, $k48zG.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, $k48zG.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $012cd0c36439364b$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, $k48zG.__assign).apply(void 0, [
                                (0, $k48zG.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (0, $k48zG.__assign).apply(void 0, [
                                (0, $k48zG.__assign).apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $012cd0c36439364b$var$logger.debug("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $33f58ce8c48d9b52$export$50fdfeece43146fd();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return (0, $k48zG.__generator)(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = (0, $k48zG.__read)(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join("&");
                $012cd0c36439364b$var$dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                $012cd0c36439364b$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        var awsCryptoHash = new (0, $ebd7417dff5d36ff$exports.Sha256)();
        awsCryptoHash.update(code);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var b64 = (0, $07b588fd8d21e909$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
        var base64URLFromAWSCrypto = this._base64URL(b64);
        return base64URLFromAWSCrypto;
    };
    OAuth.prototype._base64URL = function(string) {
        return string.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
var $012cd0c36439364b$export$2e2bcd8739ae039 = $012cd0c36439364b$var$OAuth;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $bb0ac35abf7bae40$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isNode) ;
    else throw new Error("Not supported");
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $k48zG = parcelRequire("k48zG");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f07efb23de25497d$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})($f07efb23de25497d$export$c3070468b9d65120 || ($f07efb23de25497d$export$c3070468b9d65120 = {}));


var $85d858262542f137$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("AuthError");
var $85d858262542f137$export$145273558d58e0ac = /** @class */ function(_super) {
    (0, $k48zG.__extends)(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $85d858262542f137$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        $85d858262542f137$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $85d858262542f137$export$71192787e041818c = /** @class */ function(_super) {
    (0, $k48zG.__extends)(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}($85d858262542f137$export$145273558d58e0ac);
var $85d858262542f137$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $f07efb23de25497d$export$c3070468b9d65120).DEFAULT_MSG
    }
};



var $becbf89411c44a7e$var$logger = new (0, $f4253d4db4a331c2$exports.ConsoleLogger)("AuthClass");
var $becbf89411c44a7e$var$USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $becbf89411c44a7e$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $becbf89411c44a7e$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $becbf89411c44a7e$var$dispatchAuthEvent = function(event, data, message) {
    (0, $a81f69f3afceb158$exports.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $becbf89411c44a7e$var$AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var $becbf89411c44a7e$var$MAX_DEVICES = 60;
var $becbf89411c44a7e$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var $becbf89411c44a7e$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.inflightSessionPromise = null;
        this.inflightSessionPromiseCounter = 0;
        this.Credentials = (0, $57cc9456a9b994f0$exports.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $becbf89411c44a7e$var$dispatchAuthEvent("tokenRefresh", undefined, "New token retrieved");
                else $becbf89411c44a7e$var$dispatchAuthEvent("tokenRefresh_failure", error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $a81f69f3afceb158$exports.Hub).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "verify":
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
        (0, $5f3d608f1af6a48b$export$523857f9fc06cb0d)();
        (0, $5f3d608f1af6a48b$export$972f94ce7a888cac)((0, $a43376df97178647$exports.Platform).framework);
        (0, $a43376df97178647$exports.Platform).observeFrameworkChanges(function() {
            (0, $5f3d608f1af6a48b$export$972f94ce7a888cac)((0, $a43376df97178647$exports.Platform).framework);
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $becbf89411c44a7e$var$logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, $e0246317a77f60f2$exports.parseAWSExports)(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint, storage = _a.storage;
        if (!storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $50efc6e7847b2f34$export$2e2bcd8739ae039)(cookieStorage);
            else this._storage = config.ssr ? new (0, $28660863c1e5e1c0$exports.UniversalStorage)() : new (0, $21568620555e7153$export$a2bd19c49e4760e8)().getStorage();
        } else {
            if (!this._isValidAuthStorage(storage)) {
                $becbf89411c44a7e$var$logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $68f8ca288782a4d2$export$2e2bcd8739ae039)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            identityPoolRegion: identityPoolRegion
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, $012cd0c36439364b$export$2e2bcd8739ae039)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $bb0ac35abf7bae40$export$2e2bcd8739ae039)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $becbf89411c44a7e$var$dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
            var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
            if (pollingInitiated) {
                $becbf89411c44a7e$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $63aec004f3b0b8d2$export$edb367c0a140d3db).AutoSignInError);
                this._storage.removeItem("amplify-auto-sign-in");
            }
            this._storage.removeItem("amplify-polling-started");
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, $10c9da3e6ed1135a$export$2e2bcd8739ae039)({
                Name: "email",
                Value: email
            }));
            if (phone_number) attributes.push(new (0, $10c9da3e6ed1135a$export$2e2bcd8739ae039)({
                Name: "phone_number",
                Value: phone_number
            }));
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, $10c9da3e6ed1135a$export$2e2bcd8739ae039)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params["validationData"];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, $10c9da3e6ed1135a$export$2e2bcd8739ae039)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem("amplify-auto-sign-in", "true");
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).SignUpError);
        if (!username) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyPassword);
        $becbf89411c44a7e$var$logger.debug("signUp attrs:", attributes);
        $becbf89411c44a7e$var$logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $becbf89411c44a7e$var$dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    $becbf89411c44a7e$var$dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, $1a8afb23c42827ae$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === "link") this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === "confirmSignUp") _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, $a81f69f3afceb158$exports.Hub).listen("auth", listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem("amplify-polling-started", "true");
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > $becbf89411c44a7e$var$MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                $becbf89411c44a7e$var$dispatchAuthEvent("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
                _this._storage.removeItem("amplify-auto-sign-in");
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                $becbf89411c44a7e$var$dispatchAuthEvent("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, $a81f69f3afceb158$exports.Hub).remove("auth", listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem("amplify-polling-started");
                                }
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }, function(error) {
                                $becbf89411c44a7e$var$logger.error(error);
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        $becbf89411c44a7e$var$logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    $becbf89411c44a7e$var$dispatchAuthEvent("confirmSignUp", data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        $becbf89411c44a7e$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $63aec004f3b0b8d2$export$edb367c0a140d3db).AutoSignInError);
                        _this._storage.removeItem("amplify-auto-sign-in");
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === "true" : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $63aec004f3b0b8d2$export$ad34f09783c4cb16)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") $becbf89411c44a7e$var$logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyUsername);
        var authDetails = new (0, $1a8afb23c42827ae$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return (0, $k48zG.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $becbf89411c44a7e$var$logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                $becbf89411c44a7e$var$logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $becbf89411c44a7e$var$logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $becbf89411c44a7e$var$dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $becbf89411c44a7e$var$logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $becbf89411c44a7e$var$logger.debug("signIn failure", err);
                $becbf89411c44a7e$var$dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $becbf89411c44a7e$var$logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $becbf89411c44a7e$var$logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $becbf89411c44a7e$var$logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $becbf89411c44a7e$var$logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $becbf89411c44a7e$var$logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $becbf89411c44a7e$var$logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $becbf89411c44a7e$var$logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                $becbf89411c44a7e$var$logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return (0, $k48zG.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $becbf89411c44a7e$var$logger.debug("getting preferred mfa failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej("invalid MFA Type");
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else $becbf89411c44a7e$var$logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return (0, $k48zG.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $becbf89411c44a7e$var$logger.debug("getting user data failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SOFTWARE_TOKEN_MFA":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "SMS_MFA":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $becbf89411c44a7e$var$logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $becbf89411c44a7e$var$logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    $becbf89411c44a7e$var$logger.debug("Set user mfa success", result);
                                    $becbf89411c44a7e$var$logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return (0, $k48zG.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $becbf89411c44a7e$var$logger.debug("getting user data failed", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $becbf89411c44a7e$var$logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                $becbf89411c44a7e$var$logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $becbf89411c44a7e$var$logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                $becbf89411c44a7e$var$logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $becbf89411c44a7e$var$logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $becbf89411c44a7e$var$logger.debug("associateSoftwareToken success", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $becbf89411c44a7e$var$logger.debug("verification totp token", user, challengeAnswer);
        var signInUserSession;
        if (user && typeof user.getSignInUserSession === "function") signInUserSession = user.getSignInUserSession();
        var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    $becbf89411c44a7e$var$logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    if (!isLoggedIn) $becbf89411c44a7e$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    $becbf89411c44a7e$var$dispatchAuthEvent("verify", user, "A user " + user.getUsername() + " has been verified");
                    $becbf89411c44a7e$var$logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_3, currentUser, e_4;
                        return (0, $k48zG.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $becbf89411c44a7e$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        10
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $becbf89411c44a7e$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $becbf89411c44a7e$var$logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 5:
                                    that.user = user;
                                    _a.label = 6;
                                case 6:
                                    _a.trys.push([
                                        6,
                                        8,
                                        ,
                                        9
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.currentUserPoolUser()
                                    ];
                                case 7:
                                    currentUser = _a.sent();
                                    user.attributes = currentUser.attributes;
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 8:
                                    e_4 = _a.sent();
                                    $becbf89411c44a7e$var$logger.debug("cannot get updated Cognito User", e_4);
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 9:
                                    $becbf89411c44a7e$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 10:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $becbf89411c44a7e$var$logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_5;
                        return (0, $k48zG.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $becbf89411c44a7e$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $becbf89411c44a7e$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_5 = _a.sent();
                                    $becbf89411c44a7e$var$logger.debug("cannot get cognito credentials", e_5);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $becbf89411c44a7e$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $becbf89411c44a7e$var$logger.debug("completeNewPassword failure", err);
                    $becbf89411c44a7e$var$dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $becbf89411c44a7e$var$logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $becbf89411c44a7e$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $becbf89411c44a7e$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var e_6, isSignedInHostedUI;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_6 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("Failed to sync cache info into memory", e_6);
                        throw new Error(e_6);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return (0, $k48zG.__generator)(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                $becbf89411c44a7e$var$logger.debug("Failed to get user from user pool");
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error("No current user."))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return (0, $k48zG.__generator)(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                $becbf89411c44a7e$var$logger.debug("Failed to get the user session", err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        $becbf89411c44a7e$var$dispatchAuthEvent("userDeleted", result, "The authenticated user has been deleted.");
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            $becbf89411c44a7e$var$logger.debug("failed to clear cached items");
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            $becbf89411c44a7e$var$dispatchAuthEvent("signOut", _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            $becbf89411c44a7e$var$logger.debug("no Congito User pool");
                                            rej(new Error("Cognito User pool does not exist"));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result, details) {
                    if (err) {
                        $becbf89411c44a7e$var$dispatchAuthEvent("updateUserAttributes_failure", err, "Failed to update attributes");
                        return reject(err);
                    } else {
                        var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
                        $becbf89411c44a7e$var$dispatchAuthEvent("updateUserAttributes", attrs, "Attributes successfully updated");
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    AuthClass.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
        var attrs = {};
        Object.keys(attributes).forEach(function(key) {
            attrs[key] = {
                isUpdated: true
            };
            var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
                return value.AttributeName === key;
            });
            if (codeDeliveryDetails) {
                attrs[key].isUpdated = false;
                attrs[key].codeDeliveryDetails = codeDeliveryDetails;
            }
        });
        return attrs;
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    AuthClass.prototype.isPasswordResetRequiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Password reset required for the user";
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err) || this.isPasswordResetRequiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var e_7;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else $becbf89411c44a7e$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                    var user, session, bypassCache, clientMetadata, _a, scope, err_1;
                    var _this = this;
                    return (0, $k48zG.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $becbf89411c44a7e$var$logger.debug("OAuth signIn in progress, waiting for resolution...");
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $becbf89411c44a7e$var$logger.debug("OAuth signIn in progress timeout");
                                            (0, $a81f69f3afceb158$exports.Hub).remove("auth", hostedUISignCallback);
                                            res();
                                        }, $becbf89411c44a7e$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $a81f69f3afceb158$exports.Hub).listen("auth", hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                                                $becbf89411c44a7e$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $a81f69f3afceb158$exports.Hub).remove("auth", hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $becbf89411c44a7e$var$logger.debug("Failed to get user from user pool");
                                    rej("No current user");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                _b.label = 3;
                            case 3:
                                _b.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._userSession(user)
                                ];
                            case 4:
                                session = _b.sent();
                                bypassCache = params ? params.bypassCache : false;
                                if (!bypassCache) return [
                                    3 /*break*/ ,
                                    6
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                clientMetadata = this._config.clientMetadata;
                                _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                                if (scope.split(" ").includes($becbf89411c44a7e$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                    return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                                        var cleanUpError_5, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                        return (0, $k48zG.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    $becbf89411c44a7e$var$logger.debug("getting user data failed", err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _a.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                case 5:
                                                    res(user);
                                                    _a.label = 6;
                                                case 6:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 7:
                                                    preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                                    attributeList = [];
                                                    for(i = 0; i < data.UserAttributes.length; i++){
                                                        attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value
                                                        };
                                                        userAttribute = new (0, $10c9da3e6ed1135a$export$2e2bcd8739ae039)(attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    attributes = this.attributesToObject(attributeList);
                                                    Object.assign(user, {
                                                        attributes: attributes,
                                                        preferredMFA: preferredMFA
                                                    });
                                                    return [
                                                        2 /*return*/ ,
                                                        res(user)
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    bypassCache: bypassCache,
                                    clientMetadata: clientMetadata
                                });
                                else {
                                    $becbf89411c44a7e$var$logger.debug("Unable to get the user data because the " + $becbf89411c44a7e$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                    return [
                                        2 /*return*/ ,
                                        res(user)
                                    ];
                                }
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                err_1 = _b.sent();
                                rej(err_1);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $becbf89411c44a7e$var$logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var federatedUser, e_8, federatedInfo, user, e_9;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $becbf89411c44a7e$var$logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_8 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("Failed to sync cache info into memory", e_8);
                        throw e_8;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                            if (federatedInfo) federatedUser = (0, $k48zG.__assign)((0, $k48zG.__assign)({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $becbf89411c44a7e$var$logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $becbf89411c44a7e$var$logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $becbf89411c44a7e$var$logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_9 = _a.sent();
                        if (e_9 === "No userPool") $becbf89411c44a7e$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $becbf89411c44a7e$var$logger.debug("The user is not authenticated by the error", e_9);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $becbf89411c44a7e$var$logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error("No User Pool in the configuration."));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $becbf89411c44a7e$var$logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $becbf89411c44a7e$var$logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    AuthClass.prototype._userSession = function(user) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userSession;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!user) {
                            $becbf89411c44a7e$var$logger.debug("the user is null");
                            return [
                                2 /*return*/ ,
                                this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).NoUserSession)
                            ];
                        }
                        clientMetadata = this._config.clientMetadata;
                        // Debouncing the concurrent userSession calls by caching the promise.
                        // This solution assumes users will always call this function with the same CognitoUser instance.
                        if (this.inflightSessionPromiseCounter === 0) this.inflightSessionPromise = new Promise(function(res, rej) {
                            user.getSession(function(err, session) {
                                return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                                    var cleanUpError_6;
                                    return (0, $k48zG.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!err) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                $becbf89411c44a7e$var$logger.debug("Failed to get the session from user", user);
                                                if (!this.isSessionInvalid(err)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.cleanUpInvalidSession(user)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                cleanUpError_6 = _a.sent();
                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 4:
                                                rej(err);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 5:
                                                $becbf89411c44a7e$var$logger.debug("Succeed to get the user session", session);
                                                res(session);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, {
                                clientMetadata: clientMetadata
                            });
                        });
                        this.inflightSessionPromiseCounter++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.inflightSessionPromise
                        ];
                    case 2:
                        userSession = _a.sent();
                        // Set private member. Avoid user.setSignInUserSession() to prevent excessive localstorage refresh.
                        // @ts-ignore
                        user.signInUserSession = userSession;
                        return [
                            2 /*return*/ ,
                            userSession
                        ];
                    case 3:
                        this.inflightSessionPromiseCounter--;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        return this._userSession(user);
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var e_10, federatedInfo;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $becbf89411c44a7e$var$logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_10 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("Failed to sync cache info into memory", e_10);
                        throw e_10;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            $becbf89411c44a7e$var$logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $becbf89411c44a7e$var$logger.debug("getting session success", session);
                                return _this.Credentials.set(session, "session");
                            }).catch(function() {
                                $becbf89411c44a7e$var$logger.debug("getting guest credentials");
                                return _this.Credentials.set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $becbf89411c44a7e$var$logger.debug("getting current credentials");
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var e_11, isSignedInHostedUI;
            var _this = this;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("Failed to sync cache info into memory", e_11);
                        throw e_11;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $becbf89411c44a7e$var$logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return (0, $k48zG.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_7;
                                            var _this = this;
                                            return (0, $k48zG.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $becbf89411c44a7e$var$logger.debug("failed to get the user session", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_7 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                $becbf89411c44a7e$var$logger.debug("global sign out success");
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                $becbf89411c44a7e$var$logger.debug("global sign out failed", err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    $becbf89411c44a7e$var$logger.debug("user sign out", user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error("Signout timeout fail"));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var e_12, user;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_12 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $becbf89411c44a7e$var$logger.debug("no current Cognito user");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $becbf89411c44a7e$var$logger.debug("no Cognito User pool");
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $becbf89411c44a7e$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $becbf89411c44a7e$var$logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $becbf89411c44a7e$var$logger.debug("forgot password failure", err);
                    $becbf89411c44a7e$var$dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $becbf89411c44a7e$var$dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyCode);
        if (!password) return this.rejectAuthError((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    $becbf89411c44a7e$var$dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    $becbf89411c44a7e$var$dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_13, info, err_2, user;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $becbf89411c44a7e$var$logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_13 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("Failed to retrieve credentials while getting current user info", e_13);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_2 = _a.sent();
                        $becbf89411c44a7e$var$logger.error("currentUserInfo error", err_2);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $63aec004f3b0b8d2$export$9b905d6895bdc426)(providerOrOptions) || (0, $63aec004f3b0b8d2$export$828f8efbdf71714b)(providerOrOptions) || (0, $63aec004f3b0b8d2$export$6bae5520ca265d22)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $63aec004f3b0b8d2$export$eeb013770cb92342).Cognito
                        };
                        provider = (0, $63aec004f3b0b8d2$export$9b905d6895bdc426)(options) ? options.provider : options.customProvider;
                        customState = (0, $63aec004f3b0b8d2$export$9b905d6895bdc426)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $63aec004f3b0b8d2$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) $becbf89411c44a7e$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $becbf89411c44a7e$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        $becbf89411c44a7e$var$logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
            return (0, $k48zG.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $becbf89411c44a7e$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $becbf89411c44a7e$var$dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $75cf6438f6eb1e84$export$a2708fdb45cd35f)().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, $k48zG.__read)(_a, 1), k = _b[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, $5cd7a19cd0a84897$export$98e6a39c04603d36)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, $k48zG.__read)(_a, 1), k = _b[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $95e770680909d0a2$export$2e2bcd8739ae039)({
                            IdToken: new (0, $7a21823654c70032$export$2e2bcd8739ae039)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $e6b9dd9fd45b106a$export$2e2bcd8739ae039)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $12c9e4e4b13597da$export$2e2bcd8739ae039)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, "session")
                        ];
                    case 4:
                        credentials = _b.sent();
                        $becbf89411c44a7e$var$logger.debug("AWS credentials", credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $becbf89411c44a7e$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $becbf89411c44a7e$var$dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            $becbf89411c44a7e$var$dispatchAuthEvent("customOAuthState", (0, $8802f8fc69825140$export$a7ea17e93539f9a5)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_3 = _b.sent();
                        $becbf89411c44a7e$var$logger.debug("Error in cognito hosted auth response", err_3);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $becbf89411c44a7e$var$dispatchAuthEvent("signIn_failure", err_3, "The OAuth response flow failed");
                        $becbf89411c44a7e$var$dispatchAuthEvent("cognitoHostedUI_failure", err_3, "A failure occurred when returning to the Cognito Hosted UI");
                        $becbf89411c44a7e$var$dispatchAuthEvent("customState_failure", err_3, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $527d9ea0159b8e34$export$2e2bcd8739ae039)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $63aec004f3b0b8d2$export$edb367c0a140d3db).MissingAuthConfig;
        }
        return (0, $63aec004f3b0b8d2$export$edb367c0a140d3db).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $85d858262542f137$export$145273558d58e0ac)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $85d858262542f137$export$71192787e041818c)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_2;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("The user is not authenticated by the error", error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $85d858262542f137$export$145273558d58e0ac)((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $85d858262542f137$export$145273558d58e0ac)((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_3;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("The user is not authenticated by the error", error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $85d858262542f137$export$145273558d58e0ac)((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $85d858262542f137$export$145273558d58e0ac)((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return (0, $k48zG.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_4;
            return (0, $k48zG.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        $becbf89411c44a7e$var$logger.debug("The user is not authenticated by the error", error_4);
                        throw new Error("The user is not authenticated");
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === "device_name";
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $85d858262542f137$export$145273558d58e0ac)((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $85d858262542f137$export$145273558d58e0ac)((0, $63aec004f3b0b8d2$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices($becbf89411c44a7e$var$MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var $becbf89411c44a7e$export$334c29725a78c21d = new $becbf89411c44a7e$export$eeff9d1a8b8c057b(null);
(0, $9937be76c87bee28$exports.Amplify).register($becbf89411c44a7e$export$334c29725a78c21d);





var /**
 * @deprecated use named import
 */ $629e497d86cb18ea$export$2e2bcd8739ae039 = (0, $becbf89411c44a7e$export$334c29725a78c21d);



var $322a796d5713096f$exports = {};
$322a796d5713096f$exports = JSON.parse('{"ZeitplanCdkStack":{"HostedUiDomain":"https://zeitplan.auth.us-east-1.amazoncognito.com","userpoolid":"us-east-1_GiYnFSUmL","interval":"30","webclientid":"7o95685e43ki0h7kud5nkp0j0r","graphqlapiendpoint":"https://jp6r5ko4dncehndvraphwgkqde.appsync-api.us-east-1.amazonaws.com/graphql","region":"us-east-1","HostedSiteUrl":"www.zeitplan-app.com"}}');


(0, $9937be76c87bee28$exports.Amplify).configure({
    Auth: {
        region: (0, $322a796d5713096f$exports.ZeitplanCdkStack).region,
        userPoolId: (0, $322a796d5713096f$exports.ZeitplanCdkStack).userpoolid,
        userPoolWebClientId: (0, $322a796d5713096f$exports.ZeitplanCdkStack).webclientid,
        signUpVerificationMethod: "code",
        cookieStorage: {
            domain: ".zeitplan-app.com",
            path: "/",
            expires: 7,
            sameSite: "strict",
            secure: true
        },
        authenticationFlowType: "USER_SRP_AUTH",
        oauth: {
            domain: (0, $322a796d5713096f$exports.ZeitplanCdkStack).HostedUiDomain.replace("https://", ""),
            redirectSignIn: "https://www.zeitplan-app.com/schedule",
            redirectSignOut: "https://www.zeitplan-app.com/",
            responseType: "code"
        }
    }
});
function $42193ccb0bd023c5$var$mapError(promise, map) {
    return promise.catch(map);
}
customElements.define("stripe-web-component", class extends HTMLElement {
    constructor(){
        super();
        this._clientSecret = null;
        this._stripe = null;
        this._elements = null;
        (0, $05b5adc44cf00d6f$export$de80f7562c3fd6b1)("pk_live_51IaOKoHc4HUBPWg1FjT8MCb9idXoMnFHhOnuU9vvN2KF2GZm6DOlL42VoXzxVRY74UeiaL8klBAhdHlaHeslqkRC00l2dWyjwX").then((stripe)=>{
            this._stripe = stripe;
            this.connectedCallback();
        });
    }
    connectedCallback() {
        if (this._stripe === null || !this.hasAttribute("client-secret")) return;
        this._elements = this._stripe.elements({
            clientSecret: this.getAttribute("client-secret"),
            appearance: {
                theme: "flat"
            }
        });
        this._form = document.createElement("form");
        this._paymentEL = document.createElement("div");
        this._linkAuthenticationEL = document.createElement("div");
        this._submitButton = document.createElement("button");
        this._submitButton.type = "submit";
        this._submitButton.classList.add("button");
        this._submitButton.classList.add("is-success");
        this._submitButton.classList.add("mt-2");
        this._submitButton.textContent = "Submit Payment";
        this._form.appendChild(this._linkAuthenticationEL);
        this._form.appendChild(this._paymentEL);
        this._form.appendChild(this._submitButton);
        this.append(this._form);
        this._stripePaymentEL = this._elements.create("payment");
        this._stripeLinkAuthenticationEL = this._elements.create("linkAuthentication");
        this._stripeLinkAuthenticationEL.on("change", (event)=>{
            this._email = event.value.email;
            this.dispatchEvent(new CustomEvent("emailChanged", {
                detail: event.value.email
            }));
        });
        this._stripePaymentEL.mount(this._paymentEL);
        this._stripeLinkAuthenticationEL.mount(this._linkAuthenticationEL);
        this._form.onsubmit = async (e)=>{
            e.preventDefault();
            if (this._elements === null || this._stripe === null) return;
            const { error: error } = await this._stripe?.confirmPayment({
                elements: this._elements,
                confirmParams: {
                    return_url: `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + window.location.port : ""}/payment-confirmation`,
                    receipt_email: this._email ?? undefined
                }
            });
            this._error = error;
            this.dispatchEvent(new CustomEvent("paymentError", {
                detail: error
            }));
        };
    }
});
async function $42193ccb0bd023c5$var$run() {
    const currentlyLoggedInUser = await $42193ccb0bd023c5$var$mapError((0, $becbf89411c44a7e$export$334c29725a78c21d).currentAuthenticatedUser().then(async (user)=>{
        return (0, $becbf89411c44a7e$export$334c29725a78c21d).currentSession().then((token)=>token.getAccessToken()).then((token)=>{
            return {
                ...user,
                jwt: token.getJwtToken(),
                expires: token.getExpiration() * 1000
            };
        });
    }), ()=>null);
    const graphQlEndpoint = (0, $322a796d5713096f$exports.ZeitplanCdkStack).graphqlapiendpoint;
    const app = (0, $8c1f3845b573e132$exports.Elm).Main.init({
        flags: {
            currentlyLoggedInUser: currentlyLoggedInUser,
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c46317026d1b626f$exports))),
            graphQlEndpoint: graphQlEndpoint
        },
        node: document.getElementById("zeitplan")
    });
    app.ports.signIn.subscribe(({ username: username, password: password })=>(0, $becbf89411c44a7e$export$334c29725a78c21d).signIn(username, password).then(async (user)=>{
            return (0, $becbf89411c44a7e$export$334c29725a78c21d).currentSession().then((token)=>token.getAccessToken()).then((token)=>{
                return {
                    ...user,
                    jwt: token.getJwtToken(),
                    expires: token.getExpiration() * 1000
                };
            });
        }).then(app.ports.signInOk.send).catch(app.ports.signInErr.send));
    app.ports.signUp.subscribe(({ username: username, password: password })=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).signUp({
            username: username,
            password: password,
            autoSignIn: {
                enabled: true
            }
        }).then(app.ports.signUpOk.send).catch(app.ports.signUpErr.send);
    });
    app.ports.signUpConfirm.subscribe(({ username: username, code: code })=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).confirmSignUp(username, code).then((_)=>(0, $becbf89411c44a7e$export$334c29725a78c21d).currentAuthenticatedUser({
                bypassCache: true
            })).then(async (user)=>{
            return (0, $becbf89411c44a7e$export$334c29725a78c21d).currentSession().then((token)=>token.getAccessToken()).then((token)=>({
                    ...user,
                    jwt: token.getJwtToken(),
                    expires: token.getExpiration() * 1000
                }));
        }).then(app.ports.signUpConfirmOk.send).catch((e)=>{
            if (e.code === undefined || e.code === null) window.location.reload();
            app.ports.signUpConfirmErr.send(e);
        });
    });
    app.ports.resendConfirmationCode.subscribe((username)=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).resendSignUp(username).then(app.ports.resendConfirmationCodeOk.send).catch(app.ports.resendConfirmationCodeErr.send);
    });
    app.ports.signOut.subscribe(()=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).signOut().then(app.ports.signOutOk.send).catch(app.ports.signOutErr.send);
    });
    app.ports.requestRefreshToken.subscribe(()=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).currentSession().then((token)=>token.getAccessToken()).then((token)=>{
            app.ports.refreshToken.send({
                jwt: token.getJwtToken(),
                expires: token.getExpiration() * 1000
            });
        });
    });
    app.ports.signInWithGoogle.subscribe(()=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).federatedSignIn({
            provider: (0, $63aec004f3b0b8d2$export$eeb013770cb92342).Google
        }).then(app.ports.signInWithGoogleSuccess.send).catch(app.ports.signInWithGoogleError.send);
    });
    app.ports.forgotPassword.subscribe((username)=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).forgotPassword(username).then(app.ports.forgotPasswordOk.send).catch(app.ports.forgotPasswordErr.send);
    });
    app.ports.forgotPasswordSubmit.subscribe(({ username: username, code: code, password: password })=>{
        (0, $becbf89411c44a7e$export$334c29725a78c21d).forgotPasswordSubmit(username, code, password).then(app.ports.forgotPasswordSubmitOk.send).catch(app.ports.forgotPasswordSubmitErr.send);
    });
}
$42193ccb0bd023c5$var$run();


//# sourceMappingURL=index.23f1d7df.js.map
